import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  addressCity: Maybe<Scalars['String']['output']>;
  addressPostalCode: Maybe<Scalars['String']['output']>;
  addressStreet: Maybe<Scalars['String']['output']>;
  contactEmail: Maybe<Scalars['String']['output']>;
  contactPhone: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  onboardingCompleted: Scalars['Boolean']['output'];
  orgNumber: Maybe<Scalars['String']['output']>;
  privacyUrl: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  termsUrl: Maybe<Scalars['String']['output']>;
  type: AccountTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  website: Maybe<Scalars['String']['output']>;
};

export type AccountMember = {
  __typename?: 'AccountMember';
  account: Account;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isContactPerson: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type AccountSettingsType = {
  __typename?: 'AccountSettingsType';
  brandFooterText: Maybe<Scalars['String']['output']>;
  brandLogoUrl: Maybe<Scalars['String']['output']>;
  brandPrimaryColor: Maybe<Scalars['String']['output']>;
  emailConfigured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  legalConfigured: Scalars['Boolean']['output'];
  mailFromName: Maybe<Scalars['String']['output']>;
  mailReplyTo: Maybe<Scalars['String']['output']>;
  onboardingCompleted: Scalars['Boolean']['output'];
  paymentNotificationEmail: Maybe<Scalars['String']['output']>;
  privacyUrl: Maybe<Scalars['String']['output']>;
  sectionsConfigured: Scalars['Float']['output'];
  sectionsTotal: Scalars['Float']['output'];
  smsConfigured: Scalars['Boolean']['output'];
  smsDefaultSender: Maybe<Scalars['String']['output']>;
  startInvoiceNo: Scalars['Float']['output'];
  termsUrl: Maybe<Scalars['String']['output']>;
  vippsClientIdMasked: Maybe<Scalars['String']['output']>;
  vippsConfigured: Scalars['Boolean']['output'];
  vippsMerchantSerialNumberMasked: Maybe<Scalars['String']['output']>;
  vippsValidated: Scalars['Boolean']['output'];
};

export enum AccountTypeEnum {
  Platform = 'PLATFORM',
  Tenant = 'TENANT'
}

export type BalancingMove = {
  __typename?: 'BalancingMove';
  seatId: Scalars['ID']['output'];
  seatNumber: Scalars['Int']['output'];
  tableNumber: Scalars['Int']['output'];
};

export type BalancingSuggestionDto = {
  __typename?: 'BalancingSuggestionDto';
  kind: BalancingSuggestionKind;
  moves: Array<BalancingMove>;
  reason: Scalars['String']['output'];
  tableNumber: Maybe<Scalars['Int']['output']>;
};

export enum BalancingSuggestionKind {
  BalanceMove = 'BALANCE_MOVE',
  BreakTable = 'BREAK_TABLE',
  OverCap = 'OVER_CAP'
}

export enum BeatTheProEntryStateEnum {
  Lost = 'LOST',
  Undecided = 'UNDECIDED',
  Won = 'WON'
}

export type BeatTheProExtra = {
  __typename?: 'BeatTheProExtra';
  allIn: Scalars['Boolean']['output'];
  bet: Scalars['Float']['output'];
  state: BeatTheProEntryStateEnum;
};

export type BeatTheProExtraDto = {
  allIn?: Scalars['Boolean']['input'];
  bet: Scalars['Float']['input'];
  state?: BeatTheProEntryStateEnum;
};

export type BestBallLeaderboard = {
  __typename?: 'BestBallLeaderboard';
  players: Array<GolfLeaderboardPlayer>;
  teams: Array<BestBallLeaderboardTeam>;
};

export type BestBallLeaderboardTeam = {
  __typename?: 'BestBallLeaderboardTeam';
  holesRegistred: Scalars['Float']['output'];
  points: Scalars['Float']['output'];
  rank: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  scores: Array<PolfEventScore>;
  scoresBestBall: Array<PolfEventScore>;
  strokes: Scalars['Float']['output'];
  strokesNet: Scalars['Float']['output'];
  team: PolfEventTeam;
};

export type BlindLevelInput = {
  ante: Scalars['Int']['input'];
  bigBlind: Scalars['Int']['input'];
  breakAfterMinutes?: InputMaybe<Scalars['Int']['input']>;
  durationMinutes: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  index: Scalars['Int']['input'];
  smallBlind: Scalars['Int']['input'];
};

export type BreakTableResult = {
  __typename?: 'BreakTableResult';
  moves: Array<BalancingMove>;
  poker: PolfEventPoker;
};

export type BrregAddress = {
  __typename?: 'BrregAddress';
  city: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
};

export type BrregCompanyType = {
  __typename?: 'BrregCompanyType';
  address: Maybe<BrregAddress>;
  businessAddress: Maybe<BrregAddress>;
  employeeCount: Maybe<Scalars['Float']['output']>;
  homepage: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orgNumber: Scalars['String']['output'];
  organizationForm: Maybe<Scalars['String']['output']>;
  registeredInVat: Scalars['Boolean']['output'];
};

export type Course = {
  __typename?: 'Course';
  aiImported: Scalars['Boolean']['output'];
  country: CourseCountryEnum;
  createdAt: Scalars['DateTime']['output'];
  holes: Array<CourseHole>;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  polfEvents: PolfEvent;
  status: CourseStatusEnum;
  tees: Maybe<Array<CourseTee>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CourseCountryEnum {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  An = 'AN',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cs = 'CS',
  Cu = 'CU',
  Cv = 'CV',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  St = 'ST',
  Sv = 'SV',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CourseDraftDto = {
  __typename?: 'CourseDraftDto';
  country: CourseCountryEnum;
  holes: Array<CourseDraftHoleDto>;
  name: Scalars['String']['output'];
  sources: Array<CourseDraftSourceDto>;
  tees: Array<CourseDraftTeeDto>;
};

export type CourseDraftHoleDto = {
  __typename?: 'CourseDraftHoleDto';
  index: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  par: Scalars['Int']['output'];
  tees: Array<CourseDraftHoleTeeDto>;
};

export type CourseDraftHoleInputDto = {
  index: Scalars['Int']['input'];
  number: Scalars['Int']['input'];
  par: Scalars['Int']['input'];
  tees: Array<CourseDraftHoleTeeInputDto>;
};

export type CourseDraftHoleTeeDto = {
  __typename?: 'CourseDraftHoleTeeDto';
  length: Scalars['Float']['output'];
  teeName: Scalars['String']['output'];
};

export type CourseDraftHoleTeeInputDto = {
  length: Scalars['Float']['input'];
  teeName: Scalars['String']['input'];
};

export type CourseDraftSourceDto = {
  __typename?: 'CourseDraftSourceDto';
  title: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type CourseDraftTeeDto = {
  __typename?: 'CourseDraftTeeDto';
  courseRating: Scalars['Float']['output'];
  par: Scalars['Int']['output'];
  slope: Scalars['Float']['output'];
  teeName: Scalars['String']['output'];
};

export type CourseDraftTeeInputDto = {
  courseRating: Scalars['Float']['input'];
  par: Scalars['Int']['input'];
  slope: Scalars['Float']['input'];
  teeName: Scalars['String']['input'];
};

export type CourseHole = {
  __typename?: 'CourseHole';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Float']['output'];
  number: Scalars['Float']['output'];
  par: Scalars['Float']['output'];
  tees: Maybe<Array<CourseHoleTees>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CourseHoleTees = {
  __typename?: 'CourseHoleTees';
  length: Maybe<Scalars['Float']['output']>;
  teeId: Scalars['ID']['output'];
};

export type CourseHoleTeesDto = {
  length?: InputMaybe<Scalars['Float']['input']>;
  teeId: Scalars['ID']['input'];
};

export enum CourseStatusEnum {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type CourseTee = {
  __typename?: 'CourseTee';
  courseRating: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  par: Scalars['Float']['output'];
  slope: Scalars['Float']['output'];
  teeName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CreateCourseDto = {
  country?: InputMaybe<CourseCountryEnum>;
  name: Scalars['String']['input'];
};

export type CreateCourseFromDraftDto = {
  country: CourseCountryEnum;
  holes: Array<CourseDraftHoleInputDto>;
  name: Scalars['String']['input'];
  tees: Array<CourseDraftTeeInputDto>;
};

export type CreateCourseHoleDto = {
  index: Scalars['Float']['input'];
  number: Scalars['Float']['input'];
  par: Scalars['Float']['input'];
  tees?: InputMaybe<Array<CourseHoleTeesDto>>;
};

export type CreateCourseTeeDto = {
  courseRating: Scalars['Float']['input'];
  par: Scalars['Float']['input'];
  slope: Scalars['Float']['input'];
  teeName: Scalars['String']['input'];
};

export type CreatePolfEventConsentDto = {
  consentKey: Scalars['String']['input'];
  consentText: Scalars['String']['input'];
  consentedAt: Scalars['DateTime']['input'];
  type: PolfEventConsentTypeEnum;
};

export type CreatePolfEventDto = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['DateTime']['input'];
  hcpFactor?: Scalars['Float']['input'];
  matchPlay?: InputMaybe<Scalars['Boolean']['input']>;
  mode: PolfEventModeEnum;
  name: Scalars['String']['input'];
  ranking?: InputMaybe<PolfEventRankingEnum>;
  registration?: InputMaybe<PolfEventRegistrationDto>;
  segments?: InputMaybe<Array<PolfEventSegmentDto>>;
  startingStackChips?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePolfEventHoleCompetitionDto = {
  chipValue?: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  holeId: Scalars['ID']['input'];
  type: PolfEventHoleCompetitionTypeEnum;
};

export type CreatePolfEventHoleCompetitionEntryDto = {
  /** Only used for competition type Beat the pro */
  beatTheProExtra?: InputMaybe<BeatTheProExtraDto>;
  polfEventPlayerId: Scalars['ID']['input'];
  /** Distance in cm/meter if closest/longest, or chip value if beat the pro */
  value: Scalars['Float']['input'];
};

export type CreatePolfEventHoleCompetitionOpponentDto = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  mobileNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreatePolfEventMatchDto = {
  flightId: Scalars['ID']['input'];
  playerAId?: InputMaybe<Scalars['ID']['input']>;
  playerBId?: InputMaybe<Scalars['ID']['input']>;
  segmentOrdinal?: InputMaybe<Scalars['Float']['input']>;
  teamAId?: InputMaybe<Scalars['ID']['input']>;
  teamBId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePolfEventPaymentDto = {
  consents?: InputMaybe<Array<CreatePolfEventConsentDto>>;
  /** When the event has `registration.playerPicksTee` enabled, the picked tee id travels with the payment so it survives the Vipps round-trip. Ignored when the flag is off; the course default tee is used instead. */
  courseTeeId?: InputMaybe<Scalars['String']['input']>;
  mobileNumber: Scalars['String']['input'];
  paymentMethod: VippsPaymentMethodEnum;
};

export type CreatePolfEventPlayerDto = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  courseTeeId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hcp?: InputMaybe<Scalars['Float']['input']>;
  memberNo?: InputMaybe<Scalars['String']['input']>;
  mobileNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreatePolfEventTeamDto = {
  customName?: InputMaybe<Scalars['String']['input']>;
  flightId?: InputMaybe<Scalars['ID']['input']>;
  playerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DevReseedResult = {
  __typename?: 'DevReseedResult';
  durationMs: Scalars['Int']['output'];
};

export enum DevReseedScope {
  Full = 'FULL',
  SeedTenant = 'SEED_TENANT'
}

export type GolfLeaderboard = {
  __typename?: 'GolfLeaderboard';
  players: Array<GolfLeaderboardPlayer>;
};

export type GolfLeaderboardPlayer = {
  __typename?: 'GolfLeaderboardPlayer';
  holesRegistred: Scalars['Float']['output'];
  player: PolfEventPlayer;
  points: Scalars['Float']['output'];
  rank: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  scores: Array<PolfEventScore>;
  strokes: Scalars['Float']['output'];
  strokesNet: Scalars['Float']['output'];
};

export enum HoleWinnerEnum {
  A = 'A',
  B = 'B',
  Halved = 'HALVED'
}

export type LeaderboardUnion = BestBallLeaderboard | GolfLeaderboard | PolfLeaderboard | ScrambleLeaderboard | SegmentedLeaderboard;

export enum LevelDirection {
  Next = 'NEXT',
  Prev = 'PREV'
}

export enum MatchSideEnum {
  A = 'A',
  B = 'B'
}

export enum MatchSideKindEnum {
  Player = 'PLAYER',
  Team = 'TEAM'
}

export enum MatchStatusEnum {
  Decided = 'DECIDED',
  Dormie = 'DORMIE',
  Halved = 'HALVED',
  Live = 'LIVE'
}

export type MoveSeatInput = {
  seatId: Scalars['ID']['input'];
  seatNumber: Scalars['Int']['input'];
  tableNumber: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  accountAddMember: AccountMember;
  accountCreate: Account;
  accountRemoveMember: Scalars['Boolean']['output'];
  accountSetContactPerson: Array<AccountMember>;
  courseCreate: Course;
  courseCreateFromDraft: Course;
  courseDelete: Course;
  courseHoleAdd: Course;
  courseHoleDelete: Course;
  courseStatusUpdate: Course;
  courseTeeCreate: CourseTee;
  courseTeeDelete: CourseTee;
  courseTeeSetDefault: Array<CourseTee>;
  courseTeeUpdate: CourseTee;
  courseUpdate: Course;
  courseUpdateFromDraft: Course;
  courseUpdateHoles: Course;
  currentOpponentHoleCompetitionEntryAdd: PolfEventBeatTheProPlayer;
  currentOpponentHoleCompetitionEntryDelete: PolfEventBeatTheProPlayer;
  currentOpponentHoleCompetitionEntrySetResult: PolfEventBeatTheProPlayer;
  currentPlayerHoleCompetitionEntryCreate: PolfEventHoleCompetitionEntry;
  currentPlayerHoleCompetitionEntryRemove: PolfEventHoleCompetitionEntry;
  currentPlayerHoleCompetitionEntryUpdate: PolfEventHoleCompetitionEntry;
  currentPlayerPokerStackUpdate: PolfEventPokerPlayerSeat;
  currentPlayerScoreSubmitFlight: Scalars['Boolean']['output'];
  currentPlayerScoreUpdate: Array<PolfEventMobileScore>;
  devReseed: DevReseedResult;
  myAccountAddMember: AccountMember;
  myAccountProfileUpdate: Account;
  myAccountRemoveMember: Scalars['Boolean']['output'];
  myAccountSettingsUpdate: AccountSettingsType;
  paymentCapture: VippsPaymentDetails;
  /** Create player on an authorized payment that is missing a playerId */
  paymentCreatePlayerBasedOnPaymentRecord: VippsPayment;
  paymentDeleteEmptyRecords: Array<VippsPayment>;
  paymentRefund: VippsPaymentDetails;
  /** Updated all records that do not have an end state from Vipps */
  paymentUpdateAllRecords: Array<VippsPayment>;
  platformRemoveTwoFactor: Scalars['Boolean']['output'];
  polfEventChipValuesUpdate: PolfEvent;
  polfEventClosePolfEvent: PolfEvent;
  polfEventCopyData: PolfEvent;
  polfEventCreate: PolfEvent;
  polfEventDelete: PolfEvent;
  polfEventFinishPolfEvent: PolfEvent;
  polfEventFlightAdd: PolfEventFlight;
  polfEventFlightAddPlayer: PolfEventFlight;
  polfEventFlightAddTeam: PolfEventFlight;
  polfEventFlightRemove: PolfEventFlight;
  polfEventFlightRemovePlayer: PolfEventFlight;
  polfEventFlightRemoveTeam: PolfEventFlight;
  polfEventFlightUpdate: PolfEventFlight;
  polfEventHoleCompetitionCreate: PolfEventHoleCompetition;
  polfEventHoleCompetitionEntryRemove: PolfEventHoleCompetitionEntry;
  polfEventHoleCompetitionEntryUpdate: PolfEventHoleCompetitionEntry;
  polfEventHoleCompetitionOpponentAdd: PolfEventHoleCompetition;
  polfEventHoleCompetitionOpponentUpdate: PolfEventHoleCompetition;
  polfEventHoleCompetitionRemove: PolfEventHoleCompetition;
  polfEventHoleCompetitionUpdate: PolfEventHoleCompetition;
  polfEventMatchAdd: PolfEventMatch;
  polfEventMatchDelete: Scalars['Boolean']['output'];
  polfEventMatchesAutoPair: Array<PolfEventMatch>;
  polfEventOperatorCreate: PolfEventOperator;
  polfEventOperatorRevoke: PolfEventOperator;
  polfEventOperatorSendLink: PolfEventOperator;
  polfEventOperatorSendLinkToAll: OperatorBulkSendResult;
  polfEventPlayerAdd: PolfEventPlayer;
  polfEventPlayerAddMultiple: Array<PolfEventPlayer>;
  polfEventPlayerDistributeInFlights: Array<PolfEventFlight>;
  polfEventPlayerOtherPaymentCreate: PolfEventPlayerOtherPayment;
  polfEventPlayerOtherPaymentDelete: PolfEventPlayerOtherPayment;
  polfEventPlayerPaymentReminder: PolfEventPlayer;
  polfEventPlayerRemove: PolfEventPlayer;
  polfEventPlayerRetire: PolfEventPlayer;
  polfEventPlayerRetireUndo: PolfEventPlayer;
  polfEventPlayerRetiredPlaysPokerSet: PolfEventPlayer;
  polfEventPlayerScoreUpdate: Maybe<PolfEventScore>;
  polfEventPlayerUpdate: PolfEventPlayer;
  polfEventPokerAddTable: PolfEventPoker;
  polfEventPokerAddonAll: PolfEventPoker;
  polfEventPokerAllowPlayerStackUpdateSet: PolfEventPoker;
  polfEventPokerBalancingApply: PolfEventPoker;
  polfEventPokerBlindStructureUpdate: PolfEventPoker;
  polfEventPokerBreakTable: BreakTableResult;
  polfEventPokerClockAdjust: PolfEventPoker;
  polfEventPokerClockPause: PolfEventPoker;
  polfEventPokerClockResume: PolfEventPoker;
  polfEventPokerClockStart: PolfEventPoker;
  polfEventPokerConfigUpsert: PolfEventPoker;
  polfEventPokerDrawSeats: PolfEventPoker;
  polfEventPokerFinalTableRedraw: PolfEventPoker;
  polfEventPokerFinish: PolfEventPoker;
  polfEventPokerLateRegister: PolfEventPoker;
  polfEventPokerLevelAdvance: PolfEventPoker;
  polfEventPokerPayoutStructureUpdate: PolfEventPoker;
  polfEventPokerPrizePoolUpdate: PolfEventPoker;
  polfEventPokerRebuyConfigSet: PolfEventPoker;
  polfEventPokerRegistrationClose: PolfEventPoker;
  polfEventPokerRemoveLastTable: PolfEventPoker;
  polfEventPokerReorderElimination: PolfEventPoker;
  polfEventPokerSeatAddon: PolfEventPoker;
  polfEventPokerSeatAddonRemove: PolfEventPoker;
  polfEventPokerSeatEliminate: PolfEventPoker;
  polfEventPokerSeatLockToggle: PolfEventPoker;
  polfEventPokerSeatMove: PolfEventPokerSeat;
  polfEventPokerSeatRebuy: PolfEventPoker;
  polfEventPokerSeatRestore: PolfEventPoker;
  polfEventPokerSeatStackUpdate: PolfEventPokerSeat;
  polfEventPokerSeatSwap: PolfEventPokerSeat;
  polfEventPokerSeatWithdraw: PolfEventPoker;
  polfEventPokerSeatsPerTableUpdate: PolfEventPoker;
  polfEventPokerSendSeatSms: PolfEventPokerSmsResult;
  polfEventPokerShowChipLeaderboardSet: PolfEventPoker;
  polfEventPokerUsePayoutsSet: PolfEventPoker;
  polfEventPokerVoiceAnnouncementsSet: PolfEventPoker;
  polfEventPublicAddPlayerVipps: VippsPayment;
  polfEventPublicUpdatePlayer: PolfEventPlayer;
  polfEventReopenPolfEvent: PolfEvent;
  polfEventRequestUpdatedInfo: SmsBatchResult;
  polfEventSendInvites: SmsBatchResult;
  polfEventStartPolfEvent: PolfEvent;
  polfEventTeamAdd: PolfEventTeam;
  polfEventTeamAddPlayer: PolfEventTeam;
  polfEventTeamAutogenerate: Array<PolfEventTeam>;
  polfEventTeamDelete: PolfEventTeam;
  polfEventTeamDistributeInFlights: Array<PolfEventFlight>;
  polfEventTeamRemovePlayer: PolfEventTeam;
  polfEventTeamResetName: PolfEventTeam;
  polfEventTeamUpdate: PolfEventTeam;
  polfEventUpdate: PolfEvent;
  removeMyPassword: SignInStatus;
  selectAccount: SelectAccountResponse;
  sendSms: SentSms;
  sponsorCreate: Sponsor;
  sponsorDelete: Scalars['Boolean']['output'];
  sponsorLogoUploadComplete: Sponsor;
  sponsorLogoUploadUrl: SponsorLogoUpload;
  sponsorUpdate: Sponsor;
  updateMyProfile: User;
};


export type MutationAccountAddMemberArgs = {
  accountId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};


export type MutationAccountCreateArgs = {
  contactPersonEmail: Scalars['String']['input'];
  contactPersonName: Scalars['String']['input'];
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgNumber?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAccountRemoveMemberArgs = {
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAccountSetContactPersonArgs = {
  accountId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
};


export type MutationCourseCreateArgs = {
  createCourseDto: CreateCourseDto;
};


export type MutationCourseCreateFromDraftArgs = {
  createCourseFromDraftDto: CreateCourseFromDraftDto;
};


export type MutationCourseDeleteArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationCourseHoleAddArgs = {
  courseId: Scalars['ID']['input'];
  createCourseHoleDto: CreateCourseHoleDto;
};


export type MutationCourseHoleDeleteArgs = {
  courseId: Scalars['ID']['input'];
  holeId: Scalars['ID']['input'];
};


export type MutationCourseStatusUpdateArgs = {
  courseId: Scalars['ID']['input'];
  updateCourseStatusDto: UpdateCourseStatusDto;
};


export type MutationCourseTeeCreateArgs = {
  courseId: Scalars['ID']['input'];
  createCourseTeeDto: CreateCourseTeeDto;
};


export type MutationCourseTeeDeleteArgs = {
  courseId: Scalars['ID']['input'];
  courseTeeId: Scalars['ID']['input'];
};


export type MutationCourseTeeSetDefaultArgs = {
  courseId: Scalars['ID']['input'];
  courseTeeId: Scalars['ID']['input'];
};


export type MutationCourseTeeUpdateArgs = {
  courseTeeId: Scalars['ID']['input'];
  updateCourseTeeDto: UpdateCourseTeeDto;
};


export type MutationCourseUpdateArgs = {
  courseId: Scalars['ID']['input'];
  updateCourseDto: UpdateCourseDto;
};


export type MutationCourseUpdateFromDraftArgs = {
  courseId: Scalars['ID']['input'];
  updateCourseFromDraftDto: UpdateCourseFromDraftDto;
};


export type MutationCourseUpdateHolesArgs = {
  courseId: Scalars['ID']['input'];
  updateCourseHoleDtos: Array<UpdateCourseHoleDto>;
};


export type MutationCurrentOpponentHoleCompetitionEntryAddArgs = {
  createPolfEventHoleCompetitionEntryDto: CreatePolfEventHoleCompetitionEntryDto;
};


export type MutationCurrentOpponentHoleCompetitionEntryDeleteArgs = {
  polfEventHoleCompetitionEntryId: Scalars['ID']['input'];
  polfEventPlayerId: Scalars['ID']['input'];
};


export type MutationCurrentOpponentHoleCompetitionEntrySetResultArgs = {
  polfEventHoleCompetitionEntryId: Scalars['ID']['input'];
  polfEventPlayerId: Scalars['ID']['input'];
  state: BeatTheProEntryStateEnum;
};


export type MutationCurrentPlayerHoleCompetitionEntryCreateArgs = {
  createPolfEventHoleCompetitionEntryDto: CreatePolfEventHoleCompetitionEntryDto;
  polfEventHoleCompetitionId: Scalars['ID']['input'];
};


export type MutationCurrentPlayerHoleCompetitionEntryRemoveArgs = {
  polfEventHoleCompetitionEntryId: Scalars['ID']['input'];
};


export type MutationCurrentPlayerHoleCompetitionEntryUpdateArgs = {
  polfEventHoleCompetitionEntryId: Scalars['ID']['input'];
  updatePolfEventHoleCompetitionEntryDto: UpdatePolfEventHoleCompetitionEntryDto;
};


export type MutationCurrentPlayerPokerStackUpdateArgs = {
  currentStack: Scalars['Float']['input'];
};


export type MutationCurrentPlayerScoreUpdateArgs = {
  scoreDto: PolfEventScoreDto;
};


export type MutationDevReseedArgs = {
  scope?: DevReseedScope;
};


export type MutationMyAccountAddMemberArgs = {
  email: Scalars['String']['input'];
};


export type MutationMyAccountProfileUpdateArgs = {
  profile: UpdateAccountProfileInput;
};


export type MutationMyAccountRemoveMemberArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationMyAccountSettingsUpdateArgs = {
  settings: UpdateAccountSettingsInput;
};


export type MutationPaymentCaptureArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationPaymentCreatePlayerBasedOnPaymentRecordArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationPaymentRefundArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationPlatformRemoveTwoFactorArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationPolfEventChipValuesUpdateArgs = {
  polfEventId: Scalars['ID']['input'];
  updatePolfEventChipValues: UpdatePolfEventChipValues;
};


export type MutationPolfEventClosePolfEventArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventCopyDataArgs = {
  polfEventCopyDataDto: PolfEventCopyDataDto;
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventCreateArgs = {
  createPolfEventDto: CreatePolfEventDto;
};


export type MutationPolfEventDeleteArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventFinishPolfEventArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventFlightAddArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventFlightAddPlayerArgs = {
  polfEventFlightId: Scalars['ID']['input'];
  polfEventPlayerId: Scalars['ID']['input'];
};


export type MutationPolfEventFlightAddTeamArgs = {
  polfEventFlightId: Scalars['ID']['input'];
  polfEventTeamId: Scalars['ID']['input'];
};


export type MutationPolfEventFlightRemoveArgs = {
  polfEventFlightId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventFlightRemovePlayerArgs = {
  flightId: Scalars['ID']['input'];
  polfEventPlayerId: Scalars['ID']['input'];
};


export type MutationPolfEventFlightRemoveTeamArgs = {
  flightId: Scalars['ID']['input'];
  polfEventTeamId: Scalars['ID']['input'];
};


export type MutationPolfEventFlightUpdateArgs = {
  polfEventFlightId: Scalars['ID']['input'];
  updatePolfEventFlightDto: UpdatePolfEventFlightDto;
};


export type MutationPolfEventHoleCompetitionCreateArgs = {
  createPolfEventHoleCompetitionDto: CreatePolfEventHoleCompetitionDto;
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventHoleCompetitionEntryRemoveArgs = {
  polfEventHoleCompetitionEntryId: Scalars['ID']['input'];
};


export type MutationPolfEventHoleCompetitionEntryUpdateArgs = {
  polfEventHoleCompetitionEntryId: Scalars['ID']['input'];
  updatePolfEventHoleCompetitionEntryDto: UpdatePolfEventHoleCompetitionEntryDto;
};


export type MutationPolfEventHoleCompetitionOpponentAddArgs = {
  createPolfEventHoleCompetitionOpponentDto: CreatePolfEventHoleCompetitionOpponentDto;
  polfEventHoleCompetitionId: Scalars['ID']['input'];
};


export type MutationPolfEventHoleCompetitionOpponentUpdateArgs = {
  polfEventHoleCompetitionOpponentId: Scalars['ID']['input'];
  updatePolfEventHoleCompetitionOpponentDto: UpdatePolfEventHoleCompetitionOpponentDto;
};


export type MutationPolfEventHoleCompetitionRemoveArgs = {
  polfEventHoleCompetitionId: Scalars['ID']['input'];
};


export type MutationPolfEventHoleCompetitionUpdateArgs = {
  polfEventHoleCompetitionId: Scalars['ID']['input'];
  updatePolfEventHoleCompetitionDto: UpdatePolfEventHoleCompetitionDto;
};


export type MutationPolfEventMatchAddArgs = {
  createPolfEventMatchDto: CreatePolfEventMatchDto;
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventMatchDeleteArgs = {
  polfEventMatchId: Scalars['ID']['input'];
};


export type MutationPolfEventMatchesAutoPairArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventOperatorCreateArgs = {
  input: PolfEventOperatorCreateDto;
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventOperatorRevokeArgs = {
  polfEventOperatorId: Scalars['ID']['input'];
};


export type MutationPolfEventOperatorSendLinkArgs = {
  phone?: InputMaybe<Scalars['String']['input']>;
  polfEventOperatorId: Scalars['ID']['input'];
};


export type MutationPolfEventOperatorSendLinkToAllArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPlayerAddArgs = {
  createPolfEventPlayerDto: CreatePolfEventPlayerDto;
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPlayerAddMultipleArgs = {
  createPolfEventPlayersDto: Array<CreatePolfEventPlayerDto>;
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPlayerDistributeInFlightsArgs = {
  polfEventId: Scalars['ID']['input'];
  redistributeAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPolfEventPlayerOtherPaymentCreateArgs = {
  polfEventPlayerId: Scalars['ID']['input'];
};


export type MutationPolfEventPlayerOtherPaymentDeleteArgs = {
  polfEventPlayerOtherPaymentId: Scalars['ID']['input'];
};


export type MutationPolfEventPlayerPaymentReminderArgs = {
  polfEventPlayerId: Scalars['ID']['input'];
};


export type MutationPolfEventPlayerRemoveArgs = {
  polfEventPlayerId: Scalars['ID']['input'];
};


export type MutationPolfEventPlayerRetireArgs = {
  polfEventPlayerId: Scalars['ID']['input'];
};


export type MutationPolfEventPlayerRetireUndoArgs = {
  polfEventPlayerId: Scalars['ID']['input'];
};


export type MutationPolfEventPlayerRetiredPlaysPokerSetArgs = {
  playsPoker: Scalars['Boolean']['input'];
  polfEventPlayerId: Scalars['ID']['input'];
};


export type MutationPolfEventPlayerScoreUpdateArgs = {
  polfEventId: Scalars['ID']['input'];
  scoreDto: PolfEventScoreDto;
};


export type MutationPolfEventPlayerUpdateArgs = {
  polfEventPlayerId: Scalars['ID']['input'];
  updatePolfEventPlayerDto: UpdatePolfEventPlayerDto;
};


export type MutationPolfEventPokerAddTableArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerAddonAllArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerAllowPlayerStackUpdateSetArgs = {
  allowPlayerStackUpdate: Scalars['Boolean']['input'];
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerBalancingApplyArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerBlindStructureUpdateArgs = {
  input: UpdateBlindStructureInput;
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerBreakTableArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
  tableNumber: Scalars['Int']['input'];
};


export type MutationPolfEventPokerClockAdjustArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
  remainingSeconds: Scalars['Int']['input'];
};


export type MutationPolfEventPokerClockPauseArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerClockResumeArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerClockStartArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerConfigUpsertArgs = {
  input: PokerConfigInput;
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerDrawSeatsArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerFinalTableRedrawArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerFinishArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerLateRegisterArgs = {
  playerId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerLevelAdvanceArgs = {
  direction: LevelDirection;
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerPayoutStructureUpdateArgs = {
  input: UpdatePayoutStructureInput;
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerPrizePoolUpdateArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
  prizePool?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPolfEventPokerRebuyConfigSetArgs = {
  input: RebuyAddonConfigInput;
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerRegistrationCloseArgs = {
  closed: Scalars['Boolean']['input'];
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerRemoveLastTableArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerReorderEliminationArgs = {
  direction: ReorderDirection;
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerSeatAddonArgs = {
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerSeatAddonRemoveArgs = {
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerSeatEliminateArgs = {
  knockedOutByPlayerId?: InputMaybe<Scalars['ID']['input']>;
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerSeatLockToggleArgs = {
  isLocked: Scalars['Boolean']['input'];
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerSeatMoveArgs = {
  input: MoveSeatInput;
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerSeatRebuyArgs = {
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerSeatRestoreArgs = {
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerSeatStackUpdateArgs = {
  currentStack: Scalars['Float']['input'];
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerSeatSwapArgs = {
  input: SwapSeatsInput;
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerSeatWithdrawArgs = {
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
};


export type MutationPolfEventPokerSeatsPerTableUpdateArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
  seatsPerTable: Scalars['Float']['input'];
};


export type MutationPolfEventPokerSendSeatSmsArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
  sender?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPolfEventPokerShowChipLeaderboardSetArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
  showChipLeaderboard: Scalars['Boolean']['input'];
};


export type MutationPolfEventPokerUsePayoutsSetArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
  usePayouts: Scalars['Boolean']['input'];
};


export type MutationPolfEventPokerVoiceAnnouncementsSetArgs = {
  pokerId: Scalars['ID']['input'];
  polfEventId: Scalars['ID']['input'];
  voiceAnnouncements: Scalars['Boolean']['input'];
};


export type MutationPolfEventPublicAddPlayerVippsArgs = {
  createPolfEventPaymentDto: CreatePolfEventPaymentDto;
  polfEventId: Scalars['ID']['input'];
  polfEventPlayerNanoId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPolfEventPublicUpdatePlayerArgs = {
  polfEventId: Scalars['ID']['input'];
  polfEventPlayerNanoId: Scalars['String']['input'];
  updatePolfEventPlayerDto: UpdatePolfEventPlayerDto;
};


export type MutationPolfEventReopenPolfEventArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventRequestUpdatedInfoArgs = {
  onlyInvalid?: InputMaybe<Scalars['Boolean']['input']>;
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventSendInvitesArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventStartPolfEventArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventTeamAddArgs = {
  createPolfEventTeamDto?: InputMaybe<CreatePolfEventTeamDto>;
  polfEventId: Scalars['ID']['input'];
};


export type MutationPolfEventTeamAddPlayerArgs = {
  polfEventPlayerId: Scalars['ID']['input'];
  polfEventTeamId: Scalars['ID']['input'];
};


export type MutationPolfEventTeamAutogenerateArgs = {
  polfEventId: Scalars['ID']['input'];
  teamSize: Scalars['Float']['input'];
};


export type MutationPolfEventTeamDeleteArgs = {
  polfEventTeamId: Scalars['ID']['input'];
};


export type MutationPolfEventTeamDistributeInFlightsArgs = {
  polfEventId: Scalars['ID']['input'];
  redistributeAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPolfEventTeamRemovePlayerArgs = {
  polfEventPlayerId: Scalars['ID']['input'];
  polfEventTeamId: Scalars['ID']['input'];
};


export type MutationPolfEventTeamResetNameArgs = {
  polfEventTeamId: Scalars['ID']['input'];
};


export type MutationPolfEventTeamUpdateArgs = {
  polfEventTeamId: Scalars['ID']['input'];
  updatePolfEventTeamDto: UpdatePolfEventTeamDto;
};


export type MutationPolfEventUpdateArgs = {
  polfEventId: Scalars['ID']['input'];
  updatePolfEventDto: UpdatePolfEventDto;
};


export type MutationRemoveMyPasswordArgs = {
  idToken: Scalars['String']['input'];
};


export type MutationSelectAccountArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationSendSmsArgs = {
  sendSmsDto: SendSmsDto;
};


export type MutationSponsorCreateArgs = {
  name: Scalars['String']['input'];
  polfEventId: Scalars['ID']['input'];
};


export type MutationSponsorDeleteArgs = {
  sponsorId: Scalars['ID']['input'];
};


export type MutationSponsorLogoUploadCompleteArgs = {
  sponsorId: Scalars['ID']['input'];
  storagePath: Scalars['String']['input'];
};


export type MutationSponsorLogoUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  sponsorId: Scalars['ID']['input'];
};


export type MutationSponsorUpdateArgs = {
  sponsorId: Scalars['ID']['input'];
  updateSponsorDto: UpdateSponsorDto;
};


export type MutationUpdateMyProfileArgs = {
  input: UpdateMyProfileInput;
};

export type OperatorBulkSendResult = {
  __typename?: 'OperatorBulkSendResult';
  sent: Scalars['Int']['output'];
  skippedNoPhone: Scalars['Int']['output'];
};

export type OperatorPokerView = {
  __typename?: 'OperatorPokerView';
  poker: Maybe<PolfEventPoker>;
  role: OperatorRole;
};

export enum OperatorRole {
  BtpPro = 'BTP_PRO',
  Dealer = 'DEALER',
  PokerTd = 'POKER_TD',
  ScoreKeeper = 'SCORE_KEEPER'
}

export enum PasswordStatusEnum {
  Active = 'ACTIVE',
  None = 'NONE',
  Unverified = 'UNVERIFIED'
}

export type PayoutRowInput = {
  percentageBp: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
};

export type PlatformUser = {
  __typename?: 'PlatformUser';
  accounts: Array<PlatformUserAccount>;
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signIn: SignInStatus;
};

export type PlatformUserAccount = {
  __typename?: 'PlatformUserAccount';
  id: Scalars['ID']['output'];
  isContactPerson: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: AccountTypeEnum;
};

export type PokerConfigInput = {
  allowPlayerStackUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  customLevels: Array<BlindLevelInput>;
  prizePool?: InputMaybe<Scalars['Int']['input']>;
  seatsPerTable: Scalars['Int']['input'];
  showChipLeaderboard?: InputMaybe<Scalars['Boolean']['input']>;
  usePayouts: Scalars['Boolean']['input'];
  voiceAnnouncements?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PolfBeatTheProExtraLeaderboard = {
  __typename?: 'PolfBeatTheProExtraLeaderboard';
  allIn: Scalars['Boolean']['output'];
  bet: Scalars['Float']['output'];
  state: BeatTheProEntryStateEnum;
  value: Scalars['Float']['output'];
};

export type PolfEvent = {
  __typename?: 'PolfEvent';
  account: Account;
  allowsPublicRegistration: Scalars['Boolean']['output'];
  chipValues: PolfEventChipValues;
  course: Maybe<Course>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  flightCount: Scalars['Int']['output'];
  flights: Maybe<Array<PolfEventFlight>>;
  golfFinishedAt: Maybe<Scalars['DateTime']['output']>;
  hasGolf: Scalars['Boolean']['output'];
  hasPokerPhase: Scalars['Boolean']['output'];
  hcpFactor: Scalars['Float']['output'];
  holeCompetitions: Maybe<Array<PolfEventHoleCompetition>>;
  id: Scalars['ID']['output'];
  isBestBall: Scalars['Boolean']['output'];
  isBestWorst: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isFoursome: Scalars['Boolean']['output'];
  isReadOnly: Scalars['Boolean']['output'];
  isScramble: Scalars['Boolean']['output'];
  isSegmented: Scalars['Boolean']['output'];
  isTournamentOver: Scalars['Boolean']['output'];
  matchPlay: Scalars['Boolean']['output'];
  mode: PolfEventModeEnum;
  name: Scalars['String']['output'];
  nanoId: Maybe<Scalars['String']['output']>;
  playerCount: Scalars['Int']['output'];
  players: Maybe<Array<PolfEventPlayer>>;
  publicUrl: Maybe<Scalars['String']['output']>;
  ranking: Maybe<PolfEventRankingEnum>;
  registration: Maybe<PolfEventRegistration>;
  segments: Maybe<Array<PolfEventSegment>>;
  startingStackChips: Maybe<Scalars['Float']['output']>;
  status: PolfEventStatusEnum;
  teamCount: Scalars['Int']['output'];
  teamlessPlayerCount: Scalars['Int']['output'];
  teams: Maybe<Array<PolfEventTeam>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PolfEventBeatTheProPlayer = {
  __typename?: 'PolfEventBeatTheProPlayer';
  entry: Maybe<PolfEventHoleCompetitionEntry>;
  flight: Maybe<PolfEventFlight>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PolfEventChipValues = {
  __typename?: 'PolfEventChipValues';
  birdie: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  eagle: Scalars['Float']['output'];
  flightBonus: Scalars['Float']['output'];
  flightBonusEnabled: Scalars['Boolean']['output'];
  holeInOne: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  polfEvent: PolfEvent;
  stablefordPoint: Scalars['Float']['output'];
  startStack: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PolfEventConsent = {
  __typename?: 'PolfEventConsent';
  consentKey: Scalars['String']['output'];
  consentText: Scalars['String']['output'];
  consentedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  payment: Maybe<VippsPayment>;
  player: Maybe<PolfEventPlayer>;
  type: PolfEventConsentTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  withdrawnAt: Maybe<Scalars['DateTime']['output']>;
};

export enum PolfEventConsentTypeEnum {
  Communication = 'COMMUNICATION',
  Sharing = 'SHARING',
  Terms = 'TERMS'
}

export type PolfEventCopyDataDto = {
  courseTeeId?: InputMaybe<Scalars['ID']['input']>;
  players: Scalars['Boolean']['input'];
  sourcePolfEventId: Scalars['ID']['input'];
};

export type PolfEventFlight = {
  __typename?: 'PolfEventFlight';
  createdAt: Scalars['DateTime']['output'];
  flightNumber: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  playerCount: Scalars['Float']['output'];
  players: Maybe<Array<PolfEventPlayer>>;
  startHole: Maybe<CourseHole>;
  startTime: Maybe<Scalars['String']['output']>;
  teams: Maybe<Array<PolfEventTeam>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PolfEventFlightPoints = {
  __typename?: 'PolfEventFlightPoints';
  flight: PolfEventFlight;
  sides: Array<PolfEventFlightPointsSide>;
  total: Scalars['Float']['output'];
  undecided: Scalars['Float']['output'];
};

export type PolfEventFlightPointsSide = {
  __typename?: 'PolfEventFlightPointsSide';
  halved: Scalars['Float']['output'];
  lost: Scalars['Float']['output'];
  points: Scalars['Float']['output'];
  team: PolfEventTeam;
  won: Scalars['Float']['output'];
};

export type PolfEventHoleCompetition = {
  __typename?: 'PolfEventHoleCompetition';
  chipValue: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  entries: Maybe<Array<PolfEventHoleCompetitionEntry>>;
  hole: CourseHole;
  id: Scalars['ID']['output'];
  /** Only used if comp type is BeatThePro */
  opponent: Maybe<PolfEventHoleCompetitionOpponent>;
  polfEvent: PolfEvent;
  type: PolfEventHoleCompetitionTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type PolfEventHoleCompetitionEntry = {
  __typename?: 'PolfEventHoleCompetitionEntry';
  /** Only used for competition type Beat the pro */
  beatTheProExtra: Maybe<BeatTheProExtra>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  polfEventHoleCompetition: PolfEventHoleCompetition;
  polfEventPlayer: PolfEventPlayer;
  updatedAt: Scalars['DateTime']['output'];
  /** Distance in cm/meter if closest/longest, or chip value if beat the pro */
  value: Scalars['Float']['output'];
};

export type PolfEventHoleCompetitionOpponent = {
  __typename?: 'PolfEventHoleCompetitionOpponent';
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  holeCompetition: PolfEventHoleCompetition;
  id: Scalars['ID']['output'];
  mobileNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nanoId: Maybe<Scalars['String']['output']>;
  smsInviteStatus: Maybe<SmsStatusEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PolfEventHoleCompetitionTypeEnum {
  Beatthepro = 'BEATTHEPRO',
  Closest = 'CLOSEST',
  Longest = 'LONGEST'
}

export type PolfEventMatch = {
  __typename?: 'PolfEventMatch';
  createdAt: Scalars['DateTime']['output'];
  flight: Maybe<PolfEventFlight>;
  id: Scalars['ID']['output'];
  matchNumber: Scalars['Float']['output'];
  playerA: Maybe<PolfEventPlayer>;
  playerB: Maybe<PolfEventPlayer>;
  segmentOrdinal: Maybe<Scalars['Float']['output']>;
  sideA: Maybe<PolfEventMatchSide>;
  sideB: Maybe<PolfEventMatchSide>;
  state: Maybe<PolfEventMatchState>;
  strokesA: Scalars['Float']['output'];
  strokesB: Scalars['Float']['output'];
  teamA: Maybe<PolfEventTeam>;
  teamB: Maybe<PolfEventTeam>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PolfEventMatchSide = {
  __typename?: 'PolfEventMatchSide';
  handicap: Maybe<Scalars['Float']['output']>;
  hcp: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  kind: MatchSideKindEnum;
  name: Scalars['String']['output'];
  players: Array<PolfEventPlayer>;
  strokes: Scalars['Float']['output'];
};

export type PolfEventMatchState = {
  __typename?: 'PolfEventMatchState';
  decidedAfterHoles: Maybe<Scalars['Float']['output']>;
  holeLegs: Array<Array<HoleWinnerEnum>>;
  holeSwings: Array<Scalars['Int']['output']>;
  holes: Array<HoleWinnerEnum>;
  holesRemaining: Scalars['Float']['output'];
  holesUp: Scalars['Float']['output'];
  leader: Maybe<MatchSideEnum>;
  margin: Maybe<Scalars['String']['output']>;
  pointsPerHole: Scalars['Int']['output'];
  status: MatchStatusEnum;
};

export type PolfEventMobilePlayerHoleCompetition = {
  __typename?: 'PolfEventMobilePlayerHoleCompetition';
  chipValue: Scalars['Float']['output'];
  currentLeader: Maybe<PolfEventHoleCompetitionEntry>;
  description: Scalars['String']['output'];
  entries: Maybe<Array<PolfEventHoleCompetitionEntry>>;
  hole: CourseHole;
  id: Scalars['ID']['output'];
  polfEvent: PolfEvent;
  type: PolfEventHoleCompetitionTypeEnum;
};

export type PolfEventMobileScore = {
  __typename?: 'PolfEventMobileScore';
  accumulated: PolfEventMobileScoreAccumulated;
  courseTee: Maybe<CourseTee>;
  hcp: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** True when this entry is a TEAM rather than a player. Only set on a segmented event, where one flight serves both kinds at once because ownership changes per segment — everywhere else the whole flight is one kind and the mode already says which. */
  isTeamEntry: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  scores: Maybe<Array<PolfEventScore>>;
  strokes: Maybe<Scalars['Float']['output']>;
  team: Maybe<PolfEventTeam>;
  /** Only populated when bestball */
  teamAccumulated: Maybe<PolfEventMobileScoreAccumulated>;
  /** Only populated when bestball */
  teamScores: Maybe<Array<PolfEventScore>>;
};

export type PolfEventMobileScoreAccumulated = {
  __typename?: 'PolfEventMobileScoreAccumulated';
  chips: Scalars['Float']['output'];
  holesPlayed: Scalars['Float']['output'];
  isAllIn: Scalars['Boolean']['output'];
  score: Scalars['Float']['output'];
  stablefordPoints: Scalars['Float']['output'];
  strokes: Scalars['Float']['output'];
  strokesNet: Scalars['Float']['output'];
};

export enum PolfEventModeEnum {
  Bestball = 'BESTBALL',
  Bestworst = 'BESTWORST',
  Foursome = 'FOURSOME',
  Golf = 'GOLF',
  Poker = 'POKER',
  Polf = 'POLF',
  Scramble = 'SCRAMBLE',
  Segmented = 'SEGMENTED'
}

export type PolfEventOperator = {
  __typename?: 'PolfEventOperator';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  nanoId: Scalars['String']['output'];
  opponentId: Maybe<Scalars['ID']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  polfEvent: PolfEvent;
  revokedAt: Maybe<Scalars['DateTime']['output']>;
  role: OperatorRole;
  tableNumber: Maybe<Scalars['Int']['output']>;
};

export type PolfEventOperatorCreateDto = {
  label?: InputMaybe<Scalars['String']['input']>;
  opponentId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role: OperatorRole;
  tableNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type PolfEventPlayer = {
  __typename?: 'PolfEventPlayer';
  consents: Maybe<Array<PolfEventConsent>>;
  countryCode: Scalars['String']['output'];
  courseTee: Maybe<CourseTee>;
  createdAt: Scalars['DateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  flight: Maybe<PolfEventFlight>;
  hcp: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  memberNo: Maybe<Scalars['String']['output']>;
  mobileNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nanoId: Maybe<Scalars['String']['output']>;
  payment: Maybe<PolfEventPlayerPaymentUnion>;
  polfEvent: PolfEvent;
  recruitment: Maybe<PolfEventPlayerRecruitment>;
  retiredAt: Maybe<Scalars['DateTime']['output']>;
  retiredHolesFilled: Maybe<Scalars['Float']['output']>;
  retiredPlaysPoker: Scalars['Boolean']['output'];
  scores: Maybe<Array<PolfEventScore>>;
  scoresApproved: Scalars['Boolean']['output'];
  scoresSubmitted: Scalars['Boolean']['output'];
  sentSms: Maybe<Array<SentSms>>;
  smsInviteStatus: Maybe<SmsStatusEnum>;
  strokes: Scalars['Float']['output'];
  team: Maybe<PolfEventTeam>;
  updatedAt: Scalars['DateTime']['output'];
  valid: Scalars['Boolean']['output'];
};

export type PolfEventPlayerOtherPayment = {
  __typename?: 'PolfEventPlayerOtherPayment';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  player: PolfEventPlayer;
  updatedAt: Scalars['DateTime']['output'];
};

export type PolfEventPlayerPaymentUnion = PolfEventPlayerOtherPayment | VippsPayment;

export type PolfEventPlayerRecruitment = {
  __typename?: 'PolfEventPlayerRecruitment';
  amountInCents: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  player: PolfEventPlayer;
  recruitedBy: Scalars['String']['output'];
  status: PolfEventPlayerRecruitmentStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PolfEventPlayerRecruitmentStatusEnum {
  Approved = 'APPROVED',
  Registered = 'REGISTERED',
  Rejected = 'REJECTED'
}

export type PolfEventPoker = {
  __typename?: 'PolfEventPoker';
  addonEnabled: Scalars['Boolean']['output'];
  addonStackChips: Maybe<Scalars['Int']['output']>;
  allowPlayerStackUpdate: Scalars['Boolean']['output'];
  balancingSuggestion: Maybe<BalancingSuggestionDto>;
  clockStartedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentInBreak: Scalars['Boolean']['output'];
  currentLevelIndex: Scalars['Int']['output'];
  currentLevelPausedAt: Maybe<Scalars['DateTime']['output']>;
  currentLevelStartedAt: Maybe<Scalars['DateTime']['output']>;
  finalTableRedrawnAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  levels: Array<PolfEventPokerLevel>;
  maxRebuysPerPlayer: Maybe<Scalars['Int']['output']>;
  payouts: Array<PolfEventPokerPayout>;
  polfEvent: PolfEvent;
  prizePool: Maybe<Scalars['Int']['output']>;
  rebuyStackChips: Maybe<Scalars['Int']['output']>;
  rebuyUntilLevel: Maybe<Scalars['Int']['output']>;
  rebuyWhileActive: Scalars['Boolean']['output'];
  rebuysEnabled: Scalars['Boolean']['output'];
  registrationClosedAt: Maybe<Scalars['DateTime']['output']>;
  registrationOpen: Scalars['Boolean']['output'];
  seats: Array<PolfEventPokerSeat>;
  seatsPerTable: Scalars['Int']['output'];
  seedSeatRandom: Maybe<Scalars['Int']['output']>;
  showChipLeaderboard: Scalars['Boolean']['output'];
  status: PolfEventPokerStatusEnum;
  tableCount: Scalars['Int']['output'];
  totalPausedMs: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usePayouts: Scalars['Boolean']['output'];
  voiceAnnouncements: Scalars['Boolean']['output'];
};

export type PolfEventPokerLevel = {
  __typename?: 'PolfEventPokerLevel';
  ante: Scalars['Int']['output'];
  bigBlind: Scalars['Int']['output'];
  breakAfterMinutes: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  durationMinutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  smallBlind: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PolfEventPokerLevelPublic = {
  __typename?: 'PolfEventPokerLevelPublic';
  ante: Scalars['Int']['output'];
  bigBlind: Scalars['Int']['output'];
  breakAfterMinutes: Maybe<Scalars['Int']['output']>;
  durationMinutes: Scalars['Int']['output'];
  smallBlind: Scalars['Int']['output'];
};

export type PolfEventPokerPayout = {
  __typename?: 'PolfEventPokerPayout';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  percentageBp: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PolfEventPokerPlayerPayout = {
  __typename?: 'PolfEventPokerPlayerPayout';
  percentageBp: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type PolfEventPokerPlayerSeat = {
  __typename?: 'PolfEventPokerPlayerSeat';
  currentStack: Scalars['Int']['output'];
  eliminated: Scalars['Boolean']['output'];
  finishingPosition: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  seatNumber: Scalars['Int']['output'];
  startingStack: Scalars['Int']['output'];
  tableNumber: Scalars['Int']['output'];
};

export type PolfEventPokerPlayerTableSeat = {
  __typename?: 'PolfEventPokerPlayerTableSeat';
  eliminated: Scalars['Boolean']['output'];
  finishingPosition: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isYou: Scalars['Boolean']['output'];
  seatNumber: Scalars['Int']['output'];
  shortName: Scalars['String']['output'];
  startingStack: Scalars['Int']['output'];
};

export type PolfEventPokerPlayerView = {
  __typename?: 'PolfEventPokerPlayerView';
  activeStandings: Array<PolfEventPokerPublicActive>;
  allowPlayerStackUpdate: Scalars['Boolean']['output'];
  averageStack: Maybe<Scalars['Int']['output']>;
  currentInBreak: Maybe<Scalars['Boolean']['output']>;
  currentLevel: Maybe<PolfEventPokerLevelPublic>;
  currentLevelIndex: Maybe<Scalars['Int']['output']>;
  currentLevelPausedAt: Maybe<Scalars['DateTime']['output']>;
  currentLevelStartedAt: Maybe<Scalars['DateTime']['output']>;
  eliminations: Array<PolfEventPokerPublicEliminated>;
  eventName: Scalars['String']['output'];
  nextLevel: Maybe<PolfEventPokerLevelPublic>;
  payouts: Array<PolfEventPokerPlayerPayout>;
  playersLeft: Maybe<Scalars['Int']['output']>;
  playersTotal: Maybe<Scalars['Int']['output']>;
  prizePool: Maybe<Scalars['Int']['output']>;
  seat: Maybe<PolfEventPokerPlayerSeat>;
  status: Maybe<PolfEventPokerStatusEnum>;
  tableSeats: Array<PolfEventPokerPlayerTableSeat>;
  usePayouts: Scalars['Boolean']['output'];
};

export type PolfEventPokerPublicActive = {
  __typename?: 'PolfEventPokerPublicActive';
  currentStack: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  playerName: Scalars['String']['output'];
  seatNumber: Scalars['Int']['output'];
  tableNumber: Scalars['Int']['output'];
};

export type PolfEventPokerPublicDto = {
  __typename?: 'PolfEventPokerPublicDto';
  activeStandings: Array<PolfEventPokerPublicActive>;
  averageStartingStack: Scalars['Int']['output'];
  currentInBreak: Scalars['Boolean']['output'];
  currentLevel: Maybe<PolfEventPokerLevelPublic>;
  currentLevelIndex: Scalars['Int']['output'];
  currentLevelPausedAt: Maybe<Scalars['DateTime']['output']>;
  currentLevelStartedAt: Maybe<Scalars['DateTime']['output']>;
  eliminations: Array<PolfEventPokerPublicEliminated>;
  eventName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nextLevel: Maybe<PolfEventPokerLevelPublic>;
  playersLeft: Scalars['Int']['output'];
  playersTotal: Scalars['Int']['output'];
  status: PolfEventPokerStatusEnum;
  totalLevels: Scalars['Int']['output'];
  voiceAnnouncements: Scalars['Boolean']['output'];
};

export type PolfEventPokerPublicEliminated = {
  __typename?: 'PolfEventPokerPublicEliminated';
  eliminatedAt: Maybe<Scalars['DateTime']['output']>;
  finishingPosition: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  playerName: Scalars['String']['output'];
  seatNumber: Scalars['Int']['output'];
  tableNumber: Scalars['Int']['output'];
};

export type PolfEventPokerSeat = {
  __typename?: 'PolfEventPokerSeat';
  addonTaken: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentStack: Scalars['Int']['output'];
  eliminated: Scalars['Boolean']['output'];
  eliminatedAt: Maybe<Scalars['DateTime']['output']>;
  eliminatedByOperatorId: Maybe<Scalars['ID']['output']>;
  eliminatedByUserId: Maybe<Scalars['ID']['output']>;
  finishingPosition: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  knockedOutByPlayer: Maybe<PolfEventPlayer>;
  polfEventPlayer: PolfEventPlayer;
  rebuyCount: Scalars['Int']['output'];
  seatNumber: Scalars['Int']['output'];
  startingStack: Scalars['Int']['output'];
  tableNumber: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  withdrawn: Scalars['Boolean']['output'];
};

export type PolfEventPokerSmsResult = {
  __typename?: 'PolfEventPokerSmsResult';
  failedCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
};

export enum PolfEventPokerStatusEnum {
  Finished = 'FINISHED',
  NotStarted = 'NOT_STARTED',
  Paused = 'PAUSED',
  Running = 'RUNNING',
  Seated = 'SEATED'
}

export type PolfEventPrice = {
  __typename?: 'PolfEventPrice';
  /** Amount in cents. */
  amountInCents: Scalars['Float']['output'];
};

export type PolfEventPriceDto = {
  /** Amount in cents. */
  amountInCents: Scalars['Float']['input'];
};

export enum PolfEventRankingEnum {
  NetStrokes = 'NET_STROKES',
  Stableford = 'STABLEFORD'
}

export type PolfEventRegistration = {
  __typename?: 'PolfEventRegistration';
  enabled: Scalars['Boolean']['output'];
  /** When true, the registration form lets the player pick their tee. Default (unset/false): the course default tee is auto-assigned. */
  playerPicksTee: Maybe<Scalars['Boolean']['output']>;
  price: PolfEventPrice;
  recruitment: Maybe<PolfEventRegistrationRecruitment>;
};

export type PolfEventRegistrationDto = {
  enabled: Scalars['Boolean']['input'];
  /** When true, the registration form lets the player pick their tee. Default (unset/false): the course default tee is auto-assigned. */
  playerPicksTee?: InputMaybe<Scalars['Boolean']['input']>;
  price: PolfEventPriceDto;
  recruitment?: InputMaybe<PolfEventRegistrationRecruitmentDto>;
};

export type PolfEventRegistrationRecruitment = {
  __typename?: 'PolfEventRegistrationRecruitment';
  /** Amount in cents. */
  amountInCents: Scalars['Float']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type PolfEventRegistrationRecruitmentDto = {
  /** Amount in cents. */
  amountInCents: Scalars['Float']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type PolfEventScore = {
  __typename?: 'PolfEventScore';
  approved: Scalars['Boolean']['output'];
  chips: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  hole: CourseHole;
  id: Scalars['ID']['output'];
  isBirdie: Scalars['Boolean']['output'];
  isBogey: Scalars['Boolean']['output'];
  isDoubleBogeyOrWorse: Scalars['Boolean']['output'];
  isEagleOrBetter: Scalars['Boolean']['output'];
  netScore: Maybe<Scalars['Float']['output']>;
  player: Maybe<PolfEventPlayer>;
  score: Maybe<Scalars['Float']['output']>;
  stablefordPoints: Scalars['Float']['output'];
  strokes: Scalars['Float']['output'];
  submitted: Scalars['Boolean']['output'];
  team: Maybe<PolfEventTeam>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PolfEventScoreDto = {
  polfEventScoreId: Scalars['ID']['input'];
  score: Scalars['Float']['input'];
};

export type PolfEventSegment = {
  __typename?: 'PolfEventSegment';
  format: PolfEventSegmentFormatEnum;
  fromHole: Scalars['Int']['output'];
  ordinal: Scalars['Int']['output'];
  toHole: Scalars['Int']['output'];
};

export type PolfEventSegmentDto = {
  format: PolfEventSegmentFormatEnum;
  fromHole: Scalars['Int']['input'];
  ordinal: Scalars['Int']['input'];
  toHole: Scalars['Int']['input'];
};

export enum PolfEventSegmentFormatEnum {
  Bestball = 'BESTBALL',
  Foursome = 'FOURSOME',
  Golf = 'GOLF',
  Scramble = 'SCRAMBLE'
}

export enum PolfEventStatusEnum {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Finished = 'FINISHED',
  Started = 'STARTED'
}

export type PolfEventTeam = {
  __typename?: 'PolfEventTeam';
  createdAt: Scalars['DateTime']['output'];
  flight: Maybe<PolfEventFlight>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  players: Maybe<Array<PolfEventPlayer>>;
  polfEvent: PolfEvent;
  scoredHoleCount: Scalars['Int']['output'];
  scores: Maybe<Array<PolfEventScore>>;
  strokes: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  valid: Scalars['Boolean']['output'];
};

export type PolfLeaderboard = {
  __typename?: 'PolfLeaderboard';
  flights: Array<PolfLeaderboardFlight>;
  players: Array<PolfLeaderboardPlayer>;
};

export type PolfLeaderboardFlight = {
  __typename?: 'PolfLeaderboardFlight';
  chips: Scalars['Float']['output'];
  flightNumber: Scalars['Float']['output'];
  players: Array<PolfLeaderboardPlayer>;
  rank: Scalars['Float']['output'];
};

export type PolfLeaderboardPlayer = {
  __typename?: 'PolfLeaderboardPlayer';
  beatTheProExtra: Maybe<PolfBeatTheProExtraLeaderboard>;
  birdies: PolfLeaderboardSpecialEntry;
  chips: Scalars['Float']['output'];
  chipsInclHoleCompetitions: Scalars['Float']['output'];
  closest: PolfLeaderboardSpecialEntry;
  eagles: PolfLeaderboardSpecialEntry;
  flightBonus: Maybe<Scalars['Float']['output']>;
  holeInOnes: PolfLeaderboardSpecialEntry;
  holesRegistred: Scalars['Float']['output'];
  isAllIn: Maybe<Scalars['Boolean']['output']>;
  longest: PolfLeaderboardSpecialEntry;
  player: PolfEventPlayer;
  rank: Maybe<Scalars['Float']['output']>;
  scores: Array<PolfEventScore>;
  stablefordPoints: PolfLeaderboardSpecialEntry;
  startStack: Scalars['Float']['output'];
};

export type PolfLeaderboardSpecialEntry = {
  __typename?: 'PolfLeaderboardSpecialEntry';
  chips: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
};

export type ProjectedPokerPlayer = {
  __typename?: 'ProjectedPokerPlayer';
  name: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  projectedStack: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
};

export type ProjectedPokerSetup = {
  __typename?: 'ProjectedPokerSetup';
  averageStack: Scalars['Int']['output'];
  playerCount: Scalars['Int']['output'];
  players: Array<ProjectedPokerPlayer>;
  recommendedTableCount: Scalars['Int']['output'];
  retiredPlayers: Array<ProjectedRetiredPlayer>;
  seatsPerTable: Scalars['Int']['output'];
  totalChips: Scalars['Int']['output'];
};

export type ProjectedRetiredPlayer = {
  __typename?: 'ProjectedRetiredPlayer';
  holesFilled: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playsPoker: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  accountMemberTwoFactorUserIds: Array<Scalars['ID']['output']>;
  accountMembers: Array<AccountMember>;
  accountSettings: AccountSettingsType;
  accounts: Array<Account>;
  brregSearch: Array<BrregCompanyType>;
  course: Course;
  courseTees: Array<CourseTee>;
  courses: Array<Course>;
  currentOpponent: PolfEventHoleCompetitionOpponent;
  currentOpponentHoleCompetitions: Array<PolfEventMobilePlayerHoleCompetition>;
  currentOpponentPlayers: Array<PolfEventBeatTheProPlayer>;
  currentPlayer: PolfEventPlayer;
  currentPlayerEventMatches: Array<PolfEventMatch>;
  currentPlayerFlightMatches: Array<PolfEventMatch>;
  currentPlayerFlightScores: Array<PolfEventMobileScore>;
  currentPlayerHoleCompetitions: Array<PolfEventMobilePlayerHoleCompetition>;
  currentPlayerLeaderBoard: LeaderboardUnion;
  currentPlayerMatch: Maybe<PolfEventMatch>;
  currentPlayerPokerView: PolfEventPokerPlayerView;
  currentPolfEventPublic: PolfEvent;
  devToolsEnabled: Scalars['Boolean']['output'];
  eventSponsors: Array<Sponsor>;
  findCourseDraft: CourseDraftDto;
  me: User;
  myAccountMembers: Array<AccountMember>;
  myAccountSettings: AccountSettingsType;
  myAccounts: Array<AccountMember>;
  myCurrentAccount: Account;
  /** @deprecated Use mySignInStatus.password */
  myHasPasswordLogin: Scalars['Boolean']['output'];
  mySignInStatus: SignInStatus;
  operatorPokerView: OperatorPokerView;
  payment: VippsPayment;
  paymentDetails: VippsPaymentDetails;
  payments: Array<VippsPayment>;
  platformUsers: Array<PlatformUser>;
  polfEvent: PolfEvent;
  polfEventFlightMatchPoints: Array<PolfEventFlightPoints>;
  polfEventFlights: Array<PolfEventFlight>;
  polfEventHoleCompetitions: Array<PolfEventHoleCompetition>;
  polfEventLeaderboard: LeaderboardUnion;
  polfEventMatches: Array<PolfEventMatch>;
  polfEventOperatorList: Array<PolfEventOperator>;
  polfEventPlayerOtherPayment: PolfEventPlayerOtherPayment;
  polfEventPlayers: Array<PolfEventPlayer>;
  polfEventPoker: Maybe<PolfEventPoker>;
  polfEventPokerPublic: Maybe<PolfEventPokerPublicDto>;
  polfEventPublicHoleCompetitionsWithCurrentLeader: Array<PolfEventMobilePlayerHoleCompetition>;
  polfEventPublicLeaderboard: LeaderboardUnion;
  polfEventPublicMatches: Array<PolfEventMatch>;
  polfEventPublicPlayer: PolfEventPlayer;
  polfEventScorecard: Array<PolfEventPlayer>;
  polfEventSponsorsPublic: Array<Sponsor>;
  polfEventTeams: Array<PolfEventTeam>;
  polfEvents: Array<PolfEvent>;
  projectedPokerSetup: ProjectedPokerSetup;
  smsAccountInfo: SmsMeResponse;
  smsHistory: Array<SentSms>;
};


export type QueryAccountMemberTwoFactorUserIdsArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryAccountMembersArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryAccountSettingsArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryBrregSearchArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QueryCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryCourseTeesArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryCurrentOpponentHoleCompetitionsArgs = {
  holeCompetitionType: Array<PolfEventHoleCompetitionTypeEnum>;
};


export type QueryCurrentPlayerHoleCompetitionsArgs = {
  holeCompetitionType: Array<PolfEventHoleCompetitionTypeEnum>;
};


export type QueryEventSponsorsArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryFindCourseDraftArgs = {
  country: CourseCountryEnum;
  deepenFromSources?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};


export type QueryPaymentArgs = {
  paymentId: Scalars['ID']['input'];
};


export type QueryPaymentDetailsArgs = {
  paymentId: Scalars['ID']['input'];
};


export type QueryPolfEventArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventFlightMatchPointsArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventFlightsArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventHoleCompetitionsArgs = {
  polfEventHoleCompetitionType: Array<PolfEventHoleCompetitionTypeEnum>;
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventLeaderboardArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventMatchesArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventOperatorListArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventPlayerOtherPaymentArgs = {
  polfEventPlayerOtherPaymentId: Scalars['ID']['input'];
};


export type QueryPolfEventPlayersArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventPokerArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventPokerPublicArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventPublicHoleCompetitionsWithCurrentLeaderArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventPublicLeaderboardArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventPublicMatchesArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventPublicPlayerArgs = {
  polfEventId: Scalars['ID']['input'];
  polfEventPlayerNanoId: Scalars['ID']['input'];
};


export type QueryPolfEventScorecardArgs = {
  playerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventSponsorsPublicArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryPolfEventTeamsArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QueryProjectedPokerSetupArgs = {
  polfEventId: Scalars['ID']['input'];
};


export type QuerySmsHistoryArgs = {
  sentSmsFilters?: InputMaybe<SentSmsFilters>;
};

export type RebuyAddonConfigInput = {
  addonEnabled: Scalars['Boolean']['input'];
  addonStackChips?: InputMaybe<Scalars['Int']['input']>;
  maxRebuysPerPlayer?: InputMaybe<Scalars['Int']['input']>;
  rebuyStackChips?: InputMaybe<Scalars['Int']['input']>;
  rebuyUntilLevel?: InputMaybe<Scalars['Int']['input']>;
  rebuyWhileActive: Scalars['Boolean']['input'];
  rebuysEnabled: Scalars['Boolean']['input'];
};

export enum ReorderDirection {
  Down = 'DOWN',
  Up = 'UP'
}

export type ScrambleLeaderboard = {
  __typename?: 'ScrambleLeaderboard';
  teams: Array<ScrambleLeaderboardTeam>;
};

export type ScrambleLeaderboardTeam = {
  __typename?: 'ScrambleLeaderboardTeam';
  holesRegistred: Scalars['Float']['output'];
  points: Scalars['Float']['output'];
  rank: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  scores: Array<PolfEventScore>;
  strokes: Scalars['Float']['output'];
  strokesNet: Scalars['Float']['output'];
  team: PolfEventTeam;
};

export type SegmentedLeaderboard = {
  __typename?: 'SegmentedLeaderboard';
  segments: Array<SegmentedLeaderboardSegment>;
  teams: Array<SegmentedLeaderboardTeam>;
};

export type SegmentedLeaderboardSegment = {
  __typename?: 'SegmentedLeaderboardSegment';
  format: PolfEventSegmentFormatEnum;
  fromHole: Scalars['Float']['output'];
  ordinal: Scalars['Float']['output'];
  teams: Array<SegmentedLeaderboardTeam>;
  toHole: Scalars['Float']['output'];
};

export type SegmentedLeaderboardSegmentTotal = {
  __typename?: 'SegmentedLeaderboardSegmentTotal';
  format: PolfEventSegmentFormatEnum;
  holesRegistred: Scalars['Float']['output'];
  ordinal: Scalars['Float']['output'];
  points: Scalars['Float']['output'];
  strokes: Scalars['Float']['output'];
  strokesNet: Scalars['Float']['output'];
};

export type SegmentedLeaderboardTeam = {
  __typename?: 'SegmentedLeaderboardTeam';
  holesRegistred: Scalars['Float']['output'];
  points: Scalars['Float']['output'];
  rank: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  scores: Array<PolfEventScore>;
  segmentTotals: Maybe<Array<SegmentedLeaderboardSegmentTotal>>;
  strokes: Scalars['Float']['output'];
  strokesNet: Scalars['Float']['output'];
  team: PolfEventTeam;
};

export type SelectAccountResponse = {
  __typename?: 'SelectAccountResponse';
  success: Scalars['Boolean']['output'];
};

export type SendSmsDto = {
  /** Field can be used to group messages together, use case: sending sms in bulk */
  batchId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  /** Beat-the-PRO opponent this message is for. Used to mark the opponent failed when the provider rejects the send outright — no delivery webhook arrives in that case. */
  opponentId?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  type?: InputMaybe<SmsTypeEnum>;
};

export type SentSms = {
  __typename?: 'SentSms';
  batchId: Maybe<Scalars['String']['output']>;
  cost: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  delivered: Maybe<Scalars['DateTime']['output']>;
  direction: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  flashsms: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  player: Maybe<PolfEventPlayer>;
  status: SmsStatusEnum;
  to: Scalars['String']['output'];
  type: Maybe<SmsTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SentSmsFilters = {
  showOnlyBatches: Scalars['Boolean']['input'];
};

export type SignInStatus = {
  __typename?: 'SignInStatus';
  password: PasswordStatusEnum;
  providers: Array<Scalars['String']['output']>;
  twoFactor: Scalars['Boolean']['output'];
};

export type SmsBatchResult = {
  __typename?: 'SmsBatchResult';
  /** Groups this blast in the SMS history. */
  batchId: Scalars['String']['output'];
  /** Messages accepted for sending. */
  queued: Scalars['Int']['output'];
  /** Recipients skipped before queueing, e.g. no phone number. */
  skipped: Scalars['Int']['output'];
};

export type SmsMeResponse = {
  __typename?: 'SmsMeResponse';
  balance: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  displayname: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mobilenumber: Scalars['String']['output'];
};

export enum SmsStatusEnum {
  SmsCreated = 'SMS_CREATED',
  SmsDelivered = 'SMS_DELIVERED',
  SmsDeliveryFailed = 'SMS_DELIVERY_FAILED',
  SmsSent = 'SMS_SENT'
}

export enum SmsTypeEnum {
  Paymentreminder = 'PAYMENTREMINDER'
}

export type Sponsor = {
  __typename?: 'Sponsor';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SponsorLogoUpload = {
  __typename?: 'SponsorLogoUpload';
  storagePath: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  smsEventUpdated: Scalars['Boolean']['output'];
};

export type SwapSeatsInput = {
  seatAId: Scalars['ID']['input'];
  seatBId: Scalars['ID']['input'];
};

export type UpdateAccountProfileInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressStreet?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountSettingsInput = {
  brandFooterText?: InputMaybe<Scalars['String']['input']>;
  brandLogoUrl?: InputMaybe<Scalars['String']['input']>;
  brandPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  mailFromName?: InputMaybe<Scalars['String']['input']>;
  mailReplyTo?: InputMaybe<Scalars['String']['input']>;
  paymentNotificationEmail?: InputMaybe<Scalars['String']['input']>;
  privacyUrl?: InputMaybe<Scalars['String']['input']>;
  smsDefaultSender?: InputMaybe<Scalars['String']['input']>;
  startInvoiceNo?: InputMaybe<Scalars['Float']['input']>;
  termsUrl?: InputMaybe<Scalars['String']['input']>;
  vippsClientId?: InputMaybe<Scalars['String']['input']>;
  vippsClientSecret?: InputMaybe<Scalars['String']['input']>;
  vippsMerchantSerialNumber?: InputMaybe<Scalars['String']['input']>;
  vippsSubscriptionKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlindStructureInput = {
  levels: Array<BlindLevelInput>;
};

export type UpdateCourseDto = {
  country?: InputMaybe<CourseCountryEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCourseFromDraftDto = {
  holes: Array<CourseDraftHoleInputDto>;
  name: Scalars['String']['input'];
  tees: Array<CourseDraftTeeInputDto>;
};

export type UpdateCourseHoleDto = {
  index?: InputMaybe<Scalars['Float']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  par?: InputMaybe<Scalars['Float']['input']>;
  tees?: InputMaybe<Array<CourseHoleTeesDto>>;
};

export type UpdateCourseStatusDto = {
  status: CourseStatusEnum;
};

export type UpdateCourseTeeDto = {
  courseRating?: InputMaybe<Scalars['Float']['input']>;
  par?: InputMaybe<Scalars['Float']['input']>;
  slope?: InputMaybe<Scalars['Float']['input']>;
  teeName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyProfileInput = {
  name: Scalars['String']['input'];
};

export type UpdatePayoutStructureInput = {
  rows: Array<PayoutRowInput>;
};

export type UpdatePolfEventChipValues = {
  birdie?: InputMaybe<Scalars['Float']['input']>;
  eagle?: InputMaybe<Scalars['Float']['input']>;
  flightBonus?: InputMaybe<Scalars['Float']['input']>;
  holeInOne?: InputMaybe<Scalars['Float']['input']>;
  polfEventId?: InputMaybe<Scalars['ID']['input']>;
  stablefordPoint?: InputMaybe<Scalars['Float']['input']>;
  startStack?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePolfEventDto = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  hcpFactor?: InputMaybe<Scalars['Float']['input']>;
  matchPlay?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<PolfEventModeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<PolfEventRankingEnum>;
  registration?: InputMaybe<PolfEventRegistrationDto>;
  segments?: InputMaybe<Array<PolfEventSegmentDto>>;
  startingStackChips?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePolfEventFlightDto = {
  startHoleId?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePolfEventHoleCompetitionDto = {
  chipValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  holeId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<PolfEventHoleCompetitionTypeEnum>;
};

export type UpdatePolfEventHoleCompetitionEntryDto = {
  /** Only used for competition type Beat the pro */
  beatTheProExtra?: InputMaybe<BeatTheProExtraDto>;
  polfEventPlayerId?: InputMaybe<Scalars['ID']['input']>;
  /** Distance in cm/meter if closest/longest, or chip value if beat the pro */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePolfEventHoleCompetitionOpponentDto = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePolfEventPlayerDto = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  courseTeeId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hcp?: InputMaybe<Scalars['Float']['input']>;
  memberNo?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recruitedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePolfEventTeamDto = {
  customName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSponsorDto = {
  name: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['DateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type VippsPayment = {
  __typename?: 'VippsPayment';
  aggregate: Maybe<VippsPaymentDetailsAggregate>;
  amount: Maybe<VippsPaymentDetailsAmount>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceNo: Maybe<Scalars['Float']['output']>;
  mobileNumber: Maybe<Scalars['String']['output']>;
  paymentMethod: VippsPaymentMethodEnum;
  paymentStatus: Maybe<VippsPaymentStatusEnum>;
  player: Maybe<PolfEventPlayer>;
  polfEvent: PolfEvent;
  redirectUrl: Maybe<Scalars['String']['output']>;
  reference: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  sub: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userInfo: Maybe<VippsUserInfo>;
};

/** Based on EPaymentGetPaymentResponse from Vipps */
export type VippsPaymentDetails = {
  __typename?: 'VippsPaymentDetails';
  aggregate: VippsPaymentDetailsAggregate;
  amount: VippsPaymentDetailsAmount;
  events: Array<VippsPaymentDetailsEvent>;
  paymentRecord: VippsPayment;
  reference: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type VippsPaymentDetailsAggregate = {
  __typename?: 'VippsPaymentDetailsAggregate';
  authorizedAmount: VippsPaymentDetailsAmount;
  cancelledAmount: VippsPaymentDetailsAmount;
  capturedAmount: VippsPaymentDetailsAmount;
  refundedAmount: VippsPaymentDetailsAmount;
};

export type VippsPaymentDetailsAmount = {
  __typename?: 'VippsPaymentDetailsAmount';
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type VippsPaymentDetailsEvent = {
  __typename?: 'VippsPaymentDetailsEvent';
  amount: VippsPaymentDetailsAmount;
  name: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  timestamp: Scalars['String']['output'];
};

export enum VippsPaymentMethodEnum {
  Card = 'CARD',
  Wallet = 'WALLET'
}

export enum VippsPaymentStatusEnum {
  Aborted = 'ABORTED',
  Captured = 'CAPTURED',
  Expired = 'EXPIRED',
  None = 'NONE',
  Refunded = 'REFUNDED',
  Reserved = 'RESERVED'
}

export type VippsUserInfo = {
  __typename?: 'VippsUserInfo';
  address: VippsUserInfoAddress;
  birthdate: Scalars['String']['output'];
  email: Scalars['String']['output'];
  email_verified: Scalars['Boolean']['output'];
  family_name: Scalars['String']['output'];
  given_name: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
};

export type VippsUserInfoAddress = {
  __typename?: 'VippsUserInfoAddress';
  address_type: Scalars['String']['output'];
  country: Scalars['String']['output'];
  formatted: Scalars['String']['output'];
  postal_code: Scalars['String']['output'];
  region: Scalars['String']['output'];
  street_address: Scalars['String']['output'];
};

export type MyCurrentAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCurrentAccountQuery = { __typename?: 'Query', myCurrentAccount: { __typename?: 'Account', id: string, name: string, slug: string, type: AccountTypeEnum, onboardingCompleted: boolean, orgNumber: string | undefined, addressStreet: string | undefined, addressPostalCode: string | undefined, addressCity: string | undefined, contactEmail: string | undefined, contactPhone: string | undefined, website: string | undefined, createdAt: any } };

export type MyAccountSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountSettingsQuery = { __typename?: 'Query', myAccountSettings: { __typename?: 'AccountSettingsType', id: string, vippsConfigured: boolean, vippsValidated: boolean, vippsClientIdMasked: string | undefined, vippsMerchantSerialNumberMasked: string | undefined, startInvoiceNo: number, paymentNotificationEmail: string | undefined, emailConfigured: boolean, smsConfigured: boolean, legalConfigured: boolean, onboardingCompleted: boolean, sectionsConfigured: number, sectionsTotal: number, mailFromName: string | undefined, mailReplyTo: string | undefined, smsDefaultSender: string | undefined, termsUrl: string | undefined, privacyUrl: string | undefined } };

export type MyAccountProfileUpdateMutationVariables = Exact<{
  profile: UpdateAccountProfileInput;
}>;


export type MyAccountProfileUpdateMutation = { __typename?: 'Mutation', myAccountProfileUpdate: { __typename?: 'Account', id: string, name: string, orgNumber: string | undefined, addressStreet: string | undefined, addressPostalCode: string | undefined, addressCity: string | undefined, contactEmail: string | undefined, contactPhone: string | undefined, website: string | undefined } };

export type MyAccountSettingsUpdateMutationVariables = Exact<{
  settings: UpdateAccountSettingsInput;
}>;


export type MyAccountSettingsUpdateMutation = { __typename?: 'Mutation', myAccountSettingsUpdate: { __typename?: 'AccountSettingsType', id: string, vippsConfigured: boolean, vippsValidated: boolean, vippsClientIdMasked: string | undefined, vippsMerchantSerialNumberMasked: string | undefined, startInvoiceNo: number, paymentNotificationEmail: string | undefined, emailConfigured: boolean, smsConfigured: boolean, legalConfigured: boolean, sectionsConfigured: number, sectionsTotal: number, mailFromName: string | undefined, mailReplyTo: string | undefined, smsDefaultSender: string | undefined, termsUrl: string | undefined, privacyUrl: string | undefined } };

export type MyAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountsQuery = { __typename?: 'Query', myAccounts: Array<{ __typename?: 'AccountMember', id: string, account: { __typename?: 'Account', id: string, name: string, slug: string, type: AccountTypeEnum } }> };

export type SelectAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SelectAccountMutation = { __typename?: 'Mutation', selectAccount: { __typename?: 'SelectAccountResponse', success: boolean } };

export type MyAccountMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountMembersQuery = { __typename?: 'Query', myAccountMembers: Array<{ __typename?: 'AccountMember', id: string, isContactPerson: boolean, user: { __typename?: 'User', id: string, name: string, email: string | undefined } }> };

export type MyAccountAddMemberMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type MyAccountAddMemberMutation = { __typename?: 'Mutation', myAccountAddMember: { __typename?: 'AccountMember', id: string, isContactPerson: boolean, user: { __typename?: 'User', id: string, name: string, email: string | undefined } } };

export type MyAccountRemoveMemberMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type MyAccountRemoveMemberMutation = { __typename?: 'Mutation', myAccountRemoveMember: boolean };

export type CourseFieldsFragment = { __typename?: 'Course', id: string, name: string, isValid: boolean, country: CourseCountryEnum, status: CourseStatusEnum, aiImported: boolean, updatedAt: any, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined }>, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> | undefined };

export type CourseTeeFieldsFragment = { __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number };

export type CourseHoleFieldsFragment = { __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined };

export type CoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type CoursesQuery = { __typename?: 'Query', courses: Array<{ __typename?: 'Course', id: string, name: string, isValid: boolean, country: CourseCountryEnum, status: CourseStatusEnum, aiImported: boolean, updatedAt: any, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined }>, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> | undefined }> };

export type CourseQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type CourseQuery = { __typename?: 'Query', course: { __typename?: 'Course', id: string, name: string, isValid: boolean, country: CourseCountryEnum, status: CourseStatusEnum, aiImported: boolean, updatedAt: any, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined }>, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> | undefined } };

export type CourseDraftFieldsFragment = { __typename?: 'CourseDraftDto', name: string, country: CourseCountryEnum, tees: Array<{ __typename?: 'CourseDraftTeeDto', teeName: string, courseRating: number, slope: number, par: number }>, holes: Array<{ __typename?: 'CourseDraftHoleDto', number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseDraftHoleTeeDto', teeName: string, length: number }> }>, sources: Array<{ __typename?: 'CourseDraftSourceDto', uri: string, title: string }> };

export type FindCourseDraftQueryVariables = Exact<{
  name: Scalars['String']['input'];
  country: CourseCountryEnum;
  deepenFromSources?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FindCourseDraftQuery = { __typename?: 'Query', findCourseDraft: { __typename?: 'CourseDraftDto', name: string, country: CourseCountryEnum, tees: Array<{ __typename?: 'CourseDraftTeeDto', teeName: string, courseRating: number, slope: number, par: number }>, holes: Array<{ __typename?: 'CourseDraftHoleDto', number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseDraftHoleTeeDto', teeName: string, length: number }> }>, sources: Array<{ __typename?: 'CourseDraftSourceDto', uri: string, title: string }> } };

export type CourseCreateMutationVariables = Exact<{
  createCourseDto: CreateCourseDto;
}>;


export type CourseCreateMutation = { __typename?: 'Mutation', courseCreate: { __typename?: 'Course', id: string, name: string, isValid: boolean, country: CourseCountryEnum, status: CourseStatusEnum, aiImported: boolean, updatedAt: any, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined }>, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> | undefined } };

export type CourseUpdateMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  updateCourseDto: UpdateCourseDto;
}>;


export type CourseUpdateMutation = { __typename?: 'Mutation', courseUpdate: { __typename?: 'Course', id: string, name: string, isValid: boolean, country: CourseCountryEnum, status: CourseStatusEnum, aiImported: boolean, updatedAt: any, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined }>, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> | undefined } };

export type CourseStatusUpdateMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  updateCourseStatusDto: UpdateCourseStatusDto;
}>;


export type CourseStatusUpdateMutation = { __typename?: 'Mutation', courseStatusUpdate: { __typename?: 'Course', id: string, name: string, isValid: boolean, country: CourseCountryEnum, status: CourseStatusEnum, aiImported: boolean, updatedAt: any, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined }>, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> | undefined } };

export type CourseDeleteMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type CourseDeleteMutation = { __typename?: 'Mutation', courseDelete: { __typename?: 'Course', id: string, status: CourseStatusEnum } };

export type CourseCreateFromDraftMutationVariables = Exact<{
  createCourseFromDraftDto: CreateCourseFromDraftDto;
}>;


export type CourseCreateFromDraftMutation = { __typename?: 'Mutation', courseCreateFromDraft: { __typename?: 'Course', id: string, name: string, isValid: boolean, country: CourseCountryEnum, status: CourseStatusEnum, aiImported: boolean, updatedAt: any, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined }>, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> | undefined } };

export type CourseUpdateFromDraftMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  updateCourseFromDraftDto: UpdateCourseFromDraftDto;
}>;


export type CourseUpdateFromDraftMutation = { __typename?: 'Mutation', courseUpdateFromDraft: { __typename?: 'Course', id: string, name: string, isValid: boolean, country: CourseCountryEnum, status: CourseStatusEnum, aiImported: boolean, updatedAt: any, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined }>, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> | undefined } };

export type CourseUpdateHolesMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  updateCourseHoleDtos: Array<UpdateCourseHoleDto> | UpdateCourseHoleDto;
}>;


export type CourseUpdateHolesMutation = { __typename?: 'Mutation', courseUpdateHoles: { __typename?: 'Course', id: string, name: string, isValid: boolean, country: CourseCountryEnum, status: CourseStatusEnum, aiImported: boolean, updatedAt: any, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined }>, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> | undefined } };

export type CourseHoleAddMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  createCourseHoleDto: CreateCourseHoleDto;
}>;


export type CourseHoleAddMutation = { __typename?: 'Mutation', courseHoleAdd: { __typename?: 'Course', id: string, name: string, isValid: boolean, country: CourseCountryEnum, status: CourseStatusEnum, aiImported: boolean, updatedAt: any, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined }>, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> | undefined } };

export type CourseHoleDeleteMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  holeId: Scalars['ID']['input'];
}>;


export type CourseHoleDeleteMutation = { __typename?: 'Mutation', courseHoleDelete: { __typename?: 'Course', id: string, name: string, isValid: boolean, country: CourseCountryEnum, status: CourseStatusEnum, aiImported: boolean, updatedAt: any, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number, tees: Array<{ __typename?: 'CourseHoleTees', teeId: string, length: number | undefined }> | undefined }>, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> | undefined } };

export type CourseTeeCreateMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  createCourseTeeDto: CreateCourseTeeDto;
}>;


export type CourseTeeCreateMutation = { __typename?: 'Mutation', courseTeeCreate: { __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number } };

export type CourseTeeUpdateMutationVariables = Exact<{
  courseTeeId: Scalars['ID']['input'];
  updateCourseTeeDto: UpdateCourseTeeDto;
}>;


export type CourseTeeUpdateMutation = { __typename?: 'Mutation', courseTeeUpdate: { __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number } };

export type CourseTeeDeleteMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  courseTeeId: Scalars['ID']['input'];
}>;


export type CourseTeeDeleteMutation = { __typename?: 'Mutation', courseTeeDelete: { __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number } };

export type CourseTeeSetDefaultMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  courseTeeId: Scalars['ID']['input'];
}>;


export type CourseTeeSetDefaultMutation = { __typename?: 'Mutation', courseTeeSetDefault: Array<{ __typename?: 'CourseTee', id: string, teeName: string, default: boolean, courseRating: number, slope: number, par: number }> };

export type DevToolsEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type DevToolsEnabledQuery = { __typename?: 'Query', devToolsEnabled: boolean };

export type DevReseedMutationVariables = Exact<{
  scope?: InputMaybe<DevReseedScope>;
}>;


export type DevReseedMutation = { __typename?: 'Mutation', devReseed: { __typename?: 'DevReseedResult', durationMs: number } };

export type FlightListItemFragment = { __typename?: 'PolfEventFlight', id: string, flightNumber: number, startTime: string | undefined, playerCount: number, createdAt: any, updatedAt: any, startHole: { __typename?: 'CourseHole', id: string, number: number, par: number } | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, scoresSubmitted: boolean, courseTee: { __typename?: 'CourseTee', id: string, teeName: string } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined }> | undefined, teams: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined }> | undefined };

export type PolfEventFlightsQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventFlightsQuery = { __typename?: 'Query', polfEventFlights: Array<{ __typename?: 'PolfEventFlight', id: string, flightNumber: number, startTime: string | undefined, playerCount: number, createdAt: any, updatedAt: any, startHole: { __typename?: 'CourseHole', id: string, number: number, par: number } | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, scoresSubmitted: boolean, courseTee: { __typename?: 'CourseTee', id: string, teeName: string } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined }> | undefined, teams: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined }> | undefined }> };

export type PolfEventFlightAddMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventFlightAddMutation = { __typename?: 'Mutation', polfEventFlightAdd: { __typename?: 'PolfEventFlight', id: string, flightNumber: number, startTime: string | undefined, playerCount: number, createdAt: any, updatedAt: any, startHole: { __typename?: 'CourseHole', id: string, number: number, par: number } | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, scoresSubmitted: boolean, courseTee: { __typename?: 'CourseTee', id: string, teeName: string } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined }> | undefined, teams: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined }> | undefined } };

export type PolfEventFlightUpdateMutationVariables = Exact<{
  polfEventFlightId: Scalars['ID']['input'];
  updatePolfEventFlightDto: UpdatePolfEventFlightDto;
}>;


export type PolfEventFlightUpdateMutation = { __typename?: 'Mutation', polfEventFlightUpdate: { __typename?: 'PolfEventFlight', id: string, flightNumber: number, startTime: string | undefined, playerCount: number, createdAt: any, updatedAt: any, startHole: { __typename?: 'CourseHole', id: string, number: number, par: number } | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, scoresSubmitted: boolean, courseTee: { __typename?: 'CourseTee', id: string, teeName: string } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined }> | undefined, teams: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined }> | undefined } };

export type PolfEventFlightRemoveMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  polfEventFlightId: Scalars['ID']['input'];
}>;


export type PolfEventFlightRemoveMutation = { __typename?: 'Mutation', polfEventFlightRemove: { __typename?: 'PolfEventFlight', id: string } };

export type PolfEventFlightAddPlayerMutationVariables = Exact<{
  polfEventFlightId: Scalars['ID']['input'];
  polfEventPlayerId: Scalars['ID']['input'];
}>;


export type PolfEventFlightAddPlayerMutation = { __typename?: 'Mutation', polfEventFlightAddPlayer: { __typename?: 'PolfEventFlight', id: string, flightNumber: number, startTime: string | undefined, playerCount: number, createdAt: any, updatedAt: any, startHole: { __typename?: 'CourseHole', id: string, number: number, par: number } | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, scoresSubmitted: boolean, courseTee: { __typename?: 'CourseTee', id: string, teeName: string } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined }> | undefined, teams: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined }> | undefined } };

export type PolfEventFlightRemovePlayerMutationVariables = Exact<{
  polfEventPlayerId: Scalars['ID']['input'];
  flightId: Scalars['ID']['input'];
}>;


export type PolfEventFlightRemovePlayerMutation = { __typename?: 'Mutation', polfEventFlightRemovePlayer: { __typename?: 'PolfEventFlight', id: string, flightNumber: number, startTime: string | undefined, playerCount: number, createdAt: any, updatedAt: any, startHole: { __typename?: 'CourseHole', id: string, number: number, par: number } | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, scoresSubmitted: boolean, courseTee: { __typename?: 'CourseTee', id: string, teeName: string } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined }> | undefined, teams: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined }> | undefined } };

export type PolfEventFlightAddTeamMutationVariables = Exact<{
  polfEventFlightId: Scalars['ID']['input'];
  polfEventTeamId: Scalars['ID']['input'];
}>;


export type PolfEventFlightAddTeamMutation = { __typename?: 'Mutation', polfEventFlightAddTeam: { __typename?: 'PolfEventFlight', id: string, flightNumber: number, startTime: string | undefined, playerCount: number, createdAt: any, updatedAt: any, startHole: { __typename?: 'CourseHole', id: string, number: number, par: number } | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, scoresSubmitted: boolean, courseTee: { __typename?: 'CourseTee', id: string, teeName: string } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined }> | undefined, teams: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined }> | undefined } };

export type PolfEventFlightRemoveTeamMutationVariables = Exact<{
  polfEventTeamId: Scalars['ID']['input'];
  flightId: Scalars['ID']['input'];
}>;


export type PolfEventFlightRemoveTeamMutation = { __typename?: 'Mutation', polfEventFlightRemoveTeam: { __typename?: 'PolfEventFlight', id: string, flightNumber: number, startTime: string | undefined, playerCount: number, createdAt: any, updatedAt: any, startHole: { __typename?: 'CourseHole', id: string, number: number, par: number } | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, scoresSubmitted: boolean, courseTee: { __typename?: 'CourseTee', id: string, teeName: string } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined }> | undefined, teams: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined }> | undefined } };

export type PolfEventPlayerDistributeInFlightsMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  redistributeAll?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PolfEventPlayerDistributeInFlightsMutation = { __typename?: 'Mutation', polfEventPlayerDistributeInFlights: Array<{ __typename?: 'PolfEventFlight', id: string, flightNumber: number, startTime: string | undefined, playerCount: number, createdAt: any, updatedAt: any, startHole: { __typename?: 'CourseHole', id: string, number: number, par: number } | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, scoresSubmitted: boolean, courseTee: { __typename?: 'CourseTee', id: string, teeName: string } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined }> | undefined, teams: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined }> | undefined }> };

export type PolfEventTeamDistributeInFlightsMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  redistributeAll?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PolfEventTeamDistributeInFlightsMutation = { __typename?: 'Mutation', polfEventTeamDistributeInFlights: Array<{ __typename?: 'PolfEventFlight', id: string, flightNumber: number, startTime: string | undefined, playerCount: number, createdAt: any, updatedAt: any, startHole: { __typename?: 'CourseHole', id: string, number: number, par: number } | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, scoresSubmitted: boolean, courseTee: { __typename?: 'CourseTee', id: string, teeName: string } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined }> | undefined, teams: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined }> | undefined }> };

export type HoleCompetitionItemFragment = { __typename?: 'PolfEventHoleCompetition', id: string, type: PolfEventHoleCompetitionTypeEnum, description: string, chipValue: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number }, opponent: { __typename?: 'PolfEventHoleCompetitionOpponent', id: string, name: string, countryCode: string, mobileNumber: string, nanoId: string | undefined } | undefined };

export type PolfEventHoleCompetitionsQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  polfEventHoleCompetitionType: Array<PolfEventHoleCompetitionTypeEnum> | PolfEventHoleCompetitionTypeEnum;
}>;


export type PolfEventHoleCompetitionsQuery = { __typename?: 'Query', polfEventHoleCompetitions: Array<{ __typename?: 'PolfEventHoleCompetition', id: string, type: PolfEventHoleCompetitionTypeEnum, description: string, chipValue: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number }, opponent: { __typename?: 'PolfEventHoleCompetitionOpponent', id: string, name: string, countryCode: string, mobileNumber: string, nanoId: string | undefined } | undefined }> };

export type HoleCompetitionEntryFragment = { __typename?: 'PolfEventHoleCompetitionEntry', id: string, value: number, beatTheProExtra: { __typename?: 'BeatTheProExtra', bet: number, allIn: boolean, state: BeatTheProEntryStateEnum } | undefined, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } };

export type HoleCompetitionWithEntriesFragment = { __typename?: 'PolfEventHoleCompetition', id: string, type: PolfEventHoleCompetitionTypeEnum, description: string, chipValue: number, entries: Array<{ __typename?: 'PolfEventHoleCompetitionEntry', id: string, value: number, beatTheProExtra: { __typename?: 'BeatTheProExtra', bet: number, allIn: boolean, state: BeatTheProEntryStateEnum } | undefined, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } }> | undefined, hole: { __typename?: 'CourseHole', id: string, number: number, par: number }, opponent: { __typename?: 'PolfEventHoleCompetitionOpponent', id: string, name: string, countryCode: string, mobileNumber: string, nanoId: string | undefined } | undefined };

export type PolfEventHoleCompetitionsWithEntriesQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  polfEventHoleCompetitionType: Array<PolfEventHoleCompetitionTypeEnum> | PolfEventHoleCompetitionTypeEnum;
}>;


export type PolfEventHoleCompetitionsWithEntriesQuery = { __typename?: 'Query', polfEventHoleCompetitions: Array<{ __typename?: 'PolfEventHoleCompetition', id: string, type: PolfEventHoleCompetitionTypeEnum, description: string, chipValue: number, entries: Array<{ __typename?: 'PolfEventHoleCompetitionEntry', id: string, value: number, beatTheProExtra: { __typename?: 'BeatTheProExtra', bet: number, allIn: boolean, state: BeatTheProEntryStateEnum } | undefined, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } }> | undefined, hole: { __typename?: 'CourseHole', id: string, number: number, par: number }, opponent: { __typename?: 'PolfEventHoleCompetitionOpponent', id: string, name: string, countryCode: string, mobileNumber: string, nanoId: string | undefined } | undefined }> };

export type PolfEventHoleCompetitionEntryUpdateMutationVariables = Exact<{
  polfEventHoleCompetitionEntryId: Scalars['ID']['input'];
  updatePolfEventHoleCompetitionEntryDto: UpdatePolfEventHoleCompetitionEntryDto;
}>;


export type PolfEventHoleCompetitionEntryUpdateMutation = { __typename?: 'Mutation', polfEventHoleCompetitionEntryUpdate: { __typename?: 'PolfEventHoleCompetitionEntry', id: string, value: number, beatTheProExtra: { __typename?: 'BeatTheProExtra', bet: number, allIn: boolean, state: BeatTheProEntryStateEnum } | undefined, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } } };

export type PolfEventHoleCompetitionEntryRemoveMutationVariables = Exact<{
  polfEventHoleCompetitionEntryId: Scalars['ID']['input'];
}>;


export type PolfEventHoleCompetitionEntryRemoveMutation = { __typename?: 'Mutation', polfEventHoleCompetitionEntryRemove: { __typename?: 'PolfEventHoleCompetitionEntry', id: string } };

export type PolfEventHoleCompetitionCreateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  createPolfEventHoleCompetitionDto: CreatePolfEventHoleCompetitionDto;
}>;


export type PolfEventHoleCompetitionCreateMutation = { __typename?: 'Mutation', polfEventHoleCompetitionCreate: { __typename?: 'PolfEventHoleCompetition', id: string, type: PolfEventHoleCompetitionTypeEnum, description: string, chipValue: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number }, opponent: { __typename?: 'PolfEventHoleCompetitionOpponent', id: string, name: string, countryCode: string, mobileNumber: string, nanoId: string | undefined } | undefined } };

export type PolfEventHoleCompetitionUpdateMutationVariables = Exact<{
  polfEventHoleCompetitionId: Scalars['ID']['input'];
  updatePolfEventHoleCompetitionDto: UpdatePolfEventHoleCompetitionDto;
}>;


export type PolfEventHoleCompetitionUpdateMutation = { __typename?: 'Mutation', polfEventHoleCompetitionUpdate: { __typename?: 'PolfEventHoleCompetition', id: string, type: PolfEventHoleCompetitionTypeEnum, description: string, chipValue: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number }, opponent: { __typename?: 'PolfEventHoleCompetitionOpponent', id: string, name: string, countryCode: string, mobileNumber: string, nanoId: string | undefined } | undefined } };

export type PolfEventHoleCompetitionRemoveMutationVariables = Exact<{
  polfEventHoleCompetitionId: Scalars['ID']['input'];
}>;


export type PolfEventHoleCompetitionRemoveMutation = { __typename?: 'Mutation', polfEventHoleCompetitionRemove: { __typename?: 'PolfEventHoleCompetition', id: string } };

export type PolfEventHoleCompetitionOpponentAddMutationVariables = Exact<{
  polfEventHoleCompetitionId: Scalars['ID']['input'];
  createPolfEventHoleCompetitionOpponentDto: CreatePolfEventHoleCompetitionOpponentDto;
}>;


export type PolfEventHoleCompetitionOpponentAddMutation = { __typename?: 'Mutation', polfEventHoleCompetitionOpponentAdd: { __typename?: 'PolfEventHoleCompetition', id: string, type: PolfEventHoleCompetitionTypeEnum, description: string, chipValue: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number }, opponent: { __typename?: 'PolfEventHoleCompetitionOpponent', id: string, name: string, countryCode: string, mobileNumber: string, nanoId: string | undefined } | undefined } };

export type PolfEventHoleCompetitionOpponentUpdateMutationVariables = Exact<{
  polfEventHoleCompetitionOpponentId: Scalars['ID']['input'];
  updatePolfEventHoleCompetitionOpponentDto: UpdatePolfEventHoleCompetitionOpponentDto;
}>;


export type PolfEventHoleCompetitionOpponentUpdateMutation = { __typename?: 'Mutation', polfEventHoleCompetitionOpponentUpdate: { __typename?: 'PolfEventHoleCompetition', id: string, type: PolfEventHoleCompetitionTypeEnum, description: string, chipValue: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number }, opponent: { __typename?: 'PolfEventHoleCompetitionOpponent', id: string, name: string, countryCode: string, mobileNumber: string, nanoId: string | undefined } | undefined } };

export type SummaryPolfPlayerRowFragment = { __typename?: 'PolfLeaderboardPlayer', rank: number | undefined, chips: number, chipsInclHoleCompetitions: number, startStack: number, holesRegistred: number, flightBonus: number | undefined, isAllIn: boolean | undefined, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined }, stablefordPoints: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, birdies: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, eagles: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, holeInOnes: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, closest: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, longest: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, beatTheProExtra: { __typename?: 'PolfBeatTheProExtraLeaderboard', value: number, bet: number, state: BeatTheProEntryStateEnum, allIn: boolean } | undefined };

export type SummaryGolfPlayerRowFragment = { __typename?: 'GolfLeaderboardPlayer', rank: number | undefined, strokes: number, strokesNet: number, score: number, points: number, holesRegistred: number, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined } };

export type SummaryScrambleTeamRowFragment = { __typename?: 'ScrambleLeaderboardTeam', rank: number | undefined, strokes: number, strokesNet: number, score: number, points: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } };

export type SummaryBestBallTeamRowFragment = { __typename?: 'BestBallLeaderboardTeam', rank: number | undefined, strokes: number, strokesNet: number, score: number, points: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } };

export type SummarySegmentedTeamRowFragment = { __typename?: 'SegmentedLeaderboardTeam', rank: number | undefined, strokes: number, strokesNet: number, score: number, points: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } };

export type PolfEventLeaderboardQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventLeaderboardQuery = { __typename?: 'Query', polfEventLeaderboard: { __typename: 'BestBallLeaderboard', teams: Array<{ __typename?: 'BestBallLeaderboardTeam', rank: number | undefined, strokes: number, strokesNet: number, score: number, points: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } }>, players: Array<{ __typename?: 'GolfLeaderboardPlayer', rank: number | undefined, strokes: number, strokesNet: number, score: number, points: number, holesRegistred: number, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined } }> } | { __typename: 'GolfLeaderboard', players: Array<{ __typename?: 'GolfLeaderboardPlayer', rank: number | undefined, strokes: number, strokesNet: number, score: number, points: number, holesRegistred: number, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined } }> } | { __typename: 'PolfLeaderboard', players: Array<{ __typename?: 'PolfLeaderboardPlayer', rank: number | undefined, chips: number, chipsInclHoleCompetitions: number, startStack: number, holesRegistred: number, flightBonus: number | undefined, isAllIn: boolean | undefined, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined }, stablefordPoints: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, birdies: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, eagles: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, holeInOnes: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, closest: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, longest: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, beatTheProExtra: { __typename?: 'PolfBeatTheProExtraLeaderboard', value: number, bet: number, state: BeatTheProEntryStateEnum, allIn: boolean } | undefined }> } | { __typename: 'ScrambleLeaderboard', teams: Array<{ __typename?: 'ScrambleLeaderboardTeam', rank: number | undefined, strokes: number, strokesNet: number, score: number, points: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } }> } | { __typename: 'SegmentedLeaderboard', segments: Array<{ __typename?: 'SegmentedLeaderboardSegment', ordinal: number, fromHole: number, toHole: number, format: PolfEventSegmentFormatEnum, teams: Array<{ __typename?: 'SegmentedLeaderboardTeam', rank: number | undefined, strokes: number, strokesNet: number, score: number, points: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } }> }>, teams: Array<{ __typename?: 'SegmentedLeaderboardTeam', rank: number | undefined, strokes: number, strokesNet: number, score: number, points: number, holesRegistred: number, segmentTotals: Array<{ __typename?: 'SegmentedLeaderboardSegmentTotal', ordinal: number, format: PolfEventSegmentFormatEnum, strokes: number, strokesNet: number, points: number, holesRegistred: number }> | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } }> } };

export type MatchSideFieldsFragment = { __typename?: 'PolfEventMatchSide', kind: MatchSideKindEnum, id: string, name: string, hcp: number | undefined, handicap: number | undefined, strokes: number, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number }> };

export type EventMatchFieldsFragment = { __typename?: 'PolfEventMatch', id: string, matchNumber: number, segmentOrdinal: number | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined, sideA: { __typename?: 'PolfEventMatchSide', kind: MatchSideKindEnum, id: string, name: string, hcp: number | undefined, handicap: number | undefined, strokes: number, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number }> } | undefined, sideB: { __typename?: 'PolfEventMatchSide', kind: MatchSideKindEnum, id: string, name: string, hcp: number | undefined, handicap: number | undefined, strokes: number, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number }> } | undefined, state: { __typename?: 'PolfEventMatchState', status: MatchStatusEnum, holesUp: number, leader: MatchSideEnum | undefined, holesRemaining: number, margin: string | undefined, pointsPerHole: number, holes: Array<HoleWinnerEnum> } | undefined };

export type PolfEventMatchesQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventMatchesQuery = { __typename?: 'Query', polfEventMatches: Array<{ __typename?: 'PolfEventMatch', id: string, matchNumber: number, segmentOrdinal: number | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined, sideA: { __typename?: 'PolfEventMatchSide', kind: MatchSideKindEnum, id: string, name: string, hcp: number | undefined, handicap: number | undefined, strokes: number, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number }> } | undefined, sideB: { __typename?: 'PolfEventMatchSide', kind: MatchSideKindEnum, id: string, name: string, hcp: number | undefined, handicap: number | undefined, strokes: number, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number }> } | undefined, state: { __typename?: 'PolfEventMatchState', status: MatchStatusEnum, holesUp: number, leader: MatchSideEnum | undefined, holesRemaining: number, margin: string | undefined, pointsPerHole: number, holes: Array<HoleWinnerEnum> } | undefined }> };

export type PolfEventMatchAddMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  createPolfEventMatchDto: CreatePolfEventMatchDto;
}>;


export type PolfEventMatchAddMutation = { __typename?: 'Mutation', polfEventMatchAdd: { __typename?: 'PolfEventMatch', id: string, matchNumber: number, segmentOrdinal: number | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined, sideA: { __typename?: 'PolfEventMatchSide', kind: MatchSideKindEnum, id: string, name: string, hcp: number | undefined, handicap: number | undefined, strokes: number, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number }> } | undefined, sideB: { __typename?: 'PolfEventMatchSide', kind: MatchSideKindEnum, id: string, name: string, hcp: number | undefined, handicap: number | undefined, strokes: number, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number }> } | undefined, state: { __typename?: 'PolfEventMatchState', status: MatchStatusEnum, holesUp: number, leader: MatchSideEnum | undefined, holesRemaining: number, margin: string | undefined, pointsPerHole: number, holes: Array<HoleWinnerEnum> } | undefined } };

export type PolfEventMatchDeleteMutationVariables = Exact<{
  polfEventMatchId: Scalars['ID']['input'];
}>;


export type PolfEventMatchDeleteMutation = { __typename?: 'Mutation', polfEventMatchDelete: boolean };

export type PolfEventFlightMatchPointsQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventFlightMatchPointsQuery = { __typename?: 'Query', polfEventFlightMatchPoints: Array<{ __typename?: 'PolfEventFlightPoints', total: number, undecided: number, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number }, sides: Array<{ __typename?: 'PolfEventFlightPointsSide', points: number, won: number, halved: number, lost: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } }> }> };

export type ScorecardScoreFragment = { __typename?: 'PolfEventScore', id: string, score: number | undefined, strokes: number, stablefordPoints: number, chips: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number, index: number } };

export type ScorecardPlayerFragment = { __typename?: 'PolfEventPlayer', id: string, name: string, retiredAt: any | undefined, retiredHolesFilled: number | undefined, scores: Array<{ __typename?: 'PolfEventScore', id: string, score: number | undefined, strokes: number, stablefordPoints: number, chips: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number, index: number } }> | undefined };

export type PolfEventScorecardQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  playerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PolfEventScorecardQuery = { __typename?: 'Query', polfEventScorecard: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, retiredAt: any | undefined, retiredHolesFilled: number | undefined, scores: Array<{ __typename?: 'PolfEventScore', id: string, score: number | undefined, strokes: number, stablefordPoints: number, chips: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number, index: number } }> | undefined }> };

export type PolfEventPlayerScoreUpdateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  scoreDto: PolfEventScoreDto;
}>;


export type PolfEventPlayerScoreUpdateMutation = { __typename?: 'Mutation', polfEventPlayerScoreUpdate: { __typename?: 'PolfEventScore', id: string, score: number | undefined, strokes: number, stablefordPoints: number, chips: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number, index: number } } | undefined };

export type PlayerListItemFragment = { __typename?: 'PolfEventPlayer', id: string, nanoId: string | undefined, name: string, email: string | undefined, memberNo: string | undefined, hcp: number | undefined, countryCode: string, mobileNumber: string, valid: boolean, strokes: number, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined, retiredPlaysPoker: boolean, smsInviteStatus: SmsStatusEnum | undefined, createdAt: any, updatedAt: any, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, courseRating: number, slope: number, par: number } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined, flight: { __typename?: 'PolfEventFlight', id: string } | undefined, recruitment: { __typename?: 'PolfEventPlayerRecruitment', id: string, status: PolfEventPlayerRecruitmentStatusEnum, amountInCents: number, recruitedBy: string } | undefined, sentSms: Array<{ __typename?: 'SentSms', id: string, type: SmsTypeEnum | undefined, status: SmsStatusEnum, createdAt: any }> | undefined, payment: { __typename: 'PolfEventPlayerOtherPayment', id: string, createdAt: any } | { __typename: 'VippsPayment', id: string, paymentStatus: VippsPaymentStatusEnum | undefined, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } | undefined } | undefined };

export type PolfEventPlayersQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventPlayersQuery = { __typename?: 'Query', polfEventPlayers: Array<{ __typename?: 'PolfEventPlayer', id: string, nanoId: string | undefined, name: string, email: string | undefined, memberNo: string | undefined, hcp: number | undefined, countryCode: string, mobileNumber: string, valid: boolean, strokes: number, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined, retiredPlaysPoker: boolean, smsInviteStatus: SmsStatusEnum | undefined, createdAt: any, updatedAt: any, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, courseRating: number, slope: number, par: number } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined, flight: { __typename?: 'PolfEventFlight', id: string } | undefined, recruitment: { __typename?: 'PolfEventPlayerRecruitment', id: string, status: PolfEventPlayerRecruitmentStatusEnum, amountInCents: number, recruitedBy: string } | undefined, sentSms: Array<{ __typename?: 'SentSms', id: string, type: SmsTypeEnum | undefined, status: SmsStatusEnum, createdAt: any }> | undefined, payment: { __typename: 'PolfEventPlayerOtherPayment', id: string, createdAt: any } | { __typename: 'VippsPayment', id: string, paymentStatus: VippsPaymentStatusEnum | undefined, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } | undefined } | undefined }> };

export type PolfEventPlayerAddMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  createPolfEventPlayerDto: CreatePolfEventPlayerDto;
}>;


export type PolfEventPlayerAddMutation = { __typename?: 'Mutation', polfEventPlayerAdd: { __typename?: 'PolfEventPlayer', id: string, nanoId: string | undefined, name: string, email: string | undefined, memberNo: string | undefined, hcp: number | undefined, countryCode: string, mobileNumber: string, valid: boolean, strokes: number, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined, retiredPlaysPoker: boolean, smsInviteStatus: SmsStatusEnum | undefined, createdAt: any, updatedAt: any, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, courseRating: number, slope: number, par: number } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined, flight: { __typename?: 'PolfEventFlight', id: string } | undefined, recruitment: { __typename?: 'PolfEventPlayerRecruitment', id: string, status: PolfEventPlayerRecruitmentStatusEnum, amountInCents: number, recruitedBy: string } | undefined, sentSms: Array<{ __typename?: 'SentSms', id: string, type: SmsTypeEnum | undefined, status: SmsStatusEnum, createdAt: any }> | undefined, payment: { __typename: 'PolfEventPlayerOtherPayment', id: string, createdAt: any } | { __typename: 'VippsPayment', id: string, paymentStatus: VippsPaymentStatusEnum | undefined, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } | undefined } | undefined } };

export type PolfEventPlayerAddMultipleMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  createPolfEventPlayersDto: Array<CreatePolfEventPlayerDto> | CreatePolfEventPlayerDto;
}>;


export type PolfEventPlayerAddMultipleMutation = { __typename?: 'Mutation', polfEventPlayerAddMultiple: Array<{ __typename?: 'PolfEventPlayer', id: string, nanoId: string | undefined, name: string, email: string | undefined, memberNo: string | undefined, hcp: number | undefined, countryCode: string, mobileNumber: string, valid: boolean, strokes: number, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined, retiredPlaysPoker: boolean, smsInviteStatus: SmsStatusEnum | undefined, createdAt: any, updatedAt: any, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, courseRating: number, slope: number, par: number } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined, flight: { __typename?: 'PolfEventFlight', id: string } | undefined, recruitment: { __typename?: 'PolfEventPlayerRecruitment', id: string, status: PolfEventPlayerRecruitmentStatusEnum, amountInCents: number, recruitedBy: string } | undefined, sentSms: Array<{ __typename?: 'SentSms', id: string, type: SmsTypeEnum | undefined, status: SmsStatusEnum, createdAt: any }> | undefined, payment: { __typename: 'PolfEventPlayerOtherPayment', id: string, createdAt: any } | { __typename: 'VippsPayment', id: string, paymentStatus: VippsPaymentStatusEnum | undefined, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } | undefined } | undefined }> };

export type PolfEventCopyDataMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  polfEventCopyDataDto: PolfEventCopyDataDto;
}>;


export type PolfEventCopyDataMutation = { __typename?: 'Mutation', polfEventCopyData: { __typename?: 'PolfEvent', id: string, playerCount: number } };

export type PolfEventPlayerOtherPaymentCreateMutationVariables = Exact<{
  polfEventPlayerId: Scalars['ID']['input'];
}>;


export type PolfEventPlayerOtherPaymentCreateMutation = { __typename?: 'Mutation', polfEventPlayerOtherPaymentCreate: { __typename?: 'PolfEventPlayerOtherPayment', id: string, createdAt: any } };

export type PolfEventPlayerOtherPaymentDeleteMutationVariables = Exact<{
  polfEventPlayerOtherPaymentId: Scalars['ID']['input'];
}>;


export type PolfEventPlayerOtherPaymentDeleteMutation = { __typename?: 'Mutation', polfEventPlayerOtherPaymentDelete: { __typename?: 'PolfEventPlayerOtherPayment', id: string } };

export type PolfEventPlayerUpdateMutationVariables = Exact<{
  polfEventPlayerId: Scalars['ID']['input'];
  updatePolfEventPlayerDto: UpdatePolfEventPlayerDto;
}>;


export type PolfEventPlayerUpdateMutation = { __typename?: 'Mutation', polfEventPlayerUpdate: { __typename?: 'PolfEventPlayer', id: string, nanoId: string | undefined, name: string, email: string | undefined, memberNo: string | undefined, hcp: number | undefined, countryCode: string, mobileNumber: string, valid: boolean, strokes: number, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined, retiredPlaysPoker: boolean, smsInviteStatus: SmsStatusEnum | undefined, createdAt: any, updatedAt: any, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, courseRating: number, slope: number, par: number } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined, flight: { __typename?: 'PolfEventFlight', id: string } | undefined, recruitment: { __typename?: 'PolfEventPlayerRecruitment', id: string, status: PolfEventPlayerRecruitmentStatusEnum, amountInCents: number, recruitedBy: string } | undefined, sentSms: Array<{ __typename?: 'SentSms', id: string, type: SmsTypeEnum | undefined, status: SmsStatusEnum, createdAt: any }> | undefined, payment: { __typename: 'PolfEventPlayerOtherPayment', id: string, createdAt: any } | { __typename: 'VippsPayment', id: string, paymentStatus: VippsPaymentStatusEnum | undefined, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } | undefined } | undefined } };

export type PolfEventPlayerRemoveMutationVariables = Exact<{
  polfEventPlayerId: Scalars['ID']['input'];
}>;


export type PolfEventPlayerRemoveMutation = { __typename?: 'Mutation', polfEventPlayerRemove: { __typename?: 'PolfEventPlayer', id: string } };

export type PaymentRefundMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type PaymentRefundMutation = { __typename?: 'Mutation', paymentRefund: { __typename?: 'VippsPaymentDetails', reference: string, state: string, paymentRecord: { __typename?: 'VippsPayment', id: string, paymentStatus: VippsPaymentStatusEnum | undefined } } };

export type PolfEventPlayerPaymentReminderMutationVariables = Exact<{
  polfEventPlayerId: Scalars['ID']['input'];
}>;


export type PolfEventPlayerPaymentReminderMutation = { __typename?: 'Mutation', polfEventPlayerPaymentReminder: { __typename?: 'PolfEventPlayer', id: string, smsInviteStatus: SmsStatusEnum | undefined, updatedAt: any, sentSms: Array<{ __typename?: 'SentSms', id: string, type: SmsTypeEnum | undefined, status: SmsStatusEnum, createdAt: any }> | undefined } };

export type PolfEventRequestUpdatedInfoMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  onlyInvalid?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PolfEventRequestUpdatedInfoMutation = { __typename?: 'Mutation', polfEventRequestUpdatedInfo: { __typename?: 'SmsBatchResult', batchId: string, queued: number, skipped: number } };

export type PolfEventPlayerRetireMutationVariables = Exact<{
  polfEventPlayerId: Scalars['ID']['input'];
}>;


export type PolfEventPlayerRetireMutation = { __typename?: 'Mutation', polfEventPlayerRetire: { __typename?: 'PolfEventPlayer', id: string, nanoId: string | undefined, name: string, email: string | undefined, memberNo: string | undefined, hcp: number | undefined, countryCode: string, mobileNumber: string, valid: boolean, strokes: number, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined, retiredPlaysPoker: boolean, smsInviteStatus: SmsStatusEnum | undefined, createdAt: any, updatedAt: any, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, courseRating: number, slope: number, par: number } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined, flight: { __typename?: 'PolfEventFlight', id: string } | undefined, recruitment: { __typename?: 'PolfEventPlayerRecruitment', id: string, status: PolfEventPlayerRecruitmentStatusEnum, amountInCents: number, recruitedBy: string } | undefined, sentSms: Array<{ __typename?: 'SentSms', id: string, type: SmsTypeEnum | undefined, status: SmsStatusEnum, createdAt: any }> | undefined, payment: { __typename: 'PolfEventPlayerOtherPayment', id: string, createdAt: any } | { __typename: 'VippsPayment', id: string, paymentStatus: VippsPaymentStatusEnum | undefined, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } | undefined } | undefined } };

export type PolfEventPlayerRetireUndoMutationVariables = Exact<{
  polfEventPlayerId: Scalars['ID']['input'];
}>;


export type PolfEventPlayerRetireUndoMutation = { __typename?: 'Mutation', polfEventPlayerRetireUndo: { __typename?: 'PolfEventPlayer', id: string, nanoId: string | undefined, name: string, email: string | undefined, memberNo: string | undefined, hcp: number | undefined, countryCode: string, mobileNumber: string, valid: boolean, strokes: number, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined, retiredPlaysPoker: boolean, smsInviteStatus: SmsStatusEnum | undefined, createdAt: any, updatedAt: any, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, courseRating: number, slope: number, par: number } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined, flight: { __typename?: 'PolfEventFlight', id: string } | undefined, recruitment: { __typename?: 'PolfEventPlayerRecruitment', id: string, status: PolfEventPlayerRecruitmentStatusEnum, amountInCents: number, recruitedBy: string } | undefined, sentSms: Array<{ __typename?: 'SentSms', id: string, type: SmsTypeEnum | undefined, status: SmsStatusEnum, createdAt: any }> | undefined, payment: { __typename: 'PolfEventPlayerOtherPayment', id: string, createdAt: any } | { __typename: 'VippsPayment', id: string, paymentStatus: VippsPaymentStatusEnum | undefined, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } | undefined } | undefined } };

export type PolfEventPlayerRetiredPlaysPokerSetMutationVariables = Exact<{
  polfEventPlayerId: Scalars['ID']['input'];
  playsPoker: Scalars['Boolean']['input'];
}>;


export type PolfEventPlayerRetiredPlaysPokerSetMutation = { __typename?: 'Mutation', polfEventPlayerRetiredPlaysPokerSet: { __typename?: 'PolfEventPlayer', id: string, nanoId: string | undefined, name: string, email: string | undefined, memberNo: string | undefined, hcp: number | undefined, countryCode: string, mobileNumber: string, valid: boolean, strokes: number, scoresSubmitted: boolean, retiredAt: any | undefined, retiredHolesFilled: number | undefined, retiredPlaysPoker: boolean, smsInviteStatus: SmsStatusEnum | undefined, createdAt: any, updatedAt: any, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, courseRating: number, slope: number, par: number } | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } | undefined, flight: { __typename?: 'PolfEventFlight', id: string } | undefined, recruitment: { __typename?: 'PolfEventPlayerRecruitment', id: string, status: PolfEventPlayerRecruitmentStatusEnum, amountInCents: number, recruitedBy: string } | undefined, sentSms: Array<{ __typename?: 'SentSms', id: string, type: SmsTypeEnum | undefined, status: SmsStatusEnum, createdAt: any }> | undefined, payment: { __typename: 'PolfEventPlayerOtherPayment', id: string, createdAt: any } | { __typename: 'VippsPayment', id: string, paymentStatus: VippsPaymentStatusEnum | undefined, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } | undefined } | undefined } };

export type PokerSeatRowFragment = { __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined };

export type PokerLevelRowFragment = { __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined };

export type PokerPayoutRowFragment = { __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number };

export type PokerDataFragment = { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined };

export type PolfEventPokerQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventPokerQuery = { __typename?: 'Query', polfEventPoker: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } | undefined };

export type PolfEventPokerConfigUpsertMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  input: PokerConfigInput;
}>;


export type PolfEventPokerConfigUpsertMutation = { __typename?: 'Mutation', polfEventPokerConfigUpsert: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerDrawSeatsMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventPokerDrawSeatsMutation = { __typename?: 'Mutation', polfEventPokerDrawSeats: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type ProjectedPokerSetupQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type ProjectedPokerSetupQuery = { __typename?: 'Query', projectedPokerSetup: { __typename?: 'ProjectedPokerSetup', playerCount: number, totalChips: number, averageStack: number, seatsPerTable: number, recommendedTableCount: number, players: Array<{ __typename?: 'ProjectedPokerPlayer', playerId: string, name: string, rank: number, projectedStack: number }>, retiredPlayers: Array<{ __typename?: 'ProjectedRetiredPlayer', playerId: string, name: string, playsPoker: boolean, holesFilled: number | undefined }> } };

export type PolfEventPokerBlindStructureUpdateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  input: UpdateBlindStructureInput;
}>;


export type PolfEventPokerBlindStructureUpdateMutation = { __typename?: 'Mutation', polfEventPokerBlindStructureUpdate: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerPayoutStructureUpdateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  input: UpdatePayoutStructureInput;
}>;


export type PolfEventPokerPayoutStructureUpdateMutation = { __typename?: 'Mutation', polfEventPokerPayoutStructureUpdate: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerUsePayoutsSetMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  usePayouts: Scalars['Boolean']['input'];
}>;


export type PolfEventPokerUsePayoutsSetMutation = { __typename?: 'Mutation', polfEventPokerUsePayoutsSet: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerSeatMoveMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  input: MoveSeatInput;
}>;


export type PolfEventPokerSeatMoveMutation = { __typename?: 'Mutation', polfEventPokerSeatMove: { __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number } };

export type PolfEventPokerSeatSwapMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  input: SwapSeatsInput;
}>;


export type PolfEventPokerSeatSwapMutation = { __typename?: 'Mutation', polfEventPokerSeatSwap: { __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number } };

export type PolfEventPokerClockStartMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type PolfEventPokerClockStartMutation = { __typename?: 'Mutation', polfEventPokerClockStart: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerClockPauseMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type PolfEventPokerClockPauseMutation = { __typename?: 'Mutation', polfEventPokerClockPause: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerClockResumeMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type PolfEventPokerClockResumeMutation = { __typename?: 'Mutation', polfEventPokerClockResume: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerClockAdjustMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  remainingSeconds: Scalars['Int']['input'];
}>;


export type PolfEventPokerClockAdjustMutation = { __typename?: 'Mutation', polfEventPokerClockAdjust: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerLevelAdvanceMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  direction: LevelDirection;
}>;


export type PolfEventPokerLevelAdvanceMutation = { __typename?: 'Mutation', polfEventPokerLevelAdvance: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerSeatEliminateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
  knockedOutByPlayerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PolfEventPokerSeatEliminateMutation = { __typename?: 'Mutation', polfEventPokerSeatEliminate: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerSeatRestoreMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
}>;


export type PolfEventPokerSeatRestoreMutation = { __typename?: 'Mutation', polfEventPokerSeatRestore: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerReorderEliminationMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
  direction: ReorderDirection;
}>;


export type PolfEventPokerReorderEliminationMutation = { __typename?: 'Mutation', polfEventPokerReorderElimination: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerSeatLockToggleMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
  isLocked: Scalars['Boolean']['input'];
}>;


export type PolfEventPokerSeatLockToggleMutation = { __typename?: 'Mutation', polfEventPokerSeatLockToggle: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerSeatStackUpdateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
  currentStack: Scalars['Float']['input'];
}>;


export type PolfEventPokerSeatStackUpdateMutation = { __typename?: 'Mutation', polfEventPokerSeatStackUpdate: { __typename?: 'PolfEventPokerSeat', id: string, currentStack: number } };

export type PolfEventPokerBalancingApplyMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type PolfEventPokerBalancingApplyMutation = { __typename?: 'Mutation', polfEventPokerBalancingApply: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerAddTableMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type PolfEventPokerAddTableMutation = { __typename?: 'Mutation', polfEventPokerAddTable: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerRemoveLastTableMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type PolfEventPokerRemoveLastTableMutation = { __typename?: 'Mutation', polfEventPokerRemoveLastTable: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerPrizePoolUpdateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  prizePool?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PolfEventPokerPrizePoolUpdateMutation = { __typename?: 'Mutation', polfEventPokerPrizePoolUpdate: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerSeatsPerTableUpdateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  seatsPerTable: Scalars['Float']['input'];
}>;


export type PolfEventPokerSeatsPerTableUpdateMutation = { __typename?: 'Mutation', polfEventPokerSeatsPerTableUpdate: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerShowChipLeaderboardSetMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  showChipLeaderboard: Scalars['Boolean']['input'];
}>;


export type PolfEventPokerShowChipLeaderboardSetMutation = { __typename?: 'Mutation', polfEventPokerShowChipLeaderboardSet: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerVoiceAnnouncementsSetMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  voiceAnnouncements: Scalars['Boolean']['input'];
}>;


export type PolfEventPokerVoiceAnnouncementsSetMutation = { __typename?: 'Mutation', polfEventPokerVoiceAnnouncementsSet: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerAllowPlayerStackUpdateSetMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  allowPlayerStackUpdate: Scalars['Boolean']['input'];
}>;


export type PolfEventPokerAllowPlayerStackUpdateSetMutation = { __typename?: 'Mutation', polfEventPokerAllowPlayerStackUpdateSet: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerFinalTableRedrawMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type PolfEventPokerFinalTableRedrawMutation = { __typename?: 'Mutation', polfEventPokerFinalTableRedraw: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerSendSeatSmsMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  sender?: InputMaybe<Scalars['String']['input']>;
}>;


export type PolfEventPokerSendSeatSmsMutation = { __typename?: 'Mutation', polfEventPokerSendSeatSms: { __typename?: 'PolfEventPokerSmsResult', sentCount: number, failedCount: number } };

export type PolfEventPokerFinishMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type PolfEventPokerFinishMutation = { __typename?: 'Mutation', polfEventPokerFinish: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerRebuyConfigSetMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  input: RebuyAddonConfigInput;
}>;


export type PolfEventPokerRebuyConfigSetMutation = { __typename?: 'Mutation', polfEventPokerRebuyConfigSet: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerRegistrationCloseMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  closed: Scalars['Boolean']['input'];
}>;


export type PolfEventPokerRegistrationCloseMutation = { __typename?: 'Mutation', polfEventPokerRegistrationClose: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerSeatRebuyMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
}>;


export type PolfEventPokerSeatRebuyMutation = { __typename?: 'Mutation', polfEventPokerSeatRebuy: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerSeatAddonMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
}>;


export type PolfEventPokerSeatAddonMutation = { __typename?: 'Mutation', polfEventPokerSeatAddon: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerSeatAddonRemoveMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
}>;


export type PolfEventPokerSeatAddonRemoveMutation = { __typename?: 'Mutation', polfEventPokerSeatAddonRemove: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerAddonAllMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type PolfEventPokerAddonAllMutation = { __typename?: 'Mutation', polfEventPokerAddonAll: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventPokerLateRegisterMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
}>;


export type PolfEventPokerLateRegisterMutation = { __typename?: 'Mutation', polfEventPokerLateRegister: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, tableCount: number, seatsPerTable: number, usePayouts: boolean, allowPlayerStackUpdate: boolean, showChipLeaderboard: boolean, voiceAnnouncements: boolean, finalTableRedrawnAt: any | undefined, prizePool: number | undefined, rebuysEnabled: boolean, rebuyStackChips: number | undefined, maxRebuysPerPlayer: number | undefined, rebuyWhileActive: boolean, addonEnabled: boolean, addonStackChips: number | undefined, rebuyUntilLevel: number | undefined, registrationClosedAt: any | undefined, registrationOpen: boolean, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, seedSeatRandom: number | undefined, levels: Array<{ __typename?: 'PolfEventPokerLevel', id: string, index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, startingStack: number, currentStack: number, eliminated: boolean, eliminatedAt: any | undefined, withdrawn: boolean, isLocked: boolean, finishingPosition: number | undefined, rebuyCount: number, addonTaken: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string, nanoId: string | undefined }, knockedOutByPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined }>, payouts: Array<{ __typename?: 'PolfEventPokerPayout', id: string, position: number, percentageBp: number }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } };

export type PolfEventSegmentedScorecardQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventSegmentedScorecardQuery = { __typename?: 'Query', polfEventLeaderboard: { __typename: 'BestBallLeaderboard' } | { __typename: 'GolfLeaderboard' } | { __typename: 'PolfLeaderboard' } | { __typename: 'ScrambleLeaderboard' } | { __typename: 'SegmentedLeaderboard', segments: Array<{ __typename?: 'SegmentedLeaderboardSegment', ordinal: number, fromHole: number, toHole: number, format: PolfEventSegmentFormatEnum, teams: Array<{ __typename?: 'SegmentedLeaderboardTeam', team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined }, scores: Array<{ __typename?: 'PolfEventScore', id: string, score: number | undefined, strokes: number, stablefordPoints: number, hole: { __typename?: 'CourseHole', number: number, par: number, index: number } }> }> }> } };

export type PolfEventScrambleScorecardQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventScrambleScorecardQuery = { __typename?: 'Query', polfEventLeaderboard: { __typename: 'BestBallLeaderboard' } | { __typename: 'GolfLeaderboard' } | { __typename: 'PolfLeaderboard' } | { __typename: 'ScrambleLeaderboard', teams: Array<{ __typename?: 'ScrambleLeaderboardTeam', points: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, strokes: number | undefined }, scores: Array<{ __typename?: 'PolfEventScore', score: number | undefined, hole: { __typename?: 'CourseHole', number: number, par: number, index: number } }> }> } | { __typename: 'SegmentedLeaderboard' } };

export type TeamListItemFragment = { __typename?: 'PolfEventTeam', id: string, name: string | undefined, valid: boolean, strokes: number | undefined, createdAt: any, updatedAt: any, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, countryCode: string, mobileNumber: string, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, slope: number, courseRating: number, par: number } | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined }> | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined };

export type PolfEventTeamsQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventTeamsQuery = { __typename?: 'Query', polfEventTeams: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, valid: boolean, strokes: number | undefined, createdAt: any, updatedAt: any, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, countryCode: string, mobileNumber: string, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, slope: number, courseRating: number, par: number } | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined }> | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined }> };

export type PolfEventTeamScoredHolesQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventTeamScoredHolesQuery = { __typename?: 'Query', polfEventTeams: Array<{ __typename?: 'PolfEventTeam', id: string, scoredHoleCount: number }> };

export type PolfEventTeamAddMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  createPolfEventTeamDto?: InputMaybe<CreatePolfEventTeamDto>;
}>;


export type PolfEventTeamAddMutation = { __typename?: 'Mutation', polfEventTeamAdd: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, valid: boolean, strokes: number | undefined, createdAt: any, updatedAt: any, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, countryCode: string, mobileNumber: string, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, slope: number, courseRating: number, par: number } | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined }> | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined } };

export type PolfEventTeamUpdateMutationVariables = Exact<{
  polfEventTeamId: Scalars['ID']['input'];
  updatePolfEventTeamDto: UpdatePolfEventTeamDto;
}>;


export type PolfEventTeamUpdateMutation = { __typename?: 'Mutation', polfEventTeamUpdate: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, valid: boolean, strokes: number | undefined, createdAt: any, updatedAt: any, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, countryCode: string, mobileNumber: string, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, slope: number, courseRating: number, par: number } | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined }> | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined } };

export type PolfEventTeamResetNameMutationVariables = Exact<{
  polfEventTeamId: Scalars['ID']['input'];
}>;


export type PolfEventTeamResetNameMutation = { __typename?: 'Mutation', polfEventTeamResetName: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, valid: boolean, strokes: number | undefined, createdAt: any, updatedAt: any, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, countryCode: string, mobileNumber: string, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, slope: number, courseRating: number, par: number } | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined }> | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined } };

export type PolfEventTeamDeleteMutationVariables = Exact<{
  polfEventTeamId: Scalars['ID']['input'];
}>;


export type PolfEventTeamDeleteMutation = { __typename?: 'Mutation', polfEventTeamDelete: { __typename?: 'PolfEventTeam', id: string } };

export type PolfEventTeamAddPlayerMutationVariables = Exact<{
  polfEventTeamId: Scalars['ID']['input'];
  polfEventPlayerId: Scalars['ID']['input'];
}>;


export type PolfEventTeamAddPlayerMutation = { __typename?: 'Mutation', polfEventTeamAddPlayer: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, valid: boolean, strokes: number | undefined, createdAt: any, updatedAt: any, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, countryCode: string, mobileNumber: string, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, slope: number, courseRating: number, par: number } | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined }> | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined } };

export type PolfEventTeamRemovePlayerMutationVariables = Exact<{
  polfEventPlayerId: Scalars['ID']['input'];
  polfEventTeamId: Scalars['ID']['input'];
}>;


export type PolfEventTeamRemovePlayerMutation = { __typename?: 'Mutation', polfEventTeamRemovePlayer: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, valid: boolean, strokes: number | undefined, createdAt: any, updatedAt: any, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, countryCode: string, mobileNumber: string, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, slope: number, courseRating: number, par: number } | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined }> | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined } };

export type PolfEventTeamAutogenerateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  teamSize: Scalars['Float']['input'];
}>;


export type PolfEventTeamAutogenerateMutation = { __typename?: 'Mutation', polfEventTeamAutogenerate: Array<{ __typename?: 'PolfEventTeam', id: string, name: string | undefined, valid: boolean, strokes: number | undefined, createdAt: any, updatedAt: any, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined, strokes: number, countryCode: string, mobileNumber: string, courseTee: { __typename?: 'CourseTee', id: string, teeName: string, slope: number, courseRating: number, par: number } | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined }> | undefined, flight: { __typename?: 'PolfEventFlight', id: string, flightNumber: number } | undefined }> };

export type PolfEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type PolfEventsQuery = { __typename?: 'Query', polfEvents: Array<{ __typename?: 'PolfEvent', id: string, name: string, date: any, status: PolfEventStatusEnum, mode: PolfEventModeEnum, ranking: PolfEventRankingEnum | undefined, matchPlay: boolean, hcpFactor: number, playerCount: number, teamCount: number, teamlessPlayerCount: number, flightCount: number, course: { __typename?: 'Course', id: string, name: string } | undefined }> };

export type CoursesForEventCreateQueryVariables = Exact<{ [key: string]: never; }>;


export type CoursesForEventCreateQuery = { __typename?: 'Query', courses: Array<{ __typename?: 'Course', id: string, name: string, status: CourseStatusEnum, isValid: boolean }> };

export type PolfEventCreateMutationVariables = Exact<{
  createPolfEventDto: CreatePolfEventDto;
}>;


export type PolfEventCreateMutation = { __typename?: 'Mutation', polfEventCreate: { __typename?: 'PolfEvent', id: string, name: string, date: any, mode: PolfEventModeEnum, status: PolfEventStatusEnum } };

export type PolfEventQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventQuery = { __typename?: 'Query', polfEvent: { __typename?: 'PolfEvent', id: string, name: string, date: any, nanoId: string | undefined, status: PolfEventStatusEnum, golfFinishedAt: any | undefined, isTournamentOver: boolean, hasPokerPhase: boolean, mode: PolfEventModeEnum, ranking: PolfEventRankingEnum | undefined, matchPlay: boolean, hcpFactor: number, startingStackChips: number | undefined, playerCount: number, teamCount: number, teamlessPlayerCount: number, flightCount: number, segments: Array<{ __typename?: 'PolfEventSegment', ordinal: number, fromHole: number, toHole: number, format: PolfEventSegmentFormatEnum }> | undefined, course: { __typename?: 'Course', id: string, name: string, isValid: boolean, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, courseRating: number, slope: number, par: number, default: boolean }> | undefined, holes: Array<{ __typename?: 'CourseHole', id: string, number: number, par: number, index: number }> } | undefined, registration: { __typename?: 'PolfEventRegistration', enabled: boolean, playerPicksTee: boolean | undefined, price: { __typename?: 'PolfEventPrice', amountInCents: number }, recruitment: { __typename?: 'PolfEventRegistrationRecruitment', enabled: boolean, amountInCents: number } | undefined } | undefined, chipValues: { __typename?: 'PolfEventChipValues', id: string, startStack: number, stablefordPoint: number, holeInOne: number, eagle: number, birdie: number, flightBonus: number, flightBonusEnabled: boolean } } };

export type PolfEventStartMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventStartMutation = { __typename?: 'Mutation', polfEventStartPolfEvent: { __typename?: 'PolfEvent', id: string, status: PolfEventStatusEnum } };

export type PolfEventSendInvitesMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventSendInvitesMutation = { __typename?: 'Mutation', polfEventSendInvites: { __typename?: 'SmsBatchResult', batchId: string, queued: number, skipped: number } };

export type PolfEventFinishMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventFinishMutation = { __typename?: 'Mutation', polfEventFinishPolfEvent: { __typename?: 'PolfEvent', id: string, status: PolfEventStatusEnum } };

export type PolfEventReopenMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventReopenMutation = { __typename?: 'Mutation', polfEventReopenPolfEvent: { __typename?: 'PolfEvent', id: string, status: PolfEventStatusEnum } };

export type PolfEventCloseMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventCloseMutation = { __typename?: 'Mutation', polfEventClosePolfEvent: { __typename?: 'PolfEvent', id: string, status: PolfEventStatusEnum } };

export type PolfEventDeleteMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventDeleteMutation = { __typename?: 'Mutation', polfEventDelete: { __typename?: 'PolfEvent', id: string } };

export type PolfEventUpdateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  updatePolfEventDto: UpdatePolfEventDto;
}>;


export type PolfEventUpdateMutation = { __typename?: 'Mutation', polfEventUpdate: { __typename?: 'PolfEvent', id: string, name: string, date: any, hcpFactor: number, ranking: PolfEventRankingEnum | undefined, matchPlay: boolean, registration: { __typename?: 'PolfEventRegistration', enabled: boolean, playerPicksTee: boolean | undefined, price: { __typename?: 'PolfEventPrice', amountInCents: number }, recruitment: { __typename?: 'PolfEventRegistrationRecruitment', enabled: boolean, amountInCents: number } | undefined } | undefined } };

export type PolfEventChipValuesUpdateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  updatePolfEventChipValues: UpdatePolfEventChipValues;
}>;


export type PolfEventChipValuesUpdateMutation = { __typename?: 'Mutation', polfEventChipValuesUpdate: { __typename?: 'PolfEvent', id: string, chipValues: { __typename?: 'PolfEventChipValues', id: string, startStack: number, stablefordPoint: number, holeInOne: number, eagle: number, birdie: number, flightBonus: number, flightBonusEnabled: boolean } } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string, email: string | undefined } };

export type MySignInStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MySignInStatusQuery = { __typename?: 'Query', mySignInStatus: { __typename?: 'SignInStatus', password: PasswordStatusEnum, twoFactor: boolean, providers: Array<string> } };

export type UpdateMyProfileMutationVariables = Exact<{
  input: UpdateMyProfileInput;
}>;


export type UpdateMyProfileMutation = { __typename?: 'Mutation', updateMyProfile: { __typename?: 'User', id: string, name: string, email: string | undefined } };

export type RemoveMyPasswordMutationVariables = Exact<{
  idToken: Scalars['String']['input'];
}>;


export type RemoveMyPasswordMutation = { __typename?: 'Mutation', removeMyPassword: { __typename?: 'SignInStatus', password: PasswordStatusEnum, twoFactor: boolean, providers: Array<string> } };

export type OperatorPokerViewQueryVariables = Exact<{ [key: string]: never; }>;


export type OperatorPokerViewQuery = { __typename?: 'Query', operatorPokerView: { __typename?: 'OperatorPokerView', role: OperatorRole, poker: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum, currentLevelIndex: number, currentInBreak: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, tableCount: number, seatsPerTable: number, finalTableRedrawnAt: any | undefined, polfEvent: { __typename?: 'PolfEvent', id: string, name: string }, levels: Array<{ __typename?: 'PolfEventPokerLevel', index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }>, seats: Array<{ __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number, currentStack: number, startingStack: number, eliminated: boolean, withdrawn: boolean, finishingPosition: number | undefined, isLocked: boolean, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } }>, balancingSuggestion: { __typename?: 'BalancingSuggestionDto', kind: BalancingSuggestionKind, reason: string, tableNumber: number | undefined, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } | undefined } | undefined } };

export type OperatorClockPauseMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type OperatorClockPauseMutation = { __typename?: 'Mutation', polfEventPokerClockPause: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum } };

export type OperatorClockResumeMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type OperatorClockResumeMutation = { __typename?: 'Mutation', polfEventPokerClockResume: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum } };

export type OperatorLevelAdvanceMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  direction: LevelDirection;
}>;


export type OperatorLevelAdvanceMutation = { __typename?: 'Mutation', polfEventPokerLevelAdvance: { __typename?: 'PolfEventPoker', id: string, currentLevelIndex: number } };

export type OperatorSeatStackUpdateMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
  stack: Scalars['Float']['input'];
}>;


export type OperatorSeatStackUpdateMutation = { __typename?: 'Mutation', polfEventPokerSeatStackUpdate: { __typename?: 'PolfEventPokerSeat', id: string, currentStack: number } };

export type OperatorSeatEliminateMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
}>;


export type OperatorSeatEliminateMutation = { __typename?: 'Mutation', polfEventPokerSeatEliminate: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum } };

export type OperatorSeatRestoreMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
}>;


export type OperatorSeatRestoreMutation = { __typename?: 'Mutation', polfEventPokerSeatRestore: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum } };

export type OperatorReorderEliminationMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
  direction: ReorderDirection;
}>;


export type OperatorReorderEliminationMutation = { __typename?: 'Mutation', polfEventPokerReorderElimination: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum } };

export type OperatorSeatWithdrawMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
}>;


export type OperatorSeatWithdrawMutation = { __typename?: 'Mutation', polfEventPokerSeatWithdraw: { __typename?: 'PolfEventPoker', id: string } };

export type OperatorAddTableMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type OperatorAddTableMutation = { __typename?: 'Mutation', polfEventPokerAddTable: { __typename?: 'PolfEventPoker', id: string, tableCount: number } };

export type OperatorRemoveLastTableMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type OperatorRemoveLastTableMutation = { __typename?: 'Mutation', polfEventPokerRemoveLastTable: { __typename?: 'PolfEventPoker', id: string, tableCount: number } };

export type OperatorSeatsPerTableUpdateMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  seatsPerTable: Scalars['Float']['input'];
}>;


export type OperatorSeatsPerTableUpdateMutation = { __typename?: 'Mutation', polfEventPokerSeatsPerTableUpdate: { __typename?: 'PolfEventPoker', id: string, seatsPerTable: number } };

export type OperatorClockStartMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type OperatorClockStartMutation = { __typename?: 'Mutation', polfEventPokerClockStart: { __typename?: 'PolfEventPoker', id: string, status: PolfEventPokerStatusEnum } };

export type OperatorClockAdjustMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  remainingSeconds: Scalars['Int']['input'];
}>;


export type OperatorClockAdjustMutation = { __typename?: 'Mutation', polfEventPokerClockAdjust: { __typename?: 'PolfEventPoker', id: string } };

export type OperatorSeatMoveMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  input: MoveSeatInput;
}>;


export type OperatorSeatMoveMutation = { __typename?: 'Mutation', polfEventPokerSeatMove: { __typename?: 'PolfEventPokerSeat', id: string, tableNumber: number, seatNumber: number } };

export type OperatorSeatLockToggleMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
  isLocked: Scalars['Boolean']['input'];
}>;


export type OperatorSeatLockToggleMutation = { __typename?: 'Mutation', polfEventPokerSeatLockToggle: { __typename?: 'PolfEventPoker', id: string } };

export type OperatorBalancingApplyMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type OperatorBalancingApplyMutation = { __typename?: 'Mutation', polfEventPokerBalancingApply: { __typename?: 'PolfEventPoker', id: string } };

export type OperatorFinalTableRedrawMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
}>;


export type OperatorFinalTableRedrawMutation = { __typename?: 'Mutation', polfEventPokerFinalTableRedraw: { __typename?: 'PolfEventPoker', id: string, finalTableRedrawnAt: any | undefined } };

export type OperatorBreakTableMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  tableNumber: Scalars['Int']['input'];
}>;


export type OperatorBreakTableMutation = { __typename?: 'Mutation', polfEventPokerBreakTable: { __typename?: 'BreakTableResult', poker: { __typename?: 'PolfEventPoker', id: string, tableCount: number }, moves: Array<{ __typename?: 'BalancingMove', seatId: string, tableNumber: number, seatNumber: number }> } };

export type OperatorBlindStructureUpdateMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pokerId: Scalars['ID']['input'];
  input: UpdateBlindStructureInput;
}>;


export type OperatorBlindStructureUpdateMutation = { __typename?: 'Mutation', polfEventPokerBlindStructureUpdate: { __typename?: 'PolfEventPoker', id: string, levels: Array<{ __typename?: 'PolfEventPokerLevel', index: number, smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined }> } };

export type PolfEventOperatorListQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventOperatorListQuery = { __typename?: 'Query', polfEventOperatorList: Array<{ __typename?: 'PolfEventOperator', id: string, nanoId: string, role: OperatorRole, label: string | undefined, phone: string | undefined, revokedAt: any | undefined, createdAt: any }> };

export type PolfEventOperatorCreateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  input: PolfEventOperatorCreateDto;
}>;


export type PolfEventOperatorCreateMutation = { __typename?: 'Mutation', polfEventOperatorCreate: { __typename?: 'PolfEventOperator', id: string, nanoId: string, role: OperatorRole, label: string | undefined, phone: string | undefined, revokedAt: any | undefined, createdAt: any } };

export type PolfEventOperatorRevokeMutationVariables = Exact<{
  polfEventOperatorId: Scalars['ID']['input'];
}>;


export type PolfEventOperatorRevokeMutation = { __typename?: 'Mutation', polfEventOperatorRevoke: { __typename?: 'PolfEventOperator', id: string, revokedAt: any | undefined } };

export type PolfEventOperatorSendLinkMutationVariables = Exact<{
  polfEventOperatorId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PolfEventOperatorSendLinkMutation = { __typename?: 'Mutation', polfEventOperatorSendLink: { __typename?: 'PolfEventOperator', id: string, phone: string | undefined } };

export type PolfEventOperatorSendLinkToAllMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type PolfEventOperatorSendLinkToAllMutation = { __typename?: 'Mutation', polfEventOperatorSendLinkToAll: { __typename?: 'OperatorBulkSendResult', sent: number, skippedNoPhone: number } };

export type AccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'Account', id: string, name: string, slug: string, type: AccountTypeEnum, orgNumber: string | undefined, addressStreet: string | undefined, addressPostalCode: string | undefined, addressCity: string | undefined, contactEmail: string | undefined, contactPhone: string | undefined, website: string | undefined, createdAt: any }> };

export type AccountSettingsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type AccountSettingsQuery = { __typename?: 'Query', accountSettings: { __typename?: 'AccountSettingsType', id: string, vippsConfigured: boolean, vippsValidated: boolean, vippsClientIdMasked: string | undefined, vippsMerchantSerialNumberMasked: string | undefined, startInvoiceNo: number, paymentNotificationEmail: string | undefined, emailConfigured: boolean, smsConfigured: boolean, legalConfigured: boolean, sectionsConfigured: number, sectionsTotal: number, mailFromName: string | undefined, smsDefaultSender: string | undefined, termsUrl: string | undefined, privacyUrl: string | undefined } };

export type AccountMembersQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type AccountMembersQuery = { __typename?: 'Query', accountMembers: Array<{ __typename?: 'AccountMember', id: string, isContactPerson: boolean, user: { __typename?: 'User', id: string, name: string, email: string | undefined } }> };

export type BrregSearchQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type BrregSearchQuery = { __typename?: 'Query', brregSearch: Array<{ __typename?: 'BrregCompanyType', orgNumber: string, name: string, organizationForm: string | undefined, homepage: string | undefined, address: { __typename?: 'BrregAddress', street: string | undefined, postalCode: string | undefined, city: string | undefined } | undefined, businessAddress: { __typename?: 'BrregAddress', street: string | undefined, postalCode: string | undefined, city: string | undefined } | undefined }> };

export type AccountCreateMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  contactPersonName: Scalars['String']['input'];
  contactPersonEmail: Scalars['String']['input'];
  orgNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountCreateMutation = { __typename?: 'Mutation', accountCreate: { __typename?: 'Account', id: string, name: string, slug: string, type: AccountTypeEnum, orgNumber: string | undefined, createdAt: any } };

export type AccountAddMemberMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type AccountAddMemberMutation = { __typename?: 'Mutation', accountAddMember: { __typename?: 'AccountMember', id: string, isContactPerson: boolean, user: { __typename?: 'User', id: string, name: string, email: string | undefined } } };

export type AccountRemoveMemberMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AccountRemoveMemberMutation = { __typename?: 'Mutation', accountRemoveMember: boolean };

export type AccountSetContactPersonMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type AccountSetContactPersonMutation = { __typename?: 'Mutation', accountSetContactPerson: Array<{ __typename?: 'AccountMember', id: string, isContactPerson: boolean, user: { __typename?: 'User', id: string, name: string } }> };

export type PaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentsQuery = { __typename?: 'Query', payments: Array<{ __typename?: 'VippsPayment', id: string, invoiceNo: number | undefined, reference: string | undefined, redirectUrl: string | undefined, mobileNumber: string | undefined, sub: string | undefined, state: string | undefined, paymentStatus: VippsPaymentStatusEnum | undefined, createdAt: any, updatedAt: any, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } | undefined, aggregate: { __typename?: 'VippsPaymentDetailsAggregate', authorizedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, cancelledAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, capturedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, refundedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } } | undefined, player: { __typename?: 'PolfEventPlayer', id: string, name: string, email: string | undefined } | undefined, polfEvent: { __typename?: 'PolfEvent', id: string, name: string, date: any, account: { __typename?: 'Account', id: string, name: string } } }> };

export type PaymentDeleteEmptyRecordsMutationVariables = Exact<{ [key: string]: never; }>;


export type PaymentDeleteEmptyRecordsMutation = { __typename?: 'Mutation', paymentDeleteEmptyRecords: Array<{ __typename?: 'VippsPayment', id: string }> };

export type PaymentUpdateAllRecordsMutationVariables = Exact<{ [key: string]: never; }>;


export type PaymentUpdateAllRecordsMutation = { __typename?: 'Mutation', paymentUpdateAllRecords: Array<{ __typename?: 'VippsPayment', id: string }> };

export type SmsAccountInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type SmsAccountInfoQuery = { __typename?: 'Query', smsAccountInfo: { __typename?: 'SmsMeResponse', id: string, displayname: string, email: string, mobilenumber: string, balance: number, currency: string } };

export type SmsHistoryQueryVariables = Exact<{
  sentSmsFilters?: InputMaybe<SentSmsFilters>;
}>;


export type SmsHistoryQuery = { __typename?: 'Query', smsHistory: Array<{ __typename?: 'SentSms', id: string, from: string, to: string, message: string, status: SmsStatusEnum, cost: number, createdAt: any, updatedAt: any, batchId: string | undefined, direction: string, delivered: any | undefined, flashsms: string | undefined, externalId: string, player: { __typename?: 'PolfEventPlayer', id: string, name: string, polfEvent: { __typename?: 'PolfEvent', id: string, name: string } } | undefined, createdBy: { __typename?: 'User', id: string, name: string } }> };

export type SendSmsMutationVariables = Exact<{
  sendSmsDto: SendSmsDto;
}>;


export type SendSmsMutation = { __typename?: 'Mutation', sendSms: { __typename?: 'SentSms', id: string, from: string, to: string, message: string, status: SmsStatusEnum, cost: number, createdAt: any, batchId: string | undefined } };

export type SmsEventUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SmsEventUpdatedSubscription = { __typename?: 'Subscription', smsEventUpdated: boolean };

export type ReportsEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportsEventsQuery = { __typename?: 'Query', polfEvents: Array<{ __typename?: 'PolfEvent', id: string, name: string, date: any }> };

export type AccountMemberTwoFactorUserIdsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type AccountMemberTwoFactorUserIdsQuery = { __typename?: 'Query', accountMemberTwoFactorUserIds: Array<string> };

export type PlatformRemoveTwoFactorMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type PlatformRemoveTwoFactorMutation = { __typename?: 'Mutation', platformRemoveTwoFactor: boolean };

export type PlatformUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformUsersQuery = { __typename?: 'Query', platformUsers: Array<{ __typename?: 'PlatformUser', id: string, name: string, email: string | undefined, accounts: Array<{ __typename?: 'PlatformUserAccount', id: string, name: string, type: AccountTypeEnum, isContactPerson: boolean }>, signIn: { __typename?: 'SignInStatus', password: PasswordStatusEnum, twoFactor: boolean, providers: Array<string> } }> };

export type ProjectorEventFragment = { __typename?: 'PolfEvent', id: string, name: string, date: any, mode: PolfEventModeEnum, ranking: PolfEventRankingEnum | undefined, matchPlay: boolean, status: PolfEventStatusEnum, golfFinishedAt: any | undefined, hasPokerPhase: boolean, course: { __typename?: 'Course', id: string, name: string } | undefined };

export type ProjectorHoleCompetitionEntryFragment = { __typename?: 'PolfEventHoleCompetitionEntry', id: string, value: number, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } };

export type ProjectorHoleCompetitionFragment = { __typename?: 'PolfEventMobilePlayerHoleCompetition', id: string, type: PolfEventHoleCompetitionTypeEnum, description: string, chipValue: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number }, currentLeader: { __typename?: 'PolfEventHoleCompetitionEntry', id: string, value: number, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } } | undefined };

export type ProjectorPlayerSummaryFragment = { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined };

export type ProjectorPolfLeaderboardSpecialEntryFragment = { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number };

export type ProjectorPolfLeaderboardPlayerEntryFragment = { __typename?: 'PolfLeaderboardPlayer', rank: number | undefined, isAllIn: boolean | undefined, chips: number, chipsInclHoleCompetitions: number, startStack: number, holesRegistred: number, flightBonus: number | undefined, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }, stablefordPoints: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, birdies: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, eagles: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, holeInOnes: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, closest: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, longest: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number } };

export type ProjectorGolfLeaderboardPlayerEntryFragment = { __typename?: 'GolfLeaderboardPlayer', rank: number | undefined, score: number, points: number, strokes: number, strokesNet: number, holesRegistred: number, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined } };

type ProjectorLeaderboardUnionFields_BestBallLeaderboard_Fragment = { __typename: 'BestBallLeaderboard', teams: Array<{ __typename?: 'BestBallLeaderboardTeam', rank: number | undefined, score: number, points: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } }>, players: Array<{ __typename?: 'GolfLeaderboardPlayer', rank: number | undefined, score: number, points: number, strokes: number, strokesNet: number, holesRegistred: number, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined } }> };

type ProjectorLeaderboardUnionFields_GolfLeaderboard_Fragment = { __typename: 'GolfLeaderboard', players: Array<{ __typename?: 'GolfLeaderboardPlayer', rank: number | undefined, score: number, points: number, strokes: number, strokesNet: number, holesRegistred: number, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined } }> };

type ProjectorLeaderboardUnionFields_PolfLeaderboard_Fragment = { __typename: 'PolfLeaderboard', players: Array<{ __typename?: 'PolfLeaderboardPlayer', rank: number | undefined, isAllIn: boolean | undefined, chips: number, chipsInclHoleCompetitions: number, startStack: number, holesRegistred: number, flightBonus: number | undefined, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }, stablefordPoints: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, birdies: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, eagles: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, holeInOnes: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, closest: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, longest: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number } }> };

type ProjectorLeaderboardUnionFields_ScrambleLeaderboard_Fragment = { __typename: 'ScrambleLeaderboard', teams: Array<{ __typename?: 'ScrambleLeaderboardTeam', rank: number | undefined, score: number, points: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } }> };

type ProjectorLeaderboardUnionFields_SegmentedLeaderboard_Fragment = { __typename: 'SegmentedLeaderboard', segments: Array<{ __typename?: 'SegmentedLeaderboardSegment', ordinal: number, fromHole: number, toHole: number, format: PolfEventSegmentFormatEnum, teams: Array<{ __typename?: 'SegmentedLeaderboardTeam', rank: number | undefined, score: number, points: number, strokesNet: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } }> }>, teams: Array<{ __typename?: 'SegmentedLeaderboardTeam', rank: number | undefined, score: number, points: number, strokesNet: number, holesRegistred: number, segmentTotals: Array<{ __typename?: 'SegmentedLeaderboardSegmentTotal', ordinal: number, format: PolfEventSegmentFormatEnum, strokesNet: number, points: number }> | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } }> };

export type ProjectorLeaderboardUnionFieldsFragment = ProjectorLeaderboardUnionFields_BestBallLeaderboard_Fragment | ProjectorLeaderboardUnionFields_GolfLeaderboard_Fragment | ProjectorLeaderboardUnionFields_PolfLeaderboard_Fragment | ProjectorLeaderboardUnionFields_ScrambleLeaderboard_Fragment | ProjectorLeaderboardUnionFields_SegmentedLeaderboard_Fragment;

export type ProjectorSegmentedTeamEntryFragment = { __typename?: 'SegmentedLeaderboardTeam', rank: number | undefined, score: number, points: number, strokesNet: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } };

export type ProjectorPokerLevelFragment = { __typename?: 'PolfEventPokerLevelPublic', smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined };

export type ProjectorPokerActiveStandingFragment = { __typename?: 'PolfEventPokerPublicActive', id: string, playerName: string, tableNumber: number, seatNumber: number, currentStack: number, isLocked: boolean };

export type ProjectorPokerEliminatedFragment = { __typename?: 'PolfEventPokerPublicEliminated', id: string, playerName: string, finishingPosition: number, tableNumber: number, seatNumber: number, eliminatedAt: any | undefined };

export type ProjectorPokerPublicFragment = { __typename?: 'PolfEventPokerPublicDto', id: string, eventName: string, status: PolfEventPokerStatusEnum, currentLevelIndex: number, currentInBreak: boolean, voiceAnnouncements: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, totalLevels: number, playersTotal: number, playersLeft: number, averageStartingStack: number, currentLevel: { __typename?: 'PolfEventPokerLevelPublic', smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined } | undefined, nextLevel: { __typename?: 'PolfEventPokerLevelPublic', smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined } | undefined, activeStandings: Array<{ __typename?: 'PolfEventPokerPublicActive', id: string, playerName: string, tableNumber: number, seatNumber: number, currentStack: number, isLocked: boolean }>, eliminations: Array<{ __typename?: 'PolfEventPokerPublicEliminated', id: string, playerName: string, finishingPosition: number, tableNumber: number, seatNumber: number, eliminatedAt: any | undefined }> };

export type ProjectorEventQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectorEventQuery = { __typename?: 'Query', currentPolfEventPublic: { __typename?: 'PolfEvent', id: string, name: string, date: any, mode: PolfEventModeEnum, ranking: PolfEventRankingEnum | undefined, matchPlay: boolean, status: PolfEventStatusEnum, golfFinishedAt: any | undefined, hasPokerPhase: boolean, course: { __typename?: 'Course', id: string, name: string } | undefined } };

export type ProjectorLeaderboardQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type ProjectorLeaderboardQuery = { __typename?: 'Query', polfEventPublicLeaderboard: { __typename: 'BestBallLeaderboard', teams: Array<{ __typename?: 'BestBallLeaderboardTeam', rank: number | undefined, score: number, points: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined } }>, players: Array<{ __typename?: 'GolfLeaderboardPlayer', rank: number | undefined, score: number, points: number, strokes: number, strokesNet: number, holesRegistred: number, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined } }> } | { __typename: 'GolfLeaderboard', players: Array<{ __typename?: 'GolfLeaderboardPlayer', rank: number | undefined, score: number, points: number, strokes: number, strokesNet: number, holesRegistred: number, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined } }> } | { __typename: 'PolfLeaderboard', players: Array<{ __typename?: 'PolfLeaderboardPlayer', rank: number | undefined, isAllIn: boolean | undefined, chips: number, chipsInclHoleCompetitions: number, startStack: number, holesRegistred: number, flightBonus: number | undefined, player: { __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }, stablefordPoints: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, birdies: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, eagles: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, holeInOnes: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, closest: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number }, longest: { __typename?: 'PolfLeaderboardSpecialEntry', count: number, chips: number } }> } | { __typename: 'ScrambleLeaderboard', teams: Array<{ __typename?: 'ScrambleLeaderboardTeam', rank: number | undefined, score: number, points: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } }> } | { __typename: 'SegmentedLeaderboard', segments: Array<{ __typename?: 'SegmentedLeaderboardSegment', ordinal: number, fromHole: number, toHole: number, format: PolfEventSegmentFormatEnum, teams: Array<{ __typename?: 'SegmentedLeaderboardTeam', rank: number | undefined, score: number, points: number, strokesNet: number, holesRegistred: number, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } }> }>, teams: Array<{ __typename?: 'SegmentedLeaderboardTeam', rank: number | undefined, score: number, points: number, strokesNet: number, holesRegistred: number, segmentTotals: Array<{ __typename?: 'SegmentedLeaderboardSegmentTotal', ordinal: number, format: PolfEventSegmentFormatEnum, strokesNet: number, points: number }> | undefined, team: { __typename?: 'PolfEventTeam', id: string, name: string | undefined, players: Array<{ __typename?: 'PolfEventPlayer', id: string, name: string, hcp: number | undefined }> | undefined } }> }, polfEventPublicHoleCompetitionsWithCurrentLeader: Array<{ __typename?: 'PolfEventMobilePlayerHoleCompetition', id: string, type: PolfEventHoleCompetitionTypeEnum, description: string, chipValue: number, hole: { __typename?: 'CourseHole', id: string, number: number, par: number }, currentLeader: { __typename?: 'PolfEventHoleCompetitionEntry', id: string, value: number, polfEventPlayer: { __typename?: 'PolfEventPlayer', id: string, name: string } } | undefined }> };

export type ProjectorMatchesQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type ProjectorMatchesQuery = { __typename?: 'Query', polfEventPublicMatches: Array<{ __typename?: 'PolfEventMatch', id: string, matchNumber: number, sideA: { __typename?: 'PolfEventMatchSide', kind: MatchSideKindEnum, id: string, name: string } | undefined, sideB: { __typename?: 'PolfEventMatchSide', kind: MatchSideKindEnum, id: string, name: string } | undefined, flight: { __typename?: 'PolfEventFlight', flightNumber: number } | undefined, state: { __typename?: 'PolfEventMatchState', status: MatchStatusEnum, holesUp: number, leader: MatchSideEnum | undefined, holesRemaining: number, margin: string | undefined, pointsPerHole: number } | undefined }> };

export type ProjectorPokerQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type ProjectorPokerQuery = { __typename?: 'Query', polfEventPokerPublic: { __typename?: 'PolfEventPokerPublicDto', id: string, eventName: string, status: PolfEventPokerStatusEnum, currentLevelIndex: number, currentInBreak: boolean, voiceAnnouncements: boolean, currentLevelStartedAt: any | undefined, currentLevelPausedAt: any | undefined, totalLevels: number, playersTotal: number, playersLeft: number, averageStartingStack: number, currentLevel: { __typename?: 'PolfEventPokerLevelPublic', smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined } | undefined, nextLevel: { __typename?: 'PolfEventPokerLevelPublic', smallBlind: number, bigBlind: number, ante: number, durationMinutes: number, breakAfterMinutes: number | undefined } | undefined, activeStandings: Array<{ __typename?: 'PolfEventPokerPublicActive', id: string, playerName: string, tableNumber: number, seatNumber: number, currentStack: number, isLocked: boolean }>, eliminations: Array<{ __typename?: 'PolfEventPokerPublicEliminated', id: string, playerName: string, finishingPosition: number, tableNumber: number, seatNumber: number, eliminatedAt: any | undefined }> } | undefined };

export type ProjectorSponsorsQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type ProjectorSponsorsQuery = { __typename?: 'Query', polfEventSponsorsPublic: Array<{ __typename?: 'Sponsor', id: string, name: string, logoUrl: string | undefined }> };

export type PublicRegistrationEventFragment = { __typename?: 'PolfEvent', id: string, name: string, date: any, nanoId: string | undefined, status: PolfEventStatusEnum, mode: PolfEventModeEnum, account: { __typename?: 'Account', id: string, name: string, termsUrl: string | undefined, privacyUrl: string | undefined, contactEmail: string | undefined, contactPhone: string | undefined }, course: { __typename?: 'Course', id: string, name: string, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, courseRating: number, slope: number, par: number, default: boolean }> | undefined } | undefined, registration: { __typename?: 'PolfEventRegistration', enabled: boolean, playerPicksTee: boolean | undefined, price: { __typename?: 'PolfEventPrice', amountInCents: number }, recruitment: { __typename?: 'PolfEventRegistrationRecruitment', enabled: boolean, amountInCents: number } | undefined } | undefined };

export type CurrentPolfEventPublicQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentPolfEventPublicQuery = { __typename?: 'Query', currentPolfEventPublic: { __typename?: 'PolfEvent', id: string, name: string, date: any, nanoId: string | undefined, status: PolfEventStatusEnum, mode: PolfEventModeEnum, account: { __typename?: 'Account', id: string, name: string, termsUrl: string | undefined, privacyUrl: string | undefined, contactEmail: string | undefined, contactPhone: string | undefined }, course: { __typename?: 'Course', id: string, name: string, tees: Array<{ __typename?: 'CourseTee', id: string, teeName: string, courseRating: number, slope: number, par: number, default: boolean }> | undefined } | undefined, registration: { __typename?: 'PolfEventRegistration', enabled: boolean, playerPicksTee: boolean | undefined, price: { __typename?: 'PolfEventPrice', amountInCents: number }, recruitment: { __typename?: 'PolfEventRegistrationRecruitment', enabled: boolean, amountInCents: number } | undefined } | undefined } };

export type PolfEventPublicAddPlayerVippsMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  createPolfEventPaymentDto: CreatePolfEventPaymentDto;
  polfEventPlayerNanoId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PolfEventPublicAddPlayerVippsMutation = { __typename?: 'Mutation', polfEventPublicAddPlayerVipps: { __typename?: 'VippsPayment', id: string, reference: string | undefined, redirectUrl: string | undefined, mobileNumber: string | undefined, state: string | undefined } };

export type PolfEventPublicUpdatePlayerMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  polfEventPlayerNanoId: Scalars['String']['input'];
  updatePolfEventPlayerDto: UpdatePolfEventPlayerDto;
}>;


export type PolfEventPublicUpdatePlayerMutation = { __typename?: 'Mutation', polfEventPublicUpdatePlayer: { __typename?: 'PolfEventPlayer', id: string, nanoId: string | undefined, name: string, hcp: number | undefined, memberNo: string | undefined } };

export type PolfEventPublicPlayerQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  polfEventPlayerNanoId: Scalars['ID']['input'];
}>;


export type PolfEventPublicPlayerQuery = { __typename?: 'Query', polfEventPublicPlayer: { __typename?: 'PolfEventPlayer', id: string, nanoId: string | undefined, name: string, hcp: number | undefined, memberNo: string | undefined, mobileNumber: string, payment: { __typename: 'PolfEventPlayerOtherPayment', id: string, createdAt: any } | { __typename: 'VippsPayment', id: string, paymentStatus: VippsPaymentStatusEnum | undefined, amount: { __typename?: 'VippsPaymentDetailsAmount', value: number, currency: string } | undefined } | undefined } };

export type SponsorItemFragment = { __typename?: 'Sponsor', id: string, name: string, logoUrl: string | undefined };

export type EventSponsorsQueryVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
}>;


export type EventSponsorsQuery = { __typename?: 'Query', eventSponsors: Array<{ __typename?: 'Sponsor', id: string, name: string, logoUrl: string | undefined }> };

export type SponsorCreateMutationVariables = Exact<{
  polfEventId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type SponsorCreateMutation = { __typename?: 'Mutation', sponsorCreate: { __typename?: 'Sponsor', id: string, name: string, logoUrl: string | undefined } };

export type SponsorUpdateMutationVariables = Exact<{
  sponsorId: Scalars['ID']['input'];
  updateSponsorDto: UpdateSponsorDto;
}>;


export type SponsorUpdateMutation = { __typename?: 'Mutation', sponsorUpdate: { __typename?: 'Sponsor', id: string, name: string, logoUrl: string | undefined } };

export type SponsorDeleteMutationVariables = Exact<{
  sponsorId: Scalars['ID']['input'];
}>;


export type SponsorDeleteMutation = { __typename?: 'Mutation', sponsorDelete: boolean };

export type SponsorLogoUploadUrlMutationVariables = Exact<{
  sponsorId: Scalars['ID']['input'];
  contentType: Scalars['String']['input'];
}>;


export type SponsorLogoUploadUrlMutation = { __typename?: 'Mutation', sponsorLogoUploadUrl: { __typename?: 'SponsorLogoUpload', uploadUrl: string, storagePath: string } };

export type SponsorLogoUploadCompleteMutationVariables = Exact<{
  sponsorId: Scalars['ID']['input'];
  storagePath: Scalars['String']['input'];
}>;


export type SponsorLogoUploadCompleteMutation = { __typename?: 'Mutation', sponsorLogoUploadComplete: { __typename?: 'Sponsor', id: string, name: string, logoUrl: string | undefined } };

export type VippsPaymentDetailsFieldsFragment = { __typename?: 'VippsPaymentDetails', state: string, reference: string, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, aggregate: { __typename?: 'VippsPaymentDetailsAggregate', authorizedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, capturedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, refundedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, cancelledAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } }, events: Array<{ __typename?: 'VippsPaymentDetailsEvent', reference: string, name: string | undefined, timestamp: string, success: boolean, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } }>, paymentRecord: { __typename?: 'VippsPayment', id: string, invoiceNo: number | undefined, createdAt: any, mobileNumber: string | undefined, player: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined } };

export type PaymentDetailsQueryVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type PaymentDetailsQuery = { __typename?: 'Query', paymentDetails: { __typename?: 'VippsPaymentDetails', state: string, reference: string, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, aggregate: { __typename?: 'VippsPaymentDetailsAggregate', authorizedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, capturedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, refundedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, cancelledAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } }, events: Array<{ __typename?: 'VippsPaymentDetailsEvent', reference: string, name: string | undefined, timestamp: string, success: boolean, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } }>, paymentRecord: { __typename?: 'VippsPayment', id: string, invoiceNo: number | undefined, createdAt: any, mobileNumber: string | undefined, player: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined } } };

export type PaymentCaptureMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type PaymentCaptureMutation = { __typename?: 'Mutation', paymentCapture: { __typename?: 'VippsPaymentDetails', state: string, reference: string, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, aggregate: { __typename?: 'VippsPaymentDetailsAggregate', authorizedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, capturedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, refundedAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number }, cancelledAmount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } }, events: Array<{ __typename?: 'VippsPaymentDetailsEvent', reference: string, name: string | undefined, timestamp: string, success: boolean, amount: { __typename?: 'VippsPaymentDetailsAmount', currency: string, value: number } }>, paymentRecord: { __typename?: 'VippsPayment', id: string, invoiceNo: number | undefined, createdAt: any, mobileNumber: string | undefined, player: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined } } };

export type PaymentCreatePlayerBasedOnPaymentRecordMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type PaymentCreatePlayerBasedOnPaymentRecordMutation = { __typename?: 'Mutation', paymentCreatePlayerBasedOnPaymentRecord: { __typename?: 'VippsPayment', id: string, player: { __typename?: 'PolfEventPlayer', id: string, name: string } | undefined } };

export const CourseHoleFieldsFragmentDoc = gql`
    fragment CourseHoleFields on CourseHole {
  id
  number
  par
  index
  tees {
    teeId
    length
  }
}
    `;
export const CourseTeeFieldsFragmentDoc = gql`
    fragment CourseTeeFields on CourseTee {
  id
  teeName
  default
  courseRating
  slope
  par
}
    `;
export const CourseFieldsFragmentDoc = gql`
    fragment CourseFields on Course {
  id
  name
  isValid
  country
  status
  aiImported
  updatedAt
  holes {
    ...CourseHoleFields
  }
  tees {
    ...CourseTeeFields
  }
}
    ${CourseHoleFieldsFragmentDoc}
${CourseTeeFieldsFragmentDoc}`;
export const CourseDraftFieldsFragmentDoc = gql`
    fragment CourseDraftFields on CourseDraftDto {
  name
  country
  tees {
    teeName
    courseRating
    slope
    par
  }
  holes {
    number
    par
    index
    tees {
      teeName
      length
    }
  }
  sources {
    uri
    title
  }
}
    `;
export const FlightListItemFragmentDoc = gql`
    fragment FlightListItem on PolfEventFlight {
  id
  flightNumber
  startTime
  playerCount
  createdAt
  updatedAt
  startHole {
    id
    number
    par
  }
  players {
    id
    name
    hcp
    strokes
    scoresSubmitted
    courseTee {
      id
      teeName
    }
    team {
      id
      name
    }
  }
  teams {
    id
    name
    strokes
    players {
      id
      name
      hcp
    }
  }
}
    `;
export const HoleCompetitionItemFragmentDoc = gql`
    fragment HoleCompetitionItem on PolfEventHoleCompetition {
  id
  type
  description
  chipValue
  hole {
    id
    number
    par
  }
  opponent {
    id
    name
    countryCode
    mobileNumber
    nanoId
  }
}
    `;
export const HoleCompetitionEntryFragmentDoc = gql`
    fragment HoleCompetitionEntry on PolfEventHoleCompetitionEntry {
  id
  value
  beatTheProExtra {
    bet
    allIn
    state
  }
  polfEventPlayer {
    id
    name
  }
}
    `;
export const HoleCompetitionWithEntriesFragmentDoc = gql`
    fragment HoleCompetitionWithEntries on PolfEventHoleCompetition {
  ...HoleCompetitionItem
  entries {
    ...HoleCompetitionEntry
  }
}
    ${HoleCompetitionItemFragmentDoc}
${HoleCompetitionEntryFragmentDoc}`;
export const SummaryPolfPlayerRowFragmentDoc = gql`
    fragment SummaryPolfPlayerRow on PolfLeaderboardPlayer {
  rank
  chips
  chipsInclHoleCompetitions
  startStack
  holesRegistred
  flightBonus
  isAllIn
  player {
    id
    name
    hcp
    scoresSubmitted
    retiredAt
    retiredHolesFilled
  }
  stablefordPoints {
    count
    chips
  }
  birdies {
    count
    chips
  }
  eagles {
    count
    chips
  }
  holeInOnes {
    count
    chips
  }
  closest {
    count
    chips
  }
  longest {
    count
    chips
  }
  beatTheProExtra {
    value
    bet
    state
    allIn
  }
}
    `;
export const SummaryGolfPlayerRowFragmentDoc = gql`
    fragment SummaryGolfPlayerRow on GolfLeaderboardPlayer {
  rank
  strokes
  strokesNet
  score
  points
  holesRegistred
  player {
    id
    name
    hcp
    scoresSubmitted
    retiredAt
    retiredHolesFilled
  }
}
    `;
export const SummaryScrambleTeamRowFragmentDoc = gql`
    fragment SummaryScrambleTeamRow on ScrambleLeaderboardTeam {
  rank
  strokes
  strokesNet
  score
  points
  holesRegistred
  team {
    id
    name
    players {
      id
      name
      hcp
    }
  }
}
    `;
export const SummaryBestBallTeamRowFragmentDoc = gql`
    fragment SummaryBestBallTeamRow on BestBallLeaderboardTeam {
  rank
  strokes
  strokesNet
  score
  points
  holesRegistred
  team {
    id
    name
    players {
      id
      name
      hcp
    }
  }
}
    `;
export const SummarySegmentedTeamRowFragmentDoc = gql`
    fragment SummarySegmentedTeamRow on SegmentedLeaderboardTeam {
  rank
  strokes
  strokesNet
  score
  points
  holesRegistred
  team {
    id
    name
    players {
      id
      name
      hcp
    }
  }
}
    `;
export const MatchSideFieldsFragmentDoc = gql`
    fragment MatchSideFields on PolfEventMatchSide {
  kind
  id
  name
  hcp
  handicap
  strokes
  players {
    id
    name
    hcp
    strokes
  }
}
    `;
export const EventMatchFieldsFragmentDoc = gql`
    fragment EventMatchFields on PolfEventMatch {
  id
  matchNumber
  segmentOrdinal
  flight {
    id
    flightNumber
  }
  sideA {
    ...MatchSideFields
  }
  sideB {
    ...MatchSideFields
  }
  state {
    status
    holesUp
    leader
    holesRemaining
    margin
    pointsPerHole
    holes
  }
}
    ${MatchSideFieldsFragmentDoc}`;
export const ScorecardScoreFragmentDoc = gql`
    fragment ScorecardScore on PolfEventScore {
  id
  score
  strokes
  stablefordPoints
  chips
  hole {
    id
    number
    par
    index
  }
}
    `;
export const ScorecardPlayerFragmentDoc = gql`
    fragment ScorecardPlayer on PolfEventPlayer {
  id
  name
  retiredAt
  retiredHolesFilled
  scores {
    ...ScorecardScore
  }
}
    ${ScorecardScoreFragmentDoc}`;
export const PlayerListItemFragmentDoc = gql`
    fragment PlayerListItem on PolfEventPlayer {
  id
  nanoId
  name
  email
  memberNo
  hcp
  countryCode
  mobileNumber
  valid
  strokes
  scoresSubmitted
  retiredAt
  retiredHolesFilled
  retiredPlaysPoker
  smsInviteStatus
  createdAt
  updatedAt
  courseTee {
    id
    teeName
    courseRating
    slope
    par
  }
  team {
    id
    name
  }
  flight {
    id
  }
  recruitment {
    id
    status
    amountInCents
    recruitedBy
  }
  sentSms {
    id
    type
    status
    createdAt
  }
  payment {
    __typename
    ... on VippsPayment {
      id
      paymentStatus
      amount {
        currency
        value
      }
    }
    ... on PolfEventPlayerOtherPayment {
      id
      createdAt
    }
  }
}
    `;
export const PokerLevelRowFragmentDoc = gql`
    fragment PokerLevelRow on PolfEventPokerLevel {
  id
  index
  smallBlind
  bigBlind
  ante
  durationMinutes
  breakAfterMinutes
}
    `;
export const PokerSeatRowFragmentDoc = gql`
    fragment PokerSeatRow on PolfEventPokerSeat {
  id
  tableNumber
  seatNumber
  startingStack
  currentStack
  eliminated
  eliminatedAt
  withdrawn
  isLocked
  finishingPosition
  rebuyCount
  addonTaken
  polfEventPlayer {
    id
    name
    nanoId
  }
  knockedOutByPlayer {
    id
    name
  }
}
    `;
export const PokerPayoutRowFragmentDoc = gql`
    fragment PokerPayoutRow on PolfEventPokerPayout {
  id
  position
  percentageBp
}
    `;
export const PokerDataFragmentDoc = gql`
    fragment PokerData on PolfEventPoker {
  id
  status
  tableCount
  seatsPerTable
  usePayouts
  allowPlayerStackUpdate
  showChipLeaderboard
  voiceAnnouncements
  finalTableRedrawnAt
  prizePool
  rebuysEnabled
  rebuyStackChips
  maxRebuysPerPlayer
  rebuyWhileActive
  addonEnabled
  addonStackChips
  rebuyUntilLevel
  registrationClosedAt
  registrationOpen
  currentLevelIndex
  currentInBreak
  currentLevelStartedAt
  currentLevelPausedAt
  seedSeatRandom
  levels {
    ...PokerLevelRow
  }
  seats {
    ...PokerSeatRow
  }
  payouts {
    ...PokerPayoutRow
  }
  balancingSuggestion {
    kind
    reason
    tableNumber
    moves {
      seatId
      tableNumber
      seatNumber
    }
  }
}
    ${PokerLevelRowFragmentDoc}
${PokerSeatRowFragmentDoc}
${PokerPayoutRowFragmentDoc}`;
export const TeamListItemFragmentDoc = gql`
    fragment TeamListItem on PolfEventTeam {
  id
  name
  valid
  strokes
  createdAt
  updatedAt
  players {
    id
    name
    hcp
    strokes
    countryCode
    mobileNumber
    courseTee {
      id
      teeName
      slope
      courseRating
      par
    }
    flight {
      id
      flightNumber
    }
  }
  flight {
    id
    flightNumber
  }
}
    `;
export const ProjectorEventFragmentDoc = gql`
    fragment ProjectorEvent on PolfEvent {
  id
  name
  date
  mode
  ranking
  matchPlay
  status
  golfFinishedAt
  hasPokerPhase
  course {
    id
    name
  }
}
    `;
export const ProjectorHoleCompetitionEntryFragmentDoc = gql`
    fragment ProjectorHoleCompetitionEntry on PolfEventHoleCompetitionEntry {
  id
  value
  polfEventPlayer {
    id
    name
  }
}
    `;
export const ProjectorHoleCompetitionFragmentDoc = gql`
    fragment ProjectorHoleCompetition on PolfEventMobilePlayerHoleCompetition {
  id
  type
  description
  chipValue
  hole {
    id
    number
    par
  }
  currentLeader {
    ...ProjectorHoleCompetitionEntry
  }
}
    ${ProjectorHoleCompetitionEntryFragmentDoc}`;
export const ProjectorPlayerSummaryFragmentDoc = gql`
    fragment ProjectorPlayerSummary on PolfEventPlayer {
  id
  name
  hcp
}
    `;
export const ProjectorPolfLeaderboardSpecialEntryFragmentDoc = gql`
    fragment ProjectorPolfLeaderboardSpecialEntry on PolfLeaderboardSpecialEntry {
  count
  chips
}
    `;
export const ProjectorPolfLeaderboardPlayerEntryFragmentDoc = gql`
    fragment ProjectorPolfLeaderboardPlayerEntry on PolfLeaderboardPlayer {
  rank
  isAllIn
  chips
  chipsInclHoleCompetitions
  startStack
  holesRegistred
  flightBonus
  player {
    ...ProjectorPlayerSummary
  }
  stablefordPoints {
    ...ProjectorPolfLeaderboardSpecialEntry
  }
  birdies {
    ...ProjectorPolfLeaderboardSpecialEntry
  }
  eagles {
    ...ProjectorPolfLeaderboardSpecialEntry
  }
  holeInOnes {
    ...ProjectorPolfLeaderboardSpecialEntry
  }
  closest {
    ...ProjectorPolfLeaderboardSpecialEntry
  }
  longest {
    ...ProjectorPolfLeaderboardSpecialEntry
  }
}
    ${ProjectorPlayerSummaryFragmentDoc}
${ProjectorPolfLeaderboardSpecialEntryFragmentDoc}`;
export const ProjectorGolfLeaderboardPlayerEntryFragmentDoc = gql`
    fragment ProjectorGolfLeaderboardPlayerEntry on GolfLeaderboardPlayer {
  rank
  score
  points
  strokes
  strokesNet
  holesRegistred
  player {
    ...ProjectorPlayerSummary
  }
}
    ${ProjectorPlayerSummaryFragmentDoc}`;
export const ProjectorSegmentedTeamEntryFragmentDoc = gql`
    fragment ProjectorSegmentedTeamEntry on SegmentedLeaderboardTeam {
  rank
  score
  points
  strokesNet
  holesRegistred
  team {
    id
    name
    players {
      ...ProjectorPlayerSummary
    }
  }
}
    ${ProjectorPlayerSummaryFragmentDoc}`;
export const ProjectorLeaderboardUnionFieldsFragmentDoc = gql`
    fragment ProjectorLeaderboardUnionFields on LeaderboardUnion {
  ... on PolfLeaderboard {
    __typename
    players {
      ...ProjectorPolfLeaderboardPlayerEntry
    }
  }
  ... on GolfLeaderboard {
    __typename
    players {
      ...ProjectorGolfLeaderboardPlayerEntry
    }
  }
  ... on ScrambleLeaderboard {
    __typename
    teams {
      rank
      score
      points
      holesRegistred
      team {
        id
        name
        players {
          ...ProjectorPlayerSummary
        }
      }
    }
  }
  ... on BestBallLeaderboard {
    __typename
    teams {
      rank
      score
      points
      holesRegistred
      team {
        id
        name
      }
    }
    players {
      ...ProjectorGolfLeaderboardPlayerEntry
    }
  }
  ... on SegmentedLeaderboard {
    __typename
    segments {
      ordinal
      fromHole
      toHole
      format
      teams {
        ...ProjectorSegmentedTeamEntry
      }
    }
    teams {
      ...ProjectorSegmentedTeamEntry
      segmentTotals {
        ordinal
        format
        strokesNet
        points
      }
    }
  }
}
    ${ProjectorPolfLeaderboardPlayerEntryFragmentDoc}
${ProjectorGolfLeaderboardPlayerEntryFragmentDoc}
${ProjectorPlayerSummaryFragmentDoc}
${ProjectorSegmentedTeamEntryFragmentDoc}`;
export const ProjectorPokerLevelFragmentDoc = gql`
    fragment ProjectorPokerLevel on PolfEventPokerLevelPublic {
  smallBlind
  bigBlind
  ante
  durationMinutes
  breakAfterMinutes
}
    `;
export const ProjectorPokerActiveStandingFragmentDoc = gql`
    fragment ProjectorPokerActiveStanding on PolfEventPokerPublicActive {
  id
  playerName
  tableNumber
  seatNumber
  currentStack
  isLocked
}
    `;
export const ProjectorPokerEliminatedFragmentDoc = gql`
    fragment ProjectorPokerEliminated on PolfEventPokerPublicEliminated {
  id
  playerName
  finishingPosition
  tableNumber
  seatNumber
  eliminatedAt
}
    `;
export const ProjectorPokerPublicFragmentDoc = gql`
    fragment ProjectorPokerPublic on PolfEventPokerPublicDto {
  id
  eventName
  status
  currentLevelIndex
  currentInBreak
  voiceAnnouncements
  currentLevelStartedAt
  currentLevelPausedAt
  totalLevels
  playersTotal
  playersLeft
  averageStartingStack
  currentLevel {
    ...ProjectorPokerLevel
  }
  nextLevel {
    ...ProjectorPokerLevel
  }
  activeStandings {
    ...ProjectorPokerActiveStanding
  }
  eliminations {
    ...ProjectorPokerEliminated
  }
}
    ${ProjectorPokerLevelFragmentDoc}
${ProjectorPokerActiveStandingFragmentDoc}
${ProjectorPokerEliminatedFragmentDoc}`;
export const PublicRegistrationEventFragmentDoc = gql`
    fragment PublicRegistrationEvent on PolfEvent {
  id
  name
  date
  nanoId
  status
  mode
  account {
    id
    name
    termsUrl
    privacyUrl
    contactEmail
    contactPhone
  }
  course {
    id
    name
    tees {
      id
      teeName
      courseRating
      slope
      par
      default
    }
  }
  registration {
    enabled
    playerPicksTee
    price {
      amountInCents
    }
    recruitment {
      enabled
      amountInCents
    }
  }
}
    `;
export const SponsorItemFragmentDoc = gql`
    fragment SponsorItem on Sponsor {
  id
  name
  logoUrl
}
    `;
export const VippsPaymentDetailsFieldsFragmentDoc = gql`
    fragment VippsPaymentDetailsFields on VippsPaymentDetails {
  state
  reference
  amount {
    currency
    value
  }
  aggregate {
    authorizedAmount {
      currency
      value
    }
    capturedAmount {
      currency
      value
    }
    refundedAmount {
      currency
      value
    }
    cancelledAmount {
      currency
      value
    }
  }
  events {
    reference
    name
    timestamp
    success
    amount {
      currency
      value
    }
  }
  paymentRecord {
    id
    invoiceNo
    createdAt
    mobileNumber
    player {
      id
      name
    }
  }
}
    `;
export const MyCurrentAccountDocument = gql`
    query myCurrentAccount {
  myCurrentAccount {
    id
    name
    slug
    type
    onboardingCompleted
    orgNumber
    addressStreet
    addressPostalCode
    addressCity
    contactEmail
    contactPhone
    website
    createdAt
  }
}
    `;

/**
 * __useMyCurrentAccountQuery__
 *
 * To run a query within a React component, call `useMyCurrentAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCurrentAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCurrentAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCurrentAccountQuery(baseOptions?: Apollo.QueryHookOptions<MyCurrentAccountQuery, MyCurrentAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCurrentAccountQuery, MyCurrentAccountQueryVariables>(MyCurrentAccountDocument, options);
      }
export function useMyCurrentAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCurrentAccountQuery, MyCurrentAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCurrentAccountQuery, MyCurrentAccountQueryVariables>(MyCurrentAccountDocument, options);
        }
// @ts-ignore
export function useMyCurrentAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyCurrentAccountQuery, MyCurrentAccountQueryVariables>): Apollo.UseSuspenseQueryResult<MyCurrentAccountQuery, MyCurrentAccountQueryVariables>;
export function useMyCurrentAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCurrentAccountQuery, MyCurrentAccountQueryVariables>): Apollo.UseSuspenseQueryResult<MyCurrentAccountQuery | undefined, MyCurrentAccountQueryVariables>;
export function useMyCurrentAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCurrentAccountQuery, MyCurrentAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCurrentAccountQuery, MyCurrentAccountQueryVariables>(MyCurrentAccountDocument, options);
        }
export type MyCurrentAccountQueryHookResult = ReturnType<typeof useMyCurrentAccountQuery>;
export type MyCurrentAccountLazyQueryHookResult = ReturnType<typeof useMyCurrentAccountLazyQuery>;
export type MyCurrentAccountSuspenseQueryHookResult = ReturnType<typeof useMyCurrentAccountSuspenseQuery>;
export type MyCurrentAccountQueryResult = Apollo.QueryResult<MyCurrentAccountQuery, MyCurrentAccountQueryVariables>;
export const MyAccountSettingsDocument = gql`
    query myAccountSettings {
  myAccountSettings {
    id
    vippsConfigured
    vippsValidated
    vippsClientIdMasked
    vippsMerchantSerialNumberMasked
    startInvoiceNo
    paymentNotificationEmail
    emailConfigured
    smsConfigured
    legalConfigured
    onboardingCompleted
    sectionsConfigured
    sectionsTotal
    mailFromName
    mailReplyTo
    smsDefaultSender
    termsUrl
    privacyUrl
  }
}
    `;

/**
 * __useMyAccountSettingsQuery__
 *
 * To run a query within a React component, call `useMyAccountSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccountSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAccountSettingsQuery(baseOptions?: Apollo.QueryHookOptions<MyAccountSettingsQuery, MyAccountSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccountSettingsQuery, MyAccountSettingsQueryVariables>(MyAccountSettingsDocument, options);
      }
export function useMyAccountSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccountSettingsQuery, MyAccountSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccountSettingsQuery, MyAccountSettingsQueryVariables>(MyAccountSettingsDocument, options);
        }
// @ts-ignore
export function useMyAccountSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAccountSettingsQuery, MyAccountSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<MyAccountSettingsQuery, MyAccountSettingsQueryVariables>;
export function useMyAccountSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAccountSettingsQuery, MyAccountSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<MyAccountSettingsQuery | undefined, MyAccountSettingsQueryVariables>;
export function useMyAccountSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAccountSettingsQuery, MyAccountSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAccountSettingsQuery, MyAccountSettingsQueryVariables>(MyAccountSettingsDocument, options);
        }
export type MyAccountSettingsQueryHookResult = ReturnType<typeof useMyAccountSettingsQuery>;
export type MyAccountSettingsLazyQueryHookResult = ReturnType<typeof useMyAccountSettingsLazyQuery>;
export type MyAccountSettingsSuspenseQueryHookResult = ReturnType<typeof useMyAccountSettingsSuspenseQuery>;
export type MyAccountSettingsQueryResult = Apollo.QueryResult<MyAccountSettingsQuery, MyAccountSettingsQueryVariables>;
export const MyAccountProfileUpdateDocument = gql`
    mutation myAccountProfileUpdate($profile: UpdateAccountProfileInput!) {
  myAccountProfileUpdate(profile: $profile) {
    id
    name
    orgNumber
    addressStreet
    addressPostalCode
    addressCity
    contactEmail
    contactPhone
    website
  }
}
    `;
export type MyAccountProfileUpdateMutationFn = Apollo.MutationFunction<MyAccountProfileUpdateMutation, MyAccountProfileUpdateMutationVariables>;

/**
 * __useMyAccountProfileUpdateMutation__
 *
 * To run a mutation, you first call `useMyAccountProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAccountProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAccountProfileUpdateMutation, { data, loading, error }] = useMyAccountProfileUpdateMutation({
 *   variables: {
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useMyAccountProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MyAccountProfileUpdateMutation, MyAccountProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAccountProfileUpdateMutation, MyAccountProfileUpdateMutationVariables>(MyAccountProfileUpdateDocument, options);
      }
export type MyAccountProfileUpdateMutationHookResult = ReturnType<typeof useMyAccountProfileUpdateMutation>;
export type MyAccountProfileUpdateMutationResult = Apollo.MutationResult<MyAccountProfileUpdateMutation>;
export const MyAccountSettingsUpdateDocument = gql`
    mutation myAccountSettingsUpdate($settings: UpdateAccountSettingsInput!) {
  myAccountSettingsUpdate(settings: $settings) {
    id
    vippsConfigured
    vippsValidated
    vippsClientIdMasked
    vippsMerchantSerialNumberMasked
    startInvoiceNo
    paymentNotificationEmail
    emailConfigured
    smsConfigured
    legalConfigured
    sectionsConfigured
    sectionsTotal
    mailFromName
    mailReplyTo
    smsDefaultSender
    termsUrl
    privacyUrl
  }
}
    `;
export type MyAccountSettingsUpdateMutationFn = Apollo.MutationFunction<MyAccountSettingsUpdateMutation, MyAccountSettingsUpdateMutationVariables>;

/**
 * __useMyAccountSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useMyAccountSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAccountSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAccountSettingsUpdateMutation, { data, loading, error }] = useMyAccountSettingsUpdateMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useMyAccountSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MyAccountSettingsUpdateMutation, MyAccountSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAccountSettingsUpdateMutation, MyAccountSettingsUpdateMutationVariables>(MyAccountSettingsUpdateDocument, options);
      }
export type MyAccountSettingsUpdateMutationHookResult = ReturnType<typeof useMyAccountSettingsUpdateMutation>;
export type MyAccountSettingsUpdateMutationResult = Apollo.MutationResult<MyAccountSettingsUpdateMutation>;
export const MyAccountsDocument = gql`
    query myAccounts {
  myAccounts {
    id
    account {
      id
      name
      slug
      type
    }
  }
}
    `;

/**
 * __useMyAccountsQuery__
 *
 * To run a query within a React component, call `useMyAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAccountsQuery(baseOptions?: Apollo.QueryHookOptions<MyAccountsQuery, MyAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccountsQuery, MyAccountsQueryVariables>(MyAccountsDocument, options);
      }
export function useMyAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccountsQuery, MyAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccountsQuery, MyAccountsQueryVariables>(MyAccountsDocument, options);
        }
// @ts-ignore
export function useMyAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAccountsQuery, MyAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<MyAccountsQuery, MyAccountsQueryVariables>;
export function useMyAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAccountsQuery, MyAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<MyAccountsQuery | undefined, MyAccountsQueryVariables>;
export function useMyAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAccountsQuery, MyAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAccountsQuery, MyAccountsQueryVariables>(MyAccountsDocument, options);
        }
export type MyAccountsQueryHookResult = ReturnType<typeof useMyAccountsQuery>;
export type MyAccountsLazyQueryHookResult = ReturnType<typeof useMyAccountsLazyQuery>;
export type MyAccountsSuspenseQueryHookResult = ReturnType<typeof useMyAccountsSuspenseQuery>;
export type MyAccountsQueryResult = Apollo.QueryResult<MyAccountsQuery, MyAccountsQueryVariables>;
export const SelectAccountDocument = gql`
    mutation selectAccount($accountId: ID!) {
  selectAccount(accountId: $accountId) {
    success
  }
}
    `;
export type SelectAccountMutationFn = Apollo.MutationFunction<SelectAccountMutation, SelectAccountMutationVariables>;

/**
 * __useSelectAccountMutation__
 *
 * To run a mutation, you first call `useSelectAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectAccountMutation, { data, loading, error }] = useSelectAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useSelectAccountMutation(baseOptions?: Apollo.MutationHookOptions<SelectAccountMutation, SelectAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectAccountMutation, SelectAccountMutationVariables>(SelectAccountDocument, options);
      }
export type SelectAccountMutationHookResult = ReturnType<typeof useSelectAccountMutation>;
export type SelectAccountMutationResult = Apollo.MutationResult<SelectAccountMutation>;
export const MyAccountMembersDocument = gql`
    query myAccountMembers {
  myAccountMembers {
    id
    isContactPerson
    user {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useMyAccountMembersQuery__
 *
 * To run a query within a React component, call `useMyAccountMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccountMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAccountMembersQuery(baseOptions?: Apollo.QueryHookOptions<MyAccountMembersQuery, MyAccountMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccountMembersQuery, MyAccountMembersQueryVariables>(MyAccountMembersDocument, options);
      }
export function useMyAccountMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccountMembersQuery, MyAccountMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccountMembersQuery, MyAccountMembersQueryVariables>(MyAccountMembersDocument, options);
        }
// @ts-ignore
export function useMyAccountMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAccountMembersQuery, MyAccountMembersQueryVariables>): Apollo.UseSuspenseQueryResult<MyAccountMembersQuery, MyAccountMembersQueryVariables>;
export function useMyAccountMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAccountMembersQuery, MyAccountMembersQueryVariables>): Apollo.UseSuspenseQueryResult<MyAccountMembersQuery | undefined, MyAccountMembersQueryVariables>;
export function useMyAccountMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAccountMembersQuery, MyAccountMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAccountMembersQuery, MyAccountMembersQueryVariables>(MyAccountMembersDocument, options);
        }
export type MyAccountMembersQueryHookResult = ReturnType<typeof useMyAccountMembersQuery>;
export type MyAccountMembersLazyQueryHookResult = ReturnType<typeof useMyAccountMembersLazyQuery>;
export type MyAccountMembersSuspenseQueryHookResult = ReturnType<typeof useMyAccountMembersSuspenseQuery>;
export type MyAccountMembersQueryResult = Apollo.QueryResult<MyAccountMembersQuery, MyAccountMembersQueryVariables>;
export const MyAccountAddMemberDocument = gql`
    mutation myAccountAddMember($email: String!) {
  myAccountAddMember(email: $email) {
    id
    isContactPerson
    user {
      id
      name
      email
    }
  }
}
    `;
export type MyAccountAddMemberMutationFn = Apollo.MutationFunction<MyAccountAddMemberMutation, MyAccountAddMemberMutationVariables>;

/**
 * __useMyAccountAddMemberMutation__
 *
 * To run a mutation, you first call `useMyAccountAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAccountAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAccountAddMemberMutation, { data, loading, error }] = useMyAccountAddMemberMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useMyAccountAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<MyAccountAddMemberMutation, MyAccountAddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAccountAddMemberMutation, MyAccountAddMemberMutationVariables>(MyAccountAddMemberDocument, options);
      }
export type MyAccountAddMemberMutationHookResult = ReturnType<typeof useMyAccountAddMemberMutation>;
export type MyAccountAddMemberMutationResult = Apollo.MutationResult<MyAccountAddMemberMutation>;
export const MyAccountRemoveMemberDocument = gql`
    mutation myAccountRemoveMember($userId: ID!) {
  myAccountRemoveMember(userId: $userId)
}
    `;
export type MyAccountRemoveMemberMutationFn = Apollo.MutationFunction<MyAccountRemoveMemberMutation, MyAccountRemoveMemberMutationVariables>;

/**
 * __useMyAccountRemoveMemberMutation__
 *
 * To run a mutation, you first call `useMyAccountRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAccountRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAccountRemoveMemberMutation, { data, loading, error }] = useMyAccountRemoveMemberMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMyAccountRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<MyAccountRemoveMemberMutation, MyAccountRemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAccountRemoveMemberMutation, MyAccountRemoveMemberMutationVariables>(MyAccountRemoveMemberDocument, options);
      }
export type MyAccountRemoveMemberMutationHookResult = ReturnType<typeof useMyAccountRemoveMemberMutation>;
export type MyAccountRemoveMemberMutationResult = Apollo.MutationResult<MyAccountRemoveMemberMutation>;
export const CoursesDocument = gql`
    query courses {
  courses {
    ...CourseFields
  }
}
    ${CourseFieldsFragmentDoc}`;

/**
 * __useCoursesQuery__
 *
 * To run a query within a React component, call `useCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoursesQuery(baseOptions?: Apollo.QueryHookOptions<CoursesQuery, CoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursesQuery, CoursesQueryVariables>(CoursesDocument, options);
      }
export function useCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursesQuery, CoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursesQuery, CoursesQueryVariables>(CoursesDocument, options);
        }
// @ts-ignore
export function useCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CoursesQuery, CoursesQueryVariables>): Apollo.UseSuspenseQueryResult<CoursesQuery, CoursesQueryVariables>;
export function useCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoursesQuery, CoursesQueryVariables>): Apollo.UseSuspenseQueryResult<CoursesQuery | undefined, CoursesQueryVariables>;
export function useCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoursesQuery, CoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CoursesQuery, CoursesQueryVariables>(CoursesDocument, options);
        }
export type CoursesQueryHookResult = ReturnType<typeof useCoursesQuery>;
export type CoursesLazyQueryHookResult = ReturnType<typeof useCoursesLazyQuery>;
export type CoursesSuspenseQueryHookResult = ReturnType<typeof useCoursesSuspenseQuery>;
export type CoursesQueryResult = Apollo.QueryResult<CoursesQuery, CoursesQueryVariables>;
export const CourseDocument = gql`
    query course($courseId: ID!) {
  course(courseId: $courseId) {
    ...CourseFields
  }
}
    ${CourseFieldsFragmentDoc}`;

/**
 * __useCourseQuery__
 *
 * To run a query within a React component, call `useCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseQuery(baseOptions: Apollo.QueryHookOptions<CourseQuery, CourseQueryVariables> & ({ variables: CourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseQuery, CourseQueryVariables>(CourseDocument, options);
      }
export function useCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseQuery, CourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseQuery, CourseQueryVariables>(CourseDocument, options);
        }
// @ts-ignore
export function useCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseQuery, CourseQueryVariables>): Apollo.UseSuspenseQueryResult<CourseQuery, CourseQueryVariables>;
export function useCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseQuery, CourseQueryVariables>): Apollo.UseSuspenseQueryResult<CourseQuery | undefined, CourseQueryVariables>;
export function useCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseQuery, CourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseQuery, CourseQueryVariables>(CourseDocument, options);
        }
export type CourseQueryHookResult = ReturnType<typeof useCourseQuery>;
export type CourseLazyQueryHookResult = ReturnType<typeof useCourseLazyQuery>;
export type CourseSuspenseQueryHookResult = ReturnType<typeof useCourseSuspenseQuery>;
export type CourseQueryResult = Apollo.QueryResult<CourseQuery, CourseQueryVariables>;
export const FindCourseDraftDocument = gql`
    query findCourseDraft($name: String!, $country: CourseCountryEnum!, $deepenFromSources: [String!]) {
  findCourseDraft(
    name: $name
    country: $country
    deepenFromSources: $deepenFromSources
  ) {
    ...CourseDraftFields
  }
}
    ${CourseDraftFieldsFragmentDoc}`;

/**
 * __useFindCourseDraftQuery__
 *
 * To run a query within a React component, call `useFindCourseDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCourseDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCourseDraftQuery({
 *   variables: {
 *      name: // value for 'name'
 *      country: // value for 'country'
 *      deepenFromSources: // value for 'deepenFromSources'
 *   },
 * });
 */
export function useFindCourseDraftQuery(baseOptions: Apollo.QueryHookOptions<FindCourseDraftQuery, FindCourseDraftQueryVariables> & ({ variables: FindCourseDraftQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCourseDraftQuery, FindCourseDraftQueryVariables>(FindCourseDraftDocument, options);
      }
export function useFindCourseDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCourseDraftQuery, FindCourseDraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCourseDraftQuery, FindCourseDraftQueryVariables>(FindCourseDraftDocument, options);
        }
// @ts-ignore
export function useFindCourseDraftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindCourseDraftQuery, FindCourseDraftQueryVariables>): Apollo.UseSuspenseQueryResult<FindCourseDraftQuery, FindCourseDraftQueryVariables>;
export function useFindCourseDraftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCourseDraftQuery, FindCourseDraftQueryVariables>): Apollo.UseSuspenseQueryResult<FindCourseDraftQuery | undefined, FindCourseDraftQueryVariables>;
export function useFindCourseDraftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCourseDraftQuery, FindCourseDraftQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindCourseDraftQuery, FindCourseDraftQueryVariables>(FindCourseDraftDocument, options);
        }
export type FindCourseDraftQueryHookResult = ReturnType<typeof useFindCourseDraftQuery>;
export type FindCourseDraftLazyQueryHookResult = ReturnType<typeof useFindCourseDraftLazyQuery>;
export type FindCourseDraftSuspenseQueryHookResult = ReturnType<typeof useFindCourseDraftSuspenseQuery>;
export type FindCourseDraftQueryResult = Apollo.QueryResult<FindCourseDraftQuery, FindCourseDraftQueryVariables>;
export const CourseCreateDocument = gql`
    mutation courseCreate($createCourseDto: CreateCourseDto!) {
  courseCreate(createCourseDto: $createCourseDto) {
    ...CourseFields
  }
}
    ${CourseFieldsFragmentDoc}`;
export type CourseCreateMutationFn = Apollo.MutationFunction<CourseCreateMutation, CourseCreateMutationVariables>;

/**
 * __useCourseCreateMutation__
 *
 * To run a mutation, you first call `useCourseCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseCreateMutation, { data, loading, error }] = useCourseCreateMutation({
 *   variables: {
 *      createCourseDto: // value for 'createCourseDto'
 *   },
 * });
 */
export function useCourseCreateMutation(baseOptions?: Apollo.MutationHookOptions<CourseCreateMutation, CourseCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseCreateMutation, CourseCreateMutationVariables>(CourseCreateDocument, options);
      }
export type CourseCreateMutationHookResult = ReturnType<typeof useCourseCreateMutation>;
export type CourseCreateMutationResult = Apollo.MutationResult<CourseCreateMutation>;
export const CourseUpdateDocument = gql`
    mutation courseUpdate($courseId: ID!, $updateCourseDto: UpdateCourseDto!) {
  courseUpdate(courseId: $courseId, updateCourseDto: $updateCourseDto) {
    ...CourseFields
  }
}
    ${CourseFieldsFragmentDoc}`;
export type CourseUpdateMutationFn = Apollo.MutationFunction<CourseUpdateMutation, CourseUpdateMutationVariables>;

/**
 * __useCourseUpdateMutation__
 *
 * To run a mutation, you first call `useCourseUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseUpdateMutation, { data, loading, error }] = useCourseUpdateMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      updateCourseDto: // value for 'updateCourseDto'
 *   },
 * });
 */
export function useCourseUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CourseUpdateMutation, CourseUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseUpdateMutation, CourseUpdateMutationVariables>(CourseUpdateDocument, options);
      }
export type CourseUpdateMutationHookResult = ReturnType<typeof useCourseUpdateMutation>;
export type CourseUpdateMutationResult = Apollo.MutationResult<CourseUpdateMutation>;
export const CourseStatusUpdateDocument = gql`
    mutation courseStatusUpdate($courseId: ID!, $updateCourseStatusDto: UpdateCourseStatusDto!) {
  courseStatusUpdate(
    courseId: $courseId
    updateCourseStatusDto: $updateCourseStatusDto
  ) {
    ...CourseFields
  }
}
    ${CourseFieldsFragmentDoc}`;
export type CourseStatusUpdateMutationFn = Apollo.MutationFunction<CourseStatusUpdateMutation, CourseStatusUpdateMutationVariables>;

/**
 * __useCourseStatusUpdateMutation__
 *
 * To run a mutation, you first call `useCourseStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseStatusUpdateMutation, { data, loading, error }] = useCourseStatusUpdateMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      updateCourseStatusDto: // value for 'updateCourseStatusDto'
 *   },
 * });
 */
export function useCourseStatusUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CourseStatusUpdateMutation, CourseStatusUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseStatusUpdateMutation, CourseStatusUpdateMutationVariables>(CourseStatusUpdateDocument, options);
      }
export type CourseStatusUpdateMutationHookResult = ReturnType<typeof useCourseStatusUpdateMutation>;
export type CourseStatusUpdateMutationResult = Apollo.MutationResult<CourseStatusUpdateMutation>;
export const CourseDeleteDocument = gql`
    mutation courseDelete($courseId: ID!) {
  courseDelete(courseId: $courseId) {
    id
    status
  }
}
    `;
export type CourseDeleteMutationFn = Apollo.MutationFunction<CourseDeleteMutation, CourseDeleteMutationVariables>;

/**
 * __useCourseDeleteMutation__
 *
 * To run a mutation, you first call `useCourseDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseDeleteMutation, { data, loading, error }] = useCourseDeleteMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CourseDeleteMutation, CourseDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseDeleteMutation, CourseDeleteMutationVariables>(CourseDeleteDocument, options);
      }
export type CourseDeleteMutationHookResult = ReturnType<typeof useCourseDeleteMutation>;
export type CourseDeleteMutationResult = Apollo.MutationResult<CourseDeleteMutation>;
export const CourseCreateFromDraftDocument = gql`
    mutation courseCreateFromDraft($createCourseFromDraftDto: CreateCourseFromDraftDto!) {
  courseCreateFromDraft(createCourseFromDraftDto: $createCourseFromDraftDto) {
    ...CourseFields
  }
}
    ${CourseFieldsFragmentDoc}`;
export type CourseCreateFromDraftMutationFn = Apollo.MutationFunction<CourseCreateFromDraftMutation, CourseCreateFromDraftMutationVariables>;

/**
 * __useCourseCreateFromDraftMutation__
 *
 * To run a mutation, you first call `useCourseCreateFromDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseCreateFromDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseCreateFromDraftMutation, { data, loading, error }] = useCourseCreateFromDraftMutation({
 *   variables: {
 *      createCourseFromDraftDto: // value for 'createCourseFromDraftDto'
 *   },
 * });
 */
export function useCourseCreateFromDraftMutation(baseOptions?: Apollo.MutationHookOptions<CourseCreateFromDraftMutation, CourseCreateFromDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseCreateFromDraftMutation, CourseCreateFromDraftMutationVariables>(CourseCreateFromDraftDocument, options);
      }
export type CourseCreateFromDraftMutationHookResult = ReturnType<typeof useCourseCreateFromDraftMutation>;
export type CourseCreateFromDraftMutationResult = Apollo.MutationResult<CourseCreateFromDraftMutation>;
export const CourseUpdateFromDraftDocument = gql`
    mutation courseUpdateFromDraft($courseId: ID!, $updateCourseFromDraftDto: UpdateCourseFromDraftDto!) {
  courseUpdateFromDraft(
    courseId: $courseId
    updateCourseFromDraftDto: $updateCourseFromDraftDto
  ) {
    ...CourseFields
  }
}
    ${CourseFieldsFragmentDoc}`;
export type CourseUpdateFromDraftMutationFn = Apollo.MutationFunction<CourseUpdateFromDraftMutation, CourseUpdateFromDraftMutationVariables>;

/**
 * __useCourseUpdateFromDraftMutation__
 *
 * To run a mutation, you first call `useCourseUpdateFromDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseUpdateFromDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseUpdateFromDraftMutation, { data, loading, error }] = useCourseUpdateFromDraftMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      updateCourseFromDraftDto: // value for 'updateCourseFromDraftDto'
 *   },
 * });
 */
export function useCourseUpdateFromDraftMutation(baseOptions?: Apollo.MutationHookOptions<CourseUpdateFromDraftMutation, CourseUpdateFromDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseUpdateFromDraftMutation, CourseUpdateFromDraftMutationVariables>(CourseUpdateFromDraftDocument, options);
      }
export type CourseUpdateFromDraftMutationHookResult = ReturnType<typeof useCourseUpdateFromDraftMutation>;
export type CourseUpdateFromDraftMutationResult = Apollo.MutationResult<CourseUpdateFromDraftMutation>;
export const CourseUpdateHolesDocument = gql`
    mutation courseUpdateHoles($courseId: ID!, $updateCourseHoleDtos: [UpdateCourseHoleDto!]!) {
  courseUpdateHoles(
    courseId: $courseId
    updateCourseHoleDtos: $updateCourseHoleDtos
  ) {
    ...CourseFields
  }
}
    ${CourseFieldsFragmentDoc}`;
export type CourseUpdateHolesMutationFn = Apollo.MutationFunction<CourseUpdateHolesMutation, CourseUpdateHolesMutationVariables>;

/**
 * __useCourseUpdateHolesMutation__
 *
 * To run a mutation, you first call `useCourseUpdateHolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseUpdateHolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseUpdateHolesMutation, { data, loading, error }] = useCourseUpdateHolesMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      updateCourseHoleDtos: // value for 'updateCourseHoleDtos'
 *   },
 * });
 */
export function useCourseUpdateHolesMutation(baseOptions?: Apollo.MutationHookOptions<CourseUpdateHolesMutation, CourseUpdateHolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseUpdateHolesMutation, CourseUpdateHolesMutationVariables>(CourseUpdateHolesDocument, options);
      }
export type CourseUpdateHolesMutationHookResult = ReturnType<typeof useCourseUpdateHolesMutation>;
export type CourseUpdateHolesMutationResult = Apollo.MutationResult<CourseUpdateHolesMutation>;
export const CourseHoleAddDocument = gql`
    mutation courseHoleAdd($courseId: ID!, $createCourseHoleDto: CreateCourseHoleDto!) {
  courseHoleAdd(courseId: $courseId, createCourseHoleDto: $createCourseHoleDto) {
    ...CourseFields
  }
}
    ${CourseFieldsFragmentDoc}`;
export type CourseHoleAddMutationFn = Apollo.MutationFunction<CourseHoleAddMutation, CourseHoleAddMutationVariables>;

/**
 * __useCourseHoleAddMutation__
 *
 * To run a mutation, you first call `useCourseHoleAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseHoleAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseHoleAddMutation, { data, loading, error }] = useCourseHoleAddMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      createCourseHoleDto: // value for 'createCourseHoleDto'
 *   },
 * });
 */
export function useCourseHoleAddMutation(baseOptions?: Apollo.MutationHookOptions<CourseHoleAddMutation, CourseHoleAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseHoleAddMutation, CourseHoleAddMutationVariables>(CourseHoleAddDocument, options);
      }
export type CourseHoleAddMutationHookResult = ReturnType<typeof useCourseHoleAddMutation>;
export type CourseHoleAddMutationResult = Apollo.MutationResult<CourseHoleAddMutation>;
export const CourseHoleDeleteDocument = gql`
    mutation courseHoleDelete($courseId: ID!, $holeId: ID!) {
  courseHoleDelete(courseId: $courseId, holeId: $holeId) {
    ...CourseFields
  }
}
    ${CourseFieldsFragmentDoc}`;
export type CourseHoleDeleteMutationFn = Apollo.MutationFunction<CourseHoleDeleteMutation, CourseHoleDeleteMutationVariables>;

/**
 * __useCourseHoleDeleteMutation__
 *
 * To run a mutation, you first call `useCourseHoleDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseHoleDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseHoleDeleteMutation, { data, loading, error }] = useCourseHoleDeleteMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      holeId: // value for 'holeId'
 *   },
 * });
 */
export function useCourseHoleDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CourseHoleDeleteMutation, CourseHoleDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseHoleDeleteMutation, CourseHoleDeleteMutationVariables>(CourseHoleDeleteDocument, options);
      }
export type CourseHoleDeleteMutationHookResult = ReturnType<typeof useCourseHoleDeleteMutation>;
export type CourseHoleDeleteMutationResult = Apollo.MutationResult<CourseHoleDeleteMutation>;
export const CourseTeeCreateDocument = gql`
    mutation courseTeeCreate($courseId: ID!, $createCourseTeeDto: CreateCourseTeeDto!) {
  courseTeeCreate(courseId: $courseId, createCourseTeeDto: $createCourseTeeDto) {
    ...CourseTeeFields
  }
}
    ${CourseTeeFieldsFragmentDoc}`;
export type CourseTeeCreateMutationFn = Apollo.MutationFunction<CourseTeeCreateMutation, CourseTeeCreateMutationVariables>;

/**
 * __useCourseTeeCreateMutation__
 *
 * To run a mutation, you first call `useCourseTeeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseTeeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseTeeCreateMutation, { data, loading, error }] = useCourseTeeCreateMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      createCourseTeeDto: // value for 'createCourseTeeDto'
 *   },
 * });
 */
export function useCourseTeeCreateMutation(baseOptions?: Apollo.MutationHookOptions<CourseTeeCreateMutation, CourseTeeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseTeeCreateMutation, CourseTeeCreateMutationVariables>(CourseTeeCreateDocument, options);
      }
export type CourseTeeCreateMutationHookResult = ReturnType<typeof useCourseTeeCreateMutation>;
export type CourseTeeCreateMutationResult = Apollo.MutationResult<CourseTeeCreateMutation>;
export const CourseTeeUpdateDocument = gql`
    mutation courseTeeUpdate($courseTeeId: ID!, $updateCourseTeeDto: UpdateCourseTeeDto!) {
  courseTeeUpdate(
    courseTeeId: $courseTeeId
    updateCourseTeeDto: $updateCourseTeeDto
  ) {
    ...CourseTeeFields
  }
}
    ${CourseTeeFieldsFragmentDoc}`;
export type CourseTeeUpdateMutationFn = Apollo.MutationFunction<CourseTeeUpdateMutation, CourseTeeUpdateMutationVariables>;

/**
 * __useCourseTeeUpdateMutation__
 *
 * To run a mutation, you first call `useCourseTeeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseTeeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseTeeUpdateMutation, { data, loading, error }] = useCourseTeeUpdateMutation({
 *   variables: {
 *      courseTeeId: // value for 'courseTeeId'
 *      updateCourseTeeDto: // value for 'updateCourseTeeDto'
 *   },
 * });
 */
export function useCourseTeeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CourseTeeUpdateMutation, CourseTeeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseTeeUpdateMutation, CourseTeeUpdateMutationVariables>(CourseTeeUpdateDocument, options);
      }
export type CourseTeeUpdateMutationHookResult = ReturnType<typeof useCourseTeeUpdateMutation>;
export type CourseTeeUpdateMutationResult = Apollo.MutationResult<CourseTeeUpdateMutation>;
export const CourseTeeDeleteDocument = gql`
    mutation courseTeeDelete($courseId: ID!, $courseTeeId: ID!) {
  courseTeeDelete(courseId: $courseId, courseTeeId: $courseTeeId) {
    ...CourseTeeFields
  }
}
    ${CourseTeeFieldsFragmentDoc}`;
export type CourseTeeDeleteMutationFn = Apollo.MutationFunction<CourseTeeDeleteMutation, CourseTeeDeleteMutationVariables>;

/**
 * __useCourseTeeDeleteMutation__
 *
 * To run a mutation, you first call `useCourseTeeDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseTeeDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseTeeDeleteMutation, { data, loading, error }] = useCourseTeeDeleteMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      courseTeeId: // value for 'courseTeeId'
 *   },
 * });
 */
export function useCourseTeeDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CourseTeeDeleteMutation, CourseTeeDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseTeeDeleteMutation, CourseTeeDeleteMutationVariables>(CourseTeeDeleteDocument, options);
      }
export type CourseTeeDeleteMutationHookResult = ReturnType<typeof useCourseTeeDeleteMutation>;
export type CourseTeeDeleteMutationResult = Apollo.MutationResult<CourseTeeDeleteMutation>;
export const CourseTeeSetDefaultDocument = gql`
    mutation courseTeeSetDefault($courseId: ID!, $courseTeeId: ID!) {
  courseTeeSetDefault(courseId: $courseId, courseTeeId: $courseTeeId) {
    ...CourseTeeFields
  }
}
    ${CourseTeeFieldsFragmentDoc}`;
export type CourseTeeSetDefaultMutationFn = Apollo.MutationFunction<CourseTeeSetDefaultMutation, CourseTeeSetDefaultMutationVariables>;

/**
 * __useCourseTeeSetDefaultMutation__
 *
 * To run a mutation, you first call `useCourseTeeSetDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseTeeSetDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseTeeSetDefaultMutation, { data, loading, error }] = useCourseTeeSetDefaultMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      courseTeeId: // value for 'courseTeeId'
 *   },
 * });
 */
export function useCourseTeeSetDefaultMutation(baseOptions?: Apollo.MutationHookOptions<CourseTeeSetDefaultMutation, CourseTeeSetDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseTeeSetDefaultMutation, CourseTeeSetDefaultMutationVariables>(CourseTeeSetDefaultDocument, options);
      }
export type CourseTeeSetDefaultMutationHookResult = ReturnType<typeof useCourseTeeSetDefaultMutation>;
export type CourseTeeSetDefaultMutationResult = Apollo.MutationResult<CourseTeeSetDefaultMutation>;
export const DevToolsEnabledDocument = gql`
    query devToolsEnabled {
  devToolsEnabled
}
    `;

/**
 * __useDevToolsEnabledQuery__
 *
 * To run a query within a React component, call `useDevToolsEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevToolsEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevToolsEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevToolsEnabledQuery(baseOptions?: Apollo.QueryHookOptions<DevToolsEnabledQuery, DevToolsEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevToolsEnabledQuery, DevToolsEnabledQueryVariables>(DevToolsEnabledDocument, options);
      }
export function useDevToolsEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevToolsEnabledQuery, DevToolsEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevToolsEnabledQuery, DevToolsEnabledQueryVariables>(DevToolsEnabledDocument, options);
        }
// @ts-ignore
export function useDevToolsEnabledSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevToolsEnabledQuery, DevToolsEnabledQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsEnabledQuery, DevToolsEnabledQueryVariables>;
export function useDevToolsEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsEnabledQuery, DevToolsEnabledQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsEnabledQuery | undefined, DevToolsEnabledQueryVariables>;
export function useDevToolsEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsEnabledQuery, DevToolsEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevToolsEnabledQuery, DevToolsEnabledQueryVariables>(DevToolsEnabledDocument, options);
        }
export type DevToolsEnabledQueryHookResult = ReturnType<typeof useDevToolsEnabledQuery>;
export type DevToolsEnabledLazyQueryHookResult = ReturnType<typeof useDevToolsEnabledLazyQuery>;
export type DevToolsEnabledSuspenseQueryHookResult = ReturnType<typeof useDevToolsEnabledSuspenseQuery>;
export type DevToolsEnabledQueryResult = Apollo.QueryResult<DevToolsEnabledQuery, DevToolsEnabledQueryVariables>;
export const DevReseedDocument = gql`
    mutation devReseed($scope: DevReseedScope) {
  devReseed(scope: $scope) {
    durationMs
  }
}
    `;
export type DevReseedMutationFn = Apollo.MutationFunction<DevReseedMutation, DevReseedMutationVariables>;

/**
 * __useDevReseedMutation__
 *
 * To run a mutation, you first call `useDevReseedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevReseedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devReseedMutation, { data, loading, error }] = useDevReseedMutation({
 *   variables: {
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useDevReseedMutation(baseOptions?: Apollo.MutationHookOptions<DevReseedMutation, DevReseedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevReseedMutation, DevReseedMutationVariables>(DevReseedDocument, options);
      }
export type DevReseedMutationHookResult = ReturnType<typeof useDevReseedMutation>;
export type DevReseedMutationResult = Apollo.MutationResult<DevReseedMutation>;
export const PolfEventFlightsDocument = gql`
    query polfEventFlights($polfEventId: ID!) {
  polfEventFlights(polfEventId: $polfEventId) {
    ...FlightListItem
  }
}
    ${FlightListItemFragmentDoc}`;

/**
 * __usePolfEventFlightsQuery__
 *
 * To run a query within a React component, call `usePolfEventFlightsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventFlightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventFlightsQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventFlightsQuery(baseOptions: Apollo.QueryHookOptions<PolfEventFlightsQuery, PolfEventFlightsQueryVariables> & ({ variables: PolfEventFlightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventFlightsQuery, PolfEventFlightsQueryVariables>(PolfEventFlightsDocument, options);
      }
export function usePolfEventFlightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventFlightsQuery, PolfEventFlightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventFlightsQuery, PolfEventFlightsQueryVariables>(PolfEventFlightsDocument, options);
        }
// @ts-ignore
export function usePolfEventFlightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventFlightsQuery, PolfEventFlightsQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventFlightsQuery, PolfEventFlightsQueryVariables>;
export function usePolfEventFlightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventFlightsQuery, PolfEventFlightsQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventFlightsQuery | undefined, PolfEventFlightsQueryVariables>;
export function usePolfEventFlightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventFlightsQuery, PolfEventFlightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventFlightsQuery, PolfEventFlightsQueryVariables>(PolfEventFlightsDocument, options);
        }
export type PolfEventFlightsQueryHookResult = ReturnType<typeof usePolfEventFlightsQuery>;
export type PolfEventFlightsLazyQueryHookResult = ReturnType<typeof usePolfEventFlightsLazyQuery>;
export type PolfEventFlightsSuspenseQueryHookResult = ReturnType<typeof usePolfEventFlightsSuspenseQuery>;
export type PolfEventFlightsQueryResult = Apollo.QueryResult<PolfEventFlightsQuery, PolfEventFlightsQueryVariables>;
export const PolfEventFlightAddDocument = gql`
    mutation polfEventFlightAdd($polfEventId: ID!) {
  polfEventFlightAdd(polfEventId: $polfEventId) {
    ...FlightListItem
  }
}
    ${FlightListItemFragmentDoc}`;
export type PolfEventFlightAddMutationFn = Apollo.MutationFunction<PolfEventFlightAddMutation, PolfEventFlightAddMutationVariables>;

/**
 * __usePolfEventFlightAddMutation__
 *
 * To run a mutation, you first call `usePolfEventFlightAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventFlightAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventFlightAddMutation, { data, loading, error }] = usePolfEventFlightAddMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventFlightAddMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventFlightAddMutation, PolfEventFlightAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventFlightAddMutation, PolfEventFlightAddMutationVariables>(PolfEventFlightAddDocument, options);
      }
export type PolfEventFlightAddMutationHookResult = ReturnType<typeof usePolfEventFlightAddMutation>;
export type PolfEventFlightAddMutationResult = Apollo.MutationResult<PolfEventFlightAddMutation>;
export const PolfEventFlightUpdateDocument = gql`
    mutation polfEventFlightUpdate($polfEventFlightId: ID!, $updatePolfEventFlightDto: UpdatePolfEventFlightDto!) {
  polfEventFlightUpdate(
    polfEventFlightId: $polfEventFlightId
    updatePolfEventFlightDto: $updatePolfEventFlightDto
  ) {
    ...FlightListItem
  }
}
    ${FlightListItemFragmentDoc}`;
export type PolfEventFlightUpdateMutationFn = Apollo.MutationFunction<PolfEventFlightUpdateMutation, PolfEventFlightUpdateMutationVariables>;

/**
 * __usePolfEventFlightUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventFlightUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventFlightUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventFlightUpdateMutation, { data, loading, error }] = usePolfEventFlightUpdateMutation({
 *   variables: {
 *      polfEventFlightId: // value for 'polfEventFlightId'
 *      updatePolfEventFlightDto: // value for 'updatePolfEventFlightDto'
 *   },
 * });
 */
export function usePolfEventFlightUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventFlightUpdateMutation, PolfEventFlightUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventFlightUpdateMutation, PolfEventFlightUpdateMutationVariables>(PolfEventFlightUpdateDocument, options);
      }
export type PolfEventFlightUpdateMutationHookResult = ReturnType<typeof usePolfEventFlightUpdateMutation>;
export type PolfEventFlightUpdateMutationResult = Apollo.MutationResult<PolfEventFlightUpdateMutation>;
export const PolfEventFlightRemoveDocument = gql`
    mutation polfEventFlightRemove($polfEventId: ID!, $polfEventFlightId: ID!) {
  polfEventFlightRemove(
    polfEventId: $polfEventId
    polfEventFlightId: $polfEventFlightId
  ) {
    id
  }
}
    `;
export type PolfEventFlightRemoveMutationFn = Apollo.MutationFunction<PolfEventFlightRemoveMutation, PolfEventFlightRemoveMutationVariables>;

/**
 * __usePolfEventFlightRemoveMutation__
 *
 * To run a mutation, you first call `usePolfEventFlightRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventFlightRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventFlightRemoveMutation, { data, loading, error }] = usePolfEventFlightRemoveMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      polfEventFlightId: // value for 'polfEventFlightId'
 *   },
 * });
 */
export function usePolfEventFlightRemoveMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventFlightRemoveMutation, PolfEventFlightRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventFlightRemoveMutation, PolfEventFlightRemoveMutationVariables>(PolfEventFlightRemoveDocument, options);
      }
export type PolfEventFlightRemoveMutationHookResult = ReturnType<typeof usePolfEventFlightRemoveMutation>;
export type PolfEventFlightRemoveMutationResult = Apollo.MutationResult<PolfEventFlightRemoveMutation>;
export const PolfEventFlightAddPlayerDocument = gql`
    mutation polfEventFlightAddPlayer($polfEventFlightId: ID!, $polfEventPlayerId: ID!) {
  polfEventFlightAddPlayer(
    polfEventFlightId: $polfEventFlightId
    polfEventPlayerId: $polfEventPlayerId
  ) {
    ...FlightListItem
  }
}
    ${FlightListItemFragmentDoc}`;
export type PolfEventFlightAddPlayerMutationFn = Apollo.MutationFunction<PolfEventFlightAddPlayerMutation, PolfEventFlightAddPlayerMutationVariables>;

/**
 * __usePolfEventFlightAddPlayerMutation__
 *
 * To run a mutation, you first call `usePolfEventFlightAddPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventFlightAddPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventFlightAddPlayerMutation, { data, loading, error }] = usePolfEventFlightAddPlayerMutation({
 *   variables: {
 *      polfEventFlightId: // value for 'polfEventFlightId'
 *      polfEventPlayerId: // value for 'polfEventPlayerId'
 *   },
 * });
 */
export function usePolfEventFlightAddPlayerMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventFlightAddPlayerMutation, PolfEventFlightAddPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventFlightAddPlayerMutation, PolfEventFlightAddPlayerMutationVariables>(PolfEventFlightAddPlayerDocument, options);
      }
export type PolfEventFlightAddPlayerMutationHookResult = ReturnType<typeof usePolfEventFlightAddPlayerMutation>;
export type PolfEventFlightAddPlayerMutationResult = Apollo.MutationResult<PolfEventFlightAddPlayerMutation>;
export const PolfEventFlightRemovePlayerDocument = gql`
    mutation polfEventFlightRemovePlayer($polfEventPlayerId: ID!, $flightId: ID!) {
  polfEventFlightRemovePlayer(
    polfEventPlayerId: $polfEventPlayerId
    flightId: $flightId
  ) {
    ...FlightListItem
  }
}
    ${FlightListItemFragmentDoc}`;
export type PolfEventFlightRemovePlayerMutationFn = Apollo.MutationFunction<PolfEventFlightRemovePlayerMutation, PolfEventFlightRemovePlayerMutationVariables>;

/**
 * __usePolfEventFlightRemovePlayerMutation__
 *
 * To run a mutation, you first call `usePolfEventFlightRemovePlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventFlightRemovePlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventFlightRemovePlayerMutation, { data, loading, error }] = usePolfEventFlightRemovePlayerMutation({
 *   variables: {
 *      polfEventPlayerId: // value for 'polfEventPlayerId'
 *      flightId: // value for 'flightId'
 *   },
 * });
 */
export function usePolfEventFlightRemovePlayerMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventFlightRemovePlayerMutation, PolfEventFlightRemovePlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventFlightRemovePlayerMutation, PolfEventFlightRemovePlayerMutationVariables>(PolfEventFlightRemovePlayerDocument, options);
      }
export type PolfEventFlightRemovePlayerMutationHookResult = ReturnType<typeof usePolfEventFlightRemovePlayerMutation>;
export type PolfEventFlightRemovePlayerMutationResult = Apollo.MutationResult<PolfEventFlightRemovePlayerMutation>;
export const PolfEventFlightAddTeamDocument = gql`
    mutation polfEventFlightAddTeam($polfEventFlightId: ID!, $polfEventTeamId: ID!) {
  polfEventFlightAddTeam(
    polfEventFlightId: $polfEventFlightId
    polfEventTeamId: $polfEventTeamId
  ) {
    ...FlightListItem
  }
}
    ${FlightListItemFragmentDoc}`;
export type PolfEventFlightAddTeamMutationFn = Apollo.MutationFunction<PolfEventFlightAddTeamMutation, PolfEventFlightAddTeamMutationVariables>;

/**
 * __usePolfEventFlightAddTeamMutation__
 *
 * To run a mutation, you first call `usePolfEventFlightAddTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventFlightAddTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventFlightAddTeamMutation, { data, loading, error }] = usePolfEventFlightAddTeamMutation({
 *   variables: {
 *      polfEventFlightId: // value for 'polfEventFlightId'
 *      polfEventTeamId: // value for 'polfEventTeamId'
 *   },
 * });
 */
export function usePolfEventFlightAddTeamMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventFlightAddTeamMutation, PolfEventFlightAddTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventFlightAddTeamMutation, PolfEventFlightAddTeamMutationVariables>(PolfEventFlightAddTeamDocument, options);
      }
export type PolfEventFlightAddTeamMutationHookResult = ReturnType<typeof usePolfEventFlightAddTeamMutation>;
export type PolfEventFlightAddTeamMutationResult = Apollo.MutationResult<PolfEventFlightAddTeamMutation>;
export const PolfEventFlightRemoveTeamDocument = gql`
    mutation polfEventFlightRemoveTeam($polfEventTeamId: ID!, $flightId: ID!) {
  polfEventFlightRemoveTeam(
    polfEventTeamId: $polfEventTeamId
    flightId: $flightId
  ) {
    ...FlightListItem
  }
}
    ${FlightListItemFragmentDoc}`;
export type PolfEventFlightRemoveTeamMutationFn = Apollo.MutationFunction<PolfEventFlightRemoveTeamMutation, PolfEventFlightRemoveTeamMutationVariables>;

/**
 * __usePolfEventFlightRemoveTeamMutation__
 *
 * To run a mutation, you first call `usePolfEventFlightRemoveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventFlightRemoveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventFlightRemoveTeamMutation, { data, loading, error }] = usePolfEventFlightRemoveTeamMutation({
 *   variables: {
 *      polfEventTeamId: // value for 'polfEventTeamId'
 *      flightId: // value for 'flightId'
 *   },
 * });
 */
export function usePolfEventFlightRemoveTeamMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventFlightRemoveTeamMutation, PolfEventFlightRemoveTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventFlightRemoveTeamMutation, PolfEventFlightRemoveTeamMutationVariables>(PolfEventFlightRemoveTeamDocument, options);
      }
export type PolfEventFlightRemoveTeamMutationHookResult = ReturnType<typeof usePolfEventFlightRemoveTeamMutation>;
export type PolfEventFlightRemoveTeamMutationResult = Apollo.MutationResult<PolfEventFlightRemoveTeamMutation>;
export const PolfEventPlayerDistributeInFlightsDocument = gql`
    mutation polfEventPlayerDistributeInFlights($polfEventId: ID!, $redistributeAll: Boolean) {
  polfEventPlayerDistributeInFlights(
    polfEventId: $polfEventId
    redistributeAll: $redistributeAll
  ) {
    ...FlightListItem
  }
}
    ${FlightListItemFragmentDoc}`;
export type PolfEventPlayerDistributeInFlightsMutationFn = Apollo.MutationFunction<PolfEventPlayerDistributeInFlightsMutation, PolfEventPlayerDistributeInFlightsMutationVariables>;

/**
 * __usePolfEventPlayerDistributeInFlightsMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerDistributeInFlightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerDistributeInFlightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerDistributeInFlightsMutation, { data, loading, error }] = usePolfEventPlayerDistributeInFlightsMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      redistributeAll: // value for 'redistributeAll'
 *   },
 * });
 */
export function usePolfEventPlayerDistributeInFlightsMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerDistributeInFlightsMutation, PolfEventPlayerDistributeInFlightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerDistributeInFlightsMutation, PolfEventPlayerDistributeInFlightsMutationVariables>(PolfEventPlayerDistributeInFlightsDocument, options);
      }
export type PolfEventPlayerDistributeInFlightsMutationHookResult = ReturnType<typeof usePolfEventPlayerDistributeInFlightsMutation>;
export type PolfEventPlayerDistributeInFlightsMutationResult = Apollo.MutationResult<PolfEventPlayerDistributeInFlightsMutation>;
export const PolfEventTeamDistributeInFlightsDocument = gql`
    mutation polfEventTeamDistributeInFlights($polfEventId: ID!, $redistributeAll: Boolean) {
  polfEventTeamDistributeInFlights(
    polfEventId: $polfEventId
    redistributeAll: $redistributeAll
  ) {
    ...FlightListItem
  }
}
    ${FlightListItemFragmentDoc}`;
export type PolfEventTeamDistributeInFlightsMutationFn = Apollo.MutationFunction<PolfEventTeamDistributeInFlightsMutation, PolfEventTeamDistributeInFlightsMutationVariables>;

/**
 * __usePolfEventTeamDistributeInFlightsMutation__
 *
 * To run a mutation, you first call `usePolfEventTeamDistributeInFlightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventTeamDistributeInFlightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventTeamDistributeInFlightsMutation, { data, loading, error }] = usePolfEventTeamDistributeInFlightsMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      redistributeAll: // value for 'redistributeAll'
 *   },
 * });
 */
export function usePolfEventTeamDistributeInFlightsMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventTeamDistributeInFlightsMutation, PolfEventTeamDistributeInFlightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventTeamDistributeInFlightsMutation, PolfEventTeamDistributeInFlightsMutationVariables>(PolfEventTeamDistributeInFlightsDocument, options);
      }
export type PolfEventTeamDistributeInFlightsMutationHookResult = ReturnType<typeof usePolfEventTeamDistributeInFlightsMutation>;
export type PolfEventTeamDistributeInFlightsMutationResult = Apollo.MutationResult<PolfEventTeamDistributeInFlightsMutation>;
export const PolfEventHoleCompetitionsDocument = gql`
    query polfEventHoleCompetitions($polfEventId: ID!, $polfEventHoleCompetitionType: [PolfEventHoleCompetitionTypeEnum!]!) {
  polfEventHoleCompetitions(
    polfEventId: $polfEventId
    polfEventHoleCompetitionType: $polfEventHoleCompetitionType
  ) {
    ...HoleCompetitionItem
  }
}
    ${HoleCompetitionItemFragmentDoc}`;

/**
 * __usePolfEventHoleCompetitionsQuery__
 *
 * To run a query within a React component, call `usePolfEventHoleCompetitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventHoleCompetitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventHoleCompetitionsQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      polfEventHoleCompetitionType: // value for 'polfEventHoleCompetitionType'
 *   },
 * });
 */
export function usePolfEventHoleCompetitionsQuery(baseOptions: Apollo.QueryHookOptions<PolfEventHoleCompetitionsQuery, PolfEventHoleCompetitionsQueryVariables> & ({ variables: PolfEventHoleCompetitionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventHoleCompetitionsQuery, PolfEventHoleCompetitionsQueryVariables>(PolfEventHoleCompetitionsDocument, options);
      }
export function usePolfEventHoleCompetitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventHoleCompetitionsQuery, PolfEventHoleCompetitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventHoleCompetitionsQuery, PolfEventHoleCompetitionsQueryVariables>(PolfEventHoleCompetitionsDocument, options);
        }
// @ts-ignore
export function usePolfEventHoleCompetitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventHoleCompetitionsQuery, PolfEventHoleCompetitionsQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventHoleCompetitionsQuery, PolfEventHoleCompetitionsQueryVariables>;
export function usePolfEventHoleCompetitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventHoleCompetitionsQuery, PolfEventHoleCompetitionsQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventHoleCompetitionsQuery | undefined, PolfEventHoleCompetitionsQueryVariables>;
export function usePolfEventHoleCompetitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventHoleCompetitionsQuery, PolfEventHoleCompetitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventHoleCompetitionsQuery, PolfEventHoleCompetitionsQueryVariables>(PolfEventHoleCompetitionsDocument, options);
        }
export type PolfEventHoleCompetitionsQueryHookResult = ReturnType<typeof usePolfEventHoleCompetitionsQuery>;
export type PolfEventHoleCompetitionsLazyQueryHookResult = ReturnType<typeof usePolfEventHoleCompetitionsLazyQuery>;
export type PolfEventHoleCompetitionsSuspenseQueryHookResult = ReturnType<typeof usePolfEventHoleCompetitionsSuspenseQuery>;
export type PolfEventHoleCompetitionsQueryResult = Apollo.QueryResult<PolfEventHoleCompetitionsQuery, PolfEventHoleCompetitionsQueryVariables>;
export const PolfEventHoleCompetitionsWithEntriesDocument = gql`
    query polfEventHoleCompetitionsWithEntries($polfEventId: ID!, $polfEventHoleCompetitionType: [PolfEventHoleCompetitionTypeEnum!]!) {
  polfEventHoleCompetitions(
    polfEventId: $polfEventId
    polfEventHoleCompetitionType: $polfEventHoleCompetitionType
  ) {
    ...HoleCompetitionWithEntries
  }
}
    ${HoleCompetitionWithEntriesFragmentDoc}`;

/**
 * __usePolfEventHoleCompetitionsWithEntriesQuery__
 *
 * To run a query within a React component, call `usePolfEventHoleCompetitionsWithEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventHoleCompetitionsWithEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventHoleCompetitionsWithEntriesQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      polfEventHoleCompetitionType: // value for 'polfEventHoleCompetitionType'
 *   },
 * });
 */
export function usePolfEventHoleCompetitionsWithEntriesQuery(baseOptions: Apollo.QueryHookOptions<PolfEventHoleCompetitionsWithEntriesQuery, PolfEventHoleCompetitionsWithEntriesQueryVariables> & ({ variables: PolfEventHoleCompetitionsWithEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventHoleCompetitionsWithEntriesQuery, PolfEventHoleCompetitionsWithEntriesQueryVariables>(PolfEventHoleCompetitionsWithEntriesDocument, options);
      }
export function usePolfEventHoleCompetitionsWithEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventHoleCompetitionsWithEntriesQuery, PolfEventHoleCompetitionsWithEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventHoleCompetitionsWithEntriesQuery, PolfEventHoleCompetitionsWithEntriesQueryVariables>(PolfEventHoleCompetitionsWithEntriesDocument, options);
        }
// @ts-ignore
export function usePolfEventHoleCompetitionsWithEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventHoleCompetitionsWithEntriesQuery, PolfEventHoleCompetitionsWithEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventHoleCompetitionsWithEntriesQuery, PolfEventHoleCompetitionsWithEntriesQueryVariables>;
export function usePolfEventHoleCompetitionsWithEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventHoleCompetitionsWithEntriesQuery, PolfEventHoleCompetitionsWithEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventHoleCompetitionsWithEntriesQuery | undefined, PolfEventHoleCompetitionsWithEntriesQueryVariables>;
export function usePolfEventHoleCompetitionsWithEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventHoleCompetitionsWithEntriesQuery, PolfEventHoleCompetitionsWithEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventHoleCompetitionsWithEntriesQuery, PolfEventHoleCompetitionsWithEntriesQueryVariables>(PolfEventHoleCompetitionsWithEntriesDocument, options);
        }
export type PolfEventHoleCompetitionsWithEntriesQueryHookResult = ReturnType<typeof usePolfEventHoleCompetitionsWithEntriesQuery>;
export type PolfEventHoleCompetitionsWithEntriesLazyQueryHookResult = ReturnType<typeof usePolfEventHoleCompetitionsWithEntriesLazyQuery>;
export type PolfEventHoleCompetitionsWithEntriesSuspenseQueryHookResult = ReturnType<typeof usePolfEventHoleCompetitionsWithEntriesSuspenseQuery>;
export type PolfEventHoleCompetitionsWithEntriesQueryResult = Apollo.QueryResult<PolfEventHoleCompetitionsWithEntriesQuery, PolfEventHoleCompetitionsWithEntriesQueryVariables>;
export const PolfEventHoleCompetitionEntryUpdateDocument = gql`
    mutation polfEventHoleCompetitionEntryUpdate($polfEventHoleCompetitionEntryId: ID!, $updatePolfEventHoleCompetitionEntryDto: UpdatePolfEventHoleCompetitionEntryDto!) {
  polfEventHoleCompetitionEntryUpdate(
    polfEventHoleCompetitionEntryId: $polfEventHoleCompetitionEntryId
    updatePolfEventHoleCompetitionEntryDto: $updatePolfEventHoleCompetitionEntryDto
  ) {
    ...HoleCompetitionEntry
  }
}
    ${HoleCompetitionEntryFragmentDoc}`;
export type PolfEventHoleCompetitionEntryUpdateMutationFn = Apollo.MutationFunction<PolfEventHoleCompetitionEntryUpdateMutation, PolfEventHoleCompetitionEntryUpdateMutationVariables>;

/**
 * __usePolfEventHoleCompetitionEntryUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventHoleCompetitionEntryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventHoleCompetitionEntryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventHoleCompetitionEntryUpdateMutation, { data, loading, error }] = usePolfEventHoleCompetitionEntryUpdateMutation({
 *   variables: {
 *      polfEventHoleCompetitionEntryId: // value for 'polfEventHoleCompetitionEntryId'
 *      updatePolfEventHoleCompetitionEntryDto: // value for 'updatePolfEventHoleCompetitionEntryDto'
 *   },
 * });
 */
export function usePolfEventHoleCompetitionEntryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventHoleCompetitionEntryUpdateMutation, PolfEventHoleCompetitionEntryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventHoleCompetitionEntryUpdateMutation, PolfEventHoleCompetitionEntryUpdateMutationVariables>(PolfEventHoleCompetitionEntryUpdateDocument, options);
      }
export type PolfEventHoleCompetitionEntryUpdateMutationHookResult = ReturnType<typeof usePolfEventHoleCompetitionEntryUpdateMutation>;
export type PolfEventHoleCompetitionEntryUpdateMutationResult = Apollo.MutationResult<PolfEventHoleCompetitionEntryUpdateMutation>;
export const PolfEventHoleCompetitionEntryRemoveDocument = gql`
    mutation polfEventHoleCompetitionEntryRemove($polfEventHoleCompetitionEntryId: ID!) {
  polfEventHoleCompetitionEntryRemove(
    polfEventHoleCompetitionEntryId: $polfEventHoleCompetitionEntryId
  ) {
    id
  }
}
    `;
export type PolfEventHoleCompetitionEntryRemoveMutationFn = Apollo.MutationFunction<PolfEventHoleCompetitionEntryRemoveMutation, PolfEventHoleCompetitionEntryRemoveMutationVariables>;

/**
 * __usePolfEventHoleCompetitionEntryRemoveMutation__
 *
 * To run a mutation, you first call `usePolfEventHoleCompetitionEntryRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventHoleCompetitionEntryRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventHoleCompetitionEntryRemoveMutation, { data, loading, error }] = usePolfEventHoleCompetitionEntryRemoveMutation({
 *   variables: {
 *      polfEventHoleCompetitionEntryId: // value for 'polfEventHoleCompetitionEntryId'
 *   },
 * });
 */
export function usePolfEventHoleCompetitionEntryRemoveMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventHoleCompetitionEntryRemoveMutation, PolfEventHoleCompetitionEntryRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventHoleCompetitionEntryRemoveMutation, PolfEventHoleCompetitionEntryRemoveMutationVariables>(PolfEventHoleCompetitionEntryRemoveDocument, options);
      }
export type PolfEventHoleCompetitionEntryRemoveMutationHookResult = ReturnType<typeof usePolfEventHoleCompetitionEntryRemoveMutation>;
export type PolfEventHoleCompetitionEntryRemoveMutationResult = Apollo.MutationResult<PolfEventHoleCompetitionEntryRemoveMutation>;
export const PolfEventHoleCompetitionCreateDocument = gql`
    mutation polfEventHoleCompetitionCreate($polfEventId: ID!, $createPolfEventHoleCompetitionDto: CreatePolfEventHoleCompetitionDto!) {
  polfEventHoleCompetitionCreate(
    polfEventId: $polfEventId
    createPolfEventHoleCompetitionDto: $createPolfEventHoleCompetitionDto
  ) {
    ...HoleCompetitionItem
  }
}
    ${HoleCompetitionItemFragmentDoc}`;
export type PolfEventHoleCompetitionCreateMutationFn = Apollo.MutationFunction<PolfEventHoleCompetitionCreateMutation, PolfEventHoleCompetitionCreateMutationVariables>;

/**
 * __usePolfEventHoleCompetitionCreateMutation__
 *
 * To run a mutation, you first call `usePolfEventHoleCompetitionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventHoleCompetitionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventHoleCompetitionCreateMutation, { data, loading, error }] = usePolfEventHoleCompetitionCreateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      createPolfEventHoleCompetitionDto: // value for 'createPolfEventHoleCompetitionDto'
 *   },
 * });
 */
export function usePolfEventHoleCompetitionCreateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventHoleCompetitionCreateMutation, PolfEventHoleCompetitionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventHoleCompetitionCreateMutation, PolfEventHoleCompetitionCreateMutationVariables>(PolfEventHoleCompetitionCreateDocument, options);
      }
export type PolfEventHoleCompetitionCreateMutationHookResult = ReturnType<typeof usePolfEventHoleCompetitionCreateMutation>;
export type PolfEventHoleCompetitionCreateMutationResult = Apollo.MutationResult<PolfEventHoleCompetitionCreateMutation>;
export const PolfEventHoleCompetitionUpdateDocument = gql`
    mutation polfEventHoleCompetitionUpdate($polfEventHoleCompetitionId: ID!, $updatePolfEventHoleCompetitionDto: UpdatePolfEventHoleCompetitionDto!) {
  polfEventHoleCompetitionUpdate(
    polfEventHoleCompetitionId: $polfEventHoleCompetitionId
    updatePolfEventHoleCompetitionDto: $updatePolfEventHoleCompetitionDto
  ) {
    ...HoleCompetitionItem
  }
}
    ${HoleCompetitionItemFragmentDoc}`;
export type PolfEventHoleCompetitionUpdateMutationFn = Apollo.MutationFunction<PolfEventHoleCompetitionUpdateMutation, PolfEventHoleCompetitionUpdateMutationVariables>;

/**
 * __usePolfEventHoleCompetitionUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventHoleCompetitionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventHoleCompetitionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventHoleCompetitionUpdateMutation, { data, loading, error }] = usePolfEventHoleCompetitionUpdateMutation({
 *   variables: {
 *      polfEventHoleCompetitionId: // value for 'polfEventHoleCompetitionId'
 *      updatePolfEventHoleCompetitionDto: // value for 'updatePolfEventHoleCompetitionDto'
 *   },
 * });
 */
export function usePolfEventHoleCompetitionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventHoleCompetitionUpdateMutation, PolfEventHoleCompetitionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventHoleCompetitionUpdateMutation, PolfEventHoleCompetitionUpdateMutationVariables>(PolfEventHoleCompetitionUpdateDocument, options);
      }
export type PolfEventHoleCompetitionUpdateMutationHookResult = ReturnType<typeof usePolfEventHoleCompetitionUpdateMutation>;
export type PolfEventHoleCompetitionUpdateMutationResult = Apollo.MutationResult<PolfEventHoleCompetitionUpdateMutation>;
export const PolfEventHoleCompetitionRemoveDocument = gql`
    mutation polfEventHoleCompetitionRemove($polfEventHoleCompetitionId: ID!) {
  polfEventHoleCompetitionRemove(
    polfEventHoleCompetitionId: $polfEventHoleCompetitionId
  ) {
    id
  }
}
    `;
export type PolfEventHoleCompetitionRemoveMutationFn = Apollo.MutationFunction<PolfEventHoleCompetitionRemoveMutation, PolfEventHoleCompetitionRemoveMutationVariables>;

/**
 * __usePolfEventHoleCompetitionRemoveMutation__
 *
 * To run a mutation, you first call `usePolfEventHoleCompetitionRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventHoleCompetitionRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventHoleCompetitionRemoveMutation, { data, loading, error }] = usePolfEventHoleCompetitionRemoveMutation({
 *   variables: {
 *      polfEventHoleCompetitionId: // value for 'polfEventHoleCompetitionId'
 *   },
 * });
 */
export function usePolfEventHoleCompetitionRemoveMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventHoleCompetitionRemoveMutation, PolfEventHoleCompetitionRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventHoleCompetitionRemoveMutation, PolfEventHoleCompetitionRemoveMutationVariables>(PolfEventHoleCompetitionRemoveDocument, options);
      }
export type PolfEventHoleCompetitionRemoveMutationHookResult = ReturnType<typeof usePolfEventHoleCompetitionRemoveMutation>;
export type PolfEventHoleCompetitionRemoveMutationResult = Apollo.MutationResult<PolfEventHoleCompetitionRemoveMutation>;
export const PolfEventHoleCompetitionOpponentAddDocument = gql`
    mutation polfEventHoleCompetitionOpponentAdd($polfEventHoleCompetitionId: ID!, $createPolfEventHoleCompetitionOpponentDto: CreatePolfEventHoleCompetitionOpponentDto!) {
  polfEventHoleCompetitionOpponentAdd(
    polfEventHoleCompetitionId: $polfEventHoleCompetitionId
    createPolfEventHoleCompetitionOpponentDto: $createPolfEventHoleCompetitionOpponentDto
  ) {
    ...HoleCompetitionItem
  }
}
    ${HoleCompetitionItemFragmentDoc}`;
export type PolfEventHoleCompetitionOpponentAddMutationFn = Apollo.MutationFunction<PolfEventHoleCompetitionOpponentAddMutation, PolfEventHoleCompetitionOpponentAddMutationVariables>;

/**
 * __usePolfEventHoleCompetitionOpponentAddMutation__
 *
 * To run a mutation, you first call `usePolfEventHoleCompetitionOpponentAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventHoleCompetitionOpponentAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventHoleCompetitionOpponentAddMutation, { data, loading, error }] = usePolfEventHoleCompetitionOpponentAddMutation({
 *   variables: {
 *      polfEventHoleCompetitionId: // value for 'polfEventHoleCompetitionId'
 *      createPolfEventHoleCompetitionOpponentDto: // value for 'createPolfEventHoleCompetitionOpponentDto'
 *   },
 * });
 */
export function usePolfEventHoleCompetitionOpponentAddMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventHoleCompetitionOpponentAddMutation, PolfEventHoleCompetitionOpponentAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventHoleCompetitionOpponentAddMutation, PolfEventHoleCompetitionOpponentAddMutationVariables>(PolfEventHoleCompetitionOpponentAddDocument, options);
      }
export type PolfEventHoleCompetitionOpponentAddMutationHookResult = ReturnType<typeof usePolfEventHoleCompetitionOpponentAddMutation>;
export type PolfEventHoleCompetitionOpponentAddMutationResult = Apollo.MutationResult<PolfEventHoleCompetitionOpponentAddMutation>;
export const PolfEventHoleCompetitionOpponentUpdateDocument = gql`
    mutation polfEventHoleCompetitionOpponentUpdate($polfEventHoleCompetitionOpponentId: ID!, $updatePolfEventHoleCompetitionOpponentDto: UpdatePolfEventHoleCompetitionOpponentDto!) {
  polfEventHoleCompetitionOpponentUpdate(
    polfEventHoleCompetitionOpponentId: $polfEventHoleCompetitionOpponentId
    updatePolfEventHoleCompetitionOpponentDto: $updatePolfEventHoleCompetitionOpponentDto
  ) {
    ...HoleCompetitionItem
  }
}
    ${HoleCompetitionItemFragmentDoc}`;
export type PolfEventHoleCompetitionOpponentUpdateMutationFn = Apollo.MutationFunction<PolfEventHoleCompetitionOpponentUpdateMutation, PolfEventHoleCompetitionOpponentUpdateMutationVariables>;

/**
 * __usePolfEventHoleCompetitionOpponentUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventHoleCompetitionOpponentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventHoleCompetitionOpponentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventHoleCompetitionOpponentUpdateMutation, { data, loading, error }] = usePolfEventHoleCompetitionOpponentUpdateMutation({
 *   variables: {
 *      polfEventHoleCompetitionOpponentId: // value for 'polfEventHoleCompetitionOpponentId'
 *      updatePolfEventHoleCompetitionOpponentDto: // value for 'updatePolfEventHoleCompetitionOpponentDto'
 *   },
 * });
 */
export function usePolfEventHoleCompetitionOpponentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventHoleCompetitionOpponentUpdateMutation, PolfEventHoleCompetitionOpponentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventHoleCompetitionOpponentUpdateMutation, PolfEventHoleCompetitionOpponentUpdateMutationVariables>(PolfEventHoleCompetitionOpponentUpdateDocument, options);
      }
export type PolfEventHoleCompetitionOpponentUpdateMutationHookResult = ReturnType<typeof usePolfEventHoleCompetitionOpponentUpdateMutation>;
export type PolfEventHoleCompetitionOpponentUpdateMutationResult = Apollo.MutationResult<PolfEventHoleCompetitionOpponentUpdateMutation>;
export const PolfEventLeaderboardDocument = gql`
    query polfEventLeaderboard($polfEventId: ID!) {
  polfEventLeaderboard(polfEventId: $polfEventId) {
    __typename
    ... on PolfLeaderboard {
      players {
        ...SummaryPolfPlayerRow
      }
    }
    ... on GolfLeaderboard {
      players {
        ...SummaryGolfPlayerRow
      }
    }
    ... on ScrambleLeaderboard {
      teams {
        ...SummaryScrambleTeamRow
      }
    }
    ... on BestBallLeaderboard {
      teams {
        ...SummaryBestBallTeamRow
      }
      players {
        ...SummaryGolfPlayerRow
      }
    }
    ... on SegmentedLeaderboard {
      segments {
        ordinal
        fromHole
        toHole
        format
        teams {
          ...SummarySegmentedTeamRow
        }
      }
      teams {
        ...SummarySegmentedTeamRow
        segmentTotals {
          ordinal
          format
          strokes
          strokesNet
          points
          holesRegistred
        }
      }
    }
  }
}
    ${SummaryPolfPlayerRowFragmentDoc}
${SummaryGolfPlayerRowFragmentDoc}
${SummaryScrambleTeamRowFragmentDoc}
${SummaryBestBallTeamRowFragmentDoc}
${SummarySegmentedTeamRowFragmentDoc}`;

/**
 * __usePolfEventLeaderboardQuery__
 *
 * To run a query within a React component, call `usePolfEventLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventLeaderboardQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<PolfEventLeaderboardQuery, PolfEventLeaderboardQueryVariables> & ({ variables: PolfEventLeaderboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventLeaderboardQuery, PolfEventLeaderboardQueryVariables>(PolfEventLeaderboardDocument, options);
      }
export function usePolfEventLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventLeaderboardQuery, PolfEventLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventLeaderboardQuery, PolfEventLeaderboardQueryVariables>(PolfEventLeaderboardDocument, options);
        }
// @ts-ignore
export function usePolfEventLeaderboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventLeaderboardQuery, PolfEventLeaderboardQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventLeaderboardQuery, PolfEventLeaderboardQueryVariables>;
export function usePolfEventLeaderboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventLeaderboardQuery, PolfEventLeaderboardQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventLeaderboardQuery | undefined, PolfEventLeaderboardQueryVariables>;
export function usePolfEventLeaderboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventLeaderboardQuery, PolfEventLeaderboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventLeaderboardQuery, PolfEventLeaderboardQueryVariables>(PolfEventLeaderboardDocument, options);
        }
export type PolfEventLeaderboardQueryHookResult = ReturnType<typeof usePolfEventLeaderboardQuery>;
export type PolfEventLeaderboardLazyQueryHookResult = ReturnType<typeof usePolfEventLeaderboardLazyQuery>;
export type PolfEventLeaderboardSuspenseQueryHookResult = ReturnType<typeof usePolfEventLeaderboardSuspenseQuery>;
export type PolfEventLeaderboardQueryResult = Apollo.QueryResult<PolfEventLeaderboardQuery, PolfEventLeaderboardQueryVariables>;
export const PolfEventMatchesDocument = gql`
    query PolfEventMatches($polfEventId: ID!) {
  polfEventMatches(polfEventId: $polfEventId) {
    ...EventMatchFields
  }
}
    ${EventMatchFieldsFragmentDoc}`;

/**
 * __usePolfEventMatchesQuery__
 *
 * To run a query within a React component, call `usePolfEventMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventMatchesQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventMatchesQuery(baseOptions: Apollo.QueryHookOptions<PolfEventMatchesQuery, PolfEventMatchesQueryVariables> & ({ variables: PolfEventMatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventMatchesQuery, PolfEventMatchesQueryVariables>(PolfEventMatchesDocument, options);
      }
export function usePolfEventMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventMatchesQuery, PolfEventMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventMatchesQuery, PolfEventMatchesQueryVariables>(PolfEventMatchesDocument, options);
        }
// @ts-ignore
export function usePolfEventMatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventMatchesQuery, PolfEventMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventMatchesQuery, PolfEventMatchesQueryVariables>;
export function usePolfEventMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventMatchesQuery, PolfEventMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventMatchesQuery | undefined, PolfEventMatchesQueryVariables>;
export function usePolfEventMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventMatchesQuery, PolfEventMatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventMatchesQuery, PolfEventMatchesQueryVariables>(PolfEventMatchesDocument, options);
        }
export type PolfEventMatchesQueryHookResult = ReturnType<typeof usePolfEventMatchesQuery>;
export type PolfEventMatchesLazyQueryHookResult = ReturnType<typeof usePolfEventMatchesLazyQuery>;
export type PolfEventMatchesSuspenseQueryHookResult = ReturnType<typeof usePolfEventMatchesSuspenseQuery>;
export type PolfEventMatchesQueryResult = Apollo.QueryResult<PolfEventMatchesQuery, PolfEventMatchesQueryVariables>;
export const PolfEventMatchAddDocument = gql`
    mutation PolfEventMatchAdd($polfEventId: ID!, $createPolfEventMatchDto: CreatePolfEventMatchDto!) {
  polfEventMatchAdd(
    polfEventId: $polfEventId
    createPolfEventMatchDto: $createPolfEventMatchDto
  ) {
    ...EventMatchFields
  }
}
    ${EventMatchFieldsFragmentDoc}`;
export type PolfEventMatchAddMutationFn = Apollo.MutationFunction<PolfEventMatchAddMutation, PolfEventMatchAddMutationVariables>;

/**
 * __usePolfEventMatchAddMutation__
 *
 * To run a mutation, you first call `usePolfEventMatchAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventMatchAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventMatchAddMutation, { data, loading, error }] = usePolfEventMatchAddMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      createPolfEventMatchDto: // value for 'createPolfEventMatchDto'
 *   },
 * });
 */
export function usePolfEventMatchAddMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventMatchAddMutation, PolfEventMatchAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventMatchAddMutation, PolfEventMatchAddMutationVariables>(PolfEventMatchAddDocument, options);
      }
export type PolfEventMatchAddMutationHookResult = ReturnType<typeof usePolfEventMatchAddMutation>;
export type PolfEventMatchAddMutationResult = Apollo.MutationResult<PolfEventMatchAddMutation>;
export const PolfEventMatchDeleteDocument = gql`
    mutation PolfEventMatchDelete($polfEventMatchId: ID!) {
  polfEventMatchDelete(polfEventMatchId: $polfEventMatchId)
}
    `;
export type PolfEventMatchDeleteMutationFn = Apollo.MutationFunction<PolfEventMatchDeleteMutation, PolfEventMatchDeleteMutationVariables>;

/**
 * __usePolfEventMatchDeleteMutation__
 *
 * To run a mutation, you first call `usePolfEventMatchDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventMatchDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventMatchDeleteMutation, { data, loading, error }] = usePolfEventMatchDeleteMutation({
 *   variables: {
 *      polfEventMatchId: // value for 'polfEventMatchId'
 *   },
 * });
 */
export function usePolfEventMatchDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventMatchDeleteMutation, PolfEventMatchDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventMatchDeleteMutation, PolfEventMatchDeleteMutationVariables>(PolfEventMatchDeleteDocument, options);
      }
export type PolfEventMatchDeleteMutationHookResult = ReturnType<typeof usePolfEventMatchDeleteMutation>;
export type PolfEventMatchDeleteMutationResult = Apollo.MutationResult<PolfEventMatchDeleteMutation>;
export const PolfEventFlightMatchPointsDocument = gql`
    query PolfEventFlightMatchPoints($polfEventId: ID!) {
  polfEventFlightMatchPoints(polfEventId: $polfEventId) {
    total
    undecided
    flight {
      id
      flightNumber
    }
    sides {
      points
      won
      halved
      lost
      team {
        id
        name
      }
    }
  }
}
    `;

/**
 * __usePolfEventFlightMatchPointsQuery__
 *
 * To run a query within a React component, call `usePolfEventFlightMatchPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventFlightMatchPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventFlightMatchPointsQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventFlightMatchPointsQuery(baseOptions: Apollo.QueryHookOptions<PolfEventFlightMatchPointsQuery, PolfEventFlightMatchPointsQueryVariables> & ({ variables: PolfEventFlightMatchPointsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventFlightMatchPointsQuery, PolfEventFlightMatchPointsQueryVariables>(PolfEventFlightMatchPointsDocument, options);
      }
export function usePolfEventFlightMatchPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventFlightMatchPointsQuery, PolfEventFlightMatchPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventFlightMatchPointsQuery, PolfEventFlightMatchPointsQueryVariables>(PolfEventFlightMatchPointsDocument, options);
        }
// @ts-ignore
export function usePolfEventFlightMatchPointsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventFlightMatchPointsQuery, PolfEventFlightMatchPointsQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventFlightMatchPointsQuery, PolfEventFlightMatchPointsQueryVariables>;
export function usePolfEventFlightMatchPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventFlightMatchPointsQuery, PolfEventFlightMatchPointsQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventFlightMatchPointsQuery | undefined, PolfEventFlightMatchPointsQueryVariables>;
export function usePolfEventFlightMatchPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventFlightMatchPointsQuery, PolfEventFlightMatchPointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventFlightMatchPointsQuery, PolfEventFlightMatchPointsQueryVariables>(PolfEventFlightMatchPointsDocument, options);
        }
export type PolfEventFlightMatchPointsQueryHookResult = ReturnType<typeof usePolfEventFlightMatchPointsQuery>;
export type PolfEventFlightMatchPointsLazyQueryHookResult = ReturnType<typeof usePolfEventFlightMatchPointsLazyQuery>;
export type PolfEventFlightMatchPointsSuspenseQueryHookResult = ReturnType<typeof usePolfEventFlightMatchPointsSuspenseQuery>;
export type PolfEventFlightMatchPointsQueryResult = Apollo.QueryResult<PolfEventFlightMatchPointsQuery, PolfEventFlightMatchPointsQueryVariables>;
export const PolfEventScorecardDocument = gql`
    query polfEventScorecard($polfEventId: ID!, $playerIds: [ID!]) {
  polfEventScorecard(polfEventId: $polfEventId, playerIds: $playerIds) {
    ...ScorecardPlayer
  }
}
    ${ScorecardPlayerFragmentDoc}`;

/**
 * __usePolfEventScorecardQuery__
 *
 * To run a query within a React component, call `usePolfEventScorecardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventScorecardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventScorecardQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      playerIds: // value for 'playerIds'
 *   },
 * });
 */
export function usePolfEventScorecardQuery(baseOptions: Apollo.QueryHookOptions<PolfEventScorecardQuery, PolfEventScorecardQueryVariables> & ({ variables: PolfEventScorecardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventScorecardQuery, PolfEventScorecardQueryVariables>(PolfEventScorecardDocument, options);
      }
export function usePolfEventScorecardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventScorecardQuery, PolfEventScorecardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventScorecardQuery, PolfEventScorecardQueryVariables>(PolfEventScorecardDocument, options);
        }
// @ts-ignore
export function usePolfEventScorecardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventScorecardQuery, PolfEventScorecardQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventScorecardQuery, PolfEventScorecardQueryVariables>;
export function usePolfEventScorecardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventScorecardQuery, PolfEventScorecardQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventScorecardQuery | undefined, PolfEventScorecardQueryVariables>;
export function usePolfEventScorecardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventScorecardQuery, PolfEventScorecardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventScorecardQuery, PolfEventScorecardQueryVariables>(PolfEventScorecardDocument, options);
        }
export type PolfEventScorecardQueryHookResult = ReturnType<typeof usePolfEventScorecardQuery>;
export type PolfEventScorecardLazyQueryHookResult = ReturnType<typeof usePolfEventScorecardLazyQuery>;
export type PolfEventScorecardSuspenseQueryHookResult = ReturnType<typeof usePolfEventScorecardSuspenseQuery>;
export type PolfEventScorecardQueryResult = Apollo.QueryResult<PolfEventScorecardQuery, PolfEventScorecardQueryVariables>;
export const PolfEventPlayerScoreUpdateDocument = gql`
    mutation polfEventPlayerScoreUpdate($polfEventId: ID!, $scoreDto: PolfEventScoreDto!) {
  polfEventPlayerScoreUpdate(polfEventId: $polfEventId, scoreDto: $scoreDto) {
    ...ScorecardScore
  }
}
    ${ScorecardScoreFragmentDoc}`;
export type PolfEventPlayerScoreUpdateMutationFn = Apollo.MutationFunction<PolfEventPlayerScoreUpdateMutation, PolfEventPlayerScoreUpdateMutationVariables>;

/**
 * __usePolfEventPlayerScoreUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerScoreUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerScoreUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerScoreUpdateMutation, { data, loading, error }] = usePolfEventPlayerScoreUpdateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      scoreDto: // value for 'scoreDto'
 *   },
 * });
 */
export function usePolfEventPlayerScoreUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerScoreUpdateMutation, PolfEventPlayerScoreUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerScoreUpdateMutation, PolfEventPlayerScoreUpdateMutationVariables>(PolfEventPlayerScoreUpdateDocument, options);
      }
export type PolfEventPlayerScoreUpdateMutationHookResult = ReturnType<typeof usePolfEventPlayerScoreUpdateMutation>;
export type PolfEventPlayerScoreUpdateMutationResult = Apollo.MutationResult<PolfEventPlayerScoreUpdateMutation>;
export const PolfEventPlayersDocument = gql`
    query polfEventPlayers($polfEventId: ID!) {
  polfEventPlayers(polfEventId: $polfEventId) {
    ...PlayerListItem
  }
}
    ${PlayerListItemFragmentDoc}`;

/**
 * __usePolfEventPlayersQuery__
 *
 * To run a query within a React component, call `usePolfEventPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventPlayersQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventPlayersQuery(baseOptions: Apollo.QueryHookOptions<PolfEventPlayersQuery, PolfEventPlayersQueryVariables> & ({ variables: PolfEventPlayersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventPlayersQuery, PolfEventPlayersQueryVariables>(PolfEventPlayersDocument, options);
      }
export function usePolfEventPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventPlayersQuery, PolfEventPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventPlayersQuery, PolfEventPlayersQueryVariables>(PolfEventPlayersDocument, options);
        }
// @ts-ignore
export function usePolfEventPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventPlayersQuery, PolfEventPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventPlayersQuery, PolfEventPlayersQueryVariables>;
export function usePolfEventPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventPlayersQuery, PolfEventPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventPlayersQuery | undefined, PolfEventPlayersQueryVariables>;
export function usePolfEventPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventPlayersQuery, PolfEventPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventPlayersQuery, PolfEventPlayersQueryVariables>(PolfEventPlayersDocument, options);
        }
export type PolfEventPlayersQueryHookResult = ReturnType<typeof usePolfEventPlayersQuery>;
export type PolfEventPlayersLazyQueryHookResult = ReturnType<typeof usePolfEventPlayersLazyQuery>;
export type PolfEventPlayersSuspenseQueryHookResult = ReturnType<typeof usePolfEventPlayersSuspenseQuery>;
export type PolfEventPlayersQueryResult = Apollo.QueryResult<PolfEventPlayersQuery, PolfEventPlayersQueryVariables>;
export const PolfEventPlayerAddDocument = gql`
    mutation polfEventPlayerAdd($polfEventId: ID!, $createPolfEventPlayerDto: CreatePolfEventPlayerDto!) {
  polfEventPlayerAdd(
    polfEventId: $polfEventId
    createPolfEventPlayerDto: $createPolfEventPlayerDto
  ) {
    ...PlayerListItem
  }
}
    ${PlayerListItemFragmentDoc}`;
export type PolfEventPlayerAddMutationFn = Apollo.MutationFunction<PolfEventPlayerAddMutation, PolfEventPlayerAddMutationVariables>;

/**
 * __usePolfEventPlayerAddMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerAddMutation, { data, loading, error }] = usePolfEventPlayerAddMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      createPolfEventPlayerDto: // value for 'createPolfEventPlayerDto'
 *   },
 * });
 */
export function usePolfEventPlayerAddMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerAddMutation, PolfEventPlayerAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerAddMutation, PolfEventPlayerAddMutationVariables>(PolfEventPlayerAddDocument, options);
      }
export type PolfEventPlayerAddMutationHookResult = ReturnType<typeof usePolfEventPlayerAddMutation>;
export type PolfEventPlayerAddMutationResult = Apollo.MutationResult<PolfEventPlayerAddMutation>;
export const PolfEventPlayerAddMultipleDocument = gql`
    mutation polfEventPlayerAddMultiple($polfEventId: ID!, $createPolfEventPlayersDto: [CreatePolfEventPlayerDto!]!) {
  polfEventPlayerAddMultiple(
    polfEventId: $polfEventId
    createPolfEventPlayersDto: $createPolfEventPlayersDto
  ) {
    ...PlayerListItem
  }
}
    ${PlayerListItemFragmentDoc}`;
export type PolfEventPlayerAddMultipleMutationFn = Apollo.MutationFunction<PolfEventPlayerAddMultipleMutation, PolfEventPlayerAddMultipleMutationVariables>;

/**
 * __usePolfEventPlayerAddMultipleMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerAddMultipleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerAddMultipleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerAddMultipleMutation, { data, loading, error }] = usePolfEventPlayerAddMultipleMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      createPolfEventPlayersDto: // value for 'createPolfEventPlayersDto'
 *   },
 * });
 */
export function usePolfEventPlayerAddMultipleMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerAddMultipleMutation, PolfEventPlayerAddMultipleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerAddMultipleMutation, PolfEventPlayerAddMultipleMutationVariables>(PolfEventPlayerAddMultipleDocument, options);
      }
export type PolfEventPlayerAddMultipleMutationHookResult = ReturnType<typeof usePolfEventPlayerAddMultipleMutation>;
export type PolfEventPlayerAddMultipleMutationResult = Apollo.MutationResult<PolfEventPlayerAddMultipleMutation>;
export const PolfEventCopyDataDocument = gql`
    mutation polfEventCopyData($polfEventId: ID!, $polfEventCopyDataDto: PolfEventCopyDataDto!) {
  polfEventCopyData(
    polfEventId: $polfEventId
    polfEventCopyDataDto: $polfEventCopyDataDto
  ) {
    id
    playerCount
  }
}
    `;
export type PolfEventCopyDataMutationFn = Apollo.MutationFunction<PolfEventCopyDataMutation, PolfEventCopyDataMutationVariables>;

/**
 * __usePolfEventCopyDataMutation__
 *
 * To run a mutation, you first call `usePolfEventCopyDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventCopyDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventCopyDataMutation, { data, loading, error }] = usePolfEventCopyDataMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      polfEventCopyDataDto: // value for 'polfEventCopyDataDto'
 *   },
 * });
 */
export function usePolfEventCopyDataMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventCopyDataMutation, PolfEventCopyDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventCopyDataMutation, PolfEventCopyDataMutationVariables>(PolfEventCopyDataDocument, options);
      }
export type PolfEventCopyDataMutationHookResult = ReturnType<typeof usePolfEventCopyDataMutation>;
export type PolfEventCopyDataMutationResult = Apollo.MutationResult<PolfEventCopyDataMutation>;
export const PolfEventPlayerOtherPaymentCreateDocument = gql`
    mutation polfEventPlayerOtherPaymentCreate($polfEventPlayerId: ID!) {
  polfEventPlayerOtherPaymentCreate(polfEventPlayerId: $polfEventPlayerId) {
    id
    createdAt
  }
}
    `;
export type PolfEventPlayerOtherPaymentCreateMutationFn = Apollo.MutationFunction<PolfEventPlayerOtherPaymentCreateMutation, PolfEventPlayerOtherPaymentCreateMutationVariables>;

/**
 * __usePolfEventPlayerOtherPaymentCreateMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerOtherPaymentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerOtherPaymentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerOtherPaymentCreateMutation, { data, loading, error }] = usePolfEventPlayerOtherPaymentCreateMutation({
 *   variables: {
 *      polfEventPlayerId: // value for 'polfEventPlayerId'
 *   },
 * });
 */
export function usePolfEventPlayerOtherPaymentCreateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerOtherPaymentCreateMutation, PolfEventPlayerOtherPaymentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerOtherPaymentCreateMutation, PolfEventPlayerOtherPaymentCreateMutationVariables>(PolfEventPlayerOtherPaymentCreateDocument, options);
      }
export type PolfEventPlayerOtherPaymentCreateMutationHookResult = ReturnType<typeof usePolfEventPlayerOtherPaymentCreateMutation>;
export type PolfEventPlayerOtherPaymentCreateMutationResult = Apollo.MutationResult<PolfEventPlayerOtherPaymentCreateMutation>;
export const PolfEventPlayerOtherPaymentDeleteDocument = gql`
    mutation polfEventPlayerOtherPaymentDelete($polfEventPlayerOtherPaymentId: ID!) {
  polfEventPlayerOtherPaymentDelete(
    polfEventPlayerOtherPaymentId: $polfEventPlayerOtherPaymentId
  ) {
    id
  }
}
    `;
export type PolfEventPlayerOtherPaymentDeleteMutationFn = Apollo.MutationFunction<PolfEventPlayerOtherPaymentDeleteMutation, PolfEventPlayerOtherPaymentDeleteMutationVariables>;

/**
 * __usePolfEventPlayerOtherPaymentDeleteMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerOtherPaymentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerOtherPaymentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerOtherPaymentDeleteMutation, { data, loading, error }] = usePolfEventPlayerOtherPaymentDeleteMutation({
 *   variables: {
 *      polfEventPlayerOtherPaymentId: // value for 'polfEventPlayerOtherPaymentId'
 *   },
 * });
 */
export function usePolfEventPlayerOtherPaymentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerOtherPaymentDeleteMutation, PolfEventPlayerOtherPaymentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerOtherPaymentDeleteMutation, PolfEventPlayerOtherPaymentDeleteMutationVariables>(PolfEventPlayerOtherPaymentDeleteDocument, options);
      }
export type PolfEventPlayerOtherPaymentDeleteMutationHookResult = ReturnType<typeof usePolfEventPlayerOtherPaymentDeleteMutation>;
export type PolfEventPlayerOtherPaymentDeleteMutationResult = Apollo.MutationResult<PolfEventPlayerOtherPaymentDeleteMutation>;
export const PolfEventPlayerUpdateDocument = gql`
    mutation polfEventPlayerUpdate($polfEventPlayerId: ID!, $updatePolfEventPlayerDto: UpdatePolfEventPlayerDto!) {
  polfEventPlayerUpdate(
    polfEventPlayerId: $polfEventPlayerId
    updatePolfEventPlayerDto: $updatePolfEventPlayerDto
  ) {
    ...PlayerListItem
  }
}
    ${PlayerListItemFragmentDoc}`;
export type PolfEventPlayerUpdateMutationFn = Apollo.MutationFunction<PolfEventPlayerUpdateMutation, PolfEventPlayerUpdateMutationVariables>;

/**
 * __usePolfEventPlayerUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerUpdateMutation, { data, loading, error }] = usePolfEventPlayerUpdateMutation({
 *   variables: {
 *      polfEventPlayerId: // value for 'polfEventPlayerId'
 *      updatePolfEventPlayerDto: // value for 'updatePolfEventPlayerDto'
 *   },
 * });
 */
export function usePolfEventPlayerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerUpdateMutation, PolfEventPlayerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerUpdateMutation, PolfEventPlayerUpdateMutationVariables>(PolfEventPlayerUpdateDocument, options);
      }
export type PolfEventPlayerUpdateMutationHookResult = ReturnType<typeof usePolfEventPlayerUpdateMutation>;
export type PolfEventPlayerUpdateMutationResult = Apollo.MutationResult<PolfEventPlayerUpdateMutation>;
export const PolfEventPlayerRemoveDocument = gql`
    mutation polfEventPlayerRemove($polfEventPlayerId: ID!) {
  polfEventPlayerRemove(polfEventPlayerId: $polfEventPlayerId) {
    id
  }
}
    `;
export type PolfEventPlayerRemoveMutationFn = Apollo.MutationFunction<PolfEventPlayerRemoveMutation, PolfEventPlayerRemoveMutationVariables>;

/**
 * __usePolfEventPlayerRemoveMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerRemoveMutation, { data, loading, error }] = usePolfEventPlayerRemoveMutation({
 *   variables: {
 *      polfEventPlayerId: // value for 'polfEventPlayerId'
 *   },
 * });
 */
export function usePolfEventPlayerRemoveMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerRemoveMutation, PolfEventPlayerRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerRemoveMutation, PolfEventPlayerRemoveMutationVariables>(PolfEventPlayerRemoveDocument, options);
      }
export type PolfEventPlayerRemoveMutationHookResult = ReturnType<typeof usePolfEventPlayerRemoveMutation>;
export type PolfEventPlayerRemoveMutationResult = Apollo.MutationResult<PolfEventPlayerRemoveMutation>;
export const PaymentRefundDocument = gql`
    mutation paymentRefund($paymentId: ID!) {
  paymentRefund(paymentId: $paymentId) {
    reference
    state
    paymentRecord {
      id
      paymentStatus
    }
  }
}
    `;
export type PaymentRefundMutationFn = Apollo.MutationFunction<PaymentRefundMutation, PaymentRefundMutationVariables>;

/**
 * __usePaymentRefundMutation__
 *
 * To run a mutation, you first call `usePaymentRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentRefundMutation, { data, loading, error }] = usePaymentRefundMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function usePaymentRefundMutation(baseOptions?: Apollo.MutationHookOptions<PaymentRefundMutation, PaymentRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentRefundMutation, PaymentRefundMutationVariables>(PaymentRefundDocument, options);
      }
export type PaymentRefundMutationHookResult = ReturnType<typeof usePaymentRefundMutation>;
export type PaymentRefundMutationResult = Apollo.MutationResult<PaymentRefundMutation>;
export const PolfEventPlayerPaymentReminderDocument = gql`
    mutation polfEventPlayerPaymentReminder($polfEventPlayerId: ID!) {
  polfEventPlayerPaymentReminder(polfEventPlayerId: $polfEventPlayerId) {
    id
    smsInviteStatus
    updatedAt
    sentSms {
      id
      type
      status
      createdAt
    }
  }
}
    `;
export type PolfEventPlayerPaymentReminderMutationFn = Apollo.MutationFunction<PolfEventPlayerPaymentReminderMutation, PolfEventPlayerPaymentReminderMutationVariables>;

/**
 * __usePolfEventPlayerPaymentReminderMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerPaymentReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerPaymentReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerPaymentReminderMutation, { data, loading, error }] = usePolfEventPlayerPaymentReminderMutation({
 *   variables: {
 *      polfEventPlayerId: // value for 'polfEventPlayerId'
 *   },
 * });
 */
export function usePolfEventPlayerPaymentReminderMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerPaymentReminderMutation, PolfEventPlayerPaymentReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerPaymentReminderMutation, PolfEventPlayerPaymentReminderMutationVariables>(PolfEventPlayerPaymentReminderDocument, options);
      }
export type PolfEventPlayerPaymentReminderMutationHookResult = ReturnType<typeof usePolfEventPlayerPaymentReminderMutation>;
export type PolfEventPlayerPaymentReminderMutationResult = Apollo.MutationResult<PolfEventPlayerPaymentReminderMutation>;
export const PolfEventRequestUpdatedInfoDocument = gql`
    mutation polfEventRequestUpdatedInfo($polfEventId: ID!, $onlyInvalid: Boolean) {
  polfEventRequestUpdatedInfo(
    polfEventId: $polfEventId
    onlyInvalid: $onlyInvalid
  ) {
    batchId
    queued
    skipped
  }
}
    `;
export type PolfEventRequestUpdatedInfoMutationFn = Apollo.MutationFunction<PolfEventRequestUpdatedInfoMutation, PolfEventRequestUpdatedInfoMutationVariables>;

/**
 * __usePolfEventRequestUpdatedInfoMutation__
 *
 * To run a mutation, you first call `usePolfEventRequestUpdatedInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventRequestUpdatedInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventRequestUpdatedInfoMutation, { data, loading, error }] = usePolfEventRequestUpdatedInfoMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      onlyInvalid: // value for 'onlyInvalid'
 *   },
 * });
 */
export function usePolfEventRequestUpdatedInfoMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventRequestUpdatedInfoMutation, PolfEventRequestUpdatedInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventRequestUpdatedInfoMutation, PolfEventRequestUpdatedInfoMutationVariables>(PolfEventRequestUpdatedInfoDocument, options);
      }
export type PolfEventRequestUpdatedInfoMutationHookResult = ReturnType<typeof usePolfEventRequestUpdatedInfoMutation>;
export type PolfEventRequestUpdatedInfoMutationResult = Apollo.MutationResult<PolfEventRequestUpdatedInfoMutation>;
export const PolfEventPlayerRetireDocument = gql`
    mutation polfEventPlayerRetire($polfEventPlayerId: ID!) {
  polfEventPlayerRetire(polfEventPlayerId: $polfEventPlayerId) {
    ...PlayerListItem
  }
}
    ${PlayerListItemFragmentDoc}`;
export type PolfEventPlayerRetireMutationFn = Apollo.MutationFunction<PolfEventPlayerRetireMutation, PolfEventPlayerRetireMutationVariables>;

/**
 * __usePolfEventPlayerRetireMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerRetireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerRetireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerRetireMutation, { data, loading, error }] = usePolfEventPlayerRetireMutation({
 *   variables: {
 *      polfEventPlayerId: // value for 'polfEventPlayerId'
 *   },
 * });
 */
export function usePolfEventPlayerRetireMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerRetireMutation, PolfEventPlayerRetireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerRetireMutation, PolfEventPlayerRetireMutationVariables>(PolfEventPlayerRetireDocument, options);
      }
export type PolfEventPlayerRetireMutationHookResult = ReturnType<typeof usePolfEventPlayerRetireMutation>;
export type PolfEventPlayerRetireMutationResult = Apollo.MutationResult<PolfEventPlayerRetireMutation>;
export const PolfEventPlayerRetireUndoDocument = gql`
    mutation polfEventPlayerRetireUndo($polfEventPlayerId: ID!) {
  polfEventPlayerRetireUndo(polfEventPlayerId: $polfEventPlayerId) {
    ...PlayerListItem
  }
}
    ${PlayerListItemFragmentDoc}`;
export type PolfEventPlayerRetireUndoMutationFn = Apollo.MutationFunction<PolfEventPlayerRetireUndoMutation, PolfEventPlayerRetireUndoMutationVariables>;

/**
 * __usePolfEventPlayerRetireUndoMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerRetireUndoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerRetireUndoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerRetireUndoMutation, { data, loading, error }] = usePolfEventPlayerRetireUndoMutation({
 *   variables: {
 *      polfEventPlayerId: // value for 'polfEventPlayerId'
 *   },
 * });
 */
export function usePolfEventPlayerRetireUndoMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerRetireUndoMutation, PolfEventPlayerRetireUndoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerRetireUndoMutation, PolfEventPlayerRetireUndoMutationVariables>(PolfEventPlayerRetireUndoDocument, options);
      }
export type PolfEventPlayerRetireUndoMutationHookResult = ReturnType<typeof usePolfEventPlayerRetireUndoMutation>;
export type PolfEventPlayerRetireUndoMutationResult = Apollo.MutationResult<PolfEventPlayerRetireUndoMutation>;
export const PolfEventPlayerRetiredPlaysPokerSetDocument = gql`
    mutation polfEventPlayerRetiredPlaysPokerSet($polfEventPlayerId: ID!, $playsPoker: Boolean!) {
  polfEventPlayerRetiredPlaysPokerSet(
    polfEventPlayerId: $polfEventPlayerId
    playsPoker: $playsPoker
  ) {
    ...PlayerListItem
  }
}
    ${PlayerListItemFragmentDoc}`;
export type PolfEventPlayerRetiredPlaysPokerSetMutationFn = Apollo.MutationFunction<PolfEventPlayerRetiredPlaysPokerSetMutation, PolfEventPlayerRetiredPlaysPokerSetMutationVariables>;

/**
 * __usePolfEventPlayerRetiredPlaysPokerSetMutation__
 *
 * To run a mutation, you first call `usePolfEventPlayerRetiredPlaysPokerSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPlayerRetiredPlaysPokerSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPlayerRetiredPlaysPokerSetMutation, { data, loading, error }] = usePolfEventPlayerRetiredPlaysPokerSetMutation({
 *   variables: {
 *      polfEventPlayerId: // value for 'polfEventPlayerId'
 *      playsPoker: // value for 'playsPoker'
 *   },
 * });
 */
export function usePolfEventPlayerRetiredPlaysPokerSetMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPlayerRetiredPlaysPokerSetMutation, PolfEventPlayerRetiredPlaysPokerSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPlayerRetiredPlaysPokerSetMutation, PolfEventPlayerRetiredPlaysPokerSetMutationVariables>(PolfEventPlayerRetiredPlaysPokerSetDocument, options);
      }
export type PolfEventPlayerRetiredPlaysPokerSetMutationHookResult = ReturnType<typeof usePolfEventPlayerRetiredPlaysPokerSetMutation>;
export type PolfEventPlayerRetiredPlaysPokerSetMutationResult = Apollo.MutationResult<PolfEventPlayerRetiredPlaysPokerSetMutation>;
export const PolfEventPokerDocument = gql`
    query polfEventPoker($polfEventId: ID!) {
  polfEventPoker(polfEventId: $polfEventId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;

/**
 * __usePolfEventPokerQuery__
 *
 * To run a query within a React component, call `usePolfEventPokerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventPokerQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventPokerQuery(baseOptions: Apollo.QueryHookOptions<PolfEventPokerQuery, PolfEventPokerQueryVariables> & ({ variables: PolfEventPokerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventPokerQuery, PolfEventPokerQueryVariables>(PolfEventPokerDocument, options);
      }
export function usePolfEventPokerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventPokerQuery, PolfEventPokerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventPokerQuery, PolfEventPokerQueryVariables>(PolfEventPokerDocument, options);
        }
// @ts-ignore
export function usePolfEventPokerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventPokerQuery, PolfEventPokerQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventPokerQuery, PolfEventPokerQueryVariables>;
export function usePolfEventPokerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventPokerQuery, PolfEventPokerQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventPokerQuery | undefined, PolfEventPokerQueryVariables>;
export function usePolfEventPokerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventPokerQuery, PolfEventPokerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventPokerQuery, PolfEventPokerQueryVariables>(PolfEventPokerDocument, options);
        }
export type PolfEventPokerQueryHookResult = ReturnType<typeof usePolfEventPokerQuery>;
export type PolfEventPokerLazyQueryHookResult = ReturnType<typeof usePolfEventPokerLazyQuery>;
export type PolfEventPokerSuspenseQueryHookResult = ReturnType<typeof usePolfEventPokerSuspenseQuery>;
export type PolfEventPokerQueryResult = Apollo.QueryResult<PolfEventPokerQuery, PolfEventPokerQueryVariables>;
export const PolfEventPokerConfigUpsertDocument = gql`
    mutation polfEventPokerConfigUpsert($polfEventId: ID!, $input: PokerConfigInput!) {
  polfEventPokerConfigUpsert(polfEventId: $polfEventId, input: $input) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerConfigUpsertMutationFn = Apollo.MutationFunction<PolfEventPokerConfigUpsertMutation, PolfEventPokerConfigUpsertMutationVariables>;

/**
 * __usePolfEventPokerConfigUpsertMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerConfigUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerConfigUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerConfigUpsertMutation, { data, loading, error }] = usePolfEventPokerConfigUpsertMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePolfEventPokerConfigUpsertMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerConfigUpsertMutation, PolfEventPokerConfigUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerConfigUpsertMutation, PolfEventPokerConfigUpsertMutationVariables>(PolfEventPokerConfigUpsertDocument, options);
      }
export type PolfEventPokerConfigUpsertMutationHookResult = ReturnType<typeof usePolfEventPokerConfigUpsertMutation>;
export type PolfEventPokerConfigUpsertMutationResult = Apollo.MutationResult<PolfEventPokerConfigUpsertMutation>;
export const PolfEventPokerDrawSeatsDocument = gql`
    mutation polfEventPokerDrawSeats($polfEventId: ID!) {
  polfEventPokerDrawSeats(polfEventId: $polfEventId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerDrawSeatsMutationFn = Apollo.MutationFunction<PolfEventPokerDrawSeatsMutation, PolfEventPokerDrawSeatsMutationVariables>;

/**
 * __usePolfEventPokerDrawSeatsMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerDrawSeatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerDrawSeatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerDrawSeatsMutation, { data, loading, error }] = usePolfEventPokerDrawSeatsMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventPokerDrawSeatsMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerDrawSeatsMutation, PolfEventPokerDrawSeatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerDrawSeatsMutation, PolfEventPokerDrawSeatsMutationVariables>(PolfEventPokerDrawSeatsDocument, options);
      }
export type PolfEventPokerDrawSeatsMutationHookResult = ReturnType<typeof usePolfEventPokerDrawSeatsMutation>;
export type PolfEventPokerDrawSeatsMutationResult = Apollo.MutationResult<PolfEventPokerDrawSeatsMutation>;
export const ProjectedPokerSetupDocument = gql`
    query projectedPokerSetup($polfEventId: ID!) {
  projectedPokerSetup(polfEventId: $polfEventId) {
    playerCount
    totalChips
    averageStack
    seatsPerTable
    recommendedTableCount
    players {
      playerId
      name
      rank
      projectedStack
    }
    retiredPlayers {
      playerId
      name
      playsPoker
      holesFilled
    }
  }
}
    `;

/**
 * __useProjectedPokerSetupQuery__
 *
 * To run a query within a React component, call `useProjectedPokerSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectedPokerSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectedPokerSetupQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function useProjectedPokerSetupQuery(baseOptions: Apollo.QueryHookOptions<ProjectedPokerSetupQuery, ProjectedPokerSetupQueryVariables> & ({ variables: ProjectedPokerSetupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectedPokerSetupQuery, ProjectedPokerSetupQueryVariables>(ProjectedPokerSetupDocument, options);
      }
export function useProjectedPokerSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectedPokerSetupQuery, ProjectedPokerSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectedPokerSetupQuery, ProjectedPokerSetupQueryVariables>(ProjectedPokerSetupDocument, options);
        }
// @ts-ignore
export function useProjectedPokerSetupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectedPokerSetupQuery, ProjectedPokerSetupQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectedPokerSetupQuery, ProjectedPokerSetupQueryVariables>;
export function useProjectedPokerSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectedPokerSetupQuery, ProjectedPokerSetupQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectedPokerSetupQuery | undefined, ProjectedPokerSetupQueryVariables>;
export function useProjectedPokerSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectedPokerSetupQuery, ProjectedPokerSetupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectedPokerSetupQuery, ProjectedPokerSetupQueryVariables>(ProjectedPokerSetupDocument, options);
        }
export type ProjectedPokerSetupQueryHookResult = ReturnType<typeof useProjectedPokerSetupQuery>;
export type ProjectedPokerSetupLazyQueryHookResult = ReturnType<typeof useProjectedPokerSetupLazyQuery>;
export type ProjectedPokerSetupSuspenseQueryHookResult = ReturnType<typeof useProjectedPokerSetupSuspenseQuery>;
export type ProjectedPokerSetupQueryResult = Apollo.QueryResult<ProjectedPokerSetupQuery, ProjectedPokerSetupQueryVariables>;
export const PolfEventPokerBlindStructureUpdateDocument = gql`
    mutation polfEventPokerBlindStructureUpdate($polfEventId: ID!, $pokerId: ID!, $input: UpdateBlindStructureInput!) {
  polfEventPokerBlindStructureUpdate(
    polfEventId: $polfEventId
    pokerId: $pokerId
    input: $input
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerBlindStructureUpdateMutationFn = Apollo.MutationFunction<PolfEventPokerBlindStructureUpdateMutation, PolfEventPokerBlindStructureUpdateMutationVariables>;

/**
 * __usePolfEventPokerBlindStructureUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerBlindStructureUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerBlindStructureUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerBlindStructureUpdateMutation, { data, loading, error }] = usePolfEventPokerBlindStructureUpdateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePolfEventPokerBlindStructureUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerBlindStructureUpdateMutation, PolfEventPokerBlindStructureUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerBlindStructureUpdateMutation, PolfEventPokerBlindStructureUpdateMutationVariables>(PolfEventPokerBlindStructureUpdateDocument, options);
      }
export type PolfEventPokerBlindStructureUpdateMutationHookResult = ReturnType<typeof usePolfEventPokerBlindStructureUpdateMutation>;
export type PolfEventPokerBlindStructureUpdateMutationResult = Apollo.MutationResult<PolfEventPokerBlindStructureUpdateMutation>;
export const PolfEventPokerPayoutStructureUpdateDocument = gql`
    mutation polfEventPokerPayoutStructureUpdate($polfEventId: ID!, $pokerId: ID!, $input: UpdatePayoutStructureInput!) {
  polfEventPokerPayoutStructureUpdate(
    polfEventId: $polfEventId
    pokerId: $pokerId
    input: $input
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerPayoutStructureUpdateMutationFn = Apollo.MutationFunction<PolfEventPokerPayoutStructureUpdateMutation, PolfEventPokerPayoutStructureUpdateMutationVariables>;

/**
 * __usePolfEventPokerPayoutStructureUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerPayoutStructureUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerPayoutStructureUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerPayoutStructureUpdateMutation, { data, loading, error }] = usePolfEventPokerPayoutStructureUpdateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePolfEventPokerPayoutStructureUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerPayoutStructureUpdateMutation, PolfEventPokerPayoutStructureUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerPayoutStructureUpdateMutation, PolfEventPokerPayoutStructureUpdateMutationVariables>(PolfEventPokerPayoutStructureUpdateDocument, options);
      }
export type PolfEventPokerPayoutStructureUpdateMutationHookResult = ReturnType<typeof usePolfEventPokerPayoutStructureUpdateMutation>;
export type PolfEventPokerPayoutStructureUpdateMutationResult = Apollo.MutationResult<PolfEventPokerPayoutStructureUpdateMutation>;
export const PolfEventPokerUsePayoutsSetDocument = gql`
    mutation polfEventPokerUsePayoutsSet($polfEventId: ID!, $pokerId: ID!, $usePayouts: Boolean!) {
  polfEventPokerUsePayoutsSet(
    polfEventId: $polfEventId
    pokerId: $pokerId
    usePayouts: $usePayouts
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerUsePayoutsSetMutationFn = Apollo.MutationFunction<PolfEventPokerUsePayoutsSetMutation, PolfEventPokerUsePayoutsSetMutationVariables>;

/**
 * __usePolfEventPokerUsePayoutsSetMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerUsePayoutsSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerUsePayoutsSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerUsePayoutsSetMutation, { data, loading, error }] = usePolfEventPokerUsePayoutsSetMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      usePayouts: // value for 'usePayouts'
 *   },
 * });
 */
export function usePolfEventPokerUsePayoutsSetMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerUsePayoutsSetMutation, PolfEventPokerUsePayoutsSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerUsePayoutsSetMutation, PolfEventPokerUsePayoutsSetMutationVariables>(PolfEventPokerUsePayoutsSetDocument, options);
      }
export type PolfEventPokerUsePayoutsSetMutationHookResult = ReturnType<typeof usePolfEventPokerUsePayoutsSetMutation>;
export type PolfEventPokerUsePayoutsSetMutationResult = Apollo.MutationResult<PolfEventPokerUsePayoutsSetMutation>;
export const PolfEventPokerSeatMoveDocument = gql`
    mutation polfEventPokerSeatMove($polfEventId: ID!, $input: MoveSeatInput!) {
  polfEventPokerSeatMove(polfEventId: $polfEventId, input: $input) {
    id
    tableNumber
    seatNumber
  }
}
    `;
export type PolfEventPokerSeatMoveMutationFn = Apollo.MutationFunction<PolfEventPokerSeatMoveMutation, PolfEventPokerSeatMoveMutationVariables>;

/**
 * __usePolfEventPokerSeatMoveMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerSeatMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerSeatMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerSeatMoveMutation, { data, loading, error }] = usePolfEventPokerSeatMoveMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePolfEventPokerSeatMoveMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerSeatMoveMutation, PolfEventPokerSeatMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerSeatMoveMutation, PolfEventPokerSeatMoveMutationVariables>(PolfEventPokerSeatMoveDocument, options);
      }
export type PolfEventPokerSeatMoveMutationHookResult = ReturnType<typeof usePolfEventPokerSeatMoveMutation>;
export type PolfEventPokerSeatMoveMutationResult = Apollo.MutationResult<PolfEventPokerSeatMoveMutation>;
export const PolfEventPokerSeatSwapDocument = gql`
    mutation polfEventPokerSeatSwap($polfEventId: ID!, $input: SwapSeatsInput!) {
  polfEventPokerSeatSwap(polfEventId: $polfEventId, input: $input) {
    id
    tableNumber
    seatNumber
  }
}
    `;
export type PolfEventPokerSeatSwapMutationFn = Apollo.MutationFunction<PolfEventPokerSeatSwapMutation, PolfEventPokerSeatSwapMutationVariables>;

/**
 * __usePolfEventPokerSeatSwapMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerSeatSwapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerSeatSwapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerSeatSwapMutation, { data, loading, error }] = usePolfEventPokerSeatSwapMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePolfEventPokerSeatSwapMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerSeatSwapMutation, PolfEventPokerSeatSwapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerSeatSwapMutation, PolfEventPokerSeatSwapMutationVariables>(PolfEventPokerSeatSwapDocument, options);
      }
export type PolfEventPokerSeatSwapMutationHookResult = ReturnType<typeof usePolfEventPokerSeatSwapMutation>;
export type PolfEventPokerSeatSwapMutationResult = Apollo.MutationResult<PolfEventPokerSeatSwapMutation>;
export const PolfEventPokerClockStartDocument = gql`
    mutation polfEventPokerClockStart($polfEventId: ID!, $pokerId: ID!) {
  polfEventPokerClockStart(polfEventId: $polfEventId, pokerId: $pokerId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerClockStartMutationFn = Apollo.MutationFunction<PolfEventPokerClockStartMutation, PolfEventPokerClockStartMutationVariables>;

/**
 * __usePolfEventPokerClockStartMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerClockStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerClockStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerClockStartMutation, { data, loading, error }] = usePolfEventPokerClockStartMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function usePolfEventPokerClockStartMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerClockStartMutation, PolfEventPokerClockStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerClockStartMutation, PolfEventPokerClockStartMutationVariables>(PolfEventPokerClockStartDocument, options);
      }
export type PolfEventPokerClockStartMutationHookResult = ReturnType<typeof usePolfEventPokerClockStartMutation>;
export type PolfEventPokerClockStartMutationResult = Apollo.MutationResult<PolfEventPokerClockStartMutation>;
export const PolfEventPokerClockPauseDocument = gql`
    mutation polfEventPokerClockPause($polfEventId: ID!, $pokerId: ID!) {
  polfEventPokerClockPause(polfEventId: $polfEventId, pokerId: $pokerId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerClockPauseMutationFn = Apollo.MutationFunction<PolfEventPokerClockPauseMutation, PolfEventPokerClockPauseMutationVariables>;

/**
 * __usePolfEventPokerClockPauseMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerClockPauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerClockPauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerClockPauseMutation, { data, loading, error }] = usePolfEventPokerClockPauseMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function usePolfEventPokerClockPauseMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerClockPauseMutation, PolfEventPokerClockPauseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerClockPauseMutation, PolfEventPokerClockPauseMutationVariables>(PolfEventPokerClockPauseDocument, options);
      }
export type PolfEventPokerClockPauseMutationHookResult = ReturnType<typeof usePolfEventPokerClockPauseMutation>;
export type PolfEventPokerClockPauseMutationResult = Apollo.MutationResult<PolfEventPokerClockPauseMutation>;
export const PolfEventPokerClockResumeDocument = gql`
    mutation polfEventPokerClockResume($polfEventId: ID!, $pokerId: ID!) {
  polfEventPokerClockResume(polfEventId: $polfEventId, pokerId: $pokerId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerClockResumeMutationFn = Apollo.MutationFunction<PolfEventPokerClockResumeMutation, PolfEventPokerClockResumeMutationVariables>;

/**
 * __usePolfEventPokerClockResumeMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerClockResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerClockResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerClockResumeMutation, { data, loading, error }] = usePolfEventPokerClockResumeMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function usePolfEventPokerClockResumeMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerClockResumeMutation, PolfEventPokerClockResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerClockResumeMutation, PolfEventPokerClockResumeMutationVariables>(PolfEventPokerClockResumeDocument, options);
      }
export type PolfEventPokerClockResumeMutationHookResult = ReturnType<typeof usePolfEventPokerClockResumeMutation>;
export type PolfEventPokerClockResumeMutationResult = Apollo.MutationResult<PolfEventPokerClockResumeMutation>;
export const PolfEventPokerClockAdjustDocument = gql`
    mutation polfEventPokerClockAdjust($polfEventId: ID!, $pokerId: ID!, $remainingSeconds: Int!) {
  polfEventPokerClockAdjust(
    polfEventId: $polfEventId
    pokerId: $pokerId
    remainingSeconds: $remainingSeconds
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerClockAdjustMutationFn = Apollo.MutationFunction<PolfEventPokerClockAdjustMutation, PolfEventPokerClockAdjustMutationVariables>;

/**
 * __usePolfEventPokerClockAdjustMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerClockAdjustMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerClockAdjustMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerClockAdjustMutation, { data, loading, error }] = usePolfEventPokerClockAdjustMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      remainingSeconds: // value for 'remainingSeconds'
 *   },
 * });
 */
export function usePolfEventPokerClockAdjustMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerClockAdjustMutation, PolfEventPokerClockAdjustMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerClockAdjustMutation, PolfEventPokerClockAdjustMutationVariables>(PolfEventPokerClockAdjustDocument, options);
      }
export type PolfEventPokerClockAdjustMutationHookResult = ReturnType<typeof usePolfEventPokerClockAdjustMutation>;
export type PolfEventPokerClockAdjustMutationResult = Apollo.MutationResult<PolfEventPokerClockAdjustMutation>;
export const PolfEventPokerLevelAdvanceDocument = gql`
    mutation polfEventPokerLevelAdvance($polfEventId: ID!, $pokerId: ID!, $direction: LevelDirection!) {
  polfEventPokerLevelAdvance(
    polfEventId: $polfEventId
    pokerId: $pokerId
    direction: $direction
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerLevelAdvanceMutationFn = Apollo.MutationFunction<PolfEventPokerLevelAdvanceMutation, PolfEventPokerLevelAdvanceMutationVariables>;

/**
 * __usePolfEventPokerLevelAdvanceMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerLevelAdvanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerLevelAdvanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerLevelAdvanceMutation, { data, loading, error }] = usePolfEventPokerLevelAdvanceMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function usePolfEventPokerLevelAdvanceMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerLevelAdvanceMutation, PolfEventPokerLevelAdvanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerLevelAdvanceMutation, PolfEventPokerLevelAdvanceMutationVariables>(PolfEventPokerLevelAdvanceDocument, options);
      }
export type PolfEventPokerLevelAdvanceMutationHookResult = ReturnType<typeof usePolfEventPokerLevelAdvanceMutation>;
export type PolfEventPokerLevelAdvanceMutationResult = Apollo.MutationResult<PolfEventPokerLevelAdvanceMutation>;
export const PolfEventPokerSeatEliminateDocument = gql`
    mutation polfEventPokerSeatEliminate($polfEventId: ID!, $seatId: ID!, $knockedOutByPlayerId: ID) {
  polfEventPokerSeatEliminate(
    polfEventId: $polfEventId
    seatId: $seatId
    knockedOutByPlayerId: $knockedOutByPlayerId
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerSeatEliminateMutationFn = Apollo.MutationFunction<PolfEventPokerSeatEliminateMutation, PolfEventPokerSeatEliminateMutationVariables>;

/**
 * __usePolfEventPokerSeatEliminateMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerSeatEliminateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerSeatEliminateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerSeatEliminateMutation, { data, loading, error }] = usePolfEventPokerSeatEliminateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      seatId: // value for 'seatId'
 *      knockedOutByPlayerId: // value for 'knockedOutByPlayerId'
 *   },
 * });
 */
export function usePolfEventPokerSeatEliminateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerSeatEliminateMutation, PolfEventPokerSeatEliminateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerSeatEliminateMutation, PolfEventPokerSeatEliminateMutationVariables>(PolfEventPokerSeatEliminateDocument, options);
      }
export type PolfEventPokerSeatEliminateMutationHookResult = ReturnType<typeof usePolfEventPokerSeatEliminateMutation>;
export type PolfEventPokerSeatEliminateMutationResult = Apollo.MutationResult<PolfEventPokerSeatEliminateMutation>;
export const PolfEventPokerSeatRestoreDocument = gql`
    mutation polfEventPokerSeatRestore($polfEventId: ID!, $seatId: ID!) {
  polfEventPokerSeatRestore(polfEventId: $polfEventId, seatId: $seatId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerSeatRestoreMutationFn = Apollo.MutationFunction<PolfEventPokerSeatRestoreMutation, PolfEventPokerSeatRestoreMutationVariables>;

/**
 * __usePolfEventPokerSeatRestoreMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerSeatRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerSeatRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerSeatRestoreMutation, { data, loading, error }] = usePolfEventPokerSeatRestoreMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      seatId: // value for 'seatId'
 *   },
 * });
 */
export function usePolfEventPokerSeatRestoreMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerSeatRestoreMutation, PolfEventPokerSeatRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerSeatRestoreMutation, PolfEventPokerSeatRestoreMutationVariables>(PolfEventPokerSeatRestoreDocument, options);
      }
export type PolfEventPokerSeatRestoreMutationHookResult = ReturnType<typeof usePolfEventPokerSeatRestoreMutation>;
export type PolfEventPokerSeatRestoreMutationResult = Apollo.MutationResult<PolfEventPokerSeatRestoreMutation>;
export const PolfEventPokerReorderEliminationDocument = gql`
    mutation polfEventPokerReorderElimination($polfEventId: ID!, $seatId: ID!, $direction: ReorderDirection!) {
  polfEventPokerReorderElimination(
    polfEventId: $polfEventId
    seatId: $seatId
    direction: $direction
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerReorderEliminationMutationFn = Apollo.MutationFunction<PolfEventPokerReorderEliminationMutation, PolfEventPokerReorderEliminationMutationVariables>;

/**
 * __usePolfEventPokerReorderEliminationMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerReorderEliminationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerReorderEliminationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerReorderEliminationMutation, { data, loading, error }] = usePolfEventPokerReorderEliminationMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      seatId: // value for 'seatId'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function usePolfEventPokerReorderEliminationMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerReorderEliminationMutation, PolfEventPokerReorderEliminationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerReorderEliminationMutation, PolfEventPokerReorderEliminationMutationVariables>(PolfEventPokerReorderEliminationDocument, options);
      }
export type PolfEventPokerReorderEliminationMutationHookResult = ReturnType<typeof usePolfEventPokerReorderEliminationMutation>;
export type PolfEventPokerReorderEliminationMutationResult = Apollo.MutationResult<PolfEventPokerReorderEliminationMutation>;
export const PolfEventPokerSeatLockToggleDocument = gql`
    mutation polfEventPokerSeatLockToggle($polfEventId: ID!, $seatId: ID!, $isLocked: Boolean!) {
  polfEventPokerSeatLockToggle(
    polfEventId: $polfEventId
    seatId: $seatId
    isLocked: $isLocked
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerSeatLockToggleMutationFn = Apollo.MutationFunction<PolfEventPokerSeatLockToggleMutation, PolfEventPokerSeatLockToggleMutationVariables>;

/**
 * __usePolfEventPokerSeatLockToggleMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerSeatLockToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerSeatLockToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerSeatLockToggleMutation, { data, loading, error }] = usePolfEventPokerSeatLockToggleMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      seatId: // value for 'seatId'
 *      isLocked: // value for 'isLocked'
 *   },
 * });
 */
export function usePolfEventPokerSeatLockToggleMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerSeatLockToggleMutation, PolfEventPokerSeatLockToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerSeatLockToggleMutation, PolfEventPokerSeatLockToggleMutationVariables>(PolfEventPokerSeatLockToggleDocument, options);
      }
export type PolfEventPokerSeatLockToggleMutationHookResult = ReturnType<typeof usePolfEventPokerSeatLockToggleMutation>;
export type PolfEventPokerSeatLockToggleMutationResult = Apollo.MutationResult<PolfEventPokerSeatLockToggleMutation>;
export const PolfEventPokerSeatStackUpdateDocument = gql`
    mutation polfEventPokerSeatStackUpdate($polfEventId: ID!, $seatId: ID!, $currentStack: Float!) {
  polfEventPokerSeatStackUpdate(
    polfEventId: $polfEventId
    seatId: $seatId
    currentStack: $currentStack
  ) {
    id
    currentStack
  }
}
    `;
export type PolfEventPokerSeatStackUpdateMutationFn = Apollo.MutationFunction<PolfEventPokerSeatStackUpdateMutation, PolfEventPokerSeatStackUpdateMutationVariables>;

/**
 * __usePolfEventPokerSeatStackUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerSeatStackUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerSeatStackUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerSeatStackUpdateMutation, { data, loading, error }] = usePolfEventPokerSeatStackUpdateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      seatId: // value for 'seatId'
 *      currentStack: // value for 'currentStack'
 *   },
 * });
 */
export function usePolfEventPokerSeatStackUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerSeatStackUpdateMutation, PolfEventPokerSeatStackUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerSeatStackUpdateMutation, PolfEventPokerSeatStackUpdateMutationVariables>(PolfEventPokerSeatStackUpdateDocument, options);
      }
export type PolfEventPokerSeatStackUpdateMutationHookResult = ReturnType<typeof usePolfEventPokerSeatStackUpdateMutation>;
export type PolfEventPokerSeatStackUpdateMutationResult = Apollo.MutationResult<PolfEventPokerSeatStackUpdateMutation>;
export const PolfEventPokerBalancingApplyDocument = gql`
    mutation polfEventPokerBalancingApply($polfEventId: ID!, $pokerId: ID!) {
  polfEventPokerBalancingApply(polfEventId: $polfEventId, pokerId: $pokerId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerBalancingApplyMutationFn = Apollo.MutationFunction<PolfEventPokerBalancingApplyMutation, PolfEventPokerBalancingApplyMutationVariables>;

/**
 * __usePolfEventPokerBalancingApplyMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerBalancingApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerBalancingApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerBalancingApplyMutation, { data, loading, error }] = usePolfEventPokerBalancingApplyMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function usePolfEventPokerBalancingApplyMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerBalancingApplyMutation, PolfEventPokerBalancingApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerBalancingApplyMutation, PolfEventPokerBalancingApplyMutationVariables>(PolfEventPokerBalancingApplyDocument, options);
      }
export type PolfEventPokerBalancingApplyMutationHookResult = ReturnType<typeof usePolfEventPokerBalancingApplyMutation>;
export type PolfEventPokerBalancingApplyMutationResult = Apollo.MutationResult<PolfEventPokerBalancingApplyMutation>;
export const PolfEventPokerAddTableDocument = gql`
    mutation polfEventPokerAddTable($polfEventId: ID!, $pokerId: ID!) {
  polfEventPokerAddTable(polfEventId: $polfEventId, pokerId: $pokerId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerAddTableMutationFn = Apollo.MutationFunction<PolfEventPokerAddTableMutation, PolfEventPokerAddTableMutationVariables>;

/**
 * __usePolfEventPokerAddTableMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerAddTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerAddTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerAddTableMutation, { data, loading, error }] = usePolfEventPokerAddTableMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function usePolfEventPokerAddTableMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerAddTableMutation, PolfEventPokerAddTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerAddTableMutation, PolfEventPokerAddTableMutationVariables>(PolfEventPokerAddTableDocument, options);
      }
export type PolfEventPokerAddTableMutationHookResult = ReturnType<typeof usePolfEventPokerAddTableMutation>;
export type PolfEventPokerAddTableMutationResult = Apollo.MutationResult<PolfEventPokerAddTableMutation>;
export const PolfEventPokerRemoveLastTableDocument = gql`
    mutation polfEventPokerRemoveLastTable($polfEventId: ID!, $pokerId: ID!) {
  polfEventPokerRemoveLastTable(polfEventId: $polfEventId, pokerId: $pokerId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerRemoveLastTableMutationFn = Apollo.MutationFunction<PolfEventPokerRemoveLastTableMutation, PolfEventPokerRemoveLastTableMutationVariables>;

/**
 * __usePolfEventPokerRemoveLastTableMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerRemoveLastTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerRemoveLastTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerRemoveLastTableMutation, { data, loading, error }] = usePolfEventPokerRemoveLastTableMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function usePolfEventPokerRemoveLastTableMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerRemoveLastTableMutation, PolfEventPokerRemoveLastTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerRemoveLastTableMutation, PolfEventPokerRemoveLastTableMutationVariables>(PolfEventPokerRemoveLastTableDocument, options);
      }
export type PolfEventPokerRemoveLastTableMutationHookResult = ReturnType<typeof usePolfEventPokerRemoveLastTableMutation>;
export type PolfEventPokerRemoveLastTableMutationResult = Apollo.MutationResult<PolfEventPokerRemoveLastTableMutation>;
export const PolfEventPokerPrizePoolUpdateDocument = gql`
    mutation polfEventPokerPrizePoolUpdate($polfEventId: ID!, $pokerId: ID!, $prizePool: Int) {
  polfEventPokerPrizePoolUpdate(
    polfEventId: $polfEventId
    pokerId: $pokerId
    prizePool: $prizePool
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerPrizePoolUpdateMutationFn = Apollo.MutationFunction<PolfEventPokerPrizePoolUpdateMutation, PolfEventPokerPrizePoolUpdateMutationVariables>;

/**
 * __usePolfEventPokerPrizePoolUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerPrizePoolUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerPrizePoolUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerPrizePoolUpdateMutation, { data, loading, error }] = usePolfEventPokerPrizePoolUpdateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      prizePool: // value for 'prizePool'
 *   },
 * });
 */
export function usePolfEventPokerPrizePoolUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerPrizePoolUpdateMutation, PolfEventPokerPrizePoolUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerPrizePoolUpdateMutation, PolfEventPokerPrizePoolUpdateMutationVariables>(PolfEventPokerPrizePoolUpdateDocument, options);
      }
export type PolfEventPokerPrizePoolUpdateMutationHookResult = ReturnType<typeof usePolfEventPokerPrizePoolUpdateMutation>;
export type PolfEventPokerPrizePoolUpdateMutationResult = Apollo.MutationResult<PolfEventPokerPrizePoolUpdateMutation>;
export const PolfEventPokerSeatsPerTableUpdateDocument = gql`
    mutation polfEventPokerSeatsPerTableUpdate($polfEventId: ID!, $pokerId: ID!, $seatsPerTable: Float!) {
  polfEventPokerSeatsPerTableUpdate(
    polfEventId: $polfEventId
    pokerId: $pokerId
    seatsPerTable: $seatsPerTable
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerSeatsPerTableUpdateMutationFn = Apollo.MutationFunction<PolfEventPokerSeatsPerTableUpdateMutation, PolfEventPokerSeatsPerTableUpdateMutationVariables>;

/**
 * __usePolfEventPokerSeatsPerTableUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerSeatsPerTableUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerSeatsPerTableUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerSeatsPerTableUpdateMutation, { data, loading, error }] = usePolfEventPokerSeatsPerTableUpdateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      seatsPerTable: // value for 'seatsPerTable'
 *   },
 * });
 */
export function usePolfEventPokerSeatsPerTableUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerSeatsPerTableUpdateMutation, PolfEventPokerSeatsPerTableUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerSeatsPerTableUpdateMutation, PolfEventPokerSeatsPerTableUpdateMutationVariables>(PolfEventPokerSeatsPerTableUpdateDocument, options);
      }
export type PolfEventPokerSeatsPerTableUpdateMutationHookResult = ReturnType<typeof usePolfEventPokerSeatsPerTableUpdateMutation>;
export type PolfEventPokerSeatsPerTableUpdateMutationResult = Apollo.MutationResult<PolfEventPokerSeatsPerTableUpdateMutation>;
export const PolfEventPokerShowChipLeaderboardSetDocument = gql`
    mutation polfEventPokerShowChipLeaderboardSet($polfEventId: ID!, $pokerId: ID!, $showChipLeaderboard: Boolean!) {
  polfEventPokerShowChipLeaderboardSet(
    polfEventId: $polfEventId
    pokerId: $pokerId
    showChipLeaderboard: $showChipLeaderboard
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerShowChipLeaderboardSetMutationFn = Apollo.MutationFunction<PolfEventPokerShowChipLeaderboardSetMutation, PolfEventPokerShowChipLeaderboardSetMutationVariables>;

/**
 * __usePolfEventPokerShowChipLeaderboardSetMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerShowChipLeaderboardSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerShowChipLeaderboardSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerShowChipLeaderboardSetMutation, { data, loading, error }] = usePolfEventPokerShowChipLeaderboardSetMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      showChipLeaderboard: // value for 'showChipLeaderboard'
 *   },
 * });
 */
export function usePolfEventPokerShowChipLeaderboardSetMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerShowChipLeaderboardSetMutation, PolfEventPokerShowChipLeaderboardSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerShowChipLeaderboardSetMutation, PolfEventPokerShowChipLeaderboardSetMutationVariables>(PolfEventPokerShowChipLeaderboardSetDocument, options);
      }
export type PolfEventPokerShowChipLeaderboardSetMutationHookResult = ReturnType<typeof usePolfEventPokerShowChipLeaderboardSetMutation>;
export type PolfEventPokerShowChipLeaderboardSetMutationResult = Apollo.MutationResult<PolfEventPokerShowChipLeaderboardSetMutation>;
export const PolfEventPokerVoiceAnnouncementsSetDocument = gql`
    mutation polfEventPokerVoiceAnnouncementsSet($polfEventId: ID!, $pokerId: ID!, $voiceAnnouncements: Boolean!) {
  polfEventPokerVoiceAnnouncementsSet(
    polfEventId: $polfEventId
    pokerId: $pokerId
    voiceAnnouncements: $voiceAnnouncements
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerVoiceAnnouncementsSetMutationFn = Apollo.MutationFunction<PolfEventPokerVoiceAnnouncementsSetMutation, PolfEventPokerVoiceAnnouncementsSetMutationVariables>;

/**
 * __usePolfEventPokerVoiceAnnouncementsSetMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerVoiceAnnouncementsSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerVoiceAnnouncementsSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerVoiceAnnouncementsSetMutation, { data, loading, error }] = usePolfEventPokerVoiceAnnouncementsSetMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      voiceAnnouncements: // value for 'voiceAnnouncements'
 *   },
 * });
 */
export function usePolfEventPokerVoiceAnnouncementsSetMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerVoiceAnnouncementsSetMutation, PolfEventPokerVoiceAnnouncementsSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerVoiceAnnouncementsSetMutation, PolfEventPokerVoiceAnnouncementsSetMutationVariables>(PolfEventPokerVoiceAnnouncementsSetDocument, options);
      }
export type PolfEventPokerVoiceAnnouncementsSetMutationHookResult = ReturnType<typeof usePolfEventPokerVoiceAnnouncementsSetMutation>;
export type PolfEventPokerVoiceAnnouncementsSetMutationResult = Apollo.MutationResult<PolfEventPokerVoiceAnnouncementsSetMutation>;
export const PolfEventPokerAllowPlayerStackUpdateSetDocument = gql`
    mutation polfEventPokerAllowPlayerStackUpdateSet($polfEventId: ID!, $pokerId: ID!, $allowPlayerStackUpdate: Boolean!) {
  polfEventPokerAllowPlayerStackUpdateSet(
    polfEventId: $polfEventId
    pokerId: $pokerId
    allowPlayerStackUpdate: $allowPlayerStackUpdate
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerAllowPlayerStackUpdateSetMutationFn = Apollo.MutationFunction<PolfEventPokerAllowPlayerStackUpdateSetMutation, PolfEventPokerAllowPlayerStackUpdateSetMutationVariables>;

/**
 * __usePolfEventPokerAllowPlayerStackUpdateSetMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerAllowPlayerStackUpdateSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerAllowPlayerStackUpdateSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerAllowPlayerStackUpdateSetMutation, { data, loading, error }] = usePolfEventPokerAllowPlayerStackUpdateSetMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      allowPlayerStackUpdate: // value for 'allowPlayerStackUpdate'
 *   },
 * });
 */
export function usePolfEventPokerAllowPlayerStackUpdateSetMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerAllowPlayerStackUpdateSetMutation, PolfEventPokerAllowPlayerStackUpdateSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerAllowPlayerStackUpdateSetMutation, PolfEventPokerAllowPlayerStackUpdateSetMutationVariables>(PolfEventPokerAllowPlayerStackUpdateSetDocument, options);
      }
export type PolfEventPokerAllowPlayerStackUpdateSetMutationHookResult = ReturnType<typeof usePolfEventPokerAllowPlayerStackUpdateSetMutation>;
export type PolfEventPokerAllowPlayerStackUpdateSetMutationResult = Apollo.MutationResult<PolfEventPokerAllowPlayerStackUpdateSetMutation>;
export const PolfEventPokerFinalTableRedrawDocument = gql`
    mutation polfEventPokerFinalTableRedraw($polfEventId: ID!, $pokerId: ID!) {
  polfEventPokerFinalTableRedraw(polfEventId: $polfEventId, pokerId: $pokerId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerFinalTableRedrawMutationFn = Apollo.MutationFunction<PolfEventPokerFinalTableRedrawMutation, PolfEventPokerFinalTableRedrawMutationVariables>;

/**
 * __usePolfEventPokerFinalTableRedrawMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerFinalTableRedrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerFinalTableRedrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerFinalTableRedrawMutation, { data, loading, error }] = usePolfEventPokerFinalTableRedrawMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function usePolfEventPokerFinalTableRedrawMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerFinalTableRedrawMutation, PolfEventPokerFinalTableRedrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerFinalTableRedrawMutation, PolfEventPokerFinalTableRedrawMutationVariables>(PolfEventPokerFinalTableRedrawDocument, options);
      }
export type PolfEventPokerFinalTableRedrawMutationHookResult = ReturnType<typeof usePolfEventPokerFinalTableRedrawMutation>;
export type PolfEventPokerFinalTableRedrawMutationResult = Apollo.MutationResult<PolfEventPokerFinalTableRedrawMutation>;
export const PolfEventPokerSendSeatSmsDocument = gql`
    mutation polfEventPokerSendSeatSms($polfEventId: ID!, $pokerId: ID!, $sender: String) {
  polfEventPokerSendSeatSms(
    polfEventId: $polfEventId
    pokerId: $pokerId
    sender: $sender
  ) {
    sentCount
    failedCount
  }
}
    `;
export type PolfEventPokerSendSeatSmsMutationFn = Apollo.MutationFunction<PolfEventPokerSendSeatSmsMutation, PolfEventPokerSendSeatSmsMutationVariables>;

/**
 * __usePolfEventPokerSendSeatSmsMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerSendSeatSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerSendSeatSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerSendSeatSmsMutation, { data, loading, error }] = usePolfEventPokerSendSeatSmsMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      sender: // value for 'sender'
 *   },
 * });
 */
export function usePolfEventPokerSendSeatSmsMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerSendSeatSmsMutation, PolfEventPokerSendSeatSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerSendSeatSmsMutation, PolfEventPokerSendSeatSmsMutationVariables>(PolfEventPokerSendSeatSmsDocument, options);
      }
export type PolfEventPokerSendSeatSmsMutationHookResult = ReturnType<typeof usePolfEventPokerSendSeatSmsMutation>;
export type PolfEventPokerSendSeatSmsMutationResult = Apollo.MutationResult<PolfEventPokerSendSeatSmsMutation>;
export const PolfEventPokerFinishDocument = gql`
    mutation polfEventPokerFinish($polfEventId: ID!, $pokerId: ID!) {
  polfEventPokerFinish(polfEventId: $polfEventId, pokerId: $pokerId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerFinishMutationFn = Apollo.MutationFunction<PolfEventPokerFinishMutation, PolfEventPokerFinishMutationVariables>;

/**
 * __usePolfEventPokerFinishMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerFinishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerFinishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerFinishMutation, { data, loading, error }] = usePolfEventPokerFinishMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function usePolfEventPokerFinishMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerFinishMutation, PolfEventPokerFinishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerFinishMutation, PolfEventPokerFinishMutationVariables>(PolfEventPokerFinishDocument, options);
      }
export type PolfEventPokerFinishMutationHookResult = ReturnType<typeof usePolfEventPokerFinishMutation>;
export type PolfEventPokerFinishMutationResult = Apollo.MutationResult<PolfEventPokerFinishMutation>;
export const PolfEventPokerRebuyConfigSetDocument = gql`
    mutation polfEventPokerRebuyConfigSet($polfEventId: ID!, $pokerId: ID!, $input: RebuyAddonConfigInput!) {
  polfEventPokerRebuyConfigSet(
    polfEventId: $polfEventId
    pokerId: $pokerId
    input: $input
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerRebuyConfigSetMutationFn = Apollo.MutationFunction<PolfEventPokerRebuyConfigSetMutation, PolfEventPokerRebuyConfigSetMutationVariables>;

/**
 * __usePolfEventPokerRebuyConfigSetMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerRebuyConfigSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerRebuyConfigSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerRebuyConfigSetMutation, { data, loading, error }] = usePolfEventPokerRebuyConfigSetMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePolfEventPokerRebuyConfigSetMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerRebuyConfigSetMutation, PolfEventPokerRebuyConfigSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerRebuyConfigSetMutation, PolfEventPokerRebuyConfigSetMutationVariables>(PolfEventPokerRebuyConfigSetDocument, options);
      }
export type PolfEventPokerRebuyConfigSetMutationHookResult = ReturnType<typeof usePolfEventPokerRebuyConfigSetMutation>;
export type PolfEventPokerRebuyConfigSetMutationResult = Apollo.MutationResult<PolfEventPokerRebuyConfigSetMutation>;
export const PolfEventPokerRegistrationCloseDocument = gql`
    mutation polfEventPokerRegistrationClose($polfEventId: ID!, $pokerId: ID!, $closed: Boolean!) {
  polfEventPokerRegistrationClose(
    polfEventId: $polfEventId
    pokerId: $pokerId
    closed: $closed
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerRegistrationCloseMutationFn = Apollo.MutationFunction<PolfEventPokerRegistrationCloseMutation, PolfEventPokerRegistrationCloseMutationVariables>;

/**
 * __usePolfEventPokerRegistrationCloseMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerRegistrationCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerRegistrationCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerRegistrationCloseMutation, { data, loading, error }] = usePolfEventPokerRegistrationCloseMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      closed: // value for 'closed'
 *   },
 * });
 */
export function usePolfEventPokerRegistrationCloseMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerRegistrationCloseMutation, PolfEventPokerRegistrationCloseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerRegistrationCloseMutation, PolfEventPokerRegistrationCloseMutationVariables>(PolfEventPokerRegistrationCloseDocument, options);
      }
export type PolfEventPokerRegistrationCloseMutationHookResult = ReturnType<typeof usePolfEventPokerRegistrationCloseMutation>;
export type PolfEventPokerRegistrationCloseMutationResult = Apollo.MutationResult<PolfEventPokerRegistrationCloseMutation>;
export const PolfEventPokerSeatRebuyDocument = gql`
    mutation polfEventPokerSeatRebuy($polfEventId: ID!, $seatId: ID!) {
  polfEventPokerSeatRebuy(polfEventId: $polfEventId, seatId: $seatId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerSeatRebuyMutationFn = Apollo.MutationFunction<PolfEventPokerSeatRebuyMutation, PolfEventPokerSeatRebuyMutationVariables>;

/**
 * __usePolfEventPokerSeatRebuyMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerSeatRebuyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerSeatRebuyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerSeatRebuyMutation, { data, loading, error }] = usePolfEventPokerSeatRebuyMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      seatId: // value for 'seatId'
 *   },
 * });
 */
export function usePolfEventPokerSeatRebuyMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerSeatRebuyMutation, PolfEventPokerSeatRebuyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerSeatRebuyMutation, PolfEventPokerSeatRebuyMutationVariables>(PolfEventPokerSeatRebuyDocument, options);
      }
export type PolfEventPokerSeatRebuyMutationHookResult = ReturnType<typeof usePolfEventPokerSeatRebuyMutation>;
export type PolfEventPokerSeatRebuyMutationResult = Apollo.MutationResult<PolfEventPokerSeatRebuyMutation>;
export const PolfEventPokerSeatAddonDocument = gql`
    mutation polfEventPokerSeatAddon($polfEventId: ID!, $seatId: ID!) {
  polfEventPokerSeatAddon(polfEventId: $polfEventId, seatId: $seatId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerSeatAddonMutationFn = Apollo.MutationFunction<PolfEventPokerSeatAddonMutation, PolfEventPokerSeatAddonMutationVariables>;

/**
 * __usePolfEventPokerSeatAddonMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerSeatAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerSeatAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerSeatAddonMutation, { data, loading, error }] = usePolfEventPokerSeatAddonMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      seatId: // value for 'seatId'
 *   },
 * });
 */
export function usePolfEventPokerSeatAddonMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerSeatAddonMutation, PolfEventPokerSeatAddonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerSeatAddonMutation, PolfEventPokerSeatAddonMutationVariables>(PolfEventPokerSeatAddonDocument, options);
      }
export type PolfEventPokerSeatAddonMutationHookResult = ReturnType<typeof usePolfEventPokerSeatAddonMutation>;
export type PolfEventPokerSeatAddonMutationResult = Apollo.MutationResult<PolfEventPokerSeatAddonMutation>;
export const PolfEventPokerSeatAddonRemoveDocument = gql`
    mutation polfEventPokerSeatAddonRemove($polfEventId: ID!, $seatId: ID!) {
  polfEventPokerSeatAddonRemove(polfEventId: $polfEventId, seatId: $seatId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerSeatAddonRemoveMutationFn = Apollo.MutationFunction<PolfEventPokerSeatAddonRemoveMutation, PolfEventPokerSeatAddonRemoveMutationVariables>;

/**
 * __usePolfEventPokerSeatAddonRemoveMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerSeatAddonRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerSeatAddonRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerSeatAddonRemoveMutation, { data, loading, error }] = usePolfEventPokerSeatAddonRemoveMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      seatId: // value for 'seatId'
 *   },
 * });
 */
export function usePolfEventPokerSeatAddonRemoveMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerSeatAddonRemoveMutation, PolfEventPokerSeatAddonRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerSeatAddonRemoveMutation, PolfEventPokerSeatAddonRemoveMutationVariables>(PolfEventPokerSeatAddonRemoveDocument, options);
      }
export type PolfEventPokerSeatAddonRemoveMutationHookResult = ReturnType<typeof usePolfEventPokerSeatAddonRemoveMutation>;
export type PolfEventPokerSeatAddonRemoveMutationResult = Apollo.MutationResult<PolfEventPokerSeatAddonRemoveMutation>;
export const PolfEventPokerAddonAllDocument = gql`
    mutation polfEventPokerAddonAll($polfEventId: ID!, $pokerId: ID!) {
  polfEventPokerAddonAll(polfEventId: $polfEventId, pokerId: $pokerId) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerAddonAllMutationFn = Apollo.MutationFunction<PolfEventPokerAddonAllMutation, PolfEventPokerAddonAllMutationVariables>;

/**
 * __usePolfEventPokerAddonAllMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerAddonAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerAddonAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerAddonAllMutation, { data, loading, error }] = usePolfEventPokerAddonAllMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function usePolfEventPokerAddonAllMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerAddonAllMutation, PolfEventPokerAddonAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerAddonAllMutation, PolfEventPokerAddonAllMutationVariables>(PolfEventPokerAddonAllDocument, options);
      }
export type PolfEventPokerAddonAllMutationHookResult = ReturnType<typeof usePolfEventPokerAddonAllMutation>;
export type PolfEventPokerAddonAllMutationResult = Apollo.MutationResult<PolfEventPokerAddonAllMutation>;
export const PolfEventPokerLateRegisterDocument = gql`
    mutation polfEventPokerLateRegister($polfEventId: ID!, $pokerId: ID!, $playerId: ID!) {
  polfEventPokerLateRegister(
    polfEventId: $polfEventId
    pokerId: $pokerId
    playerId: $playerId
  ) {
    ...PokerData
  }
}
    ${PokerDataFragmentDoc}`;
export type PolfEventPokerLateRegisterMutationFn = Apollo.MutationFunction<PolfEventPokerLateRegisterMutation, PolfEventPokerLateRegisterMutationVariables>;

/**
 * __usePolfEventPokerLateRegisterMutation__
 *
 * To run a mutation, you first call `usePolfEventPokerLateRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPokerLateRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPokerLateRegisterMutation, { data, loading, error }] = usePolfEventPokerLateRegisterMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      pokerId: // value for 'pokerId'
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function usePolfEventPokerLateRegisterMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPokerLateRegisterMutation, PolfEventPokerLateRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPokerLateRegisterMutation, PolfEventPokerLateRegisterMutationVariables>(PolfEventPokerLateRegisterDocument, options);
      }
export type PolfEventPokerLateRegisterMutationHookResult = ReturnType<typeof usePolfEventPokerLateRegisterMutation>;
export type PolfEventPokerLateRegisterMutationResult = Apollo.MutationResult<PolfEventPokerLateRegisterMutation>;
export const PolfEventSegmentedScorecardDocument = gql`
    query polfEventSegmentedScorecard($polfEventId: ID!) {
  polfEventLeaderboard(polfEventId: $polfEventId) {
    __typename
    ... on SegmentedLeaderboard {
      segments {
        ordinal
        fromHole
        toHole
        format
        teams {
          team {
            id
            name
            strokes
          }
          scores {
            id
            score
            strokes
            stablefordPoints
            hole {
              number
              par
              index
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePolfEventSegmentedScorecardQuery__
 *
 * To run a query within a React component, call `usePolfEventSegmentedScorecardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventSegmentedScorecardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventSegmentedScorecardQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventSegmentedScorecardQuery(baseOptions: Apollo.QueryHookOptions<PolfEventSegmentedScorecardQuery, PolfEventSegmentedScorecardQueryVariables> & ({ variables: PolfEventSegmentedScorecardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventSegmentedScorecardQuery, PolfEventSegmentedScorecardQueryVariables>(PolfEventSegmentedScorecardDocument, options);
      }
export function usePolfEventSegmentedScorecardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventSegmentedScorecardQuery, PolfEventSegmentedScorecardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventSegmentedScorecardQuery, PolfEventSegmentedScorecardQueryVariables>(PolfEventSegmentedScorecardDocument, options);
        }
// @ts-ignore
export function usePolfEventSegmentedScorecardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventSegmentedScorecardQuery, PolfEventSegmentedScorecardQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventSegmentedScorecardQuery, PolfEventSegmentedScorecardQueryVariables>;
export function usePolfEventSegmentedScorecardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventSegmentedScorecardQuery, PolfEventSegmentedScorecardQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventSegmentedScorecardQuery | undefined, PolfEventSegmentedScorecardQueryVariables>;
export function usePolfEventSegmentedScorecardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventSegmentedScorecardQuery, PolfEventSegmentedScorecardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventSegmentedScorecardQuery, PolfEventSegmentedScorecardQueryVariables>(PolfEventSegmentedScorecardDocument, options);
        }
export type PolfEventSegmentedScorecardQueryHookResult = ReturnType<typeof usePolfEventSegmentedScorecardQuery>;
export type PolfEventSegmentedScorecardLazyQueryHookResult = ReturnType<typeof usePolfEventSegmentedScorecardLazyQuery>;
export type PolfEventSegmentedScorecardSuspenseQueryHookResult = ReturnType<typeof usePolfEventSegmentedScorecardSuspenseQuery>;
export type PolfEventSegmentedScorecardQueryResult = Apollo.QueryResult<PolfEventSegmentedScorecardQuery, PolfEventSegmentedScorecardQueryVariables>;
export const PolfEventScrambleScorecardDocument = gql`
    query polfEventScrambleScorecard($polfEventId: ID!) {
  polfEventLeaderboard(polfEventId: $polfEventId) {
    __typename
    ... on ScrambleLeaderboard {
      teams {
        points
        team {
          id
          name
          strokes
        }
        scores {
          score
          hole {
            number
            par
            index
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePolfEventScrambleScorecardQuery__
 *
 * To run a query within a React component, call `usePolfEventScrambleScorecardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventScrambleScorecardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventScrambleScorecardQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventScrambleScorecardQuery(baseOptions: Apollo.QueryHookOptions<PolfEventScrambleScorecardQuery, PolfEventScrambleScorecardQueryVariables> & ({ variables: PolfEventScrambleScorecardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventScrambleScorecardQuery, PolfEventScrambleScorecardQueryVariables>(PolfEventScrambleScorecardDocument, options);
      }
export function usePolfEventScrambleScorecardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventScrambleScorecardQuery, PolfEventScrambleScorecardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventScrambleScorecardQuery, PolfEventScrambleScorecardQueryVariables>(PolfEventScrambleScorecardDocument, options);
        }
// @ts-ignore
export function usePolfEventScrambleScorecardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventScrambleScorecardQuery, PolfEventScrambleScorecardQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventScrambleScorecardQuery, PolfEventScrambleScorecardQueryVariables>;
export function usePolfEventScrambleScorecardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventScrambleScorecardQuery, PolfEventScrambleScorecardQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventScrambleScorecardQuery | undefined, PolfEventScrambleScorecardQueryVariables>;
export function usePolfEventScrambleScorecardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventScrambleScorecardQuery, PolfEventScrambleScorecardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventScrambleScorecardQuery, PolfEventScrambleScorecardQueryVariables>(PolfEventScrambleScorecardDocument, options);
        }
export type PolfEventScrambleScorecardQueryHookResult = ReturnType<typeof usePolfEventScrambleScorecardQuery>;
export type PolfEventScrambleScorecardLazyQueryHookResult = ReturnType<typeof usePolfEventScrambleScorecardLazyQuery>;
export type PolfEventScrambleScorecardSuspenseQueryHookResult = ReturnType<typeof usePolfEventScrambleScorecardSuspenseQuery>;
export type PolfEventScrambleScorecardQueryResult = Apollo.QueryResult<PolfEventScrambleScorecardQuery, PolfEventScrambleScorecardQueryVariables>;
export const PolfEventTeamsDocument = gql`
    query polfEventTeams($polfEventId: ID!) {
  polfEventTeams(polfEventId: $polfEventId) {
    ...TeamListItem
  }
}
    ${TeamListItemFragmentDoc}`;

/**
 * __usePolfEventTeamsQuery__
 *
 * To run a query within a React component, call `usePolfEventTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventTeamsQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventTeamsQuery(baseOptions: Apollo.QueryHookOptions<PolfEventTeamsQuery, PolfEventTeamsQueryVariables> & ({ variables: PolfEventTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventTeamsQuery, PolfEventTeamsQueryVariables>(PolfEventTeamsDocument, options);
      }
export function usePolfEventTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventTeamsQuery, PolfEventTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventTeamsQuery, PolfEventTeamsQueryVariables>(PolfEventTeamsDocument, options);
        }
// @ts-ignore
export function usePolfEventTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventTeamsQuery, PolfEventTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventTeamsQuery, PolfEventTeamsQueryVariables>;
export function usePolfEventTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventTeamsQuery, PolfEventTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventTeamsQuery | undefined, PolfEventTeamsQueryVariables>;
export function usePolfEventTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventTeamsQuery, PolfEventTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventTeamsQuery, PolfEventTeamsQueryVariables>(PolfEventTeamsDocument, options);
        }
export type PolfEventTeamsQueryHookResult = ReturnType<typeof usePolfEventTeamsQuery>;
export type PolfEventTeamsLazyQueryHookResult = ReturnType<typeof usePolfEventTeamsLazyQuery>;
export type PolfEventTeamsSuspenseQueryHookResult = ReturnType<typeof usePolfEventTeamsSuspenseQuery>;
export type PolfEventTeamsQueryResult = Apollo.QueryResult<PolfEventTeamsQuery, PolfEventTeamsQueryVariables>;
export const PolfEventTeamScoredHolesDocument = gql`
    query polfEventTeamScoredHoles($polfEventId: ID!) {
  polfEventTeams(polfEventId: $polfEventId) {
    id
    scoredHoleCount
  }
}
    `;

/**
 * __usePolfEventTeamScoredHolesQuery__
 *
 * To run a query within a React component, call `usePolfEventTeamScoredHolesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventTeamScoredHolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventTeamScoredHolesQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventTeamScoredHolesQuery(baseOptions: Apollo.QueryHookOptions<PolfEventTeamScoredHolesQuery, PolfEventTeamScoredHolesQueryVariables> & ({ variables: PolfEventTeamScoredHolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventTeamScoredHolesQuery, PolfEventTeamScoredHolesQueryVariables>(PolfEventTeamScoredHolesDocument, options);
      }
export function usePolfEventTeamScoredHolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventTeamScoredHolesQuery, PolfEventTeamScoredHolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventTeamScoredHolesQuery, PolfEventTeamScoredHolesQueryVariables>(PolfEventTeamScoredHolesDocument, options);
        }
// @ts-ignore
export function usePolfEventTeamScoredHolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventTeamScoredHolesQuery, PolfEventTeamScoredHolesQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventTeamScoredHolesQuery, PolfEventTeamScoredHolesQueryVariables>;
export function usePolfEventTeamScoredHolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventTeamScoredHolesQuery, PolfEventTeamScoredHolesQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventTeamScoredHolesQuery | undefined, PolfEventTeamScoredHolesQueryVariables>;
export function usePolfEventTeamScoredHolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventTeamScoredHolesQuery, PolfEventTeamScoredHolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventTeamScoredHolesQuery, PolfEventTeamScoredHolesQueryVariables>(PolfEventTeamScoredHolesDocument, options);
        }
export type PolfEventTeamScoredHolesQueryHookResult = ReturnType<typeof usePolfEventTeamScoredHolesQuery>;
export type PolfEventTeamScoredHolesLazyQueryHookResult = ReturnType<typeof usePolfEventTeamScoredHolesLazyQuery>;
export type PolfEventTeamScoredHolesSuspenseQueryHookResult = ReturnType<typeof usePolfEventTeamScoredHolesSuspenseQuery>;
export type PolfEventTeamScoredHolesQueryResult = Apollo.QueryResult<PolfEventTeamScoredHolesQuery, PolfEventTeamScoredHolesQueryVariables>;
export const PolfEventTeamAddDocument = gql`
    mutation polfEventTeamAdd($polfEventId: ID!, $createPolfEventTeamDto: CreatePolfEventTeamDto) {
  polfEventTeamAdd(
    polfEventId: $polfEventId
    createPolfEventTeamDto: $createPolfEventTeamDto
  ) {
    ...TeamListItem
  }
}
    ${TeamListItemFragmentDoc}`;
export type PolfEventTeamAddMutationFn = Apollo.MutationFunction<PolfEventTeamAddMutation, PolfEventTeamAddMutationVariables>;

/**
 * __usePolfEventTeamAddMutation__
 *
 * To run a mutation, you first call `usePolfEventTeamAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventTeamAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventTeamAddMutation, { data, loading, error }] = usePolfEventTeamAddMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      createPolfEventTeamDto: // value for 'createPolfEventTeamDto'
 *   },
 * });
 */
export function usePolfEventTeamAddMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventTeamAddMutation, PolfEventTeamAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventTeamAddMutation, PolfEventTeamAddMutationVariables>(PolfEventTeamAddDocument, options);
      }
export type PolfEventTeamAddMutationHookResult = ReturnType<typeof usePolfEventTeamAddMutation>;
export type PolfEventTeamAddMutationResult = Apollo.MutationResult<PolfEventTeamAddMutation>;
export const PolfEventTeamUpdateDocument = gql`
    mutation polfEventTeamUpdate($polfEventTeamId: ID!, $updatePolfEventTeamDto: UpdatePolfEventTeamDto!) {
  polfEventTeamUpdate(
    polfEventTeamId: $polfEventTeamId
    updatePolfEventTeamDto: $updatePolfEventTeamDto
  ) {
    ...TeamListItem
  }
}
    ${TeamListItemFragmentDoc}`;
export type PolfEventTeamUpdateMutationFn = Apollo.MutationFunction<PolfEventTeamUpdateMutation, PolfEventTeamUpdateMutationVariables>;

/**
 * __usePolfEventTeamUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventTeamUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventTeamUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventTeamUpdateMutation, { data, loading, error }] = usePolfEventTeamUpdateMutation({
 *   variables: {
 *      polfEventTeamId: // value for 'polfEventTeamId'
 *      updatePolfEventTeamDto: // value for 'updatePolfEventTeamDto'
 *   },
 * });
 */
export function usePolfEventTeamUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventTeamUpdateMutation, PolfEventTeamUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventTeamUpdateMutation, PolfEventTeamUpdateMutationVariables>(PolfEventTeamUpdateDocument, options);
      }
export type PolfEventTeamUpdateMutationHookResult = ReturnType<typeof usePolfEventTeamUpdateMutation>;
export type PolfEventTeamUpdateMutationResult = Apollo.MutationResult<PolfEventTeamUpdateMutation>;
export const PolfEventTeamResetNameDocument = gql`
    mutation polfEventTeamResetName($polfEventTeamId: ID!) {
  polfEventTeamResetName(polfEventTeamId: $polfEventTeamId) {
    ...TeamListItem
  }
}
    ${TeamListItemFragmentDoc}`;
export type PolfEventTeamResetNameMutationFn = Apollo.MutationFunction<PolfEventTeamResetNameMutation, PolfEventTeamResetNameMutationVariables>;

/**
 * __usePolfEventTeamResetNameMutation__
 *
 * To run a mutation, you first call `usePolfEventTeamResetNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventTeamResetNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventTeamResetNameMutation, { data, loading, error }] = usePolfEventTeamResetNameMutation({
 *   variables: {
 *      polfEventTeamId: // value for 'polfEventTeamId'
 *   },
 * });
 */
export function usePolfEventTeamResetNameMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventTeamResetNameMutation, PolfEventTeamResetNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventTeamResetNameMutation, PolfEventTeamResetNameMutationVariables>(PolfEventTeamResetNameDocument, options);
      }
export type PolfEventTeamResetNameMutationHookResult = ReturnType<typeof usePolfEventTeamResetNameMutation>;
export type PolfEventTeamResetNameMutationResult = Apollo.MutationResult<PolfEventTeamResetNameMutation>;
export const PolfEventTeamDeleteDocument = gql`
    mutation polfEventTeamDelete($polfEventTeamId: ID!) {
  polfEventTeamDelete(polfEventTeamId: $polfEventTeamId) {
    id
  }
}
    `;
export type PolfEventTeamDeleteMutationFn = Apollo.MutationFunction<PolfEventTeamDeleteMutation, PolfEventTeamDeleteMutationVariables>;

/**
 * __usePolfEventTeamDeleteMutation__
 *
 * To run a mutation, you first call `usePolfEventTeamDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventTeamDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventTeamDeleteMutation, { data, loading, error }] = usePolfEventTeamDeleteMutation({
 *   variables: {
 *      polfEventTeamId: // value for 'polfEventTeamId'
 *   },
 * });
 */
export function usePolfEventTeamDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventTeamDeleteMutation, PolfEventTeamDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventTeamDeleteMutation, PolfEventTeamDeleteMutationVariables>(PolfEventTeamDeleteDocument, options);
      }
export type PolfEventTeamDeleteMutationHookResult = ReturnType<typeof usePolfEventTeamDeleteMutation>;
export type PolfEventTeamDeleteMutationResult = Apollo.MutationResult<PolfEventTeamDeleteMutation>;
export const PolfEventTeamAddPlayerDocument = gql`
    mutation polfEventTeamAddPlayer($polfEventTeamId: ID!, $polfEventPlayerId: ID!) {
  polfEventTeamAddPlayer(
    polfEventTeamId: $polfEventTeamId
    polfEventPlayerId: $polfEventPlayerId
  ) {
    ...TeamListItem
  }
}
    ${TeamListItemFragmentDoc}`;
export type PolfEventTeamAddPlayerMutationFn = Apollo.MutationFunction<PolfEventTeamAddPlayerMutation, PolfEventTeamAddPlayerMutationVariables>;

/**
 * __usePolfEventTeamAddPlayerMutation__
 *
 * To run a mutation, you first call `usePolfEventTeamAddPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventTeamAddPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventTeamAddPlayerMutation, { data, loading, error }] = usePolfEventTeamAddPlayerMutation({
 *   variables: {
 *      polfEventTeamId: // value for 'polfEventTeamId'
 *      polfEventPlayerId: // value for 'polfEventPlayerId'
 *   },
 * });
 */
export function usePolfEventTeamAddPlayerMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventTeamAddPlayerMutation, PolfEventTeamAddPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventTeamAddPlayerMutation, PolfEventTeamAddPlayerMutationVariables>(PolfEventTeamAddPlayerDocument, options);
      }
export type PolfEventTeamAddPlayerMutationHookResult = ReturnType<typeof usePolfEventTeamAddPlayerMutation>;
export type PolfEventTeamAddPlayerMutationResult = Apollo.MutationResult<PolfEventTeamAddPlayerMutation>;
export const PolfEventTeamRemovePlayerDocument = gql`
    mutation polfEventTeamRemovePlayer($polfEventPlayerId: ID!, $polfEventTeamId: ID!) {
  polfEventTeamRemovePlayer(
    polfEventPlayerId: $polfEventPlayerId
    polfEventTeamId: $polfEventTeamId
  ) {
    ...TeamListItem
  }
}
    ${TeamListItemFragmentDoc}`;
export type PolfEventTeamRemovePlayerMutationFn = Apollo.MutationFunction<PolfEventTeamRemovePlayerMutation, PolfEventTeamRemovePlayerMutationVariables>;

/**
 * __usePolfEventTeamRemovePlayerMutation__
 *
 * To run a mutation, you first call `usePolfEventTeamRemovePlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventTeamRemovePlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventTeamRemovePlayerMutation, { data, loading, error }] = usePolfEventTeamRemovePlayerMutation({
 *   variables: {
 *      polfEventPlayerId: // value for 'polfEventPlayerId'
 *      polfEventTeamId: // value for 'polfEventTeamId'
 *   },
 * });
 */
export function usePolfEventTeamRemovePlayerMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventTeamRemovePlayerMutation, PolfEventTeamRemovePlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventTeamRemovePlayerMutation, PolfEventTeamRemovePlayerMutationVariables>(PolfEventTeamRemovePlayerDocument, options);
      }
export type PolfEventTeamRemovePlayerMutationHookResult = ReturnType<typeof usePolfEventTeamRemovePlayerMutation>;
export type PolfEventTeamRemovePlayerMutationResult = Apollo.MutationResult<PolfEventTeamRemovePlayerMutation>;
export const PolfEventTeamAutogenerateDocument = gql`
    mutation polfEventTeamAutogenerate($polfEventId: ID!, $teamSize: Float!) {
  polfEventTeamAutogenerate(polfEventId: $polfEventId, teamSize: $teamSize) {
    ...TeamListItem
  }
}
    ${TeamListItemFragmentDoc}`;
export type PolfEventTeamAutogenerateMutationFn = Apollo.MutationFunction<PolfEventTeamAutogenerateMutation, PolfEventTeamAutogenerateMutationVariables>;

/**
 * __usePolfEventTeamAutogenerateMutation__
 *
 * To run a mutation, you first call `usePolfEventTeamAutogenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventTeamAutogenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventTeamAutogenerateMutation, { data, loading, error }] = usePolfEventTeamAutogenerateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      teamSize: // value for 'teamSize'
 *   },
 * });
 */
export function usePolfEventTeamAutogenerateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventTeamAutogenerateMutation, PolfEventTeamAutogenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventTeamAutogenerateMutation, PolfEventTeamAutogenerateMutationVariables>(PolfEventTeamAutogenerateDocument, options);
      }
export type PolfEventTeamAutogenerateMutationHookResult = ReturnType<typeof usePolfEventTeamAutogenerateMutation>;
export type PolfEventTeamAutogenerateMutationResult = Apollo.MutationResult<PolfEventTeamAutogenerateMutation>;
export const PolfEventsDocument = gql`
    query polfEvents {
  polfEvents {
    id
    name
    date
    status
    mode
    ranking
    matchPlay
    hcpFactor
    course {
      id
      name
    }
    playerCount
    teamCount
    teamlessPlayerCount
    flightCount
  }
}
    `;

/**
 * __usePolfEventsQuery__
 *
 * To run a query within a React component, call `usePolfEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePolfEventsQuery(baseOptions?: Apollo.QueryHookOptions<PolfEventsQuery, PolfEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventsQuery, PolfEventsQueryVariables>(PolfEventsDocument, options);
      }
export function usePolfEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventsQuery, PolfEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventsQuery, PolfEventsQueryVariables>(PolfEventsDocument, options);
        }
// @ts-ignore
export function usePolfEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventsQuery, PolfEventsQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventsQuery, PolfEventsQueryVariables>;
export function usePolfEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventsQuery, PolfEventsQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventsQuery | undefined, PolfEventsQueryVariables>;
export function usePolfEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventsQuery, PolfEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventsQuery, PolfEventsQueryVariables>(PolfEventsDocument, options);
        }
export type PolfEventsQueryHookResult = ReturnType<typeof usePolfEventsQuery>;
export type PolfEventsLazyQueryHookResult = ReturnType<typeof usePolfEventsLazyQuery>;
export type PolfEventsSuspenseQueryHookResult = ReturnType<typeof usePolfEventsSuspenseQuery>;
export type PolfEventsQueryResult = Apollo.QueryResult<PolfEventsQuery, PolfEventsQueryVariables>;
export const CoursesForEventCreateDocument = gql`
    query coursesForEventCreate {
  courses {
    id
    name
    status
    isValid
  }
}
    `;

/**
 * __useCoursesForEventCreateQuery__
 *
 * To run a query within a React component, call `useCoursesForEventCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursesForEventCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursesForEventCreateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoursesForEventCreateQuery(baseOptions?: Apollo.QueryHookOptions<CoursesForEventCreateQuery, CoursesForEventCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursesForEventCreateQuery, CoursesForEventCreateQueryVariables>(CoursesForEventCreateDocument, options);
      }
export function useCoursesForEventCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursesForEventCreateQuery, CoursesForEventCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursesForEventCreateQuery, CoursesForEventCreateQueryVariables>(CoursesForEventCreateDocument, options);
        }
// @ts-ignore
export function useCoursesForEventCreateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CoursesForEventCreateQuery, CoursesForEventCreateQueryVariables>): Apollo.UseSuspenseQueryResult<CoursesForEventCreateQuery, CoursesForEventCreateQueryVariables>;
export function useCoursesForEventCreateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoursesForEventCreateQuery, CoursesForEventCreateQueryVariables>): Apollo.UseSuspenseQueryResult<CoursesForEventCreateQuery | undefined, CoursesForEventCreateQueryVariables>;
export function useCoursesForEventCreateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoursesForEventCreateQuery, CoursesForEventCreateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CoursesForEventCreateQuery, CoursesForEventCreateQueryVariables>(CoursesForEventCreateDocument, options);
        }
export type CoursesForEventCreateQueryHookResult = ReturnType<typeof useCoursesForEventCreateQuery>;
export type CoursesForEventCreateLazyQueryHookResult = ReturnType<typeof useCoursesForEventCreateLazyQuery>;
export type CoursesForEventCreateSuspenseQueryHookResult = ReturnType<typeof useCoursesForEventCreateSuspenseQuery>;
export type CoursesForEventCreateQueryResult = Apollo.QueryResult<CoursesForEventCreateQuery, CoursesForEventCreateQueryVariables>;
export const PolfEventCreateDocument = gql`
    mutation polfEventCreate($createPolfEventDto: CreatePolfEventDto!) {
  polfEventCreate(createPolfEventDto: $createPolfEventDto) {
    id
    name
    date
    mode
    status
  }
}
    `;
export type PolfEventCreateMutationFn = Apollo.MutationFunction<PolfEventCreateMutation, PolfEventCreateMutationVariables>;

/**
 * __usePolfEventCreateMutation__
 *
 * To run a mutation, you first call `usePolfEventCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventCreateMutation, { data, loading, error }] = usePolfEventCreateMutation({
 *   variables: {
 *      createPolfEventDto: // value for 'createPolfEventDto'
 *   },
 * });
 */
export function usePolfEventCreateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventCreateMutation, PolfEventCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventCreateMutation, PolfEventCreateMutationVariables>(PolfEventCreateDocument, options);
      }
export type PolfEventCreateMutationHookResult = ReturnType<typeof usePolfEventCreateMutation>;
export type PolfEventCreateMutationResult = Apollo.MutationResult<PolfEventCreateMutation>;
export const PolfEventDocument = gql`
    query polfEvent($polfEventId: ID!) {
  polfEvent(polfEventId: $polfEventId) {
    id
    name
    date
    nanoId
    status
    golfFinishedAt
    isTournamentOver
    hasPokerPhase
    mode
    ranking
    matchPlay
    hcpFactor
    startingStackChips
    segments {
      ordinal
      fromHole
      toHole
      format
    }
    course {
      id
      name
      isValid
      tees {
        id
        teeName
        courseRating
        slope
        par
        default
      }
      holes {
        id
        number
        par
        index
      }
    }
    registration {
      enabled
      playerPicksTee
      price {
        amountInCents
      }
      recruitment {
        enabled
        amountInCents
      }
    }
    chipValues {
      id
      startStack
      stablefordPoint
      holeInOne
      eagle
      birdie
      flightBonus
      flightBonusEnabled
    }
    playerCount
    teamCount
    teamlessPlayerCount
    flightCount
  }
}
    `;

/**
 * __usePolfEventQuery__
 *
 * To run a query within a React component, call `usePolfEventQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventQuery(baseOptions: Apollo.QueryHookOptions<PolfEventQuery, PolfEventQueryVariables> & ({ variables: PolfEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventQuery, PolfEventQueryVariables>(PolfEventDocument, options);
      }
export function usePolfEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventQuery, PolfEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventQuery, PolfEventQueryVariables>(PolfEventDocument, options);
        }
// @ts-ignore
export function usePolfEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventQuery, PolfEventQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventQuery, PolfEventQueryVariables>;
export function usePolfEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventQuery, PolfEventQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventQuery | undefined, PolfEventQueryVariables>;
export function usePolfEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventQuery, PolfEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventQuery, PolfEventQueryVariables>(PolfEventDocument, options);
        }
export type PolfEventQueryHookResult = ReturnType<typeof usePolfEventQuery>;
export type PolfEventLazyQueryHookResult = ReturnType<typeof usePolfEventLazyQuery>;
export type PolfEventSuspenseQueryHookResult = ReturnType<typeof usePolfEventSuspenseQuery>;
export type PolfEventQueryResult = Apollo.QueryResult<PolfEventQuery, PolfEventQueryVariables>;
export const PolfEventStartDocument = gql`
    mutation polfEventStart($polfEventId: ID!) {
  polfEventStartPolfEvent(polfEventId: $polfEventId) {
    id
    status
  }
}
    `;
export type PolfEventStartMutationFn = Apollo.MutationFunction<PolfEventStartMutation, PolfEventStartMutationVariables>;

/**
 * __usePolfEventStartMutation__
 *
 * To run a mutation, you first call `usePolfEventStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventStartMutation, { data, loading, error }] = usePolfEventStartMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventStartMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventStartMutation, PolfEventStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventStartMutation, PolfEventStartMutationVariables>(PolfEventStartDocument, options);
      }
export type PolfEventStartMutationHookResult = ReturnType<typeof usePolfEventStartMutation>;
export type PolfEventStartMutationResult = Apollo.MutationResult<PolfEventStartMutation>;
export const PolfEventSendInvitesDocument = gql`
    mutation polfEventSendInvites($polfEventId: ID!) {
  polfEventSendInvites(polfEventId: $polfEventId) {
    batchId
    queued
    skipped
  }
}
    `;
export type PolfEventSendInvitesMutationFn = Apollo.MutationFunction<PolfEventSendInvitesMutation, PolfEventSendInvitesMutationVariables>;

/**
 * __usePolfEventSendInvitesMutation__
 *
 * To run a mutation, you first call `usePolfEventSendInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventSendInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventSendInvitesMutation, { data, loading, error }] = usePolfEventSendInvitesMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventSendInvitesMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventSendInvitesMutation, PolfEventSendInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventSendInvitesMutation, PolfEventSendInvitesMutationVariables>(PolfEventSendInvitesDocument, options);
      }
export type PolfEventSendInvitesMutationHookResult = ReturnType<typeof usePolfEventSendInvitesMutation>;
export type PolfEventSendInvitesMutationResult = Apollo.MutationResult<PolfEventSendInvitesMutation>;
export const PolfEventFinishDocument = gql`
    mutation polfEventFinish($polfEventId: ID!) {
  polfEventFinishPolfEvent(polfEventId: $polfEventId) {
    id
    status
  }
}
    `;
export type PolfEventFinishMutationFn = Apollo.MutationFunction<PolfEventFinishMutation, PolfEventFinishMutationVariables>;

/**
 * __usePolfEventFinishMutation__
 *
 * To run a mutation, you first call `usePolfEventFinishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventFinishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventFinishMutation, { data, loading, error }] = usePolfEventFinishMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventFinishMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventFinishMutation, PolfEventFinishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventFinishMutation, PolfEventFinishMutationVariables>(PolfEventFinishDocument, options);
      }
export type PolfEventFinishMutationHookResult = ReturnType<typeof usePolfEventFinishMutation>;
export type PolfEventFinishMutationResult = Apollo.MutationResult<PolfEventFinishMutation>;
export const PolfEventReopenDocument = gql`
    mutation polfEventReopen($polfEventId: ID!) {
  polfEventReopenPolfEvent(polfEventId: $polfEventId) {
    id
    status
  }
}
    `;
export type PolfEventReopenMutationFn = Apollo.MutationFunction<PolfEventReopenMutation, PolfEventReopenMutationVariables>;

/**
 * __usePolfEventReopenMutation__
 *
 * To run a mutation, you first call `usePolfEventReopenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventReopenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventReopenMutation, { data, loading, error }] = usePolfEventReopenMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventReopenMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventReopenMutation, PolfEventReopenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventReopenMutation, PolfEventReopenMutationVariables>(PolfEventReopenDocument, options);
      }
export type PolfEventReopenMutationHookResult = ReturnType<typeof usePolfEventReopenMutation>;
export type PolfEventReopenMutationResult = Apollo.MutationResult<PolfEventReopenMutation>;
export const PolfEventCloseDocument = gql`
    mutation polfEventClose($polfEventId: ID!) {
  polfEventClosePolfEvent(polfEventId: $polfEventId) {
    id
    status
  }
}
    `;
export type PolfEventCloseMutationFn = Apollo.MutationFunction<PolfEventCloseMutation, PolfEventCloseMutationVariables>;

/**
 * __usePolfEventCloseMutation__
 *
 * To run a mutation, you first call `usePolfEventCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventCloseMutation, { data, loading, error }] = usePolfEventCloseMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventCloseMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventCloseMutation, PolfEventCloseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventCloseMutation, PolfEventCloseMutationVariables>(PolfEventCloseDocument, options);
      }
export type PolfEventCloseMutationHookResult = ReturnType<typeof usePolfEventCloseMutation>;
export type PolfEventCloseMutationResult = Apollo.MutationResult<PolfEventCloseMutation>;
export const PolfEventDeleteDocument = gql`
    mutation polfEventDelete($polfEventId: ID!) {
  polfEventDelete(polfEventId: $polfEventId) {
    id
  }
}
    `;
export type PolfEventDeleteMutationFn = Apollo.MutationFunction<PolfEventDeleteMutation, PolfEventDeleteMutationVariables>;

/**
 * __usePolfEventDeleteMutation__
 *
 * To run a mutation, you first call `usePolfEventDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventDeleteMutation, { data, loading, error }] = usePolfEventDeleteMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventDeleteMutation, PolfEventDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventDeleteMutation, PolfEventDeleteMutationVariables>(PolfEventDeleteDocument, options);
      }
export type PolfEventDeleteMutationHookResult = ReturnType<typeof usePolfEventDeleteMutation>;
export type PolfEventDeleteMutationResult = Apollo.MutationResult<PolfEventDeleteMutation>;
export const PolfEventUpdateDocument = gql`
    mutation polfEventUpdate($polfEventId: ID!, $updatePolfEventDto: UpdatePolfEventDto!) {
  polfEventUpdate(
    polfEventId: $polfEventId
    updatePolfEventDto: $updatePolfEventDto
  ) {
    id
    name
    date
    hcpFactor
    ranking
    matchPlay
    registration {
      enabled
      playerPicksTee
      price {
        amountInCents
      }
      recruitment {
        enabled
        amountInCents
      }
    }
  }
}
    `;
export type PolfEventUpdateMutationFn = Apollo.MutationFunction<PolfEventUpdateMutation, PolfEventUpdateMutationVariables>;

/**
 * __usePolfEventUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventUpdateMutation, { data, loading, error }] = usePolfEventUpdateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      updatePolfEventDto: // value for 'updatePolfEventDto'
 *   },
 * });
 */
export function usePolfEventUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventUpdateMutation, PolfEventUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventUpdateMutation, PolfEventUpdateMutationVariables>(PolfEventUpdateDocument, options);
      }
export type PolfEventUpdateMutationHookResult = ReturnType<typeof usePolfEventUpdateMutation>;
export type PolfEventUpdateMutationResult = Apollo.MutationResult<PolfEventUpdateMutation>;
export const PolfEventChipValuesUpdateDocument = gql`
    mutation polfEventChipValuesUpdate($polfEventId: ID!, $updatePolfEventChipValues: UpdatePolfEventChipValues!) {
  polfEventChipValuesUpdate(
    polfEventId: $polfEventId
    updatePolfEventChipValues: $updatePolfEventChipValues
  ) {
    id
    chipValues {
      id
      startStack
      stablefordPoint
      holeInOne
      eagle
      birdie
      flightBonus
      flightBonusEnabled
    }
  }
}
    `;
export type PolfEventChipValuesUpdateMutationFn = Apollo.MutationFunction<PolfEventChipValuesUpdateMutation, PolfEventChipValuesUpdateMutationVariables>;

/**
 * __usePolfEventChipValuesUpdateMutation__
 *
 * To run a mutation, you first call `usePolfEventChipValuesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventChipValuesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventChipValuesUpdateMutation, { data, loading, error }] = usePolfEventChipValuesUpdateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      updatePolfEventChipValues: // value for 'updatePolfEventChipValues'
 *   },
 * });
 */
export function usePolfEventChipValuesUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventChipValuesUpdateMutation, PolfEventChipValuesUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventChipValuesUpdateMutation, PolfEventChipValuesUpdateMutationVariables>(PolfEventChipValuesUpdateDocument, options);
      }
export type PolfEventChipValuesUpdateMutationHookResult = ReturnType<typeof usePolfEventChipValuesUpdateMutation>;
export type PolfEventChipValuesUpdateMutationResult = Apollo.MutationResult<PolfEventChipValuesUpdateMutation>;
export const MeDocument = gql`
    query me {
  me {
    id
    name
    email
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
// @ts-ignore
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery | undefined, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MySignInStatusDocument = gql`
    query mySignInStatus {
  mySignInStatus {
    password
    twoFactor
    providers
  }
}
    `;

/**
 * __useMySignInStatusQuery__
 *
 * To run a query within a React component, call `useMySignInStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySignInStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySignInStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySignInStatusQuery(baseOptions?: Apollo.QueryHookOptions<MySignInStatusQuery, MySignInStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySignInStatusQuery, MySignInStatusQueryVariables>(MySignInStatusDocument, options);
      }
export function useMySignInStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySignInStatusQuery, MySignInStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySignInStatusQuery, MySignInStatusQueryVariables>(MySignInStatusDocument, options);
        }
// @ts-ignore
export function useMySignInStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MySignInStatusQuery, MySignInStatusQueryVariables>): Apollo.UseSuspenseQueryResult<MySignInStatusQuery, MySignInStatusQueryVariables>;
export function useMySignInStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MySignInStatusQuery, MySignInStatusQueryVariables>): Apollo.UseSuspenseQueryResult<MySignInStatusQuery | undefined, MySignInStatusQueryVariables>;
export function useMySignInStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MySignInStatusQuery, MySignInStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MySignInStatusQuery, MySignInStatusQueryVariables>(MySignInStatusDocument, options);
        }
export type MySignInStatusQueryHookResult = ReturnType<typeof useMySignInStatusQuery>;
export type MySignInStatusLazyQueryHookResult = ReturnType<typeof useMySignInStatusLazyQuery>;
export type MySignInStatusSuspenseQueryHookResult = ReturnType<typeof useMySignInStatusSuspenseQuery>;
export type MySignInStatusQueryResult = Apollo.QueryResult<MySignInStatusQuery, MySignInStatusQueryVariables>;
export const UpdateMyProfileDocument = gql`
    mutation updateMyProfile($input: UpdateMyProfileInput!) {
  updateMyProfile(input: $input) {
    id
    name
    email
  }
}
    `;
export type UpdateMyProfileMutationFn = Apollo.MutationFunction<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>;

/**
 * __useUpdateMyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateMyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyProfileMutation, { data, loading, error }] = useUpdateMyProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>(UpdateMyProfileDocument, options);
      }
export type UpdateMyProfileMutationHookResult = ReturnType<typeof useUpdateMyProfileMutation>;
export type UpdateMyProfileMutationResult = Apollo.MutationResult<UpdateMyProfileMutation>;
export const RemoveMyPasswordDocument = gql`
    mutation removeMyPassword($idToken: String!) {
  removeMyPassword(idToken: $idToken) {
    password
    twoFactor
    providers
  }
}
    `;
export type RemoveMyPasswordMutationFn = Apollo.MutationFunction<RemoveMyPasswordMutation, RemoveMyPasswordMutationVariables>;

/**
 * __useRemoveMyPasswordMutation__
 *
 * To run a mutation, you first call `useRemoveMyPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMyPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMyPasswordMutation, { data, loading, error }] = useRemoveMyPasswordMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *   },
 * });
 */
export function useRemoveMyPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMyPasswordMutation, RemoveMyPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMyPasswordMutation, RemoveMyPasswordMutationVariables>(RemoveMyPasswordDocument, options);
      }
export type RemoveMyPasswordMutationHookResult = ReturnType<typeof useRemoveMyPasswordMutation>;
export type RemoveMyPasswordMutationResult = Apollo.MutationResult<RemoveMyPasswordMutation>;
export const OperatorPokerViewDocument = gql`
    query OperatorPokerView {
  operatorPokerView {
    role
    poker {
      id
      status
      currentLevelIndex
      currentInBreak
      currentLevelStartedAt
      currentLevelPausedAt
      tableCount
      seatsPerTable
      finalTableRedrawnAt
      polfEvent {
        id
        name
      }
      levels {
        index
        smallBlind
        bigBlind
        ante
        durationMinutes
        breakAfterMinutes
      }
      seats {
        id
        tableNumber
        seatNumber
        currentStack
        startingStack
        eliminated
        withdrawn
        finishingPosition
        isLocked
        polfEventPlayer {
          id
          name
        }
      }
      balancingSuggestion {
        kind
        reason
        tableNumber
        moves {
          seatId
          tableNumber
          seatNumber
        }
      }
    }
  }
}
    `;

/**
 * __useOperatorPokerViewQuery__
 *
 * To run a query within a React component, call `useOperatorPokerViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorPokerViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorPokerViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useOperatorPokerViewQuery(baseOptions?: Apollo.QueryHookOptions<OperatorPokerViewQuery, OperatorPokerViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorPokerViewQuery, OperatorPokerViewQueryVariables>(OperatorPokerViewDocument, options);
      }
export function useOperatorPokerViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorPokerViewQuery, OperatorPokerViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorPokerViewQuery, OperatorPokerViewQueryVariables>(OperatorPokerViewDocument, options);
        }
// @ts-ignore
export function useOperatorPokerViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorPokerViewQuery, OperatorPokerViewQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorPokerViewQuery, OperatorPokerViewQueryVariables>;
export function useOperatorPokerViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorPokerViewQuery, OperatorPokerViewQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorPokerViewQuery | undefined, OperatorPokerViewQueryVariables>;
export function useOperatorPokerViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorPokerViewQuery, OperatorPokerViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorPokerViewQuery, OperatorPokerViewQueryVariables>(OperatorPokerViewDocument, options);
        }
export type OperatorPokerViewQueryHookResult = ReturnType<typeof useOperatorPokerViewQuery>;
export type OperatorPokerViewLazyQueryHookResult = ReturnType<typeof useOperatorPokerViewLazyQuery>;
export type OperatorPokerViewSuspenseQueryHookResult = ReturnType<typeof useOperatorPokerViewSuspenseQuery>;
export type OperatorPokerViewQueryResult = Apollo.QueryResult<OperatorPokerViewQuery, OperatorPokerViewQueryVariables>;
export const OperatorClockPauseDocument = gql`
    mutation OperatorClockPause($eventId: ID!, $pokerId: ID!) {
  polfEventPokerClockPause(polfEventId: $eventId, pokerId: $pokerId) {
    id
    status
  }
}
    `;
export type OperatorClockPauseMutationFn = Apollo.MutationFunction<OperatorClockPauseMutation, OperatorClockPauseMutationVariables>;

/**
 * __useOperatorClockPauseMutation__
 *
 * To run a mutation, you first call `useOperatorClockPauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorClockPauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorClockPauseMutation, { data, loading, error }] = useOperatorClockPauseMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function useOperatorClockPauseMutation(baseOptions?: Apollo.MutationHookOptions<OperatorClockPauseMutation, OperatorClockPauseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorClockPauseMutation, OperatorClockPauseMutationVariables>(OperatorClockPauseDocument, options);
      }
export type OperatorClockPauseMutationHookResult = ReturnType<typeof useOperatorClockPauseMutation>;
export type OperatorClockPauseMutationResult = Apollo.MutationResult<OperatorClockPauseMutation>;
export const OperatorClockResumeDocument = gql`
    mutation OperatorClockResume($eventId: ID!, $pokerId: ID!) {
  polfEventPokerClockResume(polfEventId: $eventId, pokerId: $pokerId) {
    id
    status
  }
}
    `;
export type OperatorClockResumeMutationFn = Apollo.MutationFunction<OperatorClockResumeMutation, OperatorClockResumeMutationVariables>;

/**
 * __useOperatorClockResumeMutation__
 *
 * To run a mutation, you first call `useOperatorClockResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorClockResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorClockResumeMutation, { data, loading, error }] = useOperatorClockResumeMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function useOperatorClockResumeMutation(baseOptions?: Apollo.MutationHookOptions<OperatorClockResumeMutation, OperatorClockResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorClockResumeMutation, OperatorClockResumeMutationVariables>(OperatorClockResumeDocument, options);
      }
export type OperatorClockResumeMutationHookResult = ReturnType<typeof useOperatorClockResumeMutation>;
export type OperatorClockResumeMutationResult = Apollo.MutationResult<OperatorClockResumeMutation>;
export const OperatorLevelAdvanceDocument = gql`
    mutation OperatorLevelAdvance($eventId: ID!, $pokerId: ID!, $direction: LevelDirection!) {
  polfEventPokerLevelAdvance(
    polfEventId: $eventId
    pokerId: $pokerId
    direction: $direction
  ) {
    id
    currentLevelIndex
  }
}
    `;
export type OperatorLevelAdvanceMutationFn = Apollo.MutationFunction<OperatorLevelAdvanceMutation, OperatorLevelAdvanceMutationVariables>;

/**
 * __useOperatorLevelAdvanceMutation__
 *
 * To run a mutation, you first call `useOperatorLevelAdvanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorLevelAdvanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorLevelAdvanceMutation, { data, loading, error }] = useOperatorLevelAdvanceMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useOperatorLevelAdvanceMutation(baseOptions?: Apollo.MutationHookOptions<OperatorLevelAdvanceMutation, OperatorLevelAdvanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorLevelAdvanceMutation, OperatorLevelAdvanceMutationVariables>(OperatorLevelAdvanceDocument, options);
      }
export type OperatorLevelAdvanceMutationHookResult = ReturnType<typeof useOperatorLevelAdvanceMutation>;
export type OperatorLevelAdvanceMutationResult = Apollo.MutationResult<OperatorLevelAdvanceMutation>;
export const OperatorSeatStackUpdateDocument = gql`
    mutation OperatorSeatStackUpdate($eventId: ID!, $seatId: ID!, $stack: Float!) {
  polfEventPokerSeatStackUpdate(
    polfEventId: $eventId
    seatId: $seatId
    currentStack: $stack
  ) {
    id
    currentStack
  }
}
    `;
export type OperatorSeatStackUpdateMutationFn = Apollo.MutationFunction<OperatorSeatStackUpdateMutation, OperatorSeatStackUpdateMutationVariables>;

/**
 * __useOperatorSeatStackUpdateMutation__
 *
 * To run a mutation, you first call `useOperatorSeatStackUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorSeatStackUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorSeatStackUpdateMutation, { data, loading, error }] = useOperatorSeatStackUpdateMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      seatId: // value for 'seatId'
 *      stack: // value for 'stack'
 *   },
 * });
 */
export function useOperatorSeatStackUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OperatorSeatStackUpdateMutation, OperatorSeatStackUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorSeatStackUpdateMutation, OperatorSeatStackUpdateMutationVariables>(OperatorSeatStackUpdateDocument, options);
      }
export type OperatorSeatStackUpdateMutationHookResult = ReturnType<typeof useOperatorSeatStackUpdateMutation>;
export type OperatorSeatStackUpdateMutationResult = Apollo.MutationResult<OperatorSeatStackUpdateMutation>;
export const OperatorSeatEliminateDocument = gql`
    mutation OperatorSeatEliminate($eventId: ID!, $seatId: ID!) {
  polfEventPokerSeatEliminate(polfEventId: $eventId, seatId: $seatId) {
    id
    status
  }
}
    `;
export type OperatorSeatEliminateMutationFn = Apollo.MutationFunction<OperatorSeatEliminateMutation, OperatorSeatEliminateMutationVariables>;

/**
 * __useOperatorSeatEliminateMutation__
 *
 * To run a mutation, you first call `useOperatorSeatEliminateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorSeatEliminateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorSeatEliminateMutation, { data, loading, error }] = useOperatorSeatEliminateMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      seatId: // value for 'seatId'
 *   },
 * });
 */
export function useOperatorSeatEliminateMutation(baseOptions?: Apollo.MutationHookOptions<OperatorSeatEliminateMutation, OperatorSeatEliminateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorSeatEliminateMutation, OperatorSeatEliminateMutationVariables>(OperatorSeatEliminateDocument, options);
      }
export type OperatorSeatEliminateMutationHookResult = ReturnType<typeof useOperatorSeatEliminateMutation>;
export type OperatorSeatEliminateMutationResult = Apollo.MutationResult<OperatorSeatEliminateMutation>;
export const OperatorSeatRestoreDocument = gql`
    mutation OperatorSeatRestore($eventId: ID!, $seatId: ID!) {
  polfEventPokerSeatRestore(polfEventId: $eventId, seatId: $seatId) {
    id
    status
  }
}
    `;
export type OperatorSeatRestoreMutationFn = Apollo.MutationFunction<OperatorSeatRestoreMutation, OperatorSeatRestoreMutationVariables>;

/**
 * __useOperatorSeatRestoreMutation__
 *
 * To run a mutation, you first call `useOperatorSeatRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorSeatRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorSeatRestoreMutation, { data, loading, error }] = useOperatorSeatRestoreMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      seatId: // value for 'seatId'
 *   },
 * });
 */
export function useOperatorSeatRestoreMutation(baseOptions?: Apollo.MutationHookOptions<OperatorSeatRestoreMutation, OperatorSeatRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorSeatRestoreMutation, OperatorSeatRestoreMutationVariables>(OperatorSeatRestoreDocument, options);
      }
export type OperatorSeatRestoreMutationHookResult = ReturnType<typeof useOperatorSeatRestoreMutation>;
export type OperatorSeatRestoreMutationResult = Apollo.MutationResult<OperatorSeatRestoreMutation>;
export const OperatorReorderEliminationDocument = gql`
    mutation OperatorReorderElimination($eventId: ID!, $seatId: ID!, $direction: ReorderDirection!) {
  polfEventPokerReorderElimination(
    polfEventId: $eventId
    seatId: $seatId
    direction: $direction
  ) {
    id
    status
  }
}
    `;
export type OperatorReorderEliminationMutationFn = Apollo.MutationFunction<OperatorReorderEliminationMutation, OperatorReorderEliminationMutationVariables>;

/**
 * __useOperatorReorderEliminationMutation__
 *
 * To run a mutation, you first call `useOperatorReorderEliminationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorReorderEliminationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorReorderEliminationMutation, { data, loading, error }] = useOperatorReorderEliminationMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      seatId: // value for 'seatId'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useOperatorReorderEliminationMutation(baseOptions?: Apollo.MutationHookOptions<OperatorReorderEliminationMutation, OperatorReorderEliminationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorReorderEliminationMutation, OperatorReorderEliminationMutationVariables>(OperatorReorderEliminationDocument, options);
      }
export type OperatorReorderEliminationMutationHookResult = ReturnType<typeof useOperatorReorderEliminationMutation>;
export type OperatorReorderEliminationMutationResult = Apollo.MutationResult<OperatorReorderEliminationMutation>;
export const OperatorSeatWithdrawDocument = gql`
    mutation OperatorSeatWithdraw($eventId: ID!, $seatId: ID!) {
  polfEventPokerSeatWithdraw(polfEventId: $eventId, seatId: $seatId) {
    id
  }
}
    `;
export type OperatorSeatWithdrawMutationFn = Apollo.MutationFunction<OperatorSeatWithdrawMutation, OperatorSeatWithdrawMutationVariables>;

/**
 * __useOperatorSeatWithdrawMutation__
 *
 * To run a mutation, you first call `useOperatorSeatWithdrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorSeatWithdrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorSeatWithdrawMutation, { data, loading, error }] = useOperatorSeatWithdrawMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      seatId: // value for 'seatId'
 *   },
 * });
 */
export function useOperatorSeatWithdrawMutation(baseOptions?: Apollo.MutationHookOptions<OperatorSeatWithdrawMutation, OperatorSeatWithdrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorSeatWithdrawMutation, OperatorSeatWithdrawMutationVariables>(OperatorSeatWithdrawDocument, options);
      }
export type OperatorSeatWithdrawMutationHookResult = ReturnType<typeof useOperatorSeatWithdrawMutation>;
export type OperatorSeatWithdrawMutationResult = Apollo.MutationResult<OperatorSeatWithdrawMutation>;
export const OperatorAddTableDocument = gql`
    mutation OperatorAddTable($eventId: ID!, $pokerId: ID!) {
  polfEventPokerAddTable(polfEventId: $eventId, pokerId: $pokerId) {
    id
    tableCount
  }
}
    `;
export type OperatorAddTableMutationFn = Apollo.MutationFunction<OperatorAddTableMutation, OperatorAddTableMutationVariables>;

/**
 * __useOperatorAddTableMutation__
 *
 * To run a mutation, you first call `useOperatorAddTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAddTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAddTableMutation, { data, loading, error }] = useOperatorAddTableMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function useOperatorAddTableMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAddTableMutation, OperatorAddTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorAddTableMutation, OperatorAddTableMutationVariables>(OperatorAddTableDocument, options);
      }
export type OperatorAddTableMutationHookResult = ReturnType<typeof useOperatorAddTableMutation>;
export type OperatorAddTableMutationResult = Apollo.MutationResult<OperatorAddTableMutation>;
export const OperatorRemoveLastTableDocument = gql`
    mutation OperatorRemoveLastTable($eventId: ID!, $pokerId: ID!) {
  polfEventPokerRemoveLastTable(polfEventId: $eventId, pokerId: $pokerId) {
    id
    tableCount
  }
}
    `;
export type OperatorRemoveLastTableMutationFn = Apollo.MutationFunction<OperatorRemoveLastTableMutation, OperatorRemoveLastTableMutationVariables>;

/**
 * __useOperatorRemoveLastTableMutation__
 *
 * To run a mutation, you first call `useOperatorRemoveLastTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorRemoveLastTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorRemoveLastTableMutation, { data, loading, error }] = useOperatorRemoveLastTableMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function useOperatorRemoveLastTableMutation(baseOptions?: Apollo.MutationHookOptions<OperatorRemoveLastTableMutation, OperatorRemoveLastTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorRemoveLastTableMutation, OperatorRemoveLastTableMutationVariables>(OperatorRemoveLastTableDocument, options);
      }
export type OperatorRemoveLastTableMutationHookResult = ReturnType<typeof useOperatorRemoveLastTableMutation>;
export type OperatorRemoveLastTableMutationResult = Apollo.MutationResult<OperatorRemoveLastTableMutation>;
export const OperatorSeatsPerTableUpdateDocument = gql`
    mutation OperatorSeatsPerTableUpdate($eventId: ID!, $pokerId: ID!, $seatsPerTable: Float!) {
  polfEventPokerSeatsPerTableUpdate(
    polfEventId: $eventId
    pokerId: $pokerId
    seatsPerTable: $seatsPerTable
  ) {
    id
    seatsPerTable
  }
}
    `;
export type OperatorSeatsPerTableUpdateMutationFn = Apollo.MutationFunction<OperatorSeatsPerTableUpdateMutation, OperatorSeatsPerTableUpdateMutationVariables>;

/**
 * __useOperatorSeatsPerTableUpdateMutation__
 *
 * To run a mutation, you first call `useOperatorSeatsPerTableUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorSeatsPerTableUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorSeatsPerTableUpdateMutation, { data, loading, error }] = useOperatorSeatsPerTableUpdateMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *      seatsPerTable: // value for 'seatsPerTable'
 *   },
 * });
 */
export function useOperatorSeatsPerTableUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OperatorSeatsPerTableUpdateMutation, OperatorSeatsPerTableUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorSeatsPerTableUpdateMutation, OperatorSeatsPerTableUpdateMutationVariables>(OperatorSeatsPerTableUpdateDocument, options);
      }
export type OperatorSeatsPerTableUpdateMutationHookResult = ReturnType<typeof useOperatorSeatsPerTableUpdateMutation>;
export type OperatorSeatsPerTableUpdateMutationResult = Apollo.MutationResult<OperatorSeatsPerTableUpdateMutation>;
export const OperatorClockStartDocument = gql`
    mutation OperatorClockStart($eventId: ID!, $pokerId: ID!) {
  polfEventPokerClockStart(polfEventId: $eventId, pokerId: $pokerId) {
    id
    status
  }
}
    `;
export type OperatorClockStartMutationFn = Apollo.MutationFunction<OperatorClockStartMutation, OperatorClockStartMutationVariables>;

/**
 * __useOperatorClockStartMutation__
 *
 * To run a mutation, you first call `useOperatorClockStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorClockStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorClockStartMutation, { data, loading, error }] = useOperatorClockStartMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function useOperatorClockStartMutation(baseOptions?: Apollo.MutationHookOptions<OperatorClockStartMutation, OperatorClockStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorClockStartMutation, OperatorClockStartMutationVariables>(OperatorClockStartDocument, options);
      }
export type OperatorClockStartMutationHookResult = ReturnType<typeof useOperatorClockStartMutation>;
export type OperatorClockStartMutationResult = Apollo.MutationResult<OperatorClockStartMutation>;
export const OperatorClockAdjustDocument = gql`
    mutation OperatorClockAdjust($eventId: ID!, $pokerId: ID!, $remainingSeconds: Int!) {
  polfEventPokerClockAdjust(
    polfEventId: $eventId
    pokerId: $pokerId
    remainingSeconds: $remainingSeconds
  ) {
    id
  }
}
    `;
export type OperatorClockAdjustMutationFn = Apollo.MutationFunction<OperatorClockAdjustMutation, OperatorClockAdjustMutationVariables>;

/**
 * __useOperatorClockAdjustMutation__
 *
 * To run a mutation, you first call `useOperatorClockAdjustMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorClockAdjustMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorClockAdjustMutation, { data, loading, error }] = useOperatorClockAdjustMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *      remainingSeconds: // value for 'remainingSeconds'
 *   },
 * });
 */
export function useOperatorClockAdjustMutation(baseOptions?: Apollo.MutationHookOptions<OperatorClockAdjustMutation, OperatorClockAdjustMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorClockAdjustMutation, OperatorClockAdjustMutationVariables>(OperatorClockAdjustDocument, options);
      }
export type OperatorClockAdjustMutationHookResult = ReturnType<typeof useOperatorClockAdjustMutation>;
export type OperatorClockAdjustMutationResult = Apollo.MutationResult<OperatorClockAdjustMutation>;
export const OperatorSeatMoveDocument = gql`
    mutation OperatorSeatMove($eventId: ID!, $input: MoveSeatInput!) {
  polfEventPokerSeatMove(polfEventId: $eventId, input: $input) {
    id
    tableNumber
    seatNumber
  }
}
    `;
export type OperatorSeatMoveMutationFn = Apollo.MutationFunction<OperatorSeatMoveMutation, OperatorSeatMoveMutationVariables>;

/**
 * __useOperatorSeatMoveMutation__
 *
 * To run a mutation, you first call `useOperatorSeatMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorSeatMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorSeatMoveMutation, { data, loading, error }] = useOperatorSeatMoveMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOperatorSeatMoveMutation(baseOptions?: Apollo.MutationHookOptions<OperatorSeatMoveMutation, OperatorSeatMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorSeatMoveMutation, OperatorSeatMoveMutationVariables>(OperatorSeatMoveDocument, options);
      }
export type OperatorSeatMoveMutationHookResult = ReturnType<typeof useOperatorSeatMoveMutation>;
export type OperatorSeatMoveMutationResult = Apollo.MutationResult<OperatorSeatMoveMutation>;
export const OperatorSeatLockToggleDocument = gql`
    mutation OperatorSeatLockToggle($eventId: ID!, $seatId: ID!, $isLocked: Boolean!) {
  polfEventPokerSeatLockToggle(
    polfEventId: $eventId
    seatId: $seatId
    isLocked: $isLocked
  ) {
    id
  }
}
    `;
export type OperatorSeatLockToggleMutationFn = Apollo.MutationFunction<OperatorSeatLockToggleMutation, OperatorSeatLockToggleMutationVariables>;

/**
 * __useOperatorSeatLockToggleMutation__
 *
 * To run a mutation, you first call `useOperatorSeatLockToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorSeatLockToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorSeatLockToggleMutation, { data, loading, error }] = useOperatorSeatLockToggleMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      seatId: // value for 'seatId'
 *      isLocked: // value for 'isLocked'
 *   },
 * });
 */
export function useOperatorSeatLockToggleMutation(baseOptions?: Apollo.MutationHookOptions<OperatorSeatLockToggleMutation, OperatorSeatLockToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorSeatLockToggleMutation, OperatorSeatLockToggleMutationVariables>(OperatorSeatLockToggleDocument, options);
      }
export type OperatorSeatLockToggleMutationHookResult = ReturnType<typeof useOperatorSeatLockToggleMutation>;
export type OperatorSeatLockToggleMutationResult = Apollo.MutationResult<OperatorSeatLockToggleMutation>;
export const OperatorBalancingApplyDocument = gql`
    mutation OperatorBalancingApply($eventId: ID!, $pokerId: ID!) {
  polfEventPokerBalancingApply(polfEventId: $eventId, pokerId: $pokerId) {
    id
  }
}
    `;
export type OperatorBalancingApplyMutationFn = Apollo.MutationFunction<OperatorBalancingApplyMutation, OperatorBalancingApplyMutationVariables>;

/**
 * __useOperatorBalancingApplyMutation__
 *
 * To run a mutation, you first call `useOperatorBalancingApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorBalancingApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorBalancingApplyMutation, { data, loading, error }] = useOperatorBalancingApplyMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function useOperatorBalancingApplyMutation(baseOptions?: Apollo.MutationHookOptions<OperatorBalancingApplyMutation, OperatorBalancingApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorBalancingApplyMutation, OperatorBalancingApplyMutationVariables>(OperatorBalancingApplyDocument, options);
      }
export type OperatorBalancingApplyMutationHookResult = ReturnType<typeof useOperatorBalancingApplyMutation>;
export type OperatorBalancingApplyMutationResult = Apollo.MutationResult<OperatorBalancingApplyMutation>;
export const OperatorFinalTableRedrawDocument = gql`
    mutation OperatorFinalTableRedraw($eventId: ID!, $pokerId: ID!) {
  polfEventPokerFinalTableRedraw(polfEventId: $eventId, pokerId: $pokerId) {
    id
    finalTableRedrawnAt
  }
}
    `;
export type OperatorFinalTableRedrawMutationFn = Apollo.MutationFunction<OperatorFinalTableRedrawMutation, OperatorFinalTableRedrawMutationVariables>;

/**
 * __useOperatorFinalTableRedrawMutation__
 *
 * To run a mutation, you first call `useOperatorFinalTableRedrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorFinalTableRedrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorFinalTableRedrawMutation, { data, loading, error }] = useOperatorFinalTableRedrawMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *   },
 * });
 */
export function useOperatorFinalTableRedrawMutation(baseOptions?: Apollo.MutationHookOptions<OperatorFinalTableRedrawMutation, OperatorFinalTableRedrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorFinalTableRedrawMutation, OperatorFinalTableRedrawMutationVariables>(OperatorFinalTableRedrawDocument, options);
      }
export type OperatorFinalTableRedrawMutationHookResult = ReturnType<typeof useOperatorFinalTableRedrawMutation>;
export type OperatorFinalTableRedrawMutationResult = Apollo.MutationResult<OperatorFinalTableRedrawMutation>;
export const OperatorBreakTableDocument = gql`
    mutation OperatorBreakTable($eventId: ID!, $pokerId: ID!, $tableNumber: Int!) {
  polfEventPokerBreakTable(
    polfEventId: $eventId
    pokerId: $pokerId
    tableNumber: $tableNumber
  ) {
    poker {
      id
      tableCount
    }
    moves {
      seatId
      tableNumber
      seatNumber
    }
  }
}
    `;
export type OperatorBreakTableMutationFn = Apollo.MutationFunction<OperatorBreakTableMutation, OperatorBreakTableMutationVariables>;

/**
 * __useOperatorBreakTableMutation__
 *
 * To run a mutation, you first call `useOperatorBreakTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorBreakTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorBreakTableMutation, { data, loading, error }] = useOperatorBreakTableMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *      tableNumber: // value for 'tableNumber'
 *   },
 * });
 */
export function useOperatorBreakTableMutation(baseOptions?: Apollo.MutationHookOptions<OperatorBreakTableMutation, OperatorBreakTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorBreakTableMutation, OperatorBreakTableMutationVariables>(OperatorBreakTableDocument, options);
      }
export type OperatorBreakTableMutationHookResult = ReturnType<typeof useOperatorBreakTableMutation>;
export type OperatorBreakTableMutationResult = Apollo.MutationResult<OperatorBreakTableMutation>;
export const OperatorBlindStructureUpdateDocument = gql`
    mutation OperatorBlindStructureUpdate($eventId: ID!, $pokerId: ID!, $input: UpdateBlindStructureInput!) {
  polfEventPokerBlindStructureUpdate(
    polfEventId: $eventId
    pokerId: $pokerId
    input: $input
  ) {
    id
    levels {
      index
      smallBlind
      bigBlind
      ante
      durationMinutes
      breakAfterMinutes
    }
  }
}
    `;
export type OperatorBlindStructureUpdateMutationFn = Apollo.MutationFunction<OperatorBlindStructureUpdateMutation, OperatorBlindStructureUpdateMutationVariables>;

/**
 * __useOperatorBlindStructureUpdateMutation__
 *
 * To run a mutation, you first call `useOperatorBlindStructureUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorBlindStructureUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorBlindStructureUpdateMutation, { data, loading, error }] = useOperatorBlindStructureUpdateMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      pokerId: // value for 'pokerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOperatorBlindStructureUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OperatorBlindStructureUpdateMutation, OperatorBlindStructureUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorBlindStructureUpdateMutation, OperatorBlindStructureUpdateMutationVariables>(OperatorBlindStructureUpdateDocument, options);
      }
export type OperatorBlindStructureUpdateMutationHookResult = ReturnType<typeof useOperatorBlindStructureUpdateMutation>;
export type OperatorBlindStructureUpdateMutationResult = Apollo.MutationResult<OperatorBlindStructureUpdateMutation>;
export const PolfEventOperatorListDocument = gql`
    query polfEventOperatorList($polfEventId: ID!) {
  polfEventOperatorList(polfEventId: $polfEventId) {
    id
    nanoId
    role
    label
    phone
    revokedAt
    createdAt
  }
}
    `;

/**
 * __usePolfEventOperatorListQuery__
 *
 * To run a query within a React component, call `usePolfEventOperatorListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventOperatorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventOperatorListQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventOperatorListQuery(baseOptions: Apollo.QueryHookOptions<PolfEventOperatorListQuery, PolfEventOperatorListQueryVariables> & ({ variables: PolfEventOperatorListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventOperatorListQuery, PolfEventOperatorListQueryVariables>(PolfEventOperatorListDocument, options);
      }
export function usePolfEventOperatorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventOperatorListQuery, PolfEventOperatorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventOperatorListQuery, PolfEventOperatorListQueryVariables>(PolfEventOperatorListDocument, options);
        }
// @ts-ignore
export function usePolfEventOperatorListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventOperatorListQuery, PolfEventOperatorListQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventOperatorListQuery, PolfEventOperatorListQueryVariables>;
export function usePolfEventOperatorListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventOperatorListQuery, PolfEventOperatorListQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventOperatorListQuery | undefined, PolfEventOperatorListQueryVariables>;
export function usePolfEventOperatorListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventOperatorListQuery, PolfEventOperatorListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventOperatorListQuery, PolfEventOperatorListQueryVariables>(PolfEventOperatorListDocument, options);
        }
export type PolfEventOperatorListQueryHookResult = ReturnType<typeof usePolfEventOperatorListQuery>;
export type PolfEventOperatorListLazyQueryHookResult = ReturnType<typeof usePolfEventOperatorListLazyQuery>;
export type PolfEventOperatorListSuspenseQueryHookResult = ReturnType<typeof usePolfEventOperatorListSuspenseQuery>;
export type PolfEventOperatorListQueryResult = Apollo.QueryResult<PolfEventOperatorListQuery, PolfEventOperatorListQueryVariables>;
export const PolfEventOperatorCreateDocument = gql`
    mutation polfEventOperatorCreate($polfEventId: ID!, $input: PolfEventOperatorCreateDto!) {
  polfEventOperatorCreate(polfEventId: $polfEventId, input: $input) {
    id
    nanoId
    role
    label
    phone
    revokedAt
    createdAt
  }
}
    `;
export type PolfEventOperatorCreateMutationFn = Apollo.MutationFunction<PolfEventOperatorCreateMutation, PolfEventOperatorCreateMutationVariables>;

/**
 * __usePolfEventOperatorCreateMutation__
 *
 * To run a mutation, you first call `usePolfEventOperatorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventOperatorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventOperatorCreateMutation, { data, loading, error }] = usePolfEventOperatorCreateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePolfEventOperatorCreateMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventOperatorCreateMutation, PolfEventOperatorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventOperatorCreateMutation, PolfEventOperatorCreateMutationVariables>(PolfEventOperatorCreateDocument, options);
      }
export type PolfEventOperatorCreateMutationHookResult = ReturnType<typeof usePolfEventOperatorCreateMutation>;
export type PolfEventOperatorCreateMutationResult = Apollo.MutationResult<PolfEventOperatorCreateMutation>;
export const PolfEventOperatorRevokeDocument = gql`
    mutation polfEventOperatorRevoke($polfEventOperatorId: ID!) {
  polfEventOperatorRevoke(polfEventOperatorId: $polfEventOperatorId) {
    id
    revokedAt
  }
}
    `;
export type PolfEventOperatorRevokeMutationFn = Apollo.MutationFunction<PolfEventOperatorRevokeMutation, PolfEventOperatorRevokeMutationVariables>;

/**
 * __usePolfEventOperatorRevokeMutation__
 *
 * To run a mutation, you first call `usePolfEventOperatorRevokeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventOperatorRevokeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventOperatorRevokeMutation, { data, loading, error }] = usePolfEventOperatorRevokeMutation({
 *   variables: {
 *      polfEventOperatorId: // value for 'polfEventOperatorId'
 *   },
 * });
 */
export function usePolfEventOperatorRevokeMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventOperatorRevokeMutation, PolfEventOperatorRevokeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventOperatorRevokeMutation, PolfEventOperatorRevokeMutationVariables>(PolfEventOperatorRevokeDocument, options);
      }
export type PolfEventOperatorRevokeMutationHookResult = ReturnType<typeof usePolfEventOperatorRevokeMutation>;
export type PolfEventOperatorRevokeMutationResult = Apollo.MutationResult<PolfEventOperatorRevokeMutation>;
export const PolfEventOperatorSendLinkDocument = gql`
    mutation polfEventOperatorSendLink($polfEventOperatorId: ID!, $phone: String) {
  polfEventOperatorSendLink(
    polfEventOperatorId: $polfEventOperatorId
    phone: $phone
  ) {
    id
    phone
  }
}
    `;
export type PolfEventOperatorSendLinkMutationFn = Apollo.MutationFunction<PolfEventOperatorSendLinkMutation, PolfEventOperatorSendLinkMutationVariables>;

/**
 * __usePolfEventOperatorSendLinkMutation__
 *
 * To run a mutation, you first call `usePolfEventOperatorSendLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventOperatorSendLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventOperatorSendLinkMutation, { data, loading, error }] = usePolfEventOperatorSendLinkMutation({
 *   variables: {
 *      polfEventOperatorId: // value for 'polfEventOperatorId'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function usePolfEventOperatorSendLinkMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventOperatorSendLinkMutation, PolfEventOperatorSendLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventOperatorSendLinkMutation, PolfEventOperatorSendLinkMutationVariables>(PolfEventOperatorSendLinkDocument, options);
      }
export type PolfEventOperatorSendLinkMutationHookResult = ReturnType<typeof usePolfEventOperatorSendLinkMutation>;
export type PolfEventOperatorSendLinkMutationResult = Apollo.MutationResult<PolfEventOperatorSendLinkMutation>;
export const PolfEventOperatorSendLinkToAllDocument = gql`
    mutation polfEventOperatorSendLinkToAll($polfEventId: ID!) {
  polfEventOperatorSendLinkToAll(polfEventId: $polfEventId) {
    sent
    skippedNoPhone
  }
}
    `;
export type PolfEventOperatorSendLinkToAllMutationFn = Apollo.MutationFunction<PolfEventOperatorSendLinkToAllMutation, PolfEventOperatorSendLinkToAllMutationVariables>;

/**
 * __usePolfEventOperatorSendLinkToAllMutation__
 *
 * To run a mutation, you first call `usePolfEventOperatorSendLinkToAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventOperatorSendLinkToAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventOperatorSendLinkToAllMutation, { data, loading, error }] = usePolfEventOperatorSendLinkToAllMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function usePolfEventOperatorSendLinkToAllMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventOperatorSendLinkToAllMutation, PolfEventOperatorSendLinkToAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventOperatorSendLinkToAllMutation, PolfEventOperatorSendLinkToAllMutationVariables>(PolfEventOperatorSendLinkToAllDocument, options);
      }
export type PolfEventOperatorSendLinkToAllMutationHookResult = ReturnType<typeof usePolfEventOperatorSendLinkToAllMutation>;
export type PolfEventOperatorSendLinkToAllMutationResult = Apollo.MutationResult<PolfEventOperatorSendLinkToAllMutation>;
export const AccountsDocument = gql`
    query accounts {
  accounts {
    id
    name
    slug
    type
    orgNumber
    addressStreet
    addressPostalCode
    addressCity
    contactEmail
    contactPhone
    website
    createdAt
  }
}
    `;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
      }
export function useAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
        }
// @ts-ignore
export function useAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountsQuery, AccountsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountsQuery, AccountsQueryVariables>;
export function useAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountsQuery, AccountsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountsQuery | undefined, AccountsQueryVariables>;
export function useAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
        }
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsSuspenseQueryHookResult = ReturnType<typeof useAccountsSuspenseQuery>;
export type AccountsQueryResult = Apollo.QueryResult<AccountsQuery, AccountsQueryVariables>;
export const AccountSettingsDocument = gql`
    query accountSettings($accountId: ID!) {
  accountSettings(accountId: $accountId) {
    id
    vippsConfigured
    vippsValidated
    vippsClientIdMasked
    vippsMerchantSerialNumberMasked
    startInvoiceNo
    paymentNotificationEmail
    emailConfigured
    smsConfigured
    legalConfigured
    sectionsConfigured
    sectionsTotal
    mailFromName
    smsDefaultSender
    termsUrl
    privacyUrl
  }
}
    `;

/**
 * __useAccountSettingsQuery__
 *
 * To run a query within a React component, call `useAccountSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSettingsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountSettingsQuery(baseOptions: Apollo.QueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables> & ({ variables: AccountSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(AccountSettingsDocument, options);
      }
export function useAccountSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(AccountSettingsDocument, options);
        }
// @ts-ignore
export function useAccountSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountSettingsQuery, AccountSettingsQueryVariables>;
export function useAccountSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountSettingsQuery | undefined, AccountSettingsQueryVariables>;
export function useAccountSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(AccountSettingsDocument, options);
        }
export type AccountSettingsQueryHookResult = ReturnType<typeof useAccountSettingsQuery>;
export type AccountSettingsLazyQueryHookResult = ReturnType<typeof useAccountSettingsLazyQuery>;
export type AccountSettingsSuspenseQueryHookResult = ReturnType<typeof useAccountSettingsSuspenseQuery>;
export type AccountSettingsQueryResult = Apollo.QueryResult<AccountSettingsQuery, AccountSettingsQueryVariables>;
export const AccountMembersDocument = gql`
    query accountMembers($accountId: ID!) {
  accountMembers(accountId: $accountId) {
    id
    isContactPerson
    user {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useAccountMembersQuery__
 *
 * To run a query within a React component, call `useAccountMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountMembersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountMembersQuery(baseOptions: Apollo.QueryHookOptions<AccountMembersQuery, AccountMembersQueryVariables> & ({ variables: AccountMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountMembersQuery, AccountMembersQueryVariables>(AccountMembersDocument, options);
      }
export function useAccountMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountMembersQuery, AccountMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountMembersQuery, AccountMembersQueryVariables>(AccountMembersDocument, options);
        }
// @ts-ignore
export function useAccountMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountMembersQuery, AccountMembersQueryVariables>): Apollo.UseSuspenseQueryResult<AccountMembersQuery, AccountMembersQueryVariables>;
export function useAccountMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountMembersQuery, AccountMembersQueryVariables>): Apollo.UseSuspenseQueryResult<AccountMembersQuery | undefined, AccountMembersQueryVariables>;
export function useAccountMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountMembersQuery, AccountMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountMembersQuery, AccountMembersQueryVariables>(AccountMembersDocument, options);
        }
export type AccountMembersQueryHookResult = ReturnType<typeof useAccountMembersQuery>;
export type AccountMembersLazyQueryHookResult = ReturnType<typeof useAccountMembersLazyQuery>;
export type AccountMembersSuspenseQueryHookResult = ReturnType<typeof useAccountMembersSuspenseQuery>;
export type AccountMembersQueryResult = Apollo.QueryResult<AccountMembersQuery, AccountMembersQueryVariables>;
export const BrregSearchDocument = gql`
    query brregSearch($searchTerm: String!) {
  brregSearch(searchTerm: $searchTerm) {
    orgNumber
    name
    organizationForm
    address {
      street
      postalCode
      city
    }
    businessAddress {
      street
      postalCode
      city
    }
    homepage
  }
}
    `;

/**
 * __useBrregSearchQuery__
 *
 * To run a query within a React component, call `useBrregSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrregSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrregSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useBrregSearchQuery(baseOptions: Apollo.QueryHookOptions<BrregSearchQuery, BrregSearchQueryVariables> & ({ variables: BrregSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrregSearchQuery, BrregSearchQueryVariables>(BrregSearchDocument, options);
      }
export function useBrregSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrregSearchQuery, BrregSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrregSearchQuery, BrregSearchQueryVariables>(BrregSearchDocument, options);
        }
// @ts-ignore
export function useBrregSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrregSearchQuery, BrregSearchQueryVariables>): Apollo.UseSuspenseQueryResult<BrregSearchQuery, BrregSearchQueryVariables>;
export function useBrregSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrregSearchQuery, BrregSearchQueryVariables>): Apollo.UseSuspenseQueryResult<BrregSearchQuery | undefined, BrregSearchQueryVariables>;
export function useBrregSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrregSearchQuery, BrregSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrregSearchQuery, BrregSearchQueryVariables>(BrregSearchDocument, options);
        }
export type BrregSearchQueryHookResult = ReturnType<typeof useBrregSearchQuery>;
export type BrregSearchLazyQueryHookResult = ReturnType<typeof useBrregSearchLazyQuery>;
export type BrregSearchSuspenseQueryHookResult = ReturnType<typeof useBrregSearchSuspenseQuery>;
export type BrregSearchQueryResult = Apollo.QueryResult<BrregSearchQuery, BrregSearchQueryVariables>;
export const AccountCreateDocument = gql`
    mutation accountCreate($slug: String!, $contactPersonName: String!, $contactPersonEmail: String!, $orgNumber: String, $name: String, $contactPhone: String, $website: String) {
  accountCreate(
    slug: $slug
    contactPersonName: $contactPersonName
    contactPersonEmail: $contactPersonEmail
    orgNumber: $orgNumber
    name: $name
    contactPhone: $contactPhone
    website: $website
  ) {
    id
    name
    slug
    type
    orgNumber
    createdAt
  }
}
    `;
export type AccountCreateMutationFn = Apollo.MutationFunction<AccountCreateMutation, AccountCreateMutationVariables>;

/**
 * __useAccountCreateMutation__
 *
 * To run a mutation, you first call `useAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountCreateMutation, { data, loading, error }] = useAccountCreateMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      contactPersonName: // value for 'contactPersonName'
 *      contactPersonEmail: // value for 'contactPersonEmail'
 *      orgNumber: // value for 'orgNumber'
 *      name: // value for 'name'
 *      contactPhone: // value for 'contactPhone'
 *      website: // value for 'website'
 *   },
 * });
 */
export function useAccountCreateMutation(baseOptions?: Apollo.MutationHookOptions<AccountCreateMutation, AccountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountCreateMutation, AccountCreateMutationVariables>(AccountCreateDocument, options);
      }
export type AccountCreateMutationHookResult = ReturnType<typeof useAccountCreateMutation>;
export type AccountCreateMutationResult = Apollo.MutationResult<AccountCreateMutation>;
export const AccountAddMemberDocument = gql`
    mutation accountAddMember($accountId: ID!, $email: String!) {
  accountAddMember(accountId: $accountId, email: $email) {
    id
    isContactPerson
    user {
      id
      name
      email
    }
  }
}
    `;
export type AccountAddMemberMutationFn = Apollo.MutationFunction<AccountAddMemberMutation, AccountAddMemberMutationVariables>;

/**
 * __useAccountAddMemberMutation__
 *
 * To run a mutation, you first call `useAccountAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddMemberMutation, { data, loading, error }] = useAccountAddMemberMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAccountAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<AccountAddMemberMutation, AccountAddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountAddMemberMutation, AccountAddMemberMutationVariables>(AccountAddMemberDocument, options);
      }
export type AccountAddMemberMutationHookResult = ReturnType<typeof useAccountAddMemberMutation>;
export type AccountAddMemberMutationResult = Apollo.MutationResult<AccountAddMemberMutation>;
export const AccountRemoveMemberDocument = gql`
    mutation accountRemoveMember($accountId: ID!, $userId: ID!) {
  accountRemoveMember(accountId: $accountId, userId: $userId)
}
    `;
export type AccountRemoveMemberMutationFn = Apollo.MutationFunction<AccountRemoveMemberMutation, AccountRemoveMemberMutationVariables>;

/**
 * __useAccountRemoveMemberMutation__
 *
 * To run a mutation, you first call `useAccountRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRemoveMemberMutation, { data, loading, error }] = useAccountRemoveMemberMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<AccountRemoveMemberMutation, AccountRemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountRemoveMemberMutation, AccountRemoveMemberMutationVariables>(AccountRemoveMemberDocument, options);
      }
export type AccountRemoveMemberMutationHookResult = ReturnType<typeof useAccountRemoveMemberMutation>;
export type AccountRemoveMemberMutationResult = Apollo.MutationResult<AccountRemoveMemberMutation>;
export const AccountSetContactPersonDocument = gql`
    mutation accountSetContactPerson($accountId: ID!, $memberId: ID!) {
  accountSetContactPerson(accountId: $accountId, memberId: $memberId) {
    id
    isContactPerson
    user {
      id
      name
    }
  }
}
    `;
export type AccountSetContactPersonMutationFn = Apollo.MutationFunction<AccountSetContactPersonMutation, AccountSetContactPersonMutationVariables>;

/**
 * __useAccountSetContactPersonMutation__
 *
 * To run a mutation, you first call `useAccountSetContactPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSetContactPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSetContactPersonMutation, { data, loading, error }] = useAccountSetContactPersonMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useAccountSetContactPersonMutation(baseOptions?: Apollo.MutationHookOptions<AccountSetContactPersonMutation, AccountSetContactPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountSetContactPersonMutation, AccountSetContactPersonMutationVariables>(AccountSetContactPersonDocument, options);
      }
export type AccountSetContactPersonMutationHookResult = ReturnType<typeof useAccountSetContactPersonMutation>;
export type AccountSetContactPersonMutationResult = Apollo.MutationResult<AccountSetContactPersonMutation>;
export const PaymentsDocument = gql`
    query payments {
  payments {
    id
    invoiceNo
    reference
    redirectUrl
    mobileNumber
    sub
    state
    paymentStatus
    createdAt
    updatedAt
    amount {
      currency
      value
    }
    aggregate {
      authorizedAmount {
        currency
        value
      }
      cancelledAmount {
        currency
        value
      }
      capturedAmount {
        currency
        value
      }
      refundedAmount {
        currency
        value
      }
    }
    player {
      id
      name
      email
    }
    polfEvent {
      id
      name
      date
      account {
        id
        name
      }
    }
  }
}
    `;

/**
 * __usePaymentsQuery__
 *
 * To run a query within a React component, call `usePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
      }
export function usePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
        }
// @ts-ignore
export function usePaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentsQuery, PaymentsQueryVariables>;
export function usePaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentsQuery | undefined, PaymentsQueryVariables>;
export function usePaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
        }
export type PaymentsQueryHookResult = ReturnType<typeof usePaymentsQuery>;
export type PaymentsLazyQueryHookResult = ReturnType<typeof usePaymentsLazyQuery>;
export type PaymentsSuspenseQueryHookResult = ReturnType<typeof usePaymentsSuspenseQuery>;
export type PaymentsQueryResult = Apollo.QueryResult<PaymentsQuery, PaymentsQueryVariables>;
export const PaymentDeleteEmptyRecordsDocument = gql`
    mutation paymentDeleteEmptyRecords {
  paymentDeleteEmptyRecords {
    id
  }
}
    `;
export type PaymentDeleteEmptyRecordsMutationFn = Apollo.MutationFunction<PaymentDeleteEmptyRecordsMutation, PaymentDeleteEmptyRecordsMutationVariables>;

/**
 * __usePaymentDeleteEmptyRecordsMutation__
 *
 * To run a mutation, you first call `usePaymentDeleteEmptyRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentDeleteEmptyRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentDeleteEmptyRecordsMutation, { data, loading, error }] = usePaymentDeleteEmptyRecordsMutation({
 *   variables: {
 *   },
 * });
 */
export function usePaymentDeleteEmptyRecordsMutation(baseOptions?: Apollo.MutationHookOptions<PaymentDeleteEmptyRecordsMutation, PaymentDeleteEmptyRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentDeleteEmptyRecordsMutation, PaymentDeleteEmptyRecordsMutationVariables>(PaymentDeleteEmptyRecordsDocument, options);
      }
export type PaymentDeleteEmptyRecordsMutationHookResult = ReturnType<typeof usePaymentDeleteEmptyRecordsMutation>;
export type PaymentDeleteEmptyRecordsMutationResult = Apollo.MutationResult<PaymentDeleteEmptyRecordsMutation>;
export const PaymentUpdateAllRecordsDocument = gql`
    mutation paymentUpdateAllRecords {
  paymentUpdateAllRecords {
    id
  }
}
    `;
export type PaymentUpdateAllRecordsMutationFn = Apollo.MutationFunction<PaymentUpdateAllRecordsMutation, PaymentUpdateAllRecordsMutationVariables>;

/**
 * __usePaymentUpdateAllRecordsMutation__
 *
 * To run a mutation, you first call `usePaymentUpdateAllRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentUpdateAllRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentUpdateAllRecordsMutation, { data, loading, error }] = usePaymentUpdateAllRecordsMutation({
 *   variables: {
 *   },
 * });
 */
export function usePaymentUpdateAllRecordsMutation(baseOptions?: Apollo.MutationHookOptions<PaymentUpdateAllRecordsMutation, PaymentUpdateAllRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentUpdateAllRecordsMutation, PaymentUpdateAllRecordsMutationVariables>(PaymentUpdateAllRecordsDocument, options);
      }
export type PaymentUpdateAllRecordsMutationHookResult = ReturnType<typeof usePaymentUpdateAllRecordsMutation>;
export type PaymentUpdateAllRecordsMutationResult = Apollo.MutationResult<PaymentUpdateAllRecordsMutation>;
export const SmsAccountInfoDocument = gql`
    query smsAccountInfo {
  smsAccountInfo {
    id
    displayname
    email
    mobilenumber
    balance
    currency
  }
}
    `;

/**
 * __useSmsAccountInfoQuery__
 *
 * To run a query within a React component, call `useSmsAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsAccountInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useSmsAccountInfoQuery(baseOptions?: Apollo.QueryHookOptions<SmsAccountInfoQuery, SmsAccountInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmsAccountInfoQuery, SmsAccountInfoQueryVariables>(SmsAccountInfoDocument, options);
      }
export function useSmsAccountInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsAccountInfoQuery, SmsAccountInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmsAccountInfoQuery, SmsAccountInfoQueryVariables>(SmsAccountInfoDocument, options);
        }
// @ts-ignore
export function useSmsAccountInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SmsAccountInfoQuery, SmsAccountInfoQueryVariables>): Apollo.UseSuspenseQueryResult<SmsAccountInfoQuery, SmsAccountInfoQueryVariables>;
export function useSmsAccountInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmsAccountInfoQuery, SmsAccountInfoQueryVariables>): Apollo.UseSuspenseQueryResult<SmsAccountInfoQuery | undefined, SmsAccountInfoQueryVariables>;
export function useSmsAccountInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmsAccountInfoQuery, SmsAccountInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmsAccountInfoQuery, SmsAccountInfoQueryVariables>(SmsAccountInfoDocument, options);
        }
export type SmsAccountInfoQueryHookResult = ReturnType<typeof useSmsAccountInfoQuery>;
export type SmsAccountInfoLazyQueryHookResult = ReturnType<typeof useSmsAccountInfoLazyQuery>;
export type SmsAccountInfoSuspenseQueryHookResult = ReturnType<typeof useSmsAccountInfoSuspenseQuery>;
export type SmsAccountInfoQueryResult = Apollo.QueryResult<SmsAccountInfoQuery, SmsAccountInfoQueryVariables>;
export const SmsHistoryDocument = gql`
    query smsHistory($sentSmsFilters: SentSmsFilters) {
  smsHistory(sentSmsFilters: $sentSmsFilters) {
    id
    from
    to
    message
    status
    cost
    createdAt
    updatedAt
    batchId
    direction
    delivered
    flashsms
    externalId
    player {
      id
      name
      polfEvent {
        id
        name
      }
    }
    createdBy {
      id
      name
    }
  }
}
    `;

/**
 * __useSmsHistoryQuery__
 *
 * To run a query within a React component, call `useSmsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsHistoryQuery({
 *   variables: {
 *      sentSmsFilters: // value for 'sentSmsFilters'
 *   },
 * });
 */
export function useSmsHistoryQuery(baseOptions?: Apollo.QueryHookOptions<SmsHistoryQuery, SmsHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmsHistoryQuery, SmsHistoryQueryVariables>(SmsHistoryDocument, options);
      }
export function useSmsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsHistoryQuery, SmsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmsHistoryQuery, SmsHistoryQueryVariables>(SmsHistoryDocument, options);
        }
// @ts-ignore
export function useSmsHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SmsHistoryQuery, SmsHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<SmsHistoryQuery, SmsHistoryQueryVariables>;
export function useSmsHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmsHistoryQuery, SmsHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<SmsHistoryQuery | undefined, SmsHistoryQueryVariables>;
export function useSmsHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmsHistoryQuery, SmsHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmsHistoryQuery, SmsHistoryQueryVariables>(SmsHistoryDocument, options);
        }
export type SmsHistoryQueryHookResult = ReturnType<typeof useSmsHistoryQuery>;
export type SmsHistoryLazyQueryHookResult = ReturnType<typeof useSmsHistoryLazyQuery>;
export type SmsHistorySuspenseQueryHookResult = ReturnType<typeof useSmsHistorySuspenseQuery>;
export type SmsHistoryQueryResult = Apollo.QueryResult<SmsHistoryQuery, SmsHistoryQueryVariables>;
export const SendSmsDocument = gql`
    mutation sendSms($sendSmsDto: SendSmsDto!) {
  sendSms(sendSmsDto: $sendSmsDto) {
    id
    from
    to
    message
    status
    cost
    createdAt
    batchId
  }
}
    `;
export type SendSmsMutationFn = Apollo.MutationFunction<SendSmsMutation, SendSmsMutationVariables>;

/**
 * __useSendSmsMutation__
 *
 * To run a mutation, you first call `useSendSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSmsMutation, { data, loading, error }] = useSendSmsMutation({
 *   variables: {
 *      sendSmsDto: // value for 'sendSmsDto'
 *   },
 * });
 */
export function useSendSmsMutation(baseOptions?: Apollo.MutationHookOptions<SendSmsMutation, SendSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSmsMutation, SendSmsMutationVariables>(SendSmsDocument, options);
      }
export type SendSmsMutationHookResult = ReturnType<typeof useSendSmsMutation>;
export type SendSmsMutationResult = Apollo.MutationResult<SendSmsMutation>;
export const SmsEventUpdatedDocument = gql`
    subscription smsEventUpdated {
  smsEventUpdated
}
    `;

/**
 * __useSmsEventUpdatedSubscription__
 *
 * To run a query within a React component, call `useSmsEventUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSmsEventUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsEventUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSmsEventUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SmsEventUpdatedSubscription, SmsEventUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SmsEventUpdatedSubscription, SmsEventUpdatedSubscriptionVariables>(SmsEventUpdatedDocument, options);
      }
export type SmsEventUpdatedSubscriptionHookResult = ReturnType<typeof useSmsEventUpdatedSubscription>;
export type SmsEventUpdatedSubscriptionResult = Apollo.SubscriptionResult<SmsEventUpdatedSubscription>;
export const ReportsEventsDocument = gql`
    query reportsEvents {
  polfEvents {
    id
    name
    date
  }
}
    `;

/**
 * __useReportsEventsQuery__
 *
 * To run a query within a React component, call `useReportsEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportsEventsQuery(baseOptions?: Apollo.QueryHookOptions<ReportsEventsQuery, ReportsEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsEventsQuery, ReportsEventsQueryVariables>(ReportsEventsDocument, options);
      }
export function useReportsEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsEventsQuery, ReportsEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsEventsQuery, ReportsEventsQueryVariables>(ReportsEventsDocument, options);
        }
// @ts-ignore
export function useReportsEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportsEventsQuery, ReportsEventsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportsEventsQuery, ReportsEventsQueryVariables>;
export function useReportsEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportsEventsQuery, ReportsEventsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportsEventsQuery | undefined, ReportsEventsQueryVariables>;
export function useReportsEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportsEventsQuery, ReportsEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportsEventsQuery, ReportsEventsQueryVariables>(ReportsEventsDocument, options);
        }
export type ReportsEventsQueryHookResult = ReturnType<typeof useReportsEventsQuery>;
export type ReportsEventsLazyQueryHookResult = ReturnType<typeof useReportsEventsLazyQuery>;
export type ReportsEventsSuspenseQueryHookResult = ReturnType<typeof useReportsEventsSuspenseQuery>;
export type ReportsEventsQueryResult = Apollo.QueryResult<ReportsEventsQuery, ReportsEventsQueryVariables>;
export const AccountMemberTwoFactorUserIdsDocument = gql`
    query accountMemberTwoFactorUserIds($accountId: ID!) {
  accountMemberTwoFactorUserIds(accountId: $accountId)
}
    `;

/**
 * __useAccountMemberTwoFactorUserIdsQuery__
 *
 * To run a query within a React component, call `useAccountMemberTwoFactorUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountMemberTwoFactorUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountMemberTwoFactorUserIdsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountMemberTwoFactorUserIdsQuery(baseOptions: Apollo.QueryHookOptions<AccountMemberTwoFactorUserIdsQuery, AccountMemberTwoFactorUserIdsQueryVariables> & ({ variables: AccountMemberTwoFactorUserIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountMemberTwoFactorUserIdsQuery, AccountMemberTwoFactorUserIdsQueryVariables>(AccountMemberTwoFactorUserIdsDocument, options);
      }
export function useAccountMemberTwoFactorUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountMemberTwoFactorUserIdsQuery, AccountMemberTwoFactorUserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountMemberTwoFactorUserIdsQuery, AccountMemberTwoFactorUserIdsQueryVariables>(AccountMemberTwoFactorUserIdsDocument, options);
        }
// @ts-ignore
export function useAccountMemberTwoFactorUserIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountMemberTwoFactorUserIdsQuery, AccountMemberTwoFactorUserIdsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountMemberTwoFactorUserIdsQuery, AccountMemberTwoFactorUserIdsQueryVariables>;
export function useAccountMemberTwoFactorUserIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountMemberTwoFactorUserIdsQuery, AccountMemberTwoFactorUserIdsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountMemberTwoFactorUserIdsQuery | undefined, AccountMemberTwoFactorUserIdsQueryVariables>;
export function useAccountMemberTwoFactorUserIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountMemberTwoFactorUserIdsQuery, AccountMemberTwoFactorUserIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountMemberTwoFactorUserIdsQuery, AccountMemberTwoFactorUserIdsQueryVariables>(AccountMemberTwoFactorUserIdsDocument, options);
        }
export type AccountMemberTwoFactorUserIdsQueryHookResult = ReturnType<typeof useAccountMemberTwoFactorUserIdsQuery>;
export type AccountMemberTwoFactorUserIdsLazyQueryHookResult = ReturnType<typeof useAccountMemberTwoFactorUserIdsLazyQuery>;
export type AccountMemberTwoFactorUserIdsSuspenseQueryHookResult = ReturnType<typeof useAccountMemberTwoFactorUserIdsSuspenseQuery>;
export type AccountMemberTwoFactorUserIdsQueryResult = Apollo.QueryResult<AccountMemberTwoFactorUserIdsQuery, AccountMemberTwoFactorUserIdsQueryVariables>;
export const PlatformRemoveTwoFactorDocument = gql`
    mutation platformRemoveTwoFactor($userId: ID!) {
  platformRemoveTwoFactor(userId: $userId)
}
    `;
export type PlatformRemoveTwoFactorMutationFn = Apollo.MutationFunction<PlatformRemoveTwoFactorMutation, PlatformRemoveTwoFactorMutationVariables>;

/**
 * __usePlatformRemoveTwoFactorMutation__
 *
 * To run a mutation, you first call `usePlatformRemoveTwoFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlatformRemoveTwoFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [platformRemoveTwoFactorMutation, { data, loading, error }] = usePlatformRemoveTwoFactorMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePlatformRemoveTwoFactorMutation(baseOptions?: Apollo.MutationHookOptions<PlatformRemoveTwoFactorMutation, PlatformRemoveTwoFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlatformRemoveTwoFactorMutation, PlatformRemoveTwoFactorMutationVariables>(PlatformRemoveTwoFactorDocument, options);
      }
export type PlatformRemoveTwoFactorMutationHookResult = ReturnType<typeof usePlatformRemoveTwoFactorMutation>;
export type PlatformRemoveTwoFactorMutationResult = Apollo.MutationResult<PlatformRemoveTwoFactorMutation>;
export const PlatformUsersDocument = gql`
    query platformUsers {
  platformUsers {
    id
    name
    email
    accounts {
      id
      name
      type
      isContactPerson
    }
    signIn {
      password
      twoFactor
      providers
    }
  }
}
    `;

/**
 * __usePlatformUsersQuery__
 *
 * To run a query within a React component, call `usePlatformUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlatformUsersQuery(baseOptions?: Apollo.QueryHookOptions<PlatformUsersQuery, PlatformUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformUsersQuery, PlatformUsersQueryVariables>(PlatformUsersDocument, options);
      }
export function usePlatformUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformUsersQuery, PlatformUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformUsersQuery, PlatformUsersQueryVariables>(PlatformUsersDocument, options);
        }
// @ts-ignore
export function usePlatformUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformUsersQuery, PlatformUsersQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformUsersQuery, PlatformUsersQueryVariables>;
export function usePlatformUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformUsersQuery, PlatformUsersQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformUsersQuery | undefined, PlatformUsersQueryVariables>;
export function usePlatformUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformUsersQuery, PlatformUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformUsersQuery, PlatformUsersQueryVariables>(PlatformUsersDocument, options);
        }
export type PlatformUsersQueryHookResult = ReturnType<typeof usePlatformUsersQuery>;
export type PlatformUsersLazyQueryHookResult = ReturnType<typeof usePlatformUsersLazyQuery>;
export type PlatformUsersSuspenseQueryHookResult = ReturnType<typeof usePlatformUsersSuspenseQuery>;
export type PlatformUsersQueryResult = Apollo.QueryResult<PlatformUsersQuery, PlatformUsersQueryVariables>;
export const ProjectorEventDocument = gql`
    query projectorEvent {
  currentPolfEventPublic {
    ...ProjectorEvent
  }
}
    ${ProjectorEventFragmentDoc}`;

/**
 * __useProjectorEventQuery__
 *
 * To run a query within a React component, call `useProjectorEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectorEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectorEventQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectorEventQuery(baseOptions?: Apollo.QueryHookOptions<ProjectorEventQuery, ProjectorEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectorEventQuery, ProjectorEventQueryVariables>(ProjectorEventDocument, options);
      }
export function useProjectorEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectorEventQuery, ProjectorEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectorEventQuery, ProjectorEventQueryVariables>(ProjectorEventDocument, options);
        }
// @ts-ignore
export function useProjectorEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectorEventQuery, ProjectorEventQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectorEventQuery, ProjectorEventQueryVariables>;
export function useProjectorEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectorEventQuery, ProjectorEventQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectorEventQuery | undefined, ProjectorEventQueryVariables>;
export function useProjectorEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectorEventQuery, ProjectorEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectorEventQuery, ProjectorEventQueryVariables>(ProjectorEventDocument, options);
        }
export type ProjectorEventQueryHookResult = ReturnType<typeof useProjectorEventQuery>;
export type ProjectorEventLazyQueryHookResult = ReturnType<typeof useProjectorEventLazyQuery>;
export type ProjectorEventSuspenseQueryHookResult = ReturnType<typeof useProjectorEventSuspenseQuery>;
export type ProjectorEventQueryResult = Apollo.QueryResult<ProjectorEventQuery, ProjectorEventQueryVariables>;
export const ProjectorLeaderboardDocument = gql`
    query projectorLeaderboard($polfEventId: ID!) {
  polfEventPublicLeaderboard(polfEventId: $polfEventId) {
    ...ProjectorLeaderboardUnionFields
  }
  polfEventPublicHoleCompetitionsWithCurrentLeader(polfEventId: $polfEventId) {
    ...ProjectorHoleCompetition
  }
}
    ${ProjectorLeaderboardUnionFieldsFragmentDoc}
${ProjectorHoleCompetitionFragmentDoc}`;

/**
 * __useProjectorLeaderboardQuery__
 *
 * To run a query within a React component, call `useProjectorLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectorLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectorLeaderboardQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function useProjectorLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<ProjectorLeaderboardQuery, ProjectorLeaderboardQueryVariables> & ({ variables: ProjectorLeaderboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectorLeaderboardQuery, ProjectorLeaderboardQueryVariables>(ProjectorLeaderboardDocument, options);
      }
export function useProjectorLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectorLeaderboardQuery, ProjectorLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectorLeaderboardQuery, ProjectorLeaderboardQueryVariables>(ProjectorLeaderboardDocument, options);
        }
// @ts-ignore
export function useProjectorLeaderboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectorLeaderboardQuery, ProjectorLeaderboardQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectorLeaderboardQuery, ProjectorLeaderboardQueryVariables>;
export function useProjectorLeaderboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectorLeaderboardQuery, ProjectorLeaderboardQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectorLeaderboardQuery | undefined, ProjectorLeaderboardQueryVariables>;
export function useProjectorLeaderboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectorLeaderboardQuery, ProjectorLeaderboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectorLeaderboardQuery, ProjectorLeaderboardQueryVariables>(ProjectorLeaderboardDocument, options);
        }
export type ProjectorLeaderboardQueryHookResult = ReturnType<typeof useProjectorLeaderboardQuery>;
export type ProjectorLeaderboardLazyQueryHookResult = ReturnType<typeof useProjectorLeaderboardLazyQuery>;
export type ProjectorLeaderboardSuspenseQueryHookResult = ReturnType<typeof useProjectorLeaderboardSuspenseQuery>;
export type ProjectorLeaderboardQueryResult = Apollo.QueryResult<ProjectorLeaderboardQuery, ProjectorLeaderboardQueryVariables>;
export const ProjectorMatchesDocument = gql`
    query ProjectorMatches($polfEventId: ID!) {
  polfEventPublicMatches(polfEventId: $polfEventId) {
    id
    matchNumber
    sideA {
      kind
      id
      name
    }
    sideB {
      kind
      id
      name
    }
    flight {
      flightNumber
    }
    state {
      status
      holesUp
      leader
      holesRemaining
      margin
      pointsPerHole
    }
  }
}
    `;

/**
 * __useProjectorMatchesQuery__
 *
 * To run a query within a React component, call `useProjectorMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectorMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectorMatchesQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function useProjectorMatchesQuery(baseOptions: Apollo.QueryHookOptions<ProjectorMatchesQuery, ProjectorMatchesQueryVariables> & ({ variables: ProjectorMatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectorMatchesQuery, ProjectorMatchesQueryVariables>(ProjectorMatchesDocument, options);
      }
export function useProjectorMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectorMatchesQuery, ProjectorMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectorMatchesQuery, ProjectorMatchesQueryVariables>(ProjectorMatchesDocument, options);
        }
// @ts-ignore
export function useProjectorMatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectorMatchesQuery, ProjectorMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectorMatchesQuery, ProjectorMatchesQueryVariables>;
export function useProjectorMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectorMatchesQuery, ProjectorMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectorMatchesQuery | undefined, ProjectorMatchesQueryVariables>;
export function useProjectorMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectorMatchesQuery, ProjectorMatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectorMatchesQuery, ProjectorMatchesQueryVariables>(ProjectorMatchesDocument, options);
        }
export type ProjectorMatchesQueryHookResult = ReturnType<typeof useProjectorMatchesQuery>;
export type ProjectorMatchesLazyQueryHookResult = ReturnType<typeof useProjectorMatchesLazyQuery>;
export type ProjectorMatchesSuspenseQueryHookResult = ReturnType<typeof useProjectorMatchesSuspenseQuery>;
export type ProjectorMatchesQueryResult = Apollo.QueryResult<ProjectorMatchesQuery, ProjectorMatchesQueryVariables>;
export const ProjectorPokerDocument = gql`
    query projectorPoker($polfEventId: ID!) {
  polfEventPokerPublic(polfEventId: $polfEventId) {
    ...ProjectorPokerPublic
  }
}
    ${ProjectorPokerPublicFragmentDoc}`;

/**
 * __useProjectorPokerQuery__
 *
 * To run a query within a React component, call `useProjectorPokerQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectorPokerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectorPokerQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function useProjectorPokerQuery(baseOptions: Apollo.QueryHookOptions<ProjectorPokerQuery, ProjectorPokerQueryVariables> & ({ variables: ProjectorPokerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectorPokerQuery, ProjectorPokerQueryVariables>(ProjectorPokerDocument, options);
      }
export function useProjectorPokerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectorPokerQuery, ProjectorPokerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectorPokerQuery, ProjectorPokerQueryVariables>(ProjectorPokerDocument, options);
        }
// @ts-ignore
export function useProjectorPokerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectorPokerQuery, ProjectorPokerQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectorPokerQuery, ProjectorPokerQueryVariables>;
export function useProjectorPokerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectorPokerQuery, ProjectorPokerQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectorPokerQuery | undefined, ProjectorPokerQueryVariables>;
export function useProjectorPokerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectorPokerQuery, ProjectorPokerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectorPokerQuery, ProjectorPokerQueryVariables>(ProjectorPokerDocument, options);
        }
export type ProjectorPokerQueryHookResult = ReturnType<typeof useProjectorPokerQuery>;
export type ProjectorPokerLazyQueryHookResult = ReturnType<typeof useProjectorPokerLazyQuery>;
export type ProjectorPokerSuspenseQueryHookResult = ReturnType<typeof useProjectorPokerSuspenseQuery>;
export type ProjectorPokerQueryResult = Apollo.QueryResult<ProjectorPokerQuery, ProjectorPokerQueryVariables>;
export const ProjectorSponsorsDocument = gql`
    query projectorSponsors($polfEventId: ID!) {
  polfEventSponsorsPublic(polfEventId: $polfEventId) {
    id
    name
    logoUrl
  }
}
    `;

/**
 * __useProjectorSponsorsQuery__
 *
 * To run a query within a React component, call `useProjectorSponsorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectorSponsorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectorSponsorsQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function useProjectorSponsorsQuery(baseOptions: Apollo.QueryHookOptions<ProjectorSponsorsQuery, ProjectorSponsorsQueryVariables> & ({ variables: ProjectorSponsorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectorSponsorsQuery, ProjectorSponsorsQueryVariables>(ProjectorSponsorsDocument, options);
      }
export function useProjectorSponsorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectorSponsorsQuery, ProjectorSponsorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectorSponsorsQuery, ProjectorSponsorsQueryVariables>(ProjectorSponsorsDocument, options);
        }
// @ts-ignore
export function useProjectorSponsorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectorSponsorsQuery, ProjectorSponsorsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectorSponsorsQuery, ProjectorSponsorsQueryVariables>;
export function useProjectorSponsorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectorSponsorsQuery, ProjectorSponsorsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectorSponsorsQuery | undefined, ProjectorSponsorsQueryVariables>;
export function useProjectorSponsorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectorSponsorsQuery, ProjectorSponsorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectorSponsorsQuery, ProjectorSponsorsQueryVariables>(ProjectorSponsorsDocument, options);
        }
export type ProjectorSponsorsQueryHookResult = ReturnType<typeof useProjectorSponsorsQuery>;
export type ProjectorSponsorsLazyQueryHookResult = ReturnType<typeof useProjectorSponsorsLazyQuery>;
export type ProjectorSponsorsSuspenseQueryHookResult = ReturnType<typeof useProjectorSponsorsSuspenseQuery>;
export type ProjectorSponsorsQueryResult = Apollo.QueryResult<ProjectorSponsorsQuery, ProjectorSponsorsQueryVariables>;
export const CurrentPolfEventPublicDocument = gql`
    query currentPolfEventPublic {
  currentPolfEventPublic {
    ...PublicRegistrationEvent
  }
}
    ${PublicRegistrationEventFragmentDoc}`;

/**
 * __useCurrentPolfEventPublicQuery__
 *
 * To run a query within a React component, call `useCurrentPolfEventPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPolfEventPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPolfEventPublicQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentPolfEventPublicQuery(baseOptions?: Apollo.QueryHookOptions<CurrentPolfEventPublicQuery, CurrentPolfEventPublicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentPolfEventPublicQuery, CurrentPolfEventPublicQueryVariables>(CurrentPolfEventPublicDocument, options);
      }
export function useCurrentPolfEventPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentPolfEventPublicQuery, CurrentPolfEventPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentPolfEventPublicQuery, CurrentPolfEventPublicQueryVariables>(CurrentPolfEventPublicDocument, options);
        }
// @ts-ignore
export function useCurrentPolfEventPublicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentPolfEventPublicQuery, CurrentPolfEventPublicQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentPolfEventPublicQuery, CurrentPolfEventPublicQueryVariables>;
export function useCurrentPolfEventPublicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentPolfEventPublicQuery, CurrentPolfEventPublicQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentPolfEventPublicQuery | undefined, CurrentPolfEventPublicQueryVariables>;
export function useCurrentPolfEventPublicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentPolfEventPublicQuery, CurrentPolfEventPublicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentPolfEventPublicQuery, CurrentPolfEventPublicQueryVariables>(CurrentPolfEventPublicDocument, options);
        }
export type CurrentPolfEventPublicQueryHookResult = ReturnType<typeof useCurrentPolfEventPublicQuery>;
export type CurrentPolfEventPublicLazyQueryHookResult = ReturnType<typeof useCurrentPolfEventPublicLazyQuery>;
export type CurrentPolfEventPublicSuspenseQueryHookResult = ReturnType<typeof useCurrentPolfEventPublicSuspenseQuery>;
export type CurrentPolfEventPublicQueryResult = Apollo.QueryResult<CurrentPolfEventPublicQuery, CurrentPolfEventPublicQueryVariables>;
export const PolfEventPublicAddPlayerVippsDocument = gql`
    mutation polfEventPublicAddPlayerVipps($polfEventId: ID!, $createPolfEventPaymentDto: CreatePolfEventPaymentDto!, $polfEventPlayerNanoId: String) {
  polfEventPublicAddPlayerVipps(
    polfEventId: $polfEventId
    createPolfEventPaymentDto: $createPolfEventPaymentDto
    polfEventPlayerNanoId: $polfEventPlayerNanoId
  ) {
    id
    reference
    redirectUrl
    mobileNumber
    state
  }
}
    `;
export type PolfEventPublicAddPlayerVippsMutationFn = Apollo.MutationFunction<PolfEventPublicAddPlayerVippsMutation, PolfEventPublicAddPlayerVippsMutationVariables>;

/**
 * __usePolfEventPublicAddPlayerVippsMutation__
 *
 * To run a mutation, you first call `usePolfEventPublicAddPlayerVippsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPublicAddPlayerVippsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPublicAddPlayerVippsMutation, { data, loading, error }] = usePolfEventPublicAddPlayerVippsMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      createPolfEventPaymentDto: // value for 'createPolfEventPaymentDto'
 *      polfEventPlayerNanoId: // value for 'polfEventPlayerNanoId'
 *   },
 * });
 */
export function usePolfEventPublicAddPlayerVippsMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPublicAddPlayerVippsMutation, PolfEventPublicAddPlayerVippsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPublicAddPlayerVippsMutation, PolfEventPublicAddPlayerVippsMutationVariables>(PolfEventPublicAddPlayerVippsDocument, options);
      }
export type PolfEventPublicAddPlayerVippsMutationHookResult = ReturnType<typeof usePolfEventPublicAddPlayerVippsMutation>;
export type PolfEventPublicAddPlayerVippsMutationResult = Apollo.MutationResult<PolfEventPublicAddPlayerVippsMutation>;
export const PolfEventPublicUpdatePlayerDocument = gql`
    mutation polfEventPublicUpdatePlayer($polfEventId: ID!, $polfEventPlayerNanoId: String!, $updatePolfEventPlayerDto: UpdatePolfEventPlayerDto!) {
  polfEventPublicUpdatePlayer(
    polfEventId: $polfEventId
    polfEventPlayerNanoId: $polfEventPlayerNanoId
    updatePolfEventPlayerDto: $updatePolfEventPlayerDto
  ) {
    id
    nanoId
    name
    hcp
    memberNo
  }
}
    `;
export type PolfEventPublicUpdatePlayerMutationFn = Apollo.MutationFunction<PolfEventPublicUpdatePlayerMutation, PolfEventPublicUpdatePlayerMutationVariables>;

/**
 * __usePolfEventPublicUpdatePlayerMutation__
 *
 * To run a mutation, you first call `usePolfEventPublicUpdatePlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPublicUpdatePlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [polfEventPublicUpdatePlayerMutation, { data, loading, error }] = usePolfEventPublicUpdatePlayerMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      polfEventPlayerNanoId: // value for 'polfEventPlayerNanoId'
 *      updatePolfEventPlayerDto: // value for 'updatePolfEventPlayerDto'
 *   },
 * });
 */
export function usePolfEventPublicUpdatePlayerMutation(baseOptions?: Apollo.MutationHookOptions<PolfEventPublicUpdatePlayerMutation, PolfEventPublicUpdatePlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolfEventPublicUpdatePlayerMutation, PolfEventPublicUpdatePlayerMutationVariables>(PolfEventPublicUpdatePlayerDocument, options);
      }
export type PolfEventPublicUpdatePlayerMutationHookResult = ReturnType<typeof usePolfEventPublicUpdatePlayerMutation>;
export type PolfEventPublicUpdatePlayerMutationResult = Apollo.MutationResult<PolfEventPublicUpdatePlayerMutation>;
export const PolfEventPublicPlayerDocument = gql`
    query polfEventPublicPlayer($polfEventId: ID!, $polfEventPlayerNanoId: ID!) {
  polfEventPublicPlayer(
    polfEventId: $polfEventId
    polfEventPlayerNanoId: $polfEventPlayerNanoId
  ) {
    id
    nanoId
    name
    hcp
    memberNo
    mobileNumber
    payment {
      __typename
      ... on VippsPayment {
        id
        paymentStatus
        amount {
          value
          currency
        }
      }
      ... on PolfEventPlayerOtherPayment {
        id
        createdAt
      }
    }
  }
}
    `;

/**
 * __usePolfEventPublicPlayerQuery__
 *
 * To run a query within a React component, call `usePolfEventPublicPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolfEventPublicPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolfEventPublicPlayerQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      polfEventPlayerNanoId: // value for 'polfEventPlayerNanoId'
 *   },
 * });
 */
export function usePolfEventPublicPlayerQuery(baseOptions: Apollo.QueryHookOptions<PolfEventPublicPlayerQuery, PolfEventPublicPlayerQueryVariables> & ({ variables: PolfEventPublicPlayerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolfEventPublicPlayerQuery, PolfEventPublicPlayerQueryVariables>(PolfEventPublicPlayerDocument, options);
      }
export function usePolfEventPublicPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolfEventPublicPlayerQuery, PolfEventPublicPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolfEventPublicPlayerQuery, PolfEventPublicPlayerQueryVariables>(PolfEventPublicPlayerDocument, options);
        }
// @ts-ignore
export function usePolfEventPublicPlayerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolfEventPublicPlayerQuery, PolfEventPublicPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventPublicPlayerQuery, PolfEventPublicPlayerQueryVariables>;
export function usePolfEventPublicPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventPublicPlayerQuery, PolfEventPublicPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<PolfEventPublicPlayerQuery | undefined, PolfEventPublicPlayerQueryVariables>;
export function usePolfEventPublicPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolfEventPublicPlayerQuery, PolfEventPublicPlayerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolfEventPublicPlayerQuery, PolfEventPublicPlayerQueryVariables>(PolfEventPublicPlayerDocument, options);
        }
export type PolfEventPublicPlayerQueryHookResult = ReturnType<typeof usePolfEventPublicPlayerQuery>;
export type PolfEventPublicPlayerLazyQueryHookResult = ReturnType<typeof usePolfEventPublicPlayerLazyQuery>;
export type PolfEventPublicPlayerSuspenseQueryHookResult = ReturnType<typeof usePolfEventPublicPlayerSuspenseQuery>;
export type PolfEventPublicPlayerQueryResult = Apollo.QueryResult<PolfEventPublicPlayerQuery, PolfEventPublicPlayerQueryVariables>;
export const EventSponsorsDocument = gql`
    query eventSponsors($polfEventId: ID!) {
  eventSponsors(polfEventId: $polfEventId) {
    ...SponsorItem
  }
}
    ${SponsorItemFragmentDoc}`;

/**
 * __useEventSponsorsQuery__
 *
 * To run a query within a React component, call `useEventSponsorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSponsorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSponsorsQuery({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *   },
 * });
 */
export function useEventSponsorsQuery(baseOptions: Apollo.QueryHookOptions<EventSponsorsQuery, EventSponsorsQueryVariables> & ({ variables: EventSponsorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventSponsorsQuery, EventSponsorsQueryVariables>(EventSponsorsDocument, options);
      }
export function useEventSponsorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventSponsorsQuery, EventSponsorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventSponsorsQuery, EventSponsorsQueryVariables>(EventSponsorsDocument, options);
        }
// @ts-ignore
export function useEventSponsorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventSponsorsQuery, EventSponsorsQueryVariables>): Apollo.UseSuspenseQueryResult<EventSponsorsQuery, EventSponsorsQueryVariables>;
export function useEventSponsorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventSponsorsQuery, EventSponsorsQueryVariables>): Apollo.UseSuspenseQueryResult<EventSponsorsQuery | undefined, EventSponsorsQueryVariables>;
export function useEventSponsorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventSponsorsQuery, EventSponsorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventSponsorsQuery, EventSponsorsQueryVariables>(EventSponsorsDocument, options);
        }
export type EventSponsorsQueryHookResult = ReturnType<typeof useEventSponsorsQuery>;
export type EventSponsorsLazyQueryHookResult = ReturnType<typeof useEventSponsorsLazyQuery>;
export type EventSponsorsSuspenseQueryHookResult = ReturnType<typeof useEventSponsorsSuspenseQuery>;
export type EventSponsorsQueryResult = Apollo.QueryResult<EventSponsorsQuery, EventSponsorsQueryVariables>;
export const SponsorCreateDocument = gql`
    mutation sponsorCreate($polfEventId: ID!, $name: String!) {
  sponsorCreate(polfEventId: $polfEventId, name: $name) {
    ...SponsorItem
  }
}
    ${SponsorItemFragmentDoc}`;
export type SponsorCreateMutationFn = Apollo.MutationFunction<SponsorCreateMutation, SponsorCreateMutationVariables>;

/**
 * __useSponsorCreateMutation__
 *
 * To run a mutation, you first call `useSponsorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSponsorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sponsorCreateMutation, { data, loading, error }] = useSponsorCreateMutation({
 *   variables: {
 *      polfEventId: // value for 'polfEventId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSponsorCreateMutation(baseOptions?: Apollo.MutationHookOptions<SponsorCreateMutation, SponsorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SponsorCreateMutation, SponsorCreateMutationVariables>(SponsorCreateDocument, options);
      }
export type SponsorCreateMutationHookResult = ReturnType<typeof useSponsorCreateMutation>;
export type SponsorCreateMutationResult = Apollo.MutationResult<SponsorCreateMutation>;
export const SponsorUpdateDocument = gql`
    mutation sponsorUpdate($sponsorId: ID!, $updateSponsorDto: UpdateSponsorDto!) {
  sponsorUpdate(sponsorId: $sponsorId, updateSponsorDto: $updateSponsorDto) {
    ...SponsorItem
  }
}
    ${SponsorItemFragmentDoc}`;
export type SponsorUpdateMutationFn = Apollo.MutationFunction<SponsorUpdateMutation, SponsorUpdateMutationVariables>;

/**
 * __useSponsorUpdateMutation__
 *
 * To run a mutation, you first call `useSponsorUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSponsorUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sponsorUpdateMutation, { data, loading, error }] = useSponsorUpdateMutation({
 *   variables: {
 *      sponsorId: // value for 'sponsorId'
 *      updateSponsorDto: // value for 'updateSponsorDto'
 *   },
 * });
 */
export function useSponsorUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SponsorUpdateMutation, SponsorUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SponsorUpdateMutation, SponsorUpdateMutationVariables>(SponsorUpdateDocument, options);
      }
export type SponsorUpdateMutationHookResult = ReturnType<typeof useSponsorUpdateMutation>;
export type SponsorUpdateMutationResult = Apollo.MutationResult<SponsorUpdateMutation>;
export const SponsorDeleteDocument = gql`
    mutation sponsorDelete($sponsorId: ID!) {
  sponsorDelete(sponsorId: $sponsorId)
}
    `;
export type SponsorDeleteMutationFn = Apollo.MutationFunction<SponsorDeleteMutation, SponsorDeleteMutationVariables>;

/**
 * __useSponsorDeleteMutation__
 *
 * To run a mutation, you first call `useSponsorDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSponsorDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sponsorDeleteMutation, { data, loading, error }] = useSponsorDeleteMutation({
 *   variables: {
 *      sponsorId: // value for 'sponsorId'
 *   },
 * });
 */
export function useSponsorDeleteMutation(baseOptions?: Apollo.MutationHookOptions<SponsorDeleteMutation, SponsorDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SponsorDeleteMutation, SponsorDeleteMutationVariables>(SponsorDeleteDocument, options);
      }
export type SponsorDeleteMutationHookResult = ReturnType<typeof useSponsorDeleteMutation>;
export type SponsorDeleteMutationResult = Apollo.MutationResult<SponsorDeleteMutation>;
export const SponsorLogoUploadUrlDocument = gql`
    mutation sponsorLogoUploadUrl($sponsorId: ID!, $contentType: String!) {
  sponsorLogoUploadUrl(sponsorId: $sponsorId, contentType: $contentType) {
    uploadUrl
    storagePath
  }
}
    `;
export type SponsorLogoUploadUrlMutationFn = Apollo.MutationFunction<SponsorLogoUploadUrlMutation, SponsorLogoUploadUrlMutationVariables>;

/**
 * __useSponsorLogoUploadUrlMutation__
 *
 * To run a mutation, you first call `useSponsorLogoUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSponsorLogoUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sponsorLogoUploadUrlMutation, { data, loading, error }] = useSponsorLogoUploadUrlMutation({
 *   variables: {
 *      sponsorId: // value for 'sponsorId'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useSponsorLogoUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<SponsorLogoUploadUrlMutation, SponsorLogoUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SponsorLogoUploadUrlMutation, SponsorLogoUploadUrlMutationVariables>(SponsorLogoUploadUrlDocument, options);
      }
export type SponsorLogoUploadUrlMutationHookResult = ReturnType<typeof useSponsorLogoUploadUrlMutation>;
export type SponsorLogoUploadUrlMutationResult = Apollo.MutationResult<SponsorLogoUploadUrlMutation>;
export const SponsorLogoUploadCompleteDocument = gql`
    mutation sponsorLogoUploadComplete($sponsorId: ID!, $storagePath: String!) {
  sponsorLogoUploadComplete(sponsorId: $sponsorId, storagePath: $storagePath) {
    ...SponsorItem
  }
}
    ${SponsorItemFragmentDoc}`;
export type SponsorLogoUploadCompleteMutationFn = Apollo.MutationFunction<SponsorLogoUploadCompleteMutation, SponsorLogoUploadCompleteMutationVariables>;

/**
 * __useSponsorLogoUploadCompleteMutation__
 *
 * To run a mutation, you first call `useSponsorLogoUploadCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSponsorLogoUploadCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sponsorLogoUploadCompleteMutation, { data, loading, error }] = useSponsorLogoUploadCompleteMutation({
 *   variables: {
 *      sponsorId: // value for 'sponsorId'
 *      storagePath: // value for 'storagePath'
 *   },
 * });
 */
export function useSponsorLogoUploadCompleteMutation(baseOptions?: Apollo.MutationHookOptions<SponsorLogoUploadCompleteMutation, SponsorLogoUploadCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SponsorLogoUploadCompleteMutation, SponsorLogoUploadCompleteMutationVariables>(SponsorLogoUploadCompleteDocument, options);
      }
export type SponsorLogoUploadCompleteMutationHookResult = ReturnType<typeof useSponsorLogoUploadCompleteMutation>;
export type SponsorLogoUploadCompleteMutationResult = Apollo.MutationResult<SponsorLogoUploadCompleteMutation>;
export const PaymentDetailsDocument = gql`
    query paymentDetails($paymentId: ID!) {
  paymentDetails(paymentId: $paymentId) {
    ...VippsPaymentDetailsFields
  }
}
    ${VippsPaymentDetailsFieldsFragmentDoc}`;

/**
 * __usePaymentDetailsQuery__
 *
 * To run a query within a React component, call `usePaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentDetailsQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function usePaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<PaymentDetailsQuery, PaymentDetailsQueryVariables> & ({ variables: PaymentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentDetailsQuery, PaymentDetailsQueryVariables>(PaymentDetailsDocument, options);
      }
export function usePaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentDetailsQuery, PaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentDetailsQuery, PaymentDetailsQueryVariables>(PaymentDetailsDocument, options);
        }
// @ts-ignore
export function usePaymentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentDetailsQuery, PaymentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentDetailsQuery, PaymentDetailsQueryVariables>;
export function usePaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentDetailsQuery, PaymentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentDetailsQuery | undefined, PaymentDetailsQueryVariables>;
export function usePaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentDetailsQuery, PaymentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentDetailsQuery, PaymentDetailsQueryVariables>(PaymentDetailsDocument, options);
        }
export type PaymentDetailsQueryHookResult = ReturnType<typeof usePaymentDetailsQuery>;
export type PaymentDetailsLazyQueryHookResult = ReturnType<typeof usePaymentDetailsLazyQuery>;
export type PaymentDetailsSuspenseQueryHookResult = ReturnType<typeof usePaymentDetailsSuspenseQuery>;
export type PaymentDetailsQueryResult = Apollo.QueryResult<PaymentDetailsQuery, PaymentDetailsQueryVariables>;
export const PaymentCaptureDocument = gql`
    mutation paymentCapture($paymentId: ID!) {
  paymentCapture(paymentId: $paymentId) {
    ...VippsPaymentDetailsFields
  }
}
    ${VippsPaymentDetailsFieldsFragmentDoc}`;
export type PaymentCaptureMutationFn = Apollo.MutationFunction<PaymentCaptureMutation, PaymentCaptureMutationVariables>;

/**
 * __usePaymentCaptureMutation__
 *
 * To run a mutation, you first call `usePaymentCaptureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentCaptureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentCaptureMutation, { data, loading, error }] = usePaymentCaptureMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function usePaymentCaptureMutation(baseOptions?: Apollo.MutationHookOptions<PaymentCaptureMutation, PaymentCaptureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentCaptureMutation, PaymentCaptureMutationVariables>(PaymentCaptureDocument, options);
      }
export type PaymentCaptureMutationHookResult = ReturnType<typeof usePaymentCaptureMutation>;
export type PaymentCaptureMutationResult = Apollo.MutationResult<PaymentCaptureMutation>;
export const PaymentCreatePlayerBasedOnPaymentRecordDocument = gql`
    mutation paymentCreatePlayerBasedOnPaymentRecord($paymentId: ID!) {
  paymentCreatePlayerBasedOnPaymentRecord(paymentId: $paymentId) {
    id
    player {
      id
      name
    }
  }
}
    `;
export type PaymentCreatePlayerBasedOnPaymentRecordMutationFn = Apollo.MutationFunction<PaymentCreatePlayerBasedOnPaymentRecordMutation, PaymentCreatePlayerBasedOnPaymentRecordMutationVariables>;

/**
 * __usePaymentCreatePlayerBasedOnPaymentRecordMutation__
 *
 * To run a mutation, you first call `usePaymentCreatePlayerBasedOnPaymentRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentCreatePlayerBasedOnPaymentRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentCreatePlayerBasedOnPaymentRecordMutation, { data, loading, error }] = usePaymentCreatePlayerBasedOnPaymentRecordMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function usePaymentCreatePlayerBasedOnPaymentRecordMutation(baseOptions?: Apollo.MutationHookOptions<PaymentCreatePlayerBasedOnPaymentRecordMutation, PaymentCreatePlayerBasedOnPaymentRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentCreatePlayerBasedOnPaymentRecordMutation, PaymentCreatePlayerBasedOnPaymentRecordMutationVariables>(PaymentCreatePlayerBasedOnPaymentRecordDocument, options);
      }
export type PaymentCreatePlayerBasedOnPaymentRecordMutationHookResult = ReturnType<typeof usePaymentCreatePlayerBasedOnPaymentRecordMutation>;
export type PaymentCreatePlayerBasedOnPaymentRecordMutationResult = Apollo.MutationResult<PaymentCreatePlayerBasedOnPaymentRecordMutation>;
export const namedOperations = {
  Query: {
    myCurrentAccount: 'myCurrentAccount',
    myAccountSettings: 'myAccountSettings',
    myAccounts: 'myAccounts',
    myAccountMembers: 'myAccountMembers',
    courses: 'courses',
    course: 'course',
    findCourseDraft: 'findCourseDraft',
    devToolsEnabled: 'devToolsEnabled',
    polfEventFlights: 'polfEventFlights',
    polfEventHoleCompetitions: 'polfEventHoleCompetitions',
    polfEventHoleCompetitionsWithEntries: 'polfEventHoleCompetitionsWithEntries',
    polfEventLeaderboard: 'polfEventLeaderboard',
    PolfEventMatches: 'PolfEventMatches',
    PolfEventFlightMatchPoints: 'PolfEventFlightMatchPoints',
    polfEventScorecard: 'polfEventScorecard',
    polfEventPlayers: 'polfEventPlayers',
    polfEventPoker: 'polfEventPoker',
    projectedPokerSetup: 'projectedPokerSetup',
    polfEventSegmentedScorecard: 'polfEventSegmentedScorecard',
    polfEventScrambleScorecard: 'polfEventScrambleScorecard',
    polfEventTeams: 'polfEventTeams',
    polfEventTeamScoredHoles: 'polfEventTeamScoredHoles',
    polfEvents: 'polfEvents',
    coursesForEventCreate: 'coursesForEventCreate',
    polfEvent: 'polfEvent',
    me: 'me',
    mySignInStatus: 'mySignInStatus',
    OperatorPokerView: 'OperatorPokerView',
    polfEventOperatorList: 'polfEventOperatorList',
    accounts: 'accounts',
    accountSettings: 'accountSettings',
    accountMembers: 'accountMembers',
    brregSearch: 'brregSearch',
    payments: 'payments',
    smsAccountInfo: 'smsAccountInfo',
    smsHistory: 'smsHistory',
    reportsEvents: 'reportsEvents',
    accountMemberTwoFactorUserIds: 'accountMemberTwoFactorUserIds',
    platformUsers: 'platformUsers',
    projectorEvent: 'projectorEvent',
    projectorLeaderboard: 'projectorLeaderboard',
    ProjectorMatches: 'ProjectorMatches',
    projectorPoker: 'projectorPoker',
    projectorSponsors: 'projectorSponsors',
    currentPolfEventPublic: 'currentPolfEventPublic',
    polfEventPublicPlayer: 'polfEventPublicPlayer',
    eventSponsors: 'eventSponsors',
    paymentDetails: 'paymentDetails'
  },
  Mutation: {
    myAccountProfileUpdate: 'myAccountProfileUpdate',
    myAccountSettingsUpdate: 'myAccountSettingsUpdate',
    selectAccount: 'selectAccount',
    myAccountAddMember: 'myAccountAddMember',
    myAccountRemoveMember: 'myAccountRemoveMember',
    courseCreate: 'courseCreate',
    courseUpdate: 'courseUpdate',
    courseStatusUpdate: 'courseStatusUpdate',
    courseDelete: 'courseDelete',
    courseCreateFromDraft: 'courseCreateFromDraft',
    courseUpdateFromDraft: 'courseUpdateFromDraft',
    courseUpdateHoles: 'courseUpdateHoles',
    courseHoleAdd: 'courseHoleAdd',
    courseHoleDelete: 'courseHoleDelete',
    courseTeeCreate: 'courseTeeCreate',
    courseTeeUpdate: 'courseTeeUpdate',
    courseTeeDelete: 'courseTeeDelete',
    courseTeeSetDefault: 'courseTeeSetDefault',
    devReseed: 'devReseed',
    polfEventFlightAdd: 'polfEventFlightAdd',
    polfEventFlightUpdate: 'polfEventFlightUpdate',
    polfEventFlightRemove: 'polfEventFlightRemove',
    polfEventFlightAddPlayer: 'polfEventFlightAddPlayer',
    polfEventFlightRemovePlayer: 'polfEventFlightRemovePlayer',
    polfEventFlightAddTeam: 'polfEventFlightAddTeam',
    polfEventFlightRemoveTeam: 'polfEventFlightRemoveTeam',
    polfEventPlayerDistributeInFlights: 'polfEventPlayerDistributeInFlights',
    polfEventTeamDistributeInFlights: 'polfEventTeamDistributeInFlights',
    polfEventHoleCompetitionEntryUpdate: 'polfEventHoleCompetitionEntryUpdate',
    polfEventHoleCompetitionEntryRemove: 'polfEventHoleCompetitionEntryRemove',
    polfEventHoleCompetitionCreate: 'polfEventHoleCompetitionCreate',
    polfEventHoleCompetitionUpdate: 'polfEventHoleCompetitionUpdate',
    polfEventHoleCompetitionRemove: 'polfEventHoleCompetitionRemove',
    polfEventHoleCompetitionOpponentAdd: 'polfEventHoleCompetitionOpponentAdd',
    polfEventHoleCompetitionOpponentUpdate: 'polfEventHoleCompetitionOpponentUpdate',
    PolfEventMatchAdd: 'PolfEventMatchAdd',
    PolfEventMatchDelete: 'PolfEventMatchDelete',
    polfEventPlayerScoreUpdate: 'polfEventPlayerScoreUpdate',
    polfEventPlayerAdd: 'polfEventPlayerAdd',
    polfEventPlayerAddMultiple: 'polfEventPlayerAddMultiple',
    polfEventCopyData: 'polfEventCopyData',
    polfEventPlayerOtherPaymentCreate: 'polfEventPlayerOtherPaymentCreate',
    polfEventPlayerOtherPaymentDelete: 'polfEventPlayerOtherPaymentDelete',
    polfEventPlayerUpdate: 'polfEventPlayerUpdate',
    polfEventPlayerRemove: 'polfEventPlayerRemove',
    paymentRefund: 'paymentRefund',
    polfEventPlayerPaymentReminder: 'polfEventPlayerPaymentReminder',
    polfEventRequestUpdatedInfo: 'polfEventRequestUpdatedInfo',
    polfEventPlayerRetire: 'polfEventPlayerRetire',
    polfEventPlayerRetireUndo: 'polfEventPlayerRetireUndo',
    polfEventPlayerRetiredPlaysPokerSet: 'polfEventPlayerRetiredPlaysPokerSet',
    polfEventPokerConfigUpsert: 'polfEventPokerConfigUpsert',
    polfEventPokerDrawSeats: 'polfEventPokerDrawSeats',
    polfEventPokerBlindStructureUpdate: 'polfEventPokerBlindStructureUpdate',
    polfEventPokerPayoutStructureUpdate: 'polfEventPokerPayoutStructureUpdate',
    polfEventPokerUsePayoutsSet: 'polfEventPokerUsePayoutsSet',
    polfEventPokerSeatMove: 'polfEventPokerSeatMove',
    polfEventPokerSeatSwap: 'polfEventPokerSeatSwap',
    polfEventPokerClockStart: 'polfEventPokerClockStart',
    polfEventPokerClockPause: 'polfEventPokerClockPause',
    polfEventPokerClockResume: 'polfEventPokerClockResume',
    polfEventPokerClockAdjust: 'polfEventPokerClockAdjust',
    polfEventPokerLevelAdvance: 'polfEventPokerLevelAdvance',
    polfEventPokerSeatEliminate: 'polfEventPokerSeatEliminate',
    polfEventPokerSeatRestore: 'polfEventPokerSeatRestore',
    polfEventPokerReorderElimination: 'polfEventPokerReorderElimination',
    polfEventPokerSeatLockToggle: 'polfEventPokerSeatLockToggle',
    polfEventPokerSeatStackUpdate: 'polfEventPokerSeatStackUpdate',
    polfEventPokerBalancingApply: 'polfEventPokerBalancingApply',
    polfEventPokerAddTable: 'polfEventPokerAddTable',
    polfEventPokerRemoveLastTable: 'polfEventPokerRemoveLastTable',
    polfEventPokerPrizePoolUpdate: 'polfEventPokerPrizePoolUpdate',
    polfEventPokerSeatsPerTableUpdate: 'polfEventPokerSeatsPerTableUpdate',
    polfEventPokerShowChipLeaderboardSet: 'polfEventPokerShowChipLeaderboardSet',
    polfEventPokerVoiceAnnouncementsSet: 'polfEventPokerVoiceAnnouncementsSet',
    polfEventPokerAllowPlayerStackUpdateSet: 'polfEventPokerAllowPlayerStackUpdateSet',
    polfEventPokerFinalTableRedraw: 'polfEventPokerFinalTableRedraw',
    polfEventPokerSendSeatSms: 'polfEventPokerSendSeatSms',
    polfEventPokerFinish: 'polfEventPokerFinish',
    polfEventPokerRebuyConfigSet: 'polfEventPokerRebuyConfigSet',
    polfEventPokerRegistrationClose: 'polfEventPokerRegistrationClose',
    polfEventPokerSeatRebuy: 'polfEventPokerSeatRebuy',
    polfEventPokerSeatAddon: 'polfEventPokerSeatAddon',
    polfEventPokerSeatAddonRemove: 'polfEventPokerSeatAddonRemove',
    polfEventPokerAddonAll: 'polfEventPokerAddonAll',
    polfEventPokerLateRegister: 'polfEventPokerLateRegister',
    polfEventTeamAdd: 'polfEventTeamAdd',
    polfEventTeamUpdate: 'polfEventTeamUpdate',
    polfEventTeamResetName: 'polfEventTeamResetName',
    polfEventTeamDelete: 'polfEventTeamDelete',
    polfEventTeamAddPlayer: 'polfEventTeamAddPlayer',
    polfEventTeamRemovePlayer: 'polfEventTeamRemovePlayer',
    polfEventTeamAutogenerate: 'polfEventTeamAutogenerate',
    polfEventCreate: 'polfEventCreate',
    polfEventStart: 'polfEventStart',
    polfEventSendInvites: 'polfEventSendInvites',
    polfEventFinish: 'polfEventFinish',
    polfEventReopen: 'polfEventReopen',
    polfEventClose: 'polfEventClose',
    polfEventDelete: 'polfEventDelete',
    polfEventUpdate: 'polfEventUpdate',
    polfEventChipValuesUpdate: 'polfEventChipValuesUpdate',
    updateMyProfile: 'updateMyProfile',
    removeMyPassword: 'removeMyPassword',
    OperatorClockPause: 'OperatorClockPause',
    OperatorClockResume: 'OperatorClockResume',
    OperatorLevelAdvance: 'OperatorLevelAdvance',
    OperatorSeatStackUpdate: 'OperatorSeatStackUpdate',
    OperatorSeatEliminate: 'OperatorSeatEliminate',
    OperatorSeatRestore: 'OperatorSeatRestore',
    OperatorReorderElimination: 'OperatorReorderElimination',
    OperatorSeatWithdraw: 'OperatorSeatWithdraw',
    OperatorAddTable: 'OperatorAddTable',
    OperatorRemoveLastTable: 'OperatorRemoveLastTable',
    OperatorSeatsPerTableUpdate: 'OperatorSeatsPerTableUpdate',
    OperatorClockStart: 'OperatorClockStart',
    OperatorClockAdjust: 'OperatorClockAdjust',
    OperatorSeatMove: 'OperatorSeatMove',
    OperatorSeatLockToggle: 'OperatorSeatLockToggle',
    OperatorBalancingApply: 'OperatorBalancingApply',
    OperatorFinalTableRedraw: 'OperatorFinalTableRedraw',
    OperatorBreakTable: 'OperatorBreakTable',
    OperatorBlindStructureUpdate: 'OperatorBlindStructureUpdate',
    polfEventOperatorCreate: 'polfEventOperatorCreate',
    polfEventOperatorRevoke: 'polfEventOperatorRevoke',
    polfEventOperatorSendLink: 'polfEventOperatorSendLink',
    polfEventOperatorSendLinkToAll: 'polfEventOperatorSendLinkToAll',
    accountCreate: 'accountCreate',
    accountAddMember: 'accountAddMember',
    accountRemoveMember: 'accountRemoveMember',
    accountSetContactPerson: 'accountSetContactPerson',
    paymentDeleteEmptyRecords: 'paymentDeleteEmptyRecords',
    paymentUpdateAllRecords: 'paymentUpdateAllRecords',
    sendSms: 'sendSms',
    platformRemoveTwoFactor: 'platformRemoveTwoFactor',
    polfEventPublicAddPlayerVipps: 'polfEventPublicAddPlayerVipps',
    polfEventPublicUpdatePlayer: 'polfEventPublicUpdatePlayer',
    sponsorCreate: 'sponsorCreate',
    sponsorUpdate: 'sponsorUpdate',
    sponsorDelete: 'sponsorDelete',
    sponsorLogoUploadUrl: 'sponsorLogoUploadUrl',
    sponsorLogoUploadComplete: 'sponsorLogoUploadComplete',
    paymentCapture: 'paymentCapture',
    paymentCreatePlayerBasedOnPaymentRecord: 'paymentCreatePlayerBasedOnPaymentRecord'
  },
  Subscription: {
    smsEventUpdated: 'smsEventUpdated'
  },
  Fragment: {
    CourseFields: 'CourseFields',
    CourseTeeFields: 'CourseTeeFields',
    CourseHoleFields: 'CourseHoleFields',
    CourseDraftFields: 'CourseDraftFields',
    FlightListItem: 'FlightListItem',
    HoleCompetitionItem: 'HoleCompetitionItem',
    HoleCompetitionEntry: 'HoleCompetitionEntry',
    HoleCompetitionWithEntries: 'HoleCompetitionWithEntries',
    SummaryPolfPlayerRow: 'SummaryPolfPlayerRow',
    SummaryGolfPlayerRow: 'SummaryGolfPlayerRow',
    SummaryScrambleTeamRow: 'SummaryScrambleTeamRow',
    SummaryBestBallTeamRow: 'SummaryBestBallTeamRow',
    SummarySegmentedTeamRow: 'SummarySegmentedTeamRow',
    MatchSideFields: 'MatchSideFields',
    EventMatchFields: 'EventMatchFields',
    ScorecardScore: 'ScorecardScore',
    ScorecardPlayer: 'ScorecardPlayer',
    PlayerListItem: 'PlayerListItem',
    PokerSeatRow: 'PokerSeatRow',
    PokerLevelRow: 'PokerLevelRow',
    PokerPayoutRow: 'PokerPayoutRow',
    PokerData: 'PokerData',
    TeamListItem: 'TeamListItem',
    ProjectorEvent: 'ProjectorEvent',
    ProjectorHoleCompetitionEntry: 'ProjectorHoleCompetitionEntry',
    ProjectorHoleCompetition: 'ProjectorHoleCompetition',
    ProjectorPlayerSummary: 'ProjectorPlayerSummary',
    ProjectorPolfLeaderboardSpecialEntry: 'ProjectorPolfLeaderboardSpecialEntry',
    ProjectorPolfLeaderboardPlayerEntry: 'ProjectorPolfLeaderboardPlayerEntry',
    ProjectorGolfLeaderboardPlayerEntry: 'ProjectorGolfLeaderboardPlayerEntry',
    ProjectorLeaderboardUnionFields: 'ProjectorLeaderboardUnionFields',
    ProjectorSegmentedTeamEntry: 'ProjectorSegmentedTeamEntry',
    ProjectorPokerLevel: 'ProjectorPokerLevel',
    ProjectorPokerActiveStanding: 'ProjectorPokerActiveStanding',
    ProjectorPokerEliminated: 'ProjectorPokerEliminated',
    ProjectorPokerPublic: 'ProjectorPokerPublic',
    PublicRegistrationEvent: 'PublicRegistrationEvent',
    SponsorItem: 'SponsorItem',
    VippsPaymentDetailsFields: 'VippsPaymentDetailsFields'
  }
}